import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
  LoyaltyID: any;
  LoyaltyJSON: any;
}

/** A First Data or Adyen account (payment method) will have either credit or prepaid but not both */
export interface IAccount {
  readonly __typename?: 'Account';
  /** Common PSP payment method identifier and Adyen account identifier. */
  readonly accountIdentifier?: Maybe<Scalars['String']>;
  /** Used for making cc direct payments with chase (TH) */
  readonly chaseProfileId?: Maybe<Scalars['String']>;
  readonly credit?: Maybe<ICreditCard>;
  /** First Data account ID */
  readonly fdAccountId?: Maybe<Scalars['String']>;
  /** Orbital account stored payment method id */
  readonly orbitalIdentifier?: Maybe<Scalars['String']>;
  readonly paypal?: Maybe<Scalars['Boolean']>;
  readonly paypalIdentifier?: Maybe<Scalars['String']>;
  readonly prepaid?: Maybe<IGiftCard>;
}

export interface IAccountListResponse {
  readonly __typename?: 'AccountListResponse';
  readonly accounts?: Maybe<ReadonlyArray<Maybe<IAccount>>>;
  readonly count: Scalars['Int'];
  readonly defaultAccount?: Maybe<IAccount>;
  readonly paymentProcessor?: Maybe<PaymentProcessor>;
}

/** Deprecated */
export interface IActivateAlohaRewardResponse {
  readonly __typename?: 'ActivateAlohaRewardResponse';
  readonly alohaRewardBonusPlanId: Scalars['Int'];
  readonly rewardCategorySanityId: Scalars['String'];
  readonly rewardPointCost: Scalars['Int'];
  readonly rewardSanityId: Scalars['String'];
  /** User balance after reward activation and balance sync with Aloha. */
  readonly userPointBalance: Scalars['Int'];
}

/** Add a First Data account (payment method) for the current user */
export interface IAddAccountInput {
  /** billingAddress associated to card */
  readonly billingAddress?: InputMaybe<IBillingAddressInput>;
  /** First 6 digits of credit card */
  readonly ccBin: Scalars['String'];
  /** cc token from tokenex required for chase direct pay enrollment */
  readonly ccToken?: InputMaybe<Scalars['String']>;
  /** cc security code */
  readonly cvv?: InputMaybe<Scalars['String']>;
  /** Access token which was used to request nonce */
  readonly fdAccessToken: Scalars['String'];
  /** Nonce provided by FD linking to the new payment method */
  readonly fdNonce: Scalars['String'];
  /** Name On Card */
  readonly fullName?: InputMaybe<Scalars['String']>;
  /** Make this new account the user's default account */
  readonly makeDefault?: InputMaybe<Scalars['Boolean']>;
  /** Session ID as set by the FE. This should be derived from mParticle. */
  readonly sessionId?: InputMaybe<Scalars['String']>;
  /** threeDSOptions to resume account creation */
  readonly threeDSOptions?: InputMaybe<IThreeDsOptions>;
}

/** Add Adyen (payment method) for the current user */
export interface IAddAdyenAccountInput {
  /** Encrypted Payment Payload */
  readonly encryptedPayload: IAdyenEncryptedInfo;
}

/** Add payment method for the current user */
export interface IAddCreditAccountInput {
  readonly adyenInput?: InputMaybe<IAddAdyenAccountInput>;
  /** billingAddress associated to card */
  readonly billingAddress: IBillingAddressInput;
  readonly firstDataInput?: InputMaybe<IAddAccountInput>;
  /** Name on credit card */
  readonly fullName: Scalars['String'];
  /** (TH only) Make this new account the user's default account */
  readonly makeDefault?: InputMaybe<Scalars['Boolean']>;
  readonly orbitalInput?: InputMaybe<IAddOrbitalAccountInput>;
}

export interface IAddGiftAccountInput {
  /** Details from Apple Pay for funding. */
  readonly applePayDetails?: InputMaybe<IApplePay>;
  /**
   * Vaulted first data Account ID (credit) used to fund gift card.
   * Either this or applePayDetails is required.
   */
  readonly fdAccountId?: InputMaybe<Scalars['String']>;
  /** Amount to fund to gift card account in cents */
  readonly fundValue: Scalars['Int'];
  /** Details from Goole Pay for funding. */
  readonly googlePayDetails?: InputMaybe<IGooglePay>;
  /**
   * Unique Kount Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   */
  readonly kountSessionId?: InputMaybe<Scalars['String']>;
  /**
   * Session ID as set by the FE.
   *
   * Note that the "sessionId" field is deprecated and will be ignored.
   */
  readonly sessionId?: InputMaybe<Scalars['String']>;
}

/** Add Orbital (payment method) for the current user */
export interface IAddOrbitalAccountInput {
  readonly bin: Scalars['String'];
  readonly cardBrand: Scalars['String'];
  readonly encryptedCardNum: Scalars['String'];
  readonly encryptedCvv: Scalars['String'];
  readonly expiryMonth: Scalars['String'];
  readonly expiryYear: Scalars['String'];
  readonly pieFormat: Scalars['String'];
  readonly pieIntegrityCheck: Scalars['String'];
  readonly pieKeyID: Scalars['String'];
  readonly pieMode: Scalars['String'];
  readonly piePhaseId: Scalars['String'];
  readonly pieSubscriberId: Scalars['String'];
}

export interface IAddPaymentMethodInput {
  readonly billingAddress: IPaymentBillingAddressInput;
  readonly currency?: InputMaybe<Scalars['String']>;
  readonly paymentMethods: Scalars['String'];
}

export type IAddPaymentMethodPayload = IAddPaymentMethodSuccess | IThreeDsChallenge | IThreeDsFrictionless;

export interface IAddPaymentMethodSuccess {
  readonly __typename?: 'AddPaymentMethodSuccess';
  readonly storedPaymentMethod: IStoredPaymentMethod;
}

export interface IAdyenEncryptedInfo {
  /** Encrypted credit card number */
  readonly encryptedCN: Scalars['String'];
  /** Encrypted credit card expiry month */
  readonly encryptedEM: Scalars['String'];
  /** Encrypted credit card expiry year */
  readonly encryptedEY: Scalars['String'];
  /** Encrypted credit card security code */
  readonly encryptedSC: Scalars['String'];
}

export interface IAdyenPayment {
  /**
   * Represents a saved funding source. (i.e. fdAccountId or recurringDetailReference)
   * If passed this will be used to process payment. Either accountIdentifier or
   * encrypted payload is required.
   */
  readonly accountIdentifier?: InputMaybe<Scalars['String']>;
  /** Encrypted Payment Payload. If accountIdentifier is not passed this will be used. */
  readonly encryptedPayload?: InputMaybe<IAdyenEncryptedInfo>;
  /** Denotes the payment type */
  readonly paymentType?: InputMaybe<AdyenPaymentType>;
  /** When true, payment details will be saved as a recurring payment method in Adyen */
  readonly savePaymentMethod?: InputMaybe<Scalars['Boolean']>;
}

export enum AdyenPaymentType {
  APPLE_PAY = 'APPLE_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
  TOKENIZED_CREDIT_CARD = 'TOKENIZED_CREDIT_CARD'
}

/** Deprecated */
export interface IAlohaActiveReward {
  readonly __typename?: 'AlohaActiveReward';
  readonly pointCost: Scalars['Int'];
  readonly rewardsCount: Scalars['Int'];
  readonly sanityId: Scalars['String'];
}

export interface IApiMetadata {
  readonly __typename?: 'ApiMetadata';
  /** Pong! Simple health check. */
  readonly ping: Scalars['String'];
}

/** Details from Apple Pay used for Apple Pay funding. */
export interface IApplePay {
  /** Data of the payment method used for Apple Pay. */
  readonly PaymentMethodData?: InputMaybe<IPaymentMethodData>;
  /** Application data as passed through from Apple Pay */
  readonly applicationData: Scalars['String'];
  readonly billingAddress: IBillingAddressInput;
  /** part of the billing address from apple pay */
  readonly country: CountryCode;
  readonly data: Scalars['String'];
  readonly decryptAlias: Scalars['String'];
  readonly ephemeralPublicKey: Scalars['String'];
  readonly formatted: Scalars['String'];
  /** bundle all apple pay details into an encrypted token. */
  readonly paymentData?: InputMaybe<Scalars['String']>;
  readonly primary: Scalars['Boolean'];
  readonly publicKeyHash: Scalars['String'];
  /** Signature as passed through from Apple Pay */
  readonly signature: Scalars['String'];
  readonly transactionId: Scalars['String'];
  /** type of the billing address set in apple pay e.g. work, home, etc */
  readonly type: Scalars['String'];
  readonly version: Scalars['String'];
}

export interface IApplePayPaymentConfig {
  readonly __typename?: 'ApplePayPaymentConfig';
  readonly prepaidMerchantId?: Maybe<Scalars['String']>;
  readonly schemeMerchantId?: Maybe<Scalars['String']>;
}

export interface IAppliedOffer {
  readonly cartId?: InputMaybe<Scalars['ID']>;
  readonly id?: InputMaybe<Scalars['ID']>;
  /** This should be required but for the moment we will add it as an optional input to not introduce a breaking change */
  readonly sanityId?: InputMaybe<Scalars['ID']>;
  readonly swap?: InputMaybe<ISwapInput>;
  readonly type?: InputMaybe<OfferType>;
}

export interface IAppliedReward {
  readonly cartId: Scalars['ID'];
  readonly rewardId: Scalars['ID'];
  /** This should be required but for the moment we will add it as an optional input to not introduce a breaking change */
  readonly sanityId?: InputMaybe<Scalars['ID']>;
  readonly timesApplied: Scalars['Int'];
}

export interface IAssociateGuestUserResponse {
  readonly __typename?: 'AssociateGuestUserResponse';
  /** Date and time when the the identifier got activated */
  readonly activationDateTime: Scalars['String'];
  readonly guestBalance: Scalars['Int'];
  /** Date and time when the linking between the identifier and the loyalty user happened */
  readonly linkingDateTime: Scalars['String'];
  readonly totalBalance: Scalars['Int'];
}

/** A Prepaid balance response (payment method) */
export interface IBalance {
  readonly __typename?: 'Balance';
  /** gift card last 4 digits */
  readonly alias: Scalars['String'];
  /** dollar amount gift card begins with */
  readonly beginBalance: Scalars['Int'];
  readonly currencyCode: Scalars['String'];
  /** current gift card balance in cents */
  readonly currentBalance: Scalars['Int'];
  readonly expiryMonth: Scalars['String'];
  readonly expiryYear: Scalars['String'];
  readonly fdCorrelationId?: Maybe<Scalars['String']>;
}

export interface IBaseIncentive {
  readonly cartRequirements?: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ICartRequirement>>>>>;
  readonly coolDown?: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['String'];
  readonly endDate: Scalars['String'];
  readonly endTime?: Maybe<Scalars['String']>;
  readonly errors?: Maybe<ReadonlyArray<IRuleConditionEvaluation>>;
  readonly externalIdentifiers?: Maybe<ReadonlyArray<Maybe<IExternalIdentifiers>>>;
  readonly firstOrder?: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly maxRedemptionsDuration?: Maybe<DurationPeriod>;
  readonly maxRedemptionsLimit?: Maybe<Scalars['Int']>;
  readonly minimumSpend?: Maybe<Scalars['Int']>;
  readonly name: Scalars['String'];
  readonly paymentMethod?: Maybe<PaymentMethod>;
  readonly restaurantGroups?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly sanityId?: Maybe<Scalars['String']>;
  readonly serviceModes?: Maybe<ReadonlyArray<Maybe<ServiceMode>>>;
  readonly startDate: Scalars['String'];
  readonly startTime?: Maybe<Scalars['String']>;
  readonly storeRestrictions?: Maybe<IStoreRestrictions>;
  readonly updatedAt: Scalars['String'];
  readonly userBirthdayDuration?: Maybe<BirthdayDuration>;
  readonly userEnrollment?: Maybe<IDateSpan>;
  readonly validDaysOfTheWeek?: Maybe<ReadonlyArray<DayOfTheWeek>>;
}

export interface IBenefit {
  readonly type: BenefitType;
}

export interface IBenefitReference extends IBenefit {
  readonly __typename?: 'BenefitReference';
  readonly type: BenefitType;
  readonly value: Scalars['String'];
}

export interface IBenefitSwap extends IBenefit {
  readonly __typename?: 'BenefitSwap';
  readonly type: BenefitType;
  readonly value: ISwap;
}

export enum BenefitType {
  REFERENCE = 'REFERENCE',
  SWAP = 'SWAP'
}

export interface IBillingAddress {
  readonly __typename?: 'BillingAddress';
  /** Country */
  readonly country?: Maybe<Scalars['String']>;
  /** City */
  readonly locality: Scalars['String'];
  /** Zip Code */
  readonly postalCode: Scalars['String'];
  /** State */
  readonly region: Scalars['String'];
  /** Street Address */
  readonly streetAddress: Scalars['String'];
  /** Apt or Unit Number */
  readonly unitNumber?: Maybe<Scalars['String']>;
}

export interface IBillingAddressInput {
  /** Country */
  readonly country?: InputMaybe<Scalars['String']>;
  /** City */
  readonly locality?: InputMaybe<Scalars['String']>;
  /** Zip Code */
  readonly postalCode: Scalars['String'];
  /** State */
  readonly region?: InputMaybe<Scalars['String']>;
  /** Street Address */
  readonly streetAddress?: InputMaybe<Scalars['String']>;
  /** Apt or Unit Number */
  readonly unitNumber?: InputMaybe<Scalars['String']>;
}

export enum BirthdayDuration {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK'
}

export enum Brand {
  BK = 'BK',
  /** @deprecated only BK is allowed */
  FHS = 'FHS',
  /** @deprecated only BK is allowed */
  LTW = 'LTW',
  /** @deprecated only BK is allowed */
  PLK = 'PLK',
  /** @deprecated only BK is allowed */
  TH = 'TH'
}

export interface IBrazeUserPhone {
  readonly __typename?: 'BrazeUserPhone';
  readonly phone?: Maybe<Scalars['String']>;
}

export interface ICbaCouponResponse extends ICouponResponse {
  readonly __typename?: 'CBACouponResponse';
  readonly code: Scalars['String'];
  readonly isRedeemed?: Maybe<Scalars['Boolean']>;
  readonly isValid: Scalars['Boolean'];
  readonly message: Scalars['String'];
  readonly offerId?: Maybe<Scalars['String']>;
  readonly reason?: Maybe<Scalars['String']>;
  readonly shouldRedeem?: Maybe<Scalars['Boolean']>;
}

export interface ICbaRedeemCouponResponse extends IRedeemedCouponResponse {
  readonly __typename?: 'CBARedeemCouponResponse';
  readonly code: Scalars['String'];
  readonly isRedeemed: Scalars['Boolean'];
  readonly message?: Maybe<Scalars['String']>;
  readonly offerId?: Maybe<Scalars['String']>;
  readonly reason?: Maybe<Scalars['String']>;
}

export enum CacheControlScope {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export interface ICalories {
  readonly __typename?: 'Calories';
  readonly default?: Maybe<Scalars['Int']>;
  readonly max?: Maybe<Scalars['Int']>;
  readonly min?: Maybe<Scalars['Int']>;
}

export enum CardBrand {
  AMEX = 'AMEX',
  DINERS_CLUB = 'DINERS_CLUB',
  DISCOVER = 'DISCOVER',
  INTERAC = 'INTERAC',
  JCB = 'JCB',
  MASTERCARD = 'MASTERCARD',
  UNKNOWN = 'UNKNOWN',
  VISA = 'VISA'
}

export interface ICart {
  readonly __typename?: 'Cart';
  readonly appliedOffers?: Maybe<ReadonlyArray<Maybe<ICartAppliedOffer>>>;
  readonly brand: Brand;
  readonly cartEntries?: Maybe<ReadonlyArray<ICartEntries>>;
  readonly cartVersion?: Maybe<Scalars['Int']>;
  readonly customerLocale?: Maybe<Scalars['String']>;
  readonly customerName: Scalars['String'];
  readonly deviceOS?: Maybe<Scalars['String']>;
  readonly discounts?: Maybe<ReadonlyArray<Maybe<IDiscount>>>;
  readonly donations?: Maybe<ReadonlyArray<Maybe<IDonation>>>;
  readonly fees?: Maybe<ReadonlyArray<Maybe<IFees>>>;
  /** All evaluated offers in the cart, or all the offers supplied against the cart. */
  readonly offersFeedback?: Maybe<ReadonlyArray<Maybe<ICouponUserOffersFeedbackEntry>>>;
  readonly payment?: Maybe<IPayment>;
  readonly platform?: Maybe<Platform>;
  readonly posVendor: PosVendor;
  /**
   * ISO Timestamp from POS in local timezone e.g 2019-07-08T23:02:17.203Z
   * @deprecated Only for internal use
   */
  readonly processedAt?: Maybe<Scalars['String']>;
  /**
   * Cart entries for reordering.
   * This is usually the same as cartEntries except for when there are swaps.
   */
  readonly reorderCartEntries?: Maybe<ReadonlyArray<ICartEntries>>;
  readonly requestedAmountCents: Scalars['Int'];
  readonly rewardsApplied?: Maybe<ReadonlyArray<Maybe<ICartAppliedReward>>>;
  readonly serviceMode: ServiceMode;
  readonly storeAddress: IStoreAddress;
  readonly storeDetails?: Maybe<IStoreDetails>;
  readonly storeId: Scalars['String'];
  readonly storePosId?: Maybe<Scalars['String']>;
  readonly subTotalCents?: Maybe<Scalars['Int']>;
  /** @deprecated Not needed anymore since it is included in AppliedOffer */
  readonly swaps?: Maybe<ReadonlyArray<Maybe<ICartSwap>>>;
  readonly taxCents?: Maybe<Scalars['Int']>;
  readonly ticketNumber?: Maybe<Scalars['String']>;
  readonly totalCents?: Maybe<Scalars['Int']>;
  readonly unavailableCartEntries?: Maybe<ReadonlyArray<Maybe<IUnavailableCartEntry>>>;
  readonly userDetails?: Maybe<IUserDetails>;
  readonly userId?: Maybe<Scalars['String']>;
  readonly vatNumber?: Maybe<Scalars['String']>;
  readonly wasLoyaltyEarned?: Maybe<Scalars['Boolean']>;
}

export interface ICartAppliedOffer {
  readonly __typename?: 'CartAppliedOffer';
  readonly cartId?: Maybe<Scalars['ID']>;
  readonly id: Scalars['ID'];
  /** This should be required but for the moment we will add it as an optional input to not introduce a breaking change */
  readonly sanityId?: Maybe<Scalars['ID']>;
  readonly swap?: Maybe<ICartSwap>;
  readonly type: OfferType;
}

/** AppliedReward is duplicated here to avoid breaking changes as above definition serves as an input. */
export interface ICartAppliedReward {
  readonly __typename?: 'CartAppliedReward';
  readonly cartId: Scalars['ID'];
  readonly rewardId: Scalars['ID'];
  /** This should be required but for the moment we will add it as an optional input to not introduce a breaking change */
  readonly sanityId?: Maybe<Scalars['ID']>;
  readonly timesApplied: Scalars['Int'];
}

export interface ICartDiscount {
  readonly __typename?: 'CartDiscount';
  readonly type: CartDiscountType;
  readonly value: Scalars['Float'];
}

export interface ICartDiscountInput {
  readonly type: CartDiscountType;
  readonly value: Scalars['Float'];
}

export enum CartDiscountType {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE'
}

export interface ICartEntries {
  readonly __typename?: 'CartEntries';
  readonly children?: Maybe<ReadonlyArray<Maybe<ICartEntries>>>;
  readonly image?: Maybe<Scalars['String']>;
  readonly isDonation?: Maybe<Scalars['Boolean']>;
  readonly isExtra?: Maybe<Scalars['Boolean']>;
  readonly isInMenu?: Maybe<Scalars['Boolean']>;
  readonly lineId: Scalars['String'];
  readonly name?: Maybe<Scalars['String']>;
  readonly offerVendorConfigs?: Maybe<IVendorConfigs>;
  readonly pickerSelections?: Maybe<Scalars['String']>;
  readonly plu?: Maybe<IPlu>;
  readonly price?: Maybe<Scalars['Int']>;
  readonly quantity: Scalars['Int'];
  readonly redeemable?: Maybe<Scalars['Boolean']>;
  readonly sanityId: Scalars['String'];
  readonly type: CartEntryType;
  readonly url?: Maybe<Scalars['String']>;
  readonly vendorConfigs?: Maybe<IVendorConfigs>;
}

export interface ICartEntryInput {
  readonly children?: InputMaybe<ReadonlyArray<ICartEntryInput>>;
  readonly image?: InputMaybe<Scalars['String']>;
  readonly isDonation?: InputMaybe<Scalars['Boolean']>;
  readonly isExtra?: InputMaybe<Scalars['Boolean']>;
  readonly lineId: Scalars['String'];
  readonly markerItemPlu?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly offerVendorConfigs?: InputMaybe<IVendorConfigsInput>;
  readonly pickerSelections?: InputMaybe<Scalars['String']>;
  readonly plu?: InputMaybe<IPluInput>;
  readonly price?: InputMaybe<Scalars['Int']>;
  readonly productHierarchy?: InputMaybe<IProductHierarchyInput>;
  readonly quantity: Scalars['Int'];
  readonly sanityId: Scalars['String'];
  readonly type: CartEntryType;
  readonly url?: InputMaybe<Scalars['String']>;
  readonly vendorConfigs?: InputMaybe<IVendorConfigsInput>;
}

export enum CartEntryType {
  COMBO = 'Combo',
  COMBOSLOT = 'ComboSlot',
  ITEM = 'Item',
  ITEMOPTION = 'ItemOption',
  ITEMOPTIONMODIFIER = 'ItemOptionModifier',
  OFFERCOMBO = 'OfferCombo',
  OFFERDISCOUNT = 'OfferDiscount',
  OFFERITEM = 'OfferItem'
}

export enum CartOfferState {
  ACTIVE = 'ACTIVE',
  CONSUMED = 'CONSUMED',
  INACTIVE = 'INACTIVE'
}

export enum CartPaymentCardType {
  AMEX = 'AMEX',
  APPLE_PAY = 'APPLE_PAY',
  CASH = 'CASH',
  CREDIT = 'CREDIT',
  DINERS = 'DINERS',
  DINERS_CLUB = 'DINERS_CLUB',
  DISCOVER = 'DISCOVER',
  GIFT_CARD = 'GIFT_CARD',
  GOOGLE_PAY = 'GOOGLE_PAY',
  JCB = 'JCB',
  MASTERCARD = 'MASTERCARD',
  PAYPAL = 'PAYPAL',
  VENMO = 'VENMO',
  VISA = 'VISA'
}

export enum CartPaymentType {
  APPLE_PAY = 'APPLE_PAY',
  CASH = 'CASH',
  CREDIT_ANONYMOUS = 'CREDIT_ANONYMOUS',
  GOOGLE_PAY = 'GOOGLE_PAY',
  PAYPAL = 'PAYPAL',
  VAULTED_ACCOUNT = 'VAULTED_ACCOUNT',
  VENMO = 'VENMO'
}

export interface ICartRequirement {
  readonly __typename?: 'CartRequirement';
  readonly id: Scalars['String'];
  readonly quantity: Scalars['Int'];
}

export interface ICartSwap {
  readonly __typename?: 'CartSwap';
  readonly cartId: Scalars['String'];
  readonly from: Scalars['String'];
  readonly swapType: Scalars['String'];
  readonly to: Scalars['String'];
}

export interface ICatering {
  readonly __typename?: 'Catering';
  readonly declineReason?: Maybe<CateringDeclineReasons>;
  readonly notes?: Maybe<Scalars['String']>;
  readonly pickupTime: Scalars['String'];
}

export enum CateringDecision {
  ACCEPT = 'Accept',
  DECLINE = 'Decline'
}

export enum CateringDeclineReasons {
  CATERING_ORDER_TIME_OUT = 'CATERING_ORDER_TIME_OUT',
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  INVENTORY = 'INVENTORY',
  STAFFING = 'STAFFING',
  TIMING = 'TIMING'
}

export interface ICateringInfoInput {
  /**
   * Pickup Time - in ISO format.
   * Only ISO-formatted datetime values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
   */
  readonly pickupTime: Scalars['String'];
}

export enum Channel {
  BITENINJA = 'biteninja',
  CATERING = 'catering',
  DOORDASH = 'doordash',
  GFO = 'gfo',
  GRUBHUB = 'grubhub',
  SKIP = 'skip',
  UBER = 'uber',
  WAITR = 'waitr',
  WHITELABEL = 'whitelabel'
}

export interface ICognitoCredentials {
  readonly __typename?: 'CognitoCredentials';
  readonly challengeCode: Scalars['String'];
  readonly email?: Maybe<Scalars['String']>;
  readonly sessionId: Scalars['String'];
}

export interface ICommitDeliveryInput {
  /**
   * drop off location for delivery (user's address)
   * this can be marked as required when launch darkly
   * flag is no longer in use
   *
   * @deprecated(reason: "needs to be named dropoff")
   */
  readonly dropOff?: InputMaybe<IDeliveryWaypointInput>;
  readonly dropoff?: InputMaybe<IDeliveryWaypointInput>;
  readonly instructions?: InputMaybe<Scalars['String']>;
  /** boolean flag to mark notification setting */
  readonly pushNotification?: InputMaybe<Scalars['Boolean']>;
  readonly tipCents?: InputMaybe<Scalars['Int']>;
}

export interface ICommitOrderInput {
  /**
   * Details from Apple Pay for payment.
   * @deprecated(reason: "Use payment object")
   */
  readonly applePayDetails?: InputMaybe<IApplePay>;
  /**
   * Billing address Comes in the following format
   * billingStreetAddress, billingApt, billingCity, billingState, billingZip
   * @deprecated(reason: "Use payment object")
   */
  readonly billingAddress?: InputMaybe<IBillingAddressInput>;
  /**
   * First 6 digits of credit card.
   * Required for anonymous payment.
   * @deprecated(reason: "Use payment object")
   * @constraint(pattern: "^[0-9]{6}$")
   */
  readonly ccBin?: InputMaybe<Scalars['String']>;
  /**
   * Credit card 2 digit expiry month
   * @deprecated(reason: "Use payment object")
   */
  readonly ccExpiryMonth?: InputMaybe<Scalars['String']>;
  /**
   * Credit card 2 digit expiry year
   * @deprecated(reason: "Use payment object")
   */
  readonly ccExpiryYear?: InputMaybe<Scalars['String']>;
  /**
   * Last 6 digits of credit card.
   * Required for anonymous payment.
   * @deprecated(reason: "Use payment object")
   * @constraint(pattern: "^[0-9]{4}$")
   */
  readonly ccLast4?: InputMaybe<Scalars['String']>;
  /**
   * The payment provider type eg. (VISA/MASTERCARD/DISCOVER/AMEX)
   * @deprecated(reason: "Use payment object")
   */
  readonly creditType?: InputMaybe<CartPaymentCardType>;
  /**
   * Valid access token for accessing First Data API
   * @deprecated(reason: "Use firstDataInput on payment object")
   */
  readonly fdAccessToken?: InputMaybe<Scalars['String']>;
  /**
   * The First Data payment method ID which must be associated to the user
   * making the request.
   * @deprecated(reason: "Use firstDataInput on payment object")
   */
  readonly fdAccountId?: InputMaybe<Scalars['String']>;
  /**
   * Nonce retrieved from First Data. Sale will be performed with the payment
   * method associated with the nonce.
   * @deprecated(reason: "Use firstDataInput on payment object")
   */
  readonly fdNonce?: InputMaybe<Scalars['String']>;
  /** Takes in a time in seconds to delay the order commit */
  readonly fireOrderIn?: InputMaybe<Scalars['Int']>;
  /**
   * Customer full name
   * @deprecated(reason: "Use payment object")
   */
  readonly fullName?: InputMaybe<Scalars['String']>;
  /**
   * Details from Google Pay for payment.
   * @deprecated(reason: "Use payment object")
   */
  readonly googlePayDetails?: InputMaybe<IGooglePay>;
  /**
   * Unique Kount Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   * @deprecated(reason: "Use payment object")
   */
  readonly kountSessionId?: InputMaybe<Scalars['String']>;
  /** Contains information to submit payment for this order */
  readonly payment?: InputMaybe<IPaymentInput>;
  /** Details from Paypal for payment. */
  readonly paypalDetails?: InputMaybe<IPaypal>;
  /** ID for a previous order that has been priced */
  readonly rbiOrderId: Scalars['ID'];
  /**
   * The moment of redemption - the user's local date+time - in ISO format.
   * Only ISO-formatted timestamp values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
   */
  readonly redeemedOn?: InputMaybe<Scalars['String']>;
  /**
   * Unique Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   *
   * @deprecated(reason: "Use kountSessionId on payment object")
   */
  readonly sessionId?: InputMaybe<Scalars['String']>;
  /** Store email address */
  readonly storeEmail?: InputMaybe<Scalars['String']>;
  /** Details from 3DS transactions, relates to properties needed to resume sale transactions. */
  readonly threeDSDetails?: InputMaybe<IResumeThreeDSaleTransaction>;
  /** Details from Venmo for payment. */
  readonly venmoDetails?: InputMaybe<IVenmo>;
}

export interface ICommunicationPreference {
  readonly __typename?: 'CommunicationPreference';
  /** Database id of the preference (i.e. language) */
  readonly id?: Maybe<Scalars['String']>;
  /** Value the preference is set to */
  readonly value?: Maybe<Scalars['String']>;
}

export enum CommunicationPreferenceType {
  MARKETINGEMAIL = 'marketingEmail',
  MARKETINGPUSH = 'marketingPush',
  MARKETINGSMS = 'marketingSms'
}

export interface IConfirmCateringOrderInput {
  /** Catering JWT containing catering order info */
  readonly cateringJwt: Scalars['String'];
  /** Accept or Decline Order */
  readonly decision: CateringDecision;
  /** Decline Reason */
  readonly declineReason?: InputMaybe<CateringDeclineReasons>;
}

/**
 * https://relay.dev/graphql/connections.htm#sec-Connection-Types
 *
 * A connection as defined by the GraphQL Cursor Connections Specifications
 *
 * Provides totalCount if there is an efficient way to determine the total
 * pre-paginated results.
 *
 * Provides an array of nodes for consumers that do not need each node's cursor.
 */
export interface IConnection {
  readonly edges: ReadonlyArray<IEdge>;
  readonly nodes: ReadonlyArray<INode>;
  readonly pageInfo: IPageInfo;
  readonly totalCount?: Maybe<Scalars['Int']>;
}

/**
 * Coordinates is used by restaurants search to filter
 * by a radius and the current user's coordinates
 */
export interface ICoordinates {
  readonly searchRadius?: InputMaybe<Scalars['Float']>;
  readonly userLat?: InputMaybe<Scalars['Float']>;
  readonly userLng?: InputMaybe<Scalars['Float']>;
}

/** ***** Start of Legacy Typings ***** */
export enum CountryCode {
  CA = 'CA',
  CH = 'CH',
  GB = 'GB',
  US = 'US',
  ZA = 'ZA'
}

export interface ICoupon {
  readonly __typename?: 'Coupon';
  /** The coupon identity. */
  readonly couponId: Scalars['ID'];
  /** The ISO-formatted timestamp of when the coupon was created. */
  readonly createdAt: Scalars['String'];
  /**
   * The ISO-formatted timestamp of when the coupon expires.
   * If the value is null, then the coupon never expires.
   */
  readonly expiresOn?: Maybe<Scalars['String']>;
  /** The partition key, which is equal to userId. */
  readonly pk: Scalars['String'];
  /**
   * The ISO-formatted timestamp of when the coupon was redeemed.
   * If the value is null, then the coupon has not yet been redeemed.
   */
  readonly redeemedOn?: Maybe<Scalars['String']>;
  /**
   * The current revision number of the coupon row.
   * This value is incremented every time the row is updated.
   * If this value is zero, then the row has never been revised.
   */
  readonly revision: Scalars['Int'];
  /** The sort key, which contains the version. */
  readonly sk: Scalars['String'];
  /**
   * The ISO-formatted timestamp of when the coupon row was updated.
   * If this value matches the createdAt value, the row has never been updated.
   */
  readonly updatedAt: Scalars['String'];
  /** The identity of the user. */
  readonly userId: Scalars['ID'];
  /** An alternate sort value, allowing for ordering coupons by expiration. */
  readonly userSortKey: Scalars['String'];
}

export interface ICouponEvaluationFeedback {
  readonly __typename?: 'CouponEvaluationFeedback';
  /** The message code for the message. */
  readonly code: Scalars['String'];
  /** The result of evaluating one rule in a Coupon Rule Set. */
  readonly condition: Scalars['Boolean'];
  /** The ISO datetime when the offer expires, if applicable. */
  readonly expiresOn?: Maybe<Scalars['String']>;
  /** The message string for the message. */
  readonly message: Scalars['String'];
  /** The number of seconds the coupon can be redeemed for, if applicable. */
  readonly redeemableForSeconds?: Maybe<Scalars['Int']>;
  /** The number of seconds before the coupon can be redeemed, if applicable. */
  readonly redeemableInSeconds?: Maybe<Scalars['Int']>;
  /** The ordinal index number of the rule set entry associated with this feedback, if provided. */
  readonly ruleSetIndex?: Maybe<Scalars['Int']>;
  /** The type of Coupon Rule Set. */
  readonly ruleSetType: Scalars['String'];
  /** The Sanity ID of this rule product or product category. */
  readonly sanityId?: Maybe<Scalars['String']>;
}

export interface ICouponRedemptionEligibility {
  readonly __typename?: 'CouponRedemptionEligibility';
  /** Any feedback provided during evaluation, further describing the condition. */
  readonly evaluationFeedback: ReadonlyArray<Maybe<ICouponEvaluationFeedback>>;
  /** The ISO datetime when the offer expires, if applicable. */
  readonly expiresOn?: Maybe<Scalars['String']>;
  /**
   * The overall redemption eligibility condition.
   * Only a Coupon Rule Set which can be parsed and is valid will potentially be redeemable.
   * If the offer is a Loyalty offer which is not active, then it will also not be redeemable.
   */
  readonly isRedeemable: Scalars['Boolean'];
  /**
   * Whether the Coupon Rule Set structure and data is valid for evaluation.
   * A Coupon Rule Set which is not valid is not redeemable.
   */
  readonly isValid: Scalars['Boolean'];
  /** The redemption eligibility includes the specified moment of redemption. */
  readonly redeemedOn: Scalars['String'];
  /** Any errors which were encountered during Coupon Rule Set validation. */
  readonly validationErrors: ReadonlyArray<Maybe<ICouponValidationError>>;
}

export interface ICouponResponse {
  readonly code: Scalars['String'];
  readonly isRedeemed?: Maybe<Scalars['Boolean']>;
  readonly isValid: Scalars['Boolean'];
  readonly message: Scalars['String'];
  readonly reason?: Maybe<Scalars['String']>;
  readonly shouldRedeem?: Maybe<Scalars['Boolean']>;
}

export interface ICouponToken {
  readonly __typename?: 'CouponToken';
  /** Brief description on the situation that caused coupon to be issued */
  readonly comments?: Maybe<Scalars['String']>;
  /** The coupon identity associated with the coupon token. */
  readonly couponId: Scalars['ID'];
  /** The ISO-formatted timestamp of when the coupon token was created. */
  readonly createdAt: Scalars['String'];
  /**
   * The ISO-formatted timestamp of when the coupon token expires.
   * If the value is null, then the coupon token never expires.
   */
  readonly expiresOn?: Maybe<Scalars['String']>;
  /** The partition key, which is equal to userId. */
  readonly pk: Scalars['String'];
  /** Reason for issuing the coupon */
  readonly reason?: Maybe<Scalars['String']>;
  /** The id of the support agent who issue'd this coupon */
  readonly supportCognitoId?: Maybe<Scalars['String']>;
  /** The email of the support agent who issue'd this coupon */
  readonly supportEmail?: Maybe<Scalars['String']>;
  /** The identity of the coupon token. */
  readonly tokenId: Scalars['ID'];
  /** The identity of the user owning the coupon token. */
  readonly userId: Scalars['ID'];
}

export interface ICouponTokenListResponse {
  readonly __typename?: 'CouponTokenListResponse';
  /**
   * The count of elements in the response.
   * If this value is zero, there were no matching coupon tokens.
   */
  readonly count: Scalars['Int'];
  /**
   * A resume point for a subsequent call.
   * If this value is undefined or null, there are no more coupons.
   * Specify this value on a subsequent call to continue paginating through coupons.
   */
  readonly resumeAfter?: Maybe<Scalars['String']>;
  /**
   * The set of coupon tokens retrieved.
   * If this array is empty, there were no matching coupon tokens.
   */
  readonly tokens: ReadonlyArray<Maybe<ICouponToken>>;
}

export interface ICouponUserOffersFeedback {
  readonly __typename?: 'CouponUserOffersFeedback';
  /** All the feedback collected. */
  readonly offersFeedback: ReadonlyArray<Maybe<ICouponUserOffersFeedbackEntry>>;
}

export interface ICouponUserOffersFeedbackEntry {
  readonly __typename?: 'CouponUserOffersFeedbackEntry';
  /**
   * If the offers evaluated are sourced from the cart, this is the cart entry offer.
   * Otherwise, this field is null.
   */
  readonly cartEntry?: Maybe<ICartEntries>;
  /**
   * The identity of the coupon.
   * This may be an empty string in the event there is no couponId.
   */
  readonly couponId: Scalars['String'];
  /** If truthy, then this offer was included by Loyalty. */
  readonly isLoyalty?: Maybe<Scalars['Boolean']>;
  /** The stringified sanity offer data. */
  readonly offerDetails?: Maybe<Scalars['String']>;
  /** The current state of the offer, if applicable. */
  readonly offerState?: Maybe<CartOfferState>;
  /** Templated variables for loyalty offer. */
  readonly offerVariables?: Maybe<ReadonlyArray<Maybe<IOfferVariable>>>;
  /**
   * A weight for the offer, if applicable.
   * In the case of Tim Hortons Loyalty, this value may
   * be used to set priority status for the offer.
   */
  readonly rank?: Maybe<Scalars['Int']>;
  /** The eligibility of redemption for the coupon. */
  readonly redemptionEligibility: ICouponRedemptionEligibility;
  /**
   * The token identifier associated with the offer, if applicable.
   * In the case of Tim Hortons Loyalty, this identifier can be used to activate an
   * offer which is not currently active.
   */
  readonly tokenId?: Maybe<Scalars['String']>;
}

export interface ICouponValidationError {
  readonly __typename?: 'CouponValidationError';
  /** The message code for the message. */
  readonly code: Scalars['String'];
  /** The message string for the message. */
  readonly message: Scalars['String'];
  /** The type of Coupon Rule Set. */
  readonly ruleSetType: Scalars['String'];
}

export interface ICreateOtp {
  readonly __typename?: 'CreateOTP';
  /**
   * The maximum validation attempts allowed for the created OTP
   * @deprecated Use maxValidateAttempts
   */
  readonly maxLoginAttempts: Scalars['Int'];
  /** The maximum validation attempts allowed for the created OTP */
  readonly maxValidateAttempts: Scalars['Int'];
  /** Whether the login has been performed in US and requires redirection */
  readonly redirectToUS?: Maybe<Scalars['Boolean']>;
  /** The time-to-live for the one-time password, in seconds */
  readonly ttl: Scalars['Int'];
}

export interface ICreateOtpInput {
  /**
   * The email of the user requesting a One-Time Password. Only one of either
   * email or phoneNumber can be provided. One or the other is required.
   * @todo - only email is implemented at this time
   */
  readonly email?: InputMaybe<Scalars['String']>;
  /**
   * The phone number of the user requesting a One-Time Password. Only one of either
   * email or phoneNumber can be provided. One or the other is required.
   * @todo - not implemented
   */
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
  /** Requestor's platform */
  readonly platform: Platform;
  /**
   * A unique identifier to associate with the one-time password, to be provided on
   * validation attempts
   */
  readonly sessionId: Scalars['ID'];
}

export interface ICreateSmsOtp {
  readonly __typename?: 'CreateSmsOtp';
  /** The maximum validation attempts allowed for the created OTP */
  readonly maxValidateAttempts: Scalars['Int'];
  /** The time-to-live for the one-time password, in seconds */
  readonly ttl: Scalars['Int'];
}

export interface ICreateSmsOtpInput {
  /**
   * The phone number of the user requesting a One-Time Password. Only one of either
   * email or phoneNumber can be provided. One or the other is required.
   * @todo - not implemented
   */
  readonly phoneNumber: Scalars['String'];
  /** Requestor's platform */
  readonly platform: Platform;
  /**
   * A unique identifier to associate with the one-time password, to be provided on
   * validation attempts
   */
  readonly sessionId: Scalars['ID'];
}

export interface ICreditCard {
  readonly __typename?: 'CreditCard';
  /** Credit card last 4 digits */
  readonly alias: Scalars['String'];
  readonly billingAddress?: Maybe<IBillingAddress>;
  /** Card Provider */
  readonly cardType: Scalars['String'];
  /** Two digit expiry month */
  readonly expiryMonth: Scalars['String'];
  /** Two digit expiry year */
  readonly expiryYear: Scalars['String'];
  readonly fullName: Scalars['String'];
  /**
   * First Data credit card token.
   * Should be a numeric string, whose last 4 digits match the credit card alias.
   */
  readonly panToken?: Maybe<Scalars['String']>;
}

export interface ICreditCardMetadataInput {
  /**
   * First 6 digits of credit card.
   * Required for anonymous payment.
   * @constraint(pattern: "^[0-9]{6}$")
   */
  readonly ccBin?: InputMaybe<Scalars['String']>;
  /** Credit card 2 digit expiry month */
  readonly ccExpiryMonth?: InputMaybe<Scalars['String']>;
  /** Credit card 2 digit expiry year */
  readonly ccExpiryYear?: InputMaybe<Scalars['String']>;
  /**
   * Last 6 digits of credit card.
   * Required for anonymous payment.
   * @constraint(pattern: "^[0-9]{4}$")
   */
  readonly ccLast4?: InputMaybe<Scalars['String']>;
  /** The payment provider type eg. (VISA/MASTERCARD/DISCOVER/AMEX) */
  readonly creditType?: InputMaybe<CartPaymentCardType>;
}

export interface ICrmAttributes {
  readonly source?: InputMaybe<Scalars['String']>;
}

/**  USD/840 CAD/124 */
export interface ICurrencyCode {
  readonly __typename?: 'CurrencyCode';
  readonly code: Scalars['String'];
  readonly number: Scalars['Int'];
}

export interface IDateSpan {
  readonly __typename?: 'DateSpan';
  readonly endDate?: Maybe<Scalars['String']>;
  readonly startDate?: Maybe<Scalars['String']>;
}

export interface IDay {
  readonly __typename?: 'Day';
  readonly close?: Maybe<Scalars['String']>;
  readonly open?: Maybe<Scalars['String']>;
}

export enum DayOfTheWeek {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export interface IDayPart {
  readonly __typename?: 'DayPart';
  readonly displayName?: Maybe<Scalars['String']>;
  readonly hours?: Maybe<IOperatingHours>;
  readonly key?: Maybe<Scalars['String']>;
}

export interface IDeleteAccountInput {
  readonly accountIdentifier?: InputMaybe<Scalars['String']>;
  readonly fdAccountId?: InputMaybe<Scalars['String']>;
}

/** Delete an account (payment method) from the current user */
export interface IDeletePaymentMethodInput {
  /**
   * Represents a saved funding source. (i.e. fdAccountId or recurringDetailReference)
   * Use this field instead.
   */
  readonly storedPaymentMethodId: Scalars['String'];
}

export interface IDeletePaymentMethodPayload {
  readonly __typename?: 'DeletePaymentMethodPayload';
  readonly success: Scalars['Boolean'];
}

export interface IDelivery {
  readonly __typename?: 'Delivery';
  readonly assignedFleetName?: Maybe<Scalars['String']>;
  readonly baseDeliveryFeeCents?: Maybe<Scalars['Int']>;
  readonly cancellation?: Maybe<IDeliveryCancellation>;
  readonly customerId?: Maybe<Scalars['String']>;
  readonly deliverySurchargeFeeCents?: Maybe<Scalars['Int']>;
  readonly driver?: Maybe<IDeliveryDriver>;
  readonly dropoff: IDeliveryWaypoint;
  readonly estimateId?: Maybe<Scalars['String']>;
  readonly expiration?: Maybe<Scalars['String']>;
  readonly feeCents: Scalars['Int'];
  readonly feeDiscountCents?: Maybe<Scalars['Int']>;
  readonly fleetId?: Maybe<Scalars['String']>;
  readonly geographicalFeeCents?: Maybe<Scalars['Int']>;
  readonly instructions?: Maybe<Scalars['String']>;
  readonly pickup: IDeliveryWaypoint;
  readonly quoteId?: Maybe<Scalars['String']>;
  readonly quotedFeeCents?: Maybe<Scalars['Int']>;
  readonly serviceFeeCents?: Maybe<Scalars['Int']>;
  readonly shareUuid?: Maybe<Scalars['String']>;
  readonly smallCartFeeCents?: Maybe<Scalars['Int']>;
  readonly status: DeliveryStatus;
  readonly task?: Maybe<IDeliveryTaskDetails>;
  readonly tipCents?: Maybe<Scalars['Int']>;
  readonly userId?: Maybe<Scalars['String']>;
}

export interface IDeliveryAddress {
  readonly __typename?: 'DeliveryAddress';
  /** Address Line limited to 150 chars */
  readonly addressLine1: Scalars['String'];
  /** Address Line 2 limited to 150 chars */
  readonly addressLine2?: Maybe<Scalars['String']>;
  /** Alias to identify an address e.g home, office etc */
  readonly alias?: Maybe<Scalars['String']>;
  /** city name limited to 150 chars */
  readonly city: Scalars['String'];
  /** isoCountryCode */
  readonly country?: Maybe<IsoCountryCode>;
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  /** 10 digit phone number spaces don't matter */
  readonly phoneNumber: Scalars['String'];
  readonly route?: Maybe<Scalars['String']>;
  /** state abbreviation FL, GA, etc */
  readonly state?: Maybe<Scalars['String']>;
  readonly streetNumber?: Maybe<Scalars['String']>;
  /** zipCode 5-10 digits no spaces */
  readonly zip?: Maybe<Scalars['String']>;
}

export interface IDeliveryAddressResponse {
  readonly __typename?: 'DeliveryAddressResponse';
  readonly deliveryAddresses?: Maybe<ReadonlyArray<IDeliveryAddress>>;
}

export interface IDeliveryCancellation {
  readonly __typename?: 'DeliveryCancellation';
  readonly description?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['Int']>;
  readonly text?: Maybe<Scalars['String']>;
}

export interface IDeliveryDriver {
  readonly __typename?: 'DeliveryDriver';
  readonly name?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly profileImageUrl?: Maybe<Scalars['String']>;
}

export enum DeliveryMethod {
  CONTACTLESS = 'CONTACTLESS'
}

export interface IDeliveryRestaurant {
  readonly __typename?: 'DeliveryRestaurant';
  /** Restaurant delivery surcharge fee cents. */
  readonly deliverySurchargeFeeCents?: Maybe<Scalars['Int']>;
  /** Next available delivery time for store */
  readonly nextEarliestOpen?: Maybe<Scalars['String']>;
  /** Status of delivery order */
  readonly quote?: Maybe<DeliveryStatus>;
  /** the quoteId related to the current delivery restaurant */
  readonly quoteId?: Maybe<Scalars['String']>;
  /** Extended restaurant data containing all fields from Sanity + Dynamo */
  readonly restaurant?: Maybe<IRestaurantNode>;
  /** Status of delivery store */
  readonly storeStatus: DeliveryStoreStatus;
}

export enum DeliveryStatus {
  DRIVER_ASSIGNED = 'DRIVER_ASSIGNED',
  DRIVER_AT_CUSTOMER = 'DRIVER_AT_CUSTOMER',
  DRIVER_AT_STORE = 'DRIVER_AT_STORE',
  DRIVER_STARTING = 'DRIVER_STARTING',
  DRIVER_UNASSIGNED = 'DRIVER_UNASSIGNED',
  ORDER_ABANDONED = 'ORDER_ABANDONED',
  ORDER_CANCELLED = 'ORDER_CANCELLED',
  ORDER_CREATED = 'ORDER_CREATED',
  ORDER_DROPPED_OFF = 'ORDER_DROPPED_OFF',
  ORDER_ERROR = 'ORDER_ERROR',
  ORDER_PICKED_UP = 'ORDER_PICKED_UP',
  ORDER_TIMEOUT = 'ORDER_TIMEOUT',
  QUOTE_ERROR = 'QUOTE_ERROR',
  QUOTE_REQUESTED = 'QUOTE_REQUESTED',
  QUOTE_SUCCESSFUL = 'QUOTE_SUCCESSFUL',
  QUOTE_UNAVAILABLE = 'QUOTE_UNAVAILABLE'
}

export enum DeliveryStoreStatus {
  CLOSED = 'CLOSED',
  NO_DELIVERY = 'NO_DELIVERY',
  OPEN = 'OPEN'
}

export interface IDeliveryTaskDetails {
  readonly __typename?: 'DeliveryTaskDetails';
  readonly createdAt?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
  readonly uuid?: Maybe<Scalars['String']>;
}

export interface IDeliveryWaypoint {
  readonly __typename?: 'DeliveryWaypoint';
  readonly addressLine1: Scalars['String'];
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly afterTime?: Maybe<Scalars['String']>;
  readonly arrivalTime?: Maybe<Scalars['String']>;
  readonly beforeTime?: Maybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly country?: Maybe<Scalars['String']>;
  readonly deliveryMethod?: Maybe<DeliveryMethod>;
  readonly id?: Maybe<Scalars['String']>;
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  readonly phoneNumber: Scalars['String'];
  readonly shareUuid?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly trackingUrl?: Maybe<Scalars['String']>;
  readonly zip?: Maybe<Scalars['String']>;
}

export interface IDeliveryWaypointInput {
  readonly addressLine1: Scalars['String'];
  readonly addressLine2?: InputMaybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly country?: InputMaybe<Scalars['String']>;
  readonly deliveryMethod?: InputMaybe<DeliveryMethod>;
  readonly latitude?: InputMaybe<Scalars['Float']>;
  readonly longitude?: InputMaybe<Scalars['Float']>;
  readonly phoneNumber: Scalars['String'];
  readonly route?: InputMaybe<Scalars['String']>;
  /** flag to determine wether or not the waypoint should be saved */
  readonly shouldSave?: InputMaybe<Scalars['Boolean']>;
  readonly state?: InputMaybe<Scalars['String']>;
  readonly streetNumber?: InputMaybe<Scalars['String']>;
  readonly zip?: InputMaybe<Scalars['String']>;
}

export interface IDiscount {
  readonly __typename?: 'Discount';
  readonly name?: Maybe<DiscountTypes>;
  /** values are represented as positive integers in cents */
  readonly value?: Maybe<Scalars['Int']>;
}

export enum DiscountTypes {
  ALL_DISCOUNTS = 'ALL_DISCOUNTS',
  COMBO_AND_OFFER_DISCOUNTS = 'COMBO_AND_OFFER_DISCOUNTS',
  REWARDS_DISCOUNTS = 'REWARDS_DISCOUNTS'
}

export interface IDonation {
  readonly __typename?: 'Donation';
  readonly id?: Maybe<Scalars['String']>;
  /** Name of donation */
  readonly name?: Maybe<Scalars['String']>;
  /** Total are represented as positive integers in cents */
  readonly totalCents?: Maybe<Scalars['Int']>;
}

export enum DurationPeriod {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

/**
 * https://relay.dev/graphql/connections.htm#sec-Edge-Types
 *
 * An edge provides an association between a node and it's associated cursor.
 */
export interface IEdge {
  readonly cursor: Scalars['String'];
  readonly node: INode;
}

/** All details necessary to encrypt CC information for First Data */
export interface IEncryptionDetails {
  readonly __typename?: 'EncryptionDetails';
  /**
   * Encryption algorithm.
   *
   * You should be able to ignore this value, as we only support 'RSA/NONE/PKCS1Padding'
   */
  readonly algorithm?: Maybe<Scalars['String']>;
  /** Access token for accessing First Data API. Limited TTL. */
  readonly fdAccessToken: Scalars['String'];
  /** RBI specific API key for accessing First Data */
  readonly fdApiKey: Scalars['String'];
  /** First data customer ID. Derived from provided authentication header. */
  readonly fdCustomerId?: Maybe<Scalars['String']>;
  /** Public key for performing RSA encryption on specific First Data requests */
  readonly fdPublicKey: Scalars['String'];
  /** Time until public key expires (milliseconds?) */
  readonly fdPublicKeyExpiresInSeconds: Scalars['Int'];
  /** ISO datetime for when public key was issued */
  readonly fdPublicKeyIssuesOn: Scalars['String'];
}

export interface IEntity {
  readonly __typename?: 'Entity';
  readonly calories?: Maybe<ICalories>;
  readonly id: Scalars['String'];
  readonly isAvailable?: Maybe<Scalars['Boolean']>;
  readonly options?: Maybe<ReadonlyArray<IOption>>;
  readonly price?: Maybe<IPrice>;
}

export interface IEvaluateIncentivesInput {
  readonly appliedIncentives: ReadonlyArray<IPromotionInput>;
  readonly cartEntries?: InputMaybe<ReadonlyArray<IRbiCartEntryInput>>;
  readonly paymentMethod?: InputMaybe<PaymentMethod>;
  readonly serviceMode?: InputMaybe<ServiceMode>;
  readonly storeId?: InputMaybe<Scalars['String']>;
  readonly subtotalAmount?: InputMaybe<Scalars['Int']>;
}

/**
 * DEPRECATED
 * Incentive evaluation errors are now provided as part of the incentive data.
 */
export interface IEvaluatedIncentives {
  readonly __typename?: 'EvaluatedIncentives';
  readonly invalidOffers: ReadonlyArray<IInvalidIncentives>;
  readonly invalidRewards: ReadonlyArray<IInvalidIncentives>;
}

export interface IExchangeOtpCodeForCredentialsInput {
  /** The code associated with the user's current OTP, for validation */
  readonly code: Scalars['String'];
  /**
   * The email of the user requesting a One-Time Password. Optional, one of either
   * email or phoneNumber must always be provided
   * @todo - only email is implemented at this time
   */
  readonly email?: InputMaybe<Scalars['String']>;
  /**
   * The phone number of the user logging in with a One-Time Password. Optional, one of either
   * email or phoneNumber must always be provided.
   * @todo - not implemented
   */
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
  /** The unique identifier provided when the OTP was created */
  readonly sessionId: Scalars['ID'];
}

export interface IExpirationBucket {
  readonly __typename?: 'ExpirationBucket';
  readonly expirationDate: Scalars['String'];
  readonly pointsToExpire: Scalars['Int'];
}

export interface IExternalIdentifier {
  readonly __typename?: 'ExternalIdentifier';
  readonly type: Scalars['String'];
  readonly value: Scalars['String'];
}

export interface IExternalIdentifiers {
  readonly __typename?: 'ExternalIdentifiers';
  readonly source?: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly value: Scalars['String'];
}

export interface IFavorite {
  readonly __typename?: 'Favorite';
  readonly createdAt?: Maybe<Scalars['String']>;
  readonly entries?: Maybe<ReadonlyArray<Maybe<ICartEntries>>>;
  readonly favoriteId?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly ref?: Maybe<Scalars['String']>;
  readonly updatedAt?: Maybe<Scalars['String']>;
}

export interface IFavoriteInput {
  readonly entries?: InputMaybe<ReadonlyArray<InputMaybe<ICartEntryInput>>>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly ref?: InputMaybe<Scalars['String']>;
}

export interface IFavoriteList {
  readonly __typename?: 'FavoriteList';
  readonly count?: Maybe<Scalars['Int']>;
  readonly favorites?: Maybe<ReadonlyArray<Maybe<IFavorite>>>;
  readonly resumeAfter?: Maybe<Scalars['String']>;
}

export interface IFavoriteStore {
  readonly __typename?: 'FavoriteStore';
  /** Favorite Store ID */
  readonly storeId?: Maybe<Scalars['String']>;
  /** Favorite Store Number */
  readonly storeNumber?: Maybe<Scalars['String']>;
}

export interface IFavoriteStoreInput {
  readonly storeId?: InputMaybe<Scalars['String']>;
  readonly storeNumber: Scalars['String'];
}

export interface IFees {
  readonly __typename?: 'Fees';
  readonly name?: Maybe<Scalars['String']>;
  readonly priceCents?: Maybe<Scalars['Int']>;
  readonly quantity?: Maybe<Scalars['Int']>;
  readonly totalCents?: Maybe<Scalars['Int']>;
}

export enum FilterRestaurantType {
  FAVORITE = 'FAVORITE',
  NEARBY = 'NEARBY',
  RECENT = 'RECENT'
}

export interface IFirstDataPayment {
  /**
   * Represents a saved funding source. (i.e. fdAccountId or recurringDetailReference)
   * If passed this will be used to process payment. Either accountIdentifier or fdNonce
   * and fdAccessToken should be passed.
   */
  readonly accountIdentifier?: InputMaybe<Scalars['String']>;
  /** Valid access token for accessing First Data API */
  readonly fdAccessToken?: InputMaybe<Scalars['String']>;
  /**
   * Nonce retrieved from First Data. Sale will be performed with the payment
   * method associated with the nonce. If accountIdentifier is not passed this must
   * be passed.
   */
  readonly fdNonce?: InputMaybe<Scalars['String']>;
  /** Whether to store payment method or not */
  readonly storePaymentMethod?: InputMaybe<Scalars['Boolean']>;
}

export enum FrontendIntegration {
  CHASE_ORBITAL = 'CHASE_ORBITAL',
  FIRSTDATA = 'FIRSTDATA'
}

export interface IFulfillmentDetails {
  readonly __typename?: 'FulfillmentDetails';
  readonly pickupPin?: Maybe<Scalars['String']>;
  readonly pickupReady?: Maybe<Scalars['Boolean']>;
  readonly pickupType?: Maybe<FulfillmentPickupType>;
}

export enum FulfillmentPickupType {
  BEEPER = 'BEEPER',
  LOCKER = 'LOCKER'
}

export interface IFutureServiceHours {
  readonly __typename?: 'FutureServiceHours';
  readonly serviceMode?: Maybe<ServiceMode>;
  readonly timeSlots?: Maybe<ReadonlyArray<Maybe<IRestaurantTimeSlot>>>;
}

export interface IGetOrderSelectionByMultipleType {
  readonly key: Scalars['String'];
  readonly ostType: OstType;
}

/** A First Data gift card account (prepaid payment method) */
export interface IGiftAccount {
  readonly __typename?: 'GiftAccount';
  /** First Data account ID */
  readonly fdAccountId: Scalars['String'];
  readonly prepaid: IGiftCard;
}

/** First Data prepaid account */
export interface IGiftCard {
  readonly __typename?: 'GiftCard';
  /** last 4 digits of prepaid gift card number */
  readonly alias: Scalars['String'];
  readonly cardNumber: Scalars['String'];
  /** amount card was loaded with (cents) upon creation */
  readonly currentBalance?: Maybe<Scalars['Int']>;
  /** Two digit expiry month */
  readonly expiryMonth: Scalars['String'];
  /** Two digit expiry year */
  readonly expiryYear: Scalars['String'];
  readonly feFormattedCurrentBalance?: Maybe<Scalars['Int']>;
  /** Use to generate barcode */
  readonly shuffledCardNumber: Scalars['String'];
}

/** Details from Google Pay used for Google Pay funding. */
export interface IGooglePay {
  /** Data of the payment method used for Google Pay. */
  readonly PaymentMethodData?: InputMaybe<IPaymentMethodData>;
  /** Billing address from Google Pay */
  readonly billingAddress: IBillingAddressInput;
  /** Country Code from user account */
  readonly country: CountryCode;
  /** Signature message passed through from Google Pay */
  readonly data: Scalars['String'];
  /** Formatted billing address from Google Pay */
  readonly formatted: Scalars['String'];
  /** Encrypted token including signature and signature message as passed through from Google Pay. */
  readonly paymentData?: InputMaybe<Scalars['String']>;
  readonly primary: Scalars['Boolean'];
  /** Signature as passed through from Google Pay */
  readonly signature: Scalars['String'];
  readonly type: Scalars['String'];
  readonly version: Scalars['String'];
}

export interface IGooglePayPaymentConfig {
  readonly __typename?: 'GooglePayPaymentConfig';
  readonly prepaidMerchantId?: Maybe<Scalars['String']>;
  readonly schemeMerchantId?: Maybe<Scalars['String']>;
}

export interface IIdAndPay {
  readonly __typename?: 'IdAndPay';
  readonly enabled?: Maybe<Scalars['Boolean']>;
  readonly forterDeviceId?: Maybe<Scalars['String']>;
  readonly forterTokenCookie?: Maybe<Scalars['String']>;
  readonly storedPaymentMethodId?: Maybe<Scalars['String']>;
}

export interface IIdAndPayInput {
  readonly enabled: Scalars['Boolean'];
  readonly forterDeviceId?: InputMaybe<Scalars['String']>;
  readonly forterTokenCookie?: InputMaybe<Scalars['String']>;
  readonly storedPaymentMethodId?: InputMaybe<Scalars['String']>;
}

export interface IIdAndPayUpdateResponse {
  readonly __typename?: 'IdAndPayUpdateResponse';
  readonly enabled?: Maybe<Scalars['Boolean']>;
}

export interface IInRestaurantIncentive {
  readonly __typename?: 'InRestaurantIncentive';
  /** Loyalty engine ID of the incentive */
  readonly id: Scalars['ID'];
  /** Type of incentive */
  readonly type: InRestaurantIncentiveType;
}

export interface IInRestaurantIncentiveInput {
  /** The presentational description of the incentive item */
  readonly description?: InputMaybe<Scalars['String']>;
  /** Specifies incentive should apply a cart level discount */
  readonly discount?: InputMaybe<ICartDiscountInput>;
  /** Loyalty engine ID of the incentive */
  readonly id: Scalars['ID'];
  /** List of incentive's vendor configs */
  readonly incentiveVendorConfigs?: InputMaybe<ReadonlyArray<IRbiVendorConfigsInput>>;
  /** The presentational name of the incentive item */
  readonly name?: InputMaybe<Scalars['String']>;
  /** The offer short code */
  readonly offerCode?: InputMaybe<Scalars['String']>;
  /** Type of incentive */
  readonly type: InRestaurantIncentiveType;
}

export enum InRestaurantIncentiveType {
  LEGACY_OFFER = 'LEGACY_OFFER',
  OFFER = 'OFFER',
  REWARD = 'REWARD'
}

export interface IInRestaurantOrderLineItem {
  /**
   * ID of incentive (e.g. offer / reward / promotion)
   * Should not be sent if line item is not in the loyalty engine
   */
  readonly incentive?: InputMaybe<IInRestaurantIncentiveInput>;
  /** The offer 'short code' */
  readonly incentivePlu?: InputMaybe<Scalars['String']>;
  /** CMS id */
  readonly productId?: InputMaybe<Scalars['String']>;
  /** Quantity of items */
  readonly quantity: Scalars['Int'];
  /** A unique id for internal reference purposes */
  readonly referenceId: Scalars['ID'];
  /** Restaurant vendorConfigs */
  readonly vendorConfigs: IRbiVendorConfigsInput;
}

export interface IInRestaurantOrderLineItemType {
  readonly __typename?: 'InRestaurantOrderLineItemType';
  /**
   * ID of incentive (e.g. offer / reward / promotion)
   * Should not be sent if line item is not in the loyalty engine
   */
  readonly incentive?: Maybe<IInRestaurantIncentive>;
  /** Quantity of items */
  readonly quantity: Scalars['Int'];
  /** A unique id for internal reference purposes */
  readonly referenceId: Scalars['ID'];
  /** Restaurant vendorConfigs */
  readonly vendorConfigs: IRbiVendorConfigs;
}

/**
 * DEPRECATED
 * Incentive evaluation errors are now provided as part of the incentive data.
 */
export interface IInvalidIncentives {
  readonly __typename?: 'InvalidIncentives';
  readonly errors: ReadonlyArray<IRuleConditionEvaluation>;
  readonly id: Scalars['ID'];
}

export enum IsoCountryCode {
  ATA = 'ATA',
  CAN = 'CAN',
  CHE = 'CHE',
  DEU = 'DEU',
  GBR = 'GBR',
  KOR = 'KOR',
  NZL = 'NZL',
  USA = 'USA',
  ZAF = 'ZAF'
}

export enum Language {
  EN = 'EN',
  ES = 'ES',
  FR = 'FR'
}

export enum Locale {
  DE = 'de',
  EN = 'en',
  FR = 'fr',
  IT = 'it'
}

/** Deprecated */
export interface ILoyaltyActivateAlohaRewardResponse {
  readonly __typename?: 'LoyaltyActivateAlohaRewardResponse';
  readonly alohaRewardBonusPlanId: Scalars['Int'];
  readonly rewardCategorySanityId: Scalars['String'];
  readonly rewardPointCost: Scalars['Int'];
  readonly rewardSanityId: Scalars['String'];
  /** User balance after reward activation and balance sync with Aloha. */
  readonly userPointBalance: Scalars['Int'];
}

/** Deprecated */
export interface ILoyaltyAlohaActiveReward {
  readonly __typename?: 'LoyaltyAlohaActiveReward';
  readonly pointCost: Scalars['Int'];
  readonly rewardsCount: Scalars['Int'];
  readonly sanityId: Scalars['String'];
}

export interface ILoyaltyAssociateGuestUserResponse {
  readonly __typename?: 'LoyaltyAssociateGuestUserResponse';
  /** Date and time when the the identifier got activated */
  readonly activationDateTime: Scalars['String'];
  readonly guestBalance: Scalars['Int'];
  /** Date and time when the linking between the identifier and the loyalty user happened */
  readonly linkingDateTime: Scalars['String'];
  readonly totalBalance: Scalars['Int'];
}

export interface ILoyaltyBaseIncentive {
  readonly cartRequirements?: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ILoyaltyCartRequirement>>>>>;
  readonly coolDown?: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['String'];
  readonly endDate: Scalars['String'];
  readonly endTime?: Maybe<Scalars['String']>;
  readonly errors?: Maybe<ReadonlyArray<ILoyaltyRuleConditionEvaluation>>;
  readonly externalIdentifiers?: Maybe<ReadonlyArray<Maybe<ILoyaltyExternalIdentifiers>>>;
  readonly firstOrder?: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['LoyaltyID'];
  readonly maxRedemptionsDuration?: Maybe<LoyaltyDurationPeriod>;
  readonly maxRedemptionsLimit?: Maybe<Scalars['Int']>;
  readonly minimumSpend?: Maybe<Scalars['Int']>;
  readonly name: Scalars['String'];
  readonly paymentMethod?: Maybe<LoyaltyPaymentMethod>;
  readonly restaurantGroups?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly sanityId?: Maybe<Scalars['String']>;
  readonly serviceModes?: Maybe<ReadonlyArray<Maybe<LoyaltyServiceMode>>>;
  readonly startDate: Scalars['String'];
  readonly startTime?: Maybe<Scalars['String']>;
  readonly storeRestrictions?: Maybe<ILoyaltyStoreRestrictions>;
  readonly updatedAt: Scalars['String'];
  readonly userBirthdayDuration?: Maybe<LoyaltyBirthdayDuration>;
  readonly userEnrollment?: Maybe<ILoyaltyDateSpan>;
  readonly validDaysOfTheWeek?: Maybe<ReadonlyArray<LoyaltyDayOfTheWeek>>;
}

export interface ILoyaltyBenefit {
  readonly type: LoyaltyBenefitType;
}

export interface ILoyaltyBenefitReference extends ILoyaltyBenefit {
  readonly __typename?: 'LoyaltyBenefitReference';
  readonly type: LoyaltyBenefitType;
  readonly value: Scalars['String'];
}

export interface ILoyaltyBenefitSwap extends ILoyaltyBenefit {
  readonly __typename?: 'LoyaltyBenefitSwap';
  readonly type: LoyaltyBenefitType;
  readonly value: ILoyaltySwap;
}

export enum LoyaltyBenefitType {
  REFERENCE = 'REFERENCE',
  SWAP = 'SWAP'
}

export enum LoyaltyBirthdayDuration {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK'
}

export interface ILoyaltyCardTransaction {
  readonly __typename?: 'LoyaltyCardTransaction';
  /** The taxes of the basket. */
  readonly basketTaxes?: Maybe<Scalars['Int']>;
  /** The total of the basket including taxes. */
  readonly basketTotal?: Maybe<Scalars['Int']>;
  /** Bonus points earned */
  readonly bonusPoints?: Maybe<Scalars['Int']>;
  /** City of store where loyalty was redeemed */
  readonly city?: Maybe<Scalars['String']>;
  /** The total amount discounted */
  readonly discountAmount?: Maybe<Scalars['Int']>;
  readonly expiredPoints?: Maybe<ILoyaltyExpiredPoints>;
  /** True if this visit was given from customer support. False otherwise. */
  readonly isCustomerServiceVisit?: Maybe<Scalars['Boolean']>;
  /** True if the transaction counted as a visit. */
  readonly isVisit?: Maybe<Scalars['Boolean']>;
  /** Offer that was associated with the transaction */
  readonly offerId?: Maybe<Scalars['Int']>;
  /** Loyalty points earned from transaction */
  readonly pointsEarned?: Maybe<Scalars['Int']>;
  /** Loyalty points used from transaction */
  readonly pointsUsed?: Maybe<Scalars['Int']>;
  /** True if this transaction earned a rewards */
  readonly rewardEarned?: Maybe<Scalars['Boolean']>;
  /** Reward redeemed upon transaction */
  readonly rewardRedeemed?: Maybe<Scalars['Boolean']>;
  /** State or Province of store where loyalty was redeemed */
  readonly stateOrProvince?: Maybe<Scalars['String']>;
  /** Store ID where loyalty was redeemed */
  readonly storeId?: Maybe<Scalars['String']>;
  /**
   * Tag string indicating the source of the rewards earned
   * e.g. FREQUENCY_CHALLENGE_COMPLETE, HOCKEY_1
   */
  readonly tag?: Maybe<Scalars['String']>;
  /** The time of the transaction in UTC. */
  readonly timestamp?: Maybe<Scalars['String']>;
  /** A unique identifier for transaction */
  readonly transactionId?: Maybe<Scalars['String']>;
  /**
   * A tag for the type of visit. This will be null for normal transactions.
   * When a visit or reward is issued through the IssueVisit/IssueReward endpoints
   * a VisitType may be specified that will surface in this field
   */
  readonly visitType?: Maybe<Scalars['String']>;
  /**
   * True if the discount was active or available for this transaction.
   * False if no discount was applied.
   */
  readonly wasDiscountActive?: Maybe<Scalars['Boolean']>;
}

export interface ILoyaltyCartDiscount {
  readonly __typename?: 'LoyaltyCartDiscount';
  readonly type: LoyaltyCartDiscountType;
  readonly value: Scalars['Float'];
}

export interface ILoyaltyCartDiscountInput {
  readonly type: LoyaltyCartDiscountType;
  readonly value: Scalars['Float'];
}

export enum LoyaltyCartDiscountType {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE'
}

export interface ILoyaltyCartRequirement {
  readonly __typename?: 'LoyaltyCartRequirement';
  readonly id: Scalars['String'];
  readonly quantity: Scalars['Int'];
}

export interface ILoyaltyCouponResponse extends ICouponResponse {
  readonly __typename?: 'LoyaltyCouponResponse';
  readonly code: Scalars['String'];
  readonly configId?: Maybe<Scalars['String']>;
  readonly isRedeemed?: Maybe<Scalars['Boolean']>;
  readonly isValid: Scalars['Boolean'];
  readonly message: Scalars['String'];
  readonly personalizedOfferId?: Maybe<Scalars['String']>;
  readonly reason?: Maybe<Scalars['String']>;
  readonly shouldRedeem?: Maybe<Scalars['Boolean']>;
}

export interface ILoyaltyCreateOrderSelectionInput {
  /** Unique engine identifier for the user this order selection belongs to */
  readonly loyaltyId: Scalars['String'];
  /** The incentives selected to be redeemed w/ this order selection */
  readonly selectedIncentives: ReadonlyArray<ILoyaltyOrderSelectionIncentiveInput>;
  /** The store or location that this order selection will be used at */
  readonly storeId?: InputMaybe<Scalars['String']>;
  /** The classification of order selection - otp | lyid */
  readonly type: LoyaltyOrderSelectionType;
}

export interface ILoyaltyCreateOrderSelectionResponse {
  readonly __typename?: 'LoyaltyCreateOrderSelectionResponse';
  readonly key: Scalars['String'];
  readonly orderSelection: ILoyaltyOrderSelection;
}

export interface ILoyaltyDateSpan {
  readonly __typename?: 'LoyaltyDateSpan';
  readonly endDate?: Maybe<Scalars['String']>;
  readonly startDate?: Maybe<Scalars['String']>;
}

export enum LoyaltyDayOfTheWeek {
  FRIDAY = 'FRIDAY',
  MONDAY = 'MONDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
  THURSDAY = 'THURSDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY'
}

export interface ILoyaltyDeleteOrderSelectionInput {
  /** The primary identifier for this order selection */
  readonly key: Scalars['String'];
  /** Unique engine identifier for the user this order selection belongs to */
  readonly loyaltyId: Scalars['String'];
  /** The classification of order selection - otp | lyid */
  readonly type: LoyaltyOrderSelectionType;
}

export enum LoyaltyDurationPeriod {
  DAY = 'DAY',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  YEAR = 'YEAR'
}

export interface ILoyaltyEvaluateIncentivesInput {
  readonly appliedIncentives: ReadonlyArray<ILoyaltyPromotionInput>;
  readonly cartEntries?: InputMaybe<ReadonlyArray<ILoyaltyRbiCartEntryInput>>;
  readonly paymentMethod?: InputMaybe<LoyaltyPaymentMethod>;
  readonly serviceMode?: InputMaybe<LoyaltyServiceMode>;
  readonly storeId?: InputMaybe<Scalars['String']>;
  readonly subtotalAmount?: InputMaybe<Scalars['Int']>;
}

/**
 * DEPRECATED
 * Incentive evaluation errors are now provided as part of the incentive data.
 */
export interface ILoyaltyEvaluatedIncentives {
  readonly __typename?: 'LoyaltyEvaluatedIncentives';
  readonly invalidOffers: ReadonlyArray<ILoyaltyInvalidIncentives>;
  readonly invalidRewards: ReadonlyArray<ILoyaltyInvalidIncentives>;
}

export interface ILoyaltyExpirationBucket {
  readonly __typename?: 'LoyaltyExpirationBucket';
  readonly expirationDate: Scalars['String'];
  readonly pointsToExpire: Scalars['Int'];
}

export interface ILoyaltyExpiredPoints {
  readonly __typename?: 'LoyaltyExpiredPoints';
  /** Loyalty card barcode */
  readonly barcode?: Maybe<Scalars['String']>;
  readonly expirationDate?: Maybe<Scalars['String']>;
  readonly points?: Maybe<Scalars['Int']>;
  readonly ttl?: Maybe<Scalars['String']>;
}

export interface ILoyaltyExternalIdentifier {
  readonly __typename?: 'LoyaltyExternalIdentifier';
  readonly type: Scalars['String'];
  readonly value: Scalars['String'];
}

export interface ILoyaltyExternalIdentifiers {
  readonly __typename?: 'LoyaltyExternalIdentifiers';
  readonly source?: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly value: Scalars['String'];
}

export interface ILoyaltyGetOrderSelectionByMultipleType {
  readonly key: Scalars['String'];
  readonly ostType: LoyaltyOstType;
}

export interface ILoyaltyIdAndPay {
  readonly __typename?: 'LoyaltyIdAndPay';
  readonly enabled?: Maybe<Scalars['Boolean']>;
  readonly forterDeviceId?: Maybe<Scalars['String']>;
  readonly forterTokenCookie?: Maybe<Scalars['String']>;
  readonly storedPaymentMethodId?: Maybe<Scalars['String']>;
}

export interface ILoyaltyIdAndPayInput {
  readonly enabled: Scalars['Boolean'];
  readonly forterDeviceId?: InputMaybe<Scalars['String']>;
  readonly forterTokenCookie?: InputMaybe<Scalars['String']>;
  readonly storedPaymentMethodId?: InputMaybe<Scalars['String']>;
}

export interface ILoyaltyIdAndPayUpdateResponse {
  readonly __typename?: 'LoyaltyIdAndPayUpdateResponse';
  readonly enabled?: Maybe<Scalars['Boolean']>;
}

export interface ILoyaltyInRestaurantIncentive {
  readonly __typename?: 'LoyaltyInRestaurantIncentive';
  /** Loyalty engine ID of the incentive */
  readonly id: Scalars['LoyaltyID'];
  /** Type of incentive */
  readonly type: LoyaltyInRestaurantIncentiveType;
}

export interface ILoyaltyInRestaurantIncentiveInput {
  /** The presentational description of the incentive item */
  readonly description?: InputMaybe<Scalars['String']>;
  /** Specifies incentive should apply a cart level discount */
  readonly discount?: InputMaybe<ILoyaltyCartDiscountInput>;
  /** Loyalty engine ID of the incentive */
  readonly id: Scalars['LoyaltyID'];
  /** List of incentive's vendor configs */
  readonly incentiveVendorConfigs?: InputMaybe<ReadonlyArray<ILoyaltyRbiVendorConfigsInput>>;
  /** The presentational name of the incentive item */
  readonly name?: InputMaybe<Scalars['String']>;
  /** The offer short code */
  readonly offerCode?: InputMaybe<Scalars['String']>;
  /** Type of incentive */
  readonly type: LoyaltyInRestaurantIncentiveType;
}

export enum LoyaltyInRestaurantIncentiveType {
  LEGACY_OFFER = 'LEGACY_OFFER',
  OFFER = 'OFFER',
  REWARD = 'REWARD'
}

export interface ILoyaltyInRestaurantOrderLineItem {
  /**
   * ID of incentive (e.g. offer / reward / promotion)
   * Should not be sent if line item is not in the loyalty engine
   */
  readonly incentive?: InputMaybe<ILoyaltyInRestaurantIncentiveInput>;
  /** The offer 'short code' */
  readonly incentivePlu?: InputMaybe<Scalars['String']>;
  /** CMS id */
  readonly productId?: InputMaybe<Scalars['String']>;
  /** Quantity of items */
  readonly quantity: Scalars['Int'];
  /** A unique id for internal reference purposes */
  readonly referenceId: Scalars['LoyaltyID'];
  /** Restaurant vendorConfigs */
  readonly vendorConfigs: ILoyaltyRbiVendorConfigsInput;
}

export interface ILoyaltyInRestaurantOrderLineItemType {
  readonly __typename?: 'LoyaltyInRestaurantOrderLineItemType';
  /**
   * ID of incentive (e.g. offer / reward / promotion)
   * Should not be sent if line item is not in the loyalty engine
   */
  readonly incentive?: Maybe<ILoyaltyInRestaurantIncentive>;
  /** Quantity of items */
  readonly quantity: Scalars['Int'];
  /** A unique id for internal reference purposes */
  readonly referenceId: Scalars['LoyaltyID'];
  /** Restaurant vendorConfigs */
  readonly vendorConfigs: ILoyaltyRbiVendorConfigs;
}

/**
 * DEPRECATED
 * Incentive evaluation errors are now provided as part of the incentive data.
 */
export interface ILoyaltyInvalidIncentives {
  readonly __typename?: 'LoyaltyInvalidIncentives';
  readonly errors: ReadonlyArray<ILoyaltyRuleConditionEvaluation>;
  readonly id: Scalars['LoyaltyID'];
}

export enum LoyaltyLanguage {
  EN = 'EN',
  ES = 'ES',
  FR = 'FR'
}

export interface ILoyaltyMultipleOstCreationPayload {
  readonly __typename?: 'LoyaltyMultipleOstCreationPayload';
  readonly expirationTime: Scalars['String'];
  readonly key: Scalars['String'];
  readonly ostType: LoyaltyOstType;
}

export interface ILoyaltyObjectType {
  readonly __typename?: 'LoyaltyObjectType';
  readonly key?: Maybe<Scalars['String']>;
  readonly value?: Maybe<Scalars['LoyaltyJSON']>;
}

export interface ILoyaltyOffer extends ILoyaltyBaseIncentive {
  readonly __typename?: 'LoyaltyOffer';
  readonly benefits?: Maybe<ReadonlyArray<ILoyaltyBenefit>>;
  readonly cartRequirements?: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ILoyaltyCartRequirement>>>>>;
  readonly configId?: Maybe<Scalars['LoyaltyID']>;
  readonly coolDown?: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['String'];
  readonly endDate: Scalars['String'];
  readonly endTime?: Maybe<Scalars['String']>;
  readonly errors?: Maybe<ReadonlyArray<ILoyaltyRuleConditionEvaluation>>;
  readonly externalIdentifiers?: Maybe<ReadonlyArray<Maybe<ILoyaltyExternalIdentifiers>>>;
  readonly firstOrder?: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['LoyaltyID'];
  /** Deprecated - Please configure offer stackability by redemption type in the loyalty configuration. */
  readonly isStackable?: Maybe<Scalars['Boolean']>;
  readonly loyaltyId?: Maybe<Scalars['LoyaltyID']>;
  readonly maxRedemptionsDuration?: Maybe<LoyaltyDurationPeriod>;
  readonly maxRedemptionsLimit?: Maybe<Scalars['Int']>;
  readonly metadata?: Maybe<ReadonlyArray<Maybe<ILoyaltyObjectType>>>;
  readonly minimumSpend?: Maybe<Scalars['Int']>;
  readonly name: Scalars['String'];
  readonly paymentMethod?: Maybe<LoyaltyPaymentMethod>;
  readonly questId?: Maybe<Scalars['String']>;
  readonly redemptionType?: Maybe<LoyaltyOfferRedemptionType>;
  readonly restaurantGroups?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly sanityId?: Maybe<Scalars['String']>;
  readonly serviceModes?: Maybe<ReadonlyArray<Maybe<LoyaltyServiceMode>>>;
  readonly startDate: Scalars['String'];
  readonly startTime?: Maybe<Scalars['String']>;
  /** Deprecated - storeRestrictions will be omited because it is not used and the size of the response is too large. */
  readonly storeRestrictions?: Maybe<ILoyaltyStoreRestrictions>;
  readonly templateId?: Maybe<Scalars['LoyaltyID']>;
  readonly type: LoyaltyOfferType;
  readonly updatedAt: Scalars['String'];
  readonly userBirthdayDuration?: Maybe<LoyaltyBirthdayDuration>;
  readonly userEnrollment?: Maybe<ILoyaltyDateSpan>;
  readonly validDaysOfTheWeek?: Maybe<ReadonlyArray<LoyaltyDayOfTheWeek>>;
}

export interface ILoyaltyOfferChallengeStatus {
  readonly __typename?: 'LoyaltyOfferChallengeStatus';
  readonly goalId: Scalars['String'];
  readonly goals?: Maybe<ILoyaltyOfferGoalType>;
  readonly reward?: Maybe<ILoyaltyOfferRewardType>;
  readonly status: Scalars['String'];
}

export interface ILoyaltyOfferGoalType {
  readonly __typename?: 'LoyaltyOfferGoalType';
  readonly category?: Maybe<Scalars['String']>;
  readonly daypart?: Maybe<Scalars['String']>;
  readonly foodType?: Maybe<Scalars['String']>;
  readonly minSpend?: Maybe<Scalars['Int']>;
}

export interface ILoyaltyOfferRedemptionAvailability {
  readonly __typename?: 'LoyaltyOfferRedemptionAvailability';
  readonly availableAfter?: Maybe<Scalars['String']>;
  readonly transactionId?: Maybe<Scalars['String']>;
}

export enum LoyaltyOfferRedemptionType {
  PROMO_CODE = 'PROMO_CODE',
  STANDARD = 'STANDARD',
  SURPRISE = 'SURPRISE',
  SWAP = 'SWAP'
}

export interface ILoyaltyOfferRewardType {
  readonly __typename?: 'LoyaltyOfferRewardType';
  readonly points?: Maybe<Scalars['Int']>;
}

export enum LoyaltyOfferType {
  GLOBAL = 'GLOBAL',
  PERSONALIZED = 'PERSONALIZED'
}

export interface ILoyaltyOffersInput {
  readonly appliedIncentives?: InputMaybe<ReadonlyArray<ILoyaltyPromotionInput>>;
  readonly appliedPromotions?: InputMaybe<ReadonlyArray<ILoyaltyPromotionInput>>;
  readonly cartEntries?: InputMaybe<ReadonlyArray<ILoyaltyRbiCartEntryInput>>;
  readonly configId?: InputMaybe<Scalars['LoyaltyID']>;
  readonly global?: InputMaybe<Scalars['Boolean']>;
  readonly ids?: InputMaybe<ReadonlyArray<Scalars['LoyaltyID']>>;
  readonly ignoreRules?: InputMaybe<Scalars['Boolean']>;
  readonly isTransactionCreation?: InputMaybe<Scalars['Boolean']>;
  readonly limit?: InputMaybe<Scalars['Int']>;
  readonly omitInvalids?: InputMaybe<Scalars['Boolean']>;
  readonly paymentMethod?: InputMaybe<LoyaltyPaymentMethod>;
  readonly redemptionTypes?: InputMaybe<ReadonlyArray<LoyaltyOfferRedemptionType>>;
  readonly serviceMode?: InputMaybe<LoyaltyServiceMode>;
  readonly storeId?: InputMaybe<Scalars['String']>;
  readonly subtotalAmount?: InputMaybe<Scalars['Int']>;
}

export interface ILoyaltyOrderSelection {
  readonly __typename?: 'LoyaltyOrderSelection';
  /** Creation time of order selection */
  readonly createdAt: Scalars['String'];
  /** Expiry time in seconds for order selection from when the order selection was created */
  readonly expiry?: Maybe<Scalars['Int']>;
  /** Unique engine identifier for the user this order selection belongs to */
  readonly loyaltyId?: Maybe<Scalars['String']>;
  /** 6-digit code to identify this order selection */
  readonly otp?: Maybe<Scalars['String']>;
  /** The incentives selected to be redeemed w/ this order selection */
  readonly selectedIncentives: ReadonlyArray<ILoyaltyOrderSelectionIncentive>;
  /** The status of the order selection */
  readonly status: LoyaltyOrderSelectionStatus;
  /** The store or location that this order selection will be used at */
  readonly storeId?: Maybe<Scalars['String']>;
  /** The resulting transaction when the order selection is identified */
  readonly transactionId?: Maybe<Scalars['String']>;
}

export interface ILoyaltyOrderSelectionIncentive {
  readonly __typename?: 'LoyaltyOrderSelectionIncentive';
  /**
   * The output of the incentive
   *
   * I.E what the customer receives for redeeming the incentive
   */
  readonly benefits: ReadonlyArray<ILoyaltyOrderSelectionIncentiveBenefit>;
  /**
   * Specifies incentive should apply a cart level discount
   *
   * NOTE - While this is a "benefit" of the incentive, a discount has very specific fields that does not conform to the common benefit structure
   * nor will it produce an order-line as it applies at a cart level and not an individual line-item level
   */
  readonly cartDiscount?: Maybe<ICartDiscount>;
  /** optional description for incentive */
  readonly description?: Maybe<Scalars['String']>;
  /** Unique internal engine id for incentive */
  readonly id: Scalars['String'];
  /** Unique cart identifier for incentive */
  readonly lineId: Scalars['String'];
  /** Display name for incentive */
  readonly name: Scalars['String'];
  /** The Sanity ID of the incentive */
  readonly productId: Scalars['String'];
  /** Count of many of the incentive is to be redeemed */
  readonly quantity: Scalars['Int'];
  /** Incentive classification - Offer | Reward */
  readonly type: LoyaltyOrderSelectionIncentiveType;
}

export interface ILoyaltyOrderSelectionIncentiveBenefit {
  readonly __typename?: 'LoyaltyOrderSelectionIncentiveBenefit';
  /** optional description for incentive benefit */
  readonly description?: Maybe<Scalars['String']>;
  /** Display name of order selection benefit */
  readonly name: Scalars['String'];
  /** The Sanity ID of the incentive's benefit */
  readonly productId: Scalars['String'];
}

export interface ILoyaltyOrderSelectionIncentiveBenefitInput {
  /** optional description for incentive benefit */
  readonly description?: InputMaybe<Scalars['String']>;
  /** Display name of order selection benefit */
  readonly name: Scalars['String'];
  /** The Sanity ID of the incentive's benefit */
  readonly productId: Scalars['String'];
  /** Sanity Vendor PLU configurations for the incentive's benefit */
  readonly vendorConfigs: ILoyaltyVendorConfigsInput;
}

export interface ILoyaltyOrderSelectionIncentiveInput {
  /**
   * The output of the incentive
   *
   * I.E what the customer receives for redeeming the incentive
   */
  readonly benefits: ReadonlyArray<ILoyaltyOrderSelectionIncentiveBenefitInput>;
  /**
   * Specifies incentive should apply a cart level discount
   *
   * NOTE - While this is a "benefit" of the incentive, a discount has very specific fields that does not conform to the common benefit structure
   * nor will it produce an order-line as it applies at a cart level and not an individual line-item level
   */
  readonly cartDiscount?: InputMaybe<ICartDiscountInput>;
  /** optional description for incentive */
  readonly description?: InputMaybe<Scalars['String']>;
  /** Unique internal engine id for incentive */
  readonly id: Scalars['String'];
  /** Unique cart identifier for incentive */
  readonly lineId: Scalars['String'];
  /** Display name for incentive */
  readonly name: Scalars['String'];
  /** The Sanity ID of the incentive */
  readonly productId: Scalars['String'];
  /** Count of how many of the incentive is to be redeemed */
  readonly quantity: Scalars['Int'];
  /**
   * 4 digit short code for the incentive to present to the cashier
   * FOR US this is typically the plu unless the plu is longer than 4 digits, in which case its the truncated plu
   */
  readonly shortCode?: InputMaybe<Scalars['String']>;
  /** Incentive classification - Offer | Reward */
  readonly type: LoyaltyOrderSelectionIncentiveType;
  /** Sanity Vendor PLU configurations for the incentive */
  readonly vendorConfigs: IRbiVendorConfigsInput;
}

export enum LoyaltyOrderSelectionIncentiveType {
  OFFER = 'OFFER',
  REWARD = 'REWARD'
}

export enum LoyaltyOrderSelectionStatus {
  CLAIMED = 'CLAIMED',
  PENDING = 'PENDING'
}

export interface ILoyaltyOrderSelectionTransfer {
  readonly __typename?: 'LoyaltyOrderSelectionTransfer';
  readonly createdAt: Scalars['String'];
  readonly expiry?: Maybe<Scalars['Int']>;
  readonly loyaltyId?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly order: ReadonlyArray<ILoyaltyInRestaurantOrderLineItemType>;
  readonly otp?: Maybe<Scalars['String']>;
  readonly restaurantId?: Maybe<Scalars['String']>;
  readonly status?: Maybe<OrderSelectionStatus>;
  readonly transactionId?: Maybe<Scalars['String']>;
  readonly updatedAt?: Maybe<Scalars['String']>;
}

export enum LoyaltyOrderSelectionType {
  LOYALTY_ID = 'LOYALTY_ID',
  OTP = 'OTP'
}

export interface ILoyaltyOrderlessIncentiveInput {
  readonly id: Scalars['String'];
  readonly metadata?: InputMaybe<Scalars['LoyaltyJSON']>;
  readonly type: LoyaltyPromotionType;
}

export interface ILoyaltyOrderlessTransactionInput {
  /** Represents the source of the transaction i.e web | mobile | support | campaign | receipt etc. */
  readonly channel: Scalars['String'];
  readonly cognitoId?: InputMaybe<Scalars['String']>;
  readonly incentives: ReadonlyArray<ILoyaltyOrderlessIncentiveInput>;
  readonly loyaltyId?: InputMaybe<Scalars['String']>;
  readonly storeId?: InputMaybe<Scalars['String']>;
}

export interface ILoyaltyOstCreationPayload {
  readonly __typename?: 'LoyaltyOstCreationPayload';
  readonly expirationTime: Scalars['String'];
  readonly key: Scalars['String'];
}

export enum LoyaltyOstType {
  LOYALTY_ID = 'LOYALTY_ID',
  OTP = 'OTP'
}

export interface ILoyaltyOtp {
  readonly __typename?: 'LoyaltyOtp';
  readonly expirationTime: Scalars['String'];
  readonly password: Scalars['String'];
}

export interface ILoyaltyParentChildPluInput {
  readonly childPlu?: InputMaybe<Scalars['String']>;
  readonly plu?: InputMaybe<Scalars['String']>;
}

export interface ILoyaltyPaymentExpiration {
  readonly __typename?: 'LoyaltyPaymentExpiration';
  readonly month?: Maybe<Scalars['Int']>;
  readonly year?: Maybe<Scalars['Int']>;
}

export enum LoyaltyPaymentMethod {
  AMEX = 'AMEX',
  APPLE_PAY = 'APPLE_PAY',
  CASH = 'CASH',
  CREDIT = 'CREDIT',
  DINERSCLUB = 'DINERSCLUB',
  DISCOVER = 'DISCOVER',
  GIFT_CARD = 'GIFT_CARD',
  GOOGLE_PAY = 'GOOGLE_PAY',
  JCB = 'JCB',
  MASTERCARD = 'MASTERCARD',
  PAYPAL = 'PAYPAL',
  VENMO = 'VENMO',
  VISA = 'VISA'
}

export interface ILoyaltyPerson {
  readonly __typename?: 'LoyaltyPerson';
  readonly email?: Maybe<Scalars['String']>;
  readonly externalIds?: Maybe<ReadonlyArray<Maybe<ILoyaltyExternalIdentifier>>>;
  readonly phone?: Maybe<Scalars['String']>;
}

export interface ILoyaltyPickupContact {
  readonly __typename?: 'LoyaltyPickupContact';
  readonly hasArrived: Scalars['Boolean'];
  readonly name?: Maybe<Scalars['String']>;
  readonly phone?: Maybe<Scalars['String']>;
  readonly vehicle?: Maybe<ILoyaltyPickupContactVehicle>;
}

export interface ILoyaltyPickupContactVehicle {
  readonly __typename?: 'LoyaltyPickupContactVehicle';
  readonly color?: Maybe<Scalars['String']>;
  readonly licensePlate?: Maybe<Scalars['String']>;
  readonly make?: Maybe<Scalars['String']>;
  readonly model?: Maybe<Scalars['String']>;
}

export interface ILoyaltyPointExpiry {
  readonly __typename?: 'LoyaltyPointExpiry';
  readonly expirationDate: Scalars['String'];
  readonly points: Scalars['Int'];
}

export interface ILoyaltyProcessSmgCodeResponse {
  readonly __typename?: 'LoyaltyProcessSmgCodeResponse';
  readonly pointsEarned: Scalars['Int'];
  readonly status: LoyaltySmgCodeStatus;
}

export interface ILoyaltyPromotion {
  readonly __typename?: 'LoyaltyPromotion';
  readonly id: Scalars['String'];
  readonly lineId?: Maybe<Scalars['String']>;
  readonly type: LoyaltyPromotionType;
}

export interface ILoyaltyPromotionInput {
  readonly id: Scalars['String'];
  readonly lineId?: InputMaybe<Scalars['String']>;
  readonly swap?: InputMaybe<ILoyaltyPromotionSwapInput>;
  readonly type: LoyaltyPromotionType;
}

export interface ILoyaltyPromotionSwapInput {
  readonly from: Scalars['String'];
  readonly lineId: Scalars['String'];
  readonly to: Scalars['String'];
  readonly type: LoyaltySwapType;
}

export enum LoyaltyPromotionType {
  OFFER = 'OFFER',
  REWARD = 'REWARD',
  SYSTEMWIDE_PROMOTION = 'SYSTEMWIDE_PROMOTION'
}

export interface ILoyaltyPromotionsInput {
  readonly omitInvalids?: InputMaybe<Scalars['Boolean']>;
  readonly serviceMode?: InputMaybe<LoyaltyServiceMode>;
  readonly storeId?: InputMaybe<Scalars['String']>;
  readonly subtotalAmount?: InputMaybe<Scalars['Int']>;
}

export interface ILoyaltyQuantityPluInput {
  readonly plu?: InputMaybe<Scalars['String']>;
  readonly qualifier?: InputMaybe<Scalars['String']>;
  readonly quantity?: InputMaybe<Scalars['Int']>;
}

export interface ILoyaltyQuest {
  readonly __typename?: 'LoyaltyQuest';
  readonly bonusPoints?: Maybe<Scalars['Int']>;
  readonly completions?: Maybe<ReadonlyArray<Maybe<ILoyaltyQuestCompletion>>>;
  readonly configId?: Maybe<Scalars['LoyaltyID']>;
  readonly createdAt: Scalars['String'];
  readonly endDate: Scalars['String'];
  readonly externalIdentifiers?: Maybe<ReadonlyArray<Maybe<ILoyaltyExternalIdentifiers>>>;
  readonly id: Scalars['LoyaltyID'];
  readonly incentiveId?: Maybe<Scalars['LoyaltyID']>;
  readonly incentiveRedeemed: Scalars['Boolean'];
  readonly incentiveType: LoyaltyQuestIncentiveType;
  readonly lastCompletion?: Maybe<ILoyaltyQuestCompletion>;
  readonly sanityId?: Maybe<Scalars['String']>;
  readonly startDate: Scalars['String'];
  readonly status: LoyaltyQuestStatus;
  readonly steps?: Maybe<ReadonlyArray<ILoyaltyQuestStep>>;
  readonly type: LoyaltyQuestType;
}

export interface ILoyaltyQuestCompletion {
  readonly __typename?: 'LoyaltyQuestCompletion';
  readonly benefitId: Scalars['String'];
  readonly completedAt: Scalars['String'];
  readonly redeemed: Scalars['Boolean'];
}

export enum LoyaltyQuestIncentiveType {
  BONUS_POINTS = 'BONUS_POINTS',
  OFFER = 'OFFER',
  REWARD = 'REWARD'
}

export enum LoyaltyQuestStatus {
  ACTIVATED = 'ACTIVATED',
  COMPLETED = 'COMPLETED',
  NOT_COMPLETED = 'NOT_COMPLETED',
  NOT_ENROLLED = 'NOT_ENROLLED'
}

export interface ILoyaltyQuestStep {
  readonly __typename?: 'LoyaltyQuestStep';
  readonly cartRequirements?: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ILoyaltyCartRequirement>>>>>;
  readonly completedAt?: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly status: LoyaltyQuestStepStatus;
}

export enum LoyaltyQuestStepStatus {
  COMPLETED = 'COMPLETED',
  NOT_COMPLETED = 'NOT_COMPLETED'
}

export enum LoyaltyQuestType {
  CONFIG = 'CONFIG',
  GLOBAL = 'GLOBAL',
  PERSONALIZED = 'PERSONALIZED'
}

export interface ILoyaltyQuestsInput {
  readonly activeOrEligible?: InputMaybe<Scalars['Boolean']>;
}

export interface ILoyaltyRbiCartEntryInput {
  readonly children?: InputMaybe<ReadonlyArray<ILoyaltyRbiCartEntryInput>>;
  readonly lineId?: InputMaybe<Scalars['String']>;
  readonly price?: InputMaybe<Scalars['Int']>;
  readonly quantity: Scalars['Int'];
  readonly sanityId: Scalars['String'];
}

export enum LoyaltyRbiChannel {
  APP = 'APP',
  ORDERLESS = 'ORDERLESS',
  RECEIPT = 'RECEIPT',
  REMEDIATION = 'REMEDIATION',
  RESTAURANT = 'RESTAURANT',
  WEB = 'WEB'
}

export interface ILoyaltyRbiParentChildPlu {
  readonly __typename?: 'LoyaltyRbiParentChildPlu';
  readonly childPlu?: Maybe<Scalars['String']>;
  readonly plu?: Maybe<Scalars['String']>;
}

export interface ILoyaltyRbiParentChildPluInput {
  readonly childPlu?: InputMaybe<Scalars['String']>;
  readonly plu?: InputMaybe<Scalars['String']>;
}

export interface ILoyaltyRbiQuantityPlu {
  readonly __typename?: 'LoyaltyRbiQuantityPlu';
  readonly plu?: Maybe<Scalars['String']>;
  readonly qualifier?: Maybe<Scalars['String']>;
  readonly quantity?: Maybe<Scalars['Int']>;
}

export interface ILoyaltyRbiQuantityPluInput {
  readonly plu?: InputMaybe<Scalars['String']>;
  readonly qualifier?: InputMaybe<Scalars['String']>;
  readonly quantity?: InputMaybe<Scalars['Int']>;
}

export interface ILoyaltyRbiSizeBasedPlu {
  readonly __typename?: 'LoyaltyRbiSizeBasedPlu';
  readonly comboPlu?: Maybe<Scalars['String']>;
  readonly comboSize?: Maybe<Scalars['String']>;
}

export interface ILoyaltyRbiSizeBasedPluInput {
  readonly comboPlu?: InputMaybe<Scalars['String']>;
  readonly comboSize?: InputMaybe<Scalars['String']>;
}

export interface ILoyaltyRbiVendorConfig {
  readonly __typename?: 'LoyaltyRbiVendorConfig';
  readonly constantPlu?: Maybe<Scalars['String']>;
  readonly discountPlu?: Maybe<Scalars['String']>;
  readonly multiConstantPlus?: Maybe<ReadonlyArray<Maybe<ILoyaltyRbiQuantityPlu>>>;
  readonly parentChildPlu?: Maybe<ILoyaltyRbiParentChildPlu>;
  readonly parentSanityId?: Maybe<Scalars['String']>;
  readonly pluType?: Maybe<Scalars['String']>;
  readonly pullUpLevels?: Maybe<Scalars['Int']>;
  readonly quantityBasedPlu?: Maybe<ReadonlyArray<Maybe<ILoyaltyRbiQuantityPlu>>>;
  readonly sizeBasedPlu?: Maybe<ILoyaltyRbiSizeBasedPlu>;
}

export interface ILoyaltyRbiVendorConfigInput {
  readonly constantPlu?: InputMaybe<Scalars['String']>;
  readonly discountPlu?: InputMaybe<Scalars['String']>;
  readonly multiConstantPlus?: InputMaybe<ReadonlyArray<InputMaybe<ILoyaltyRbiQuantityPluInput>>>;
  readonly parentChildPlu?: InputMaybe<ILoyaltyRbiParentChildPluInput>;
  readonly parentSanityId?: InputMaybe<Scalars['String']>;
  readonly pluType?: InputMaybe<Scalars['String']>;
  readonly pullUpLevels?: InputMaybe<Scalars['Int']>;
  readonly quantityBasedPlu?: InputMaybe<ReadonlyArray<InputMaybe<ILoyaltyRbiQuantityPluInput>>>;
  readonly sizeBasedPlu?: InputMaybe<ILoyaltyRbiSizeBasedPluInput>;
}

export interface ILoyaltyRbiVendorConfigs {
  readonly __typename?: 'LoyaltyRbiVendorConfigs';
  readonly brink?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly brinkDelivery?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly carrols?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly carrolsDelivery?: Maybe<ILoyaltyRbiVendorConfig>;
  /** HDX is not currently supported */
  readonly hdx?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly ncr?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly ncrDelivery?: Maybe<ILoyaltyRbiVendorConfig>;
  /** Deprecated */
  readonly oheics?: Maybe<ILoyaltyRbiVendorConfig>;
  /** Deprecated */
  readonly oheicsDelivery?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly partner?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly partnerDelivery?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly productNumber?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly productNumberDelivery?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly qdi?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly qdiDelivery?: Maybe<ILoyaltyRbiVendorConfig>;
  /** QST is not currently supported */
  readonly qst?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly rpos?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly rposDelivery?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly sicom?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly sicomDelivery?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly simphony?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly simphonyDelivery?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly tablet?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly tabletDelivery?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly xenial?: Maybe<ILoyaltyRbiVendorConfig>;
  readonly xenialDelivery?: Maybe<ILoyaltyRbiVendorConfig>;
}

export interface ILoyaltyRbiVendorConfigsInput {
  readonly brink?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly brinkDelivery?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly carrols?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly carrolsDelivery?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  /** HDX is not currently supported */
  readonly hdx?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly ncr?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly ncrDelivery?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  /** Deprecated */
  readonly oheics?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  /** Deprecated */
  readonly oheicsDelivery?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly partner?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly partnerDelivery?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly productNumber?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly productNumberDelivery?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly qdi?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly qdiDelivery?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  /** QST is not currently supported */
  readonly qst?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly rpos?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly rposDelivery?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly sicom?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly sicomDelivery?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly simphony?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly simphonyDelivery?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly tablet?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly tabletDelivery?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly xenial?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
  readonly xenialDelivery?: InputMaybe<ILoyaltyRbiVendorConfigInput>;
}

export interface ILoyaltyRedeemCouponResponse extends IRedeemedCouponResponse {
  readonly __typename?: 'LoyaltyRedeemCouponResponse';
  readonly code: Scalars['String'];
  readonly configId?: Maybe<Scalars['String']>;
  readonly isRedeemed: Scalars['Boolean'];
  readonly message?: Maybe<Scalars['String']>;
  readonly reason?: Maybe<Scalars['String']>;
}

export interface ILoyaltyRedeemPromoCodeInput {
  readonly code: Scalars['String'];
  readonly loyaltyId: Scalars['String'];
  readonly personalizedOfferId: Scalars['String'];
}

export interface ILoyaltyReward extends ILoyaltyBaseIncentive {
  readonly __typename?: 'LoyaltyReward';
  readonly cartRequirements?: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ILoyaltyCartRequirement>>>>>;
  readonly coolDown?: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['String'];
  readonly endDate: Scalars['String'];
  readonly endTime?: Maybe<Scalars['String']>;
  readonly errors?: Maybe<ReadonlyArray<ILoyaltyRuleConditionEvaluation>>;
  readonly externalIdentifiers?: Maybe<ReadonlyArray<Maybe<ILoyaltyExternalIdentifiers>>>;
  readonly firstOrder?: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['LoyaltyID'];
  readonly limitPerOrder?: Maybe<Scalars['Int']>;
  readonly locked?: Maybe<Scalars['Boolean']>;
  readonly maxRedemptionsDuration?: Maybe<LoyaltyDurationPeriod>;
  readonly maxRedemptionsLimit?: Maybe<Scalars['Int']>;
  readonly metadata?: Maybe<ReadonlyArray<Maybe<ILoyaltyObjectType>>>;
  readonly minimumSpend?: Maybe<Scalars['Int']>;
  readonly name: Scalars['String'];
  readonly paymentMethod?: Maybe<LoyaltyPaymentMethod>;
  readonly pointCost: Scalars['Int'];
  readonly redemptionPercentage?: Maybe<Scalars['Int']>;
  readonly remainingPointsNeededForRedemption?: Maybe<Scalars['Int']>;
  readonly restaurantGroups?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly rewardBenefitId: Scalars['String'];
  readonly sanityId?: Maybe<Scalars['String']>;
  readonly serviceModes?: Maybe<ReadonlyArray<Maybe<LoyaltyServiceMode>>>;
  readonly startDate: Scalars['String'];
  readonly startTime?: Maybe<Scalars['String']>;
  readonly storeRestrictions?: Maybe<ILoyaltyStoreRestrictions>;
  readonly type: LoyaltyRewardType;
  readonly updatedAt: Scalars['String'];
  readonly userBirthdayDuration?: Maybe<LoyaltyBirthdayDuration>;
  readonly userEnrollment?: Maybe<ILoyaltyDateSpan>;
  readonly validDaysOfTheWeek?: Maybe<ReadonlyArray<LoyaltyDayOfTheWeek>>;
}

export enum LoyaltyRewardType {
  GLOBAL = 'GLOBAL',
  PERSONALIZED = 'PERSONALIZED'
}

export interface ILoyaltyRewardsInput {
  readonly appliedIncentives?: InputMaybe<ReadonlyArray<ILoyaltyPromotionInput>>;
  readonly cartEntries?: InputMaybe<ReadonlyArray<ILoyaltyRbiCartEntryInput>>;
  readonly configId?: InputMaybe<Scalars['LoyaltyID']>;
  readonly ignorePointBalance?: InputMaybe<Scalars['Boolean']>;
  readonly ignoreRules?: InputMaybe<Scalars['Boolean']>;
  readonly incentiveIds?: InputMaybe<ReadonlyArray<Scalars['LoyaltyID']>>;
  readonly isTransactionCreation?: InputMaybe<Scalars['Boolean']>;
  readonly omitInvalids?: InputMaybe<Scalars['Boolean']>;
  readonly paymentMethod?: InputMaybe<LoyaltyPaymentMethod>;
  readonly rewardIds?: InputMaybe<ReadonlyArray<Scalars['LoyaltyID']>>;
  readonly serviceMode?: InputMaybe<LoyaltyServiceMode>;
  readonly storeId?: InputMaybe<Scalars['String']>;
  readonly subtotalAmount?: InputMaybe<Scalars['Int']>;
}

export interface ILoyaltyRuleConditionEvaluation {
  readonly __typename?: 'LoyaltyRuleConditionEvaluation';
  readonly code: Scalars['String'];
  readonly currentValue?: Maybe<Scalars['LoyaltyJSON']>;
  readonly message?: Maybe<Scalars['String']>;
  readonly ruleId: Scalars['String'];
  readonly targetValue?: Maybe<Scalars['LoyaltyJSON']>;
}

export interface ILoyaltySecondaryIdentifier {
  readonly __typename?: 'LoyaltySecondaryIdentifier';
  readonly createdAt?: Maybe<Scalars['String']>;
  readonly identifier: Scalars['String'];
  readonly identifierType: LoyaltySecondaryIdentifierType;
  readonly loyaltyId?: Maybe<Scalars['LoyaltyID']>;
  readonly verified?: Maybe<Scalars['Boolean']>;
}

export enum LoyaltySecondaryIdentifierType {
  LOYALTY12DIGITSWIPECARD = 'LOYALTY12DIGITSWIPECARD',
  LOYALTYSWIPECARD = 'LOYALTYSWIPECARD',
  PANTOKEN = 'PANTOKEN',
  PHONENUMBER = 'PHONENUMBER'
}

export enum LoyaltyServiceMode {
  CATERING_DELIVERY = 'CATERING_DELIVERY',
  CATERING_PICKUP = 'CATERING_PICKUP',
  CURBSIDE = 'CURBSIDE',
  DELIVERY = 'DELIVERY',
  DRIVE_THRU = 'DRIVE_THRU',
  EAT_IN = 'EAT_IN',
  TABLE_SERVICE = 'TABLE_SERVICE',
  TAKEOUT = 'TAKEOUT'
}

export interface ILoyaltySizeBasedPluInput {
  readonly comboPlu?: InputMaybe<Scalars['String']>;
  readonly comboSize?: InputMaybe<Scalars['String']>;
}

export enum LoyaltySmgCodeStatus {
  ACCEPTED = 'ACCEPTED',
  CODE_EXISTS = 'CODE_EXISTS',
  EXPIRED = 'EXPIRED',
  INVALID_FORMAT = 'INVALID_FORMAT',
  INVALID_RESTAURANT = 'INVALID_RESTAURANT',
  LIMIT_EXCEEDED = 'LIMIT_EXCEEDED',
  NOT_FOUND = 'NOT_FOUND',
  RETRY_REQUESTED = 'RETRY_REQUESTED',
  THROTTLING_ERROR = 'THROTTLING_ERROR',
  TRANSACTION_CLAIMED = 'TRANSACTION_CLAIMED'
}

export interface ILoyaltyStoreRestrictions {
  readonly __typename?: 'LoyaltyStoreRestrictions';
  readonly ids: ReadonlyArray<Maybe<Scalars['String']>>;
  readonly inclusive: Scalars['Boolean'];
}

export interface ILoyaltySwap {
  readonly __typename?: 'LoyaltySwap';
  readonly from: Scalars['String'];
  readonly to: Scalars['String'];
  readonly type: LoyaltySwapType;
}

export enum LoyaltySwapType {
  UPSIZE = 'UPSIZE'
}

export interface ILoyaltySystemWidePromotion extends ILoyaltyBaseIncentive {
  readonly __typename?: 'LoyaltySystemWidePromotion';
  readonly bonusPoints?: Maybe<Scalars['Int']>;
  readonly cartRequirements?: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ILoyaltyCartRequirement>>>>>;
  readonly coolDown?: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['String'];
  readonly endDate: Scalars['String'];
  readonly endTime?: Maybe<Scalars['String']>;
  readonly errors?: Maybe<ReadonlyArray<ILoyaltyRuleConditionEvaluation>>;
  readonly externalIdentifiers?: Maybe<ReadonlyArray<Maybe<ILoyaltyExternalIdentifiers>>>;
  readonly firstOrder?: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['LoyaltyID'];
  readonly maxRedemptionsDuration?: Maybe<LoyaltyDurationPeriod>;
  readonly maxRedemptionsLimit?: Maybe<Scalars['Int']>;
  readonly metadata?: Maybe<Scalars['LoyaltyJSON']>;
  readonly minimumSpend?: Maybe<Scalars['Int']>;
  readonly name: Scalars['String'];
  readonly paymentMethod?: Maybe<LoyaltyPaymentMethod>;
  readonly pointMultiplier?: Maybe<Scalars['Int']>;
  readonly restaurantGroups?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly sanityId?: Maybe<Scalars['String']>;
  readonly serviceModes?: Maybe<ReadonlyArray<Maybe<LoyaltyServiceMode>>>;
  readonly startDate: Scalars['String'];
  readonly startTime?: Maybe<Scalars['String']>;
  readonly storeRestrictions?: Maybe<ILoyaltyStoreRestrictions>;
  readonly updatedAt: Scalars['String'];
  readonly userBirthdayDuration?: Maybe<LoyaltyBirthdayDuration>;
  readonly userEnrollment?: Maybe<ILoyaltyDateSpan>;
  readonly validDaysOfTheWeek?: Maybe<ReadonlyArray<LoyaltyDayOfTheWeek>>;
}

export interface ILoyaltyTransaction {
  readonly __typename?: 'LoyaltyTransaction';
  /** Bonus points earned. */
  readonly bonusPointsEarned: Scalars['Int'];
  readonly id: Scalars['String'];
  /** Points balance after this transaction. */
  readonly pointsBalance: Scalars['Int'];
  /** Points earned. */
  readonly pointsEarned: Scalars['Int'];
  /** Points used. */
  readonly pointsUsed: Scalars['Int'];
  /** Number of rewards used. */
  readonly rewardsUsed: Scalars['Int'];
}

export interface ILoyaltyTransactionAdditionalReferenceId {
  readonly __typename?: 'LoyaltyTransactionAdditionalReferenceId';
  readonly description?: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly type: Scalars['String'];
}

export interface ILoyaltyTransactionDetails {
  readonly __typename?: 'LoyaltyTransactionDetails';
  readonly currency: Scalars['String'];
  readonly fulfillment: ILoyaltyTransactionFulfillment;
  readonly language?: Maybe<LoyaltyLanguage>;
  readonly orders: ReadonlyArray<ILoyaltyTransactionOrder>;
  readonly payments: ReadonlyArray<ILoyaltyTransactionPayment>;
  readonly person?: Maybe<ILoyaltyPerson>;
  readonly pickupContact?: Maybe<ILoyaltyPickupContact>;
  readonly posVendor?: Maybe<ILoyaltyTransactionPosVendor>;
  readonly promotions?: Maybe<ReadonlyArray<ILoyaltyPromotion>>;
}

export interface ILoyaltyTransactionFulfillment {
  readonly __typename?: 'LoyaltyTransactionFulfillment';
  readonly autoRelease?: Maybe<Scalars['Boolean']>;
  readonly type: Scalars['String'];
}

export interface ILoyaltyTransactionOrder {
  readonly __typename?: 'LoyaltyTransactionOrder';
  readonly parentReferenceId?: Maybe<Scalars['String']>;
  readonly price: Scalars['Int'];
  readonly productId?: Maybe<Scalars['String']>;
  readonly quantity: Scalars['Int'];
}

export interface ILoyaltyTransactionPayment {
  readonly __typename?: 'LoyaltyTransactionPayment';
  readonly amount: Scalars['Int'];
  readonly description?: Maybe<Scalars['String']>;
  readonly expiration?: Maybe<ILoyaltyPaymentExpiration>;
  readonly token?: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
}

export interface ILoyaltyTransactionPosVendor {
  readonly __typename?: 'LoyaltyTransactionPosVendor';
  readonly id?: Maybe<Scalars['String']>;
  readonly transactionId: Scalars['String'];
  readonly type: Scalars['String'];
}

export enum LoyaltyTransactionStatus {
  CLAIMED = 'CLAIMED',
  PENDING = 'PENDING',
  UNCLAIMED = 'UNCLAIMED',
  VOID = 'VOID'
}

export interface ILoyaltyTransactionV2 {
  readonly __typename?: 'LoyaltyTransactionV2';
  readonly additionalReferenceIds?: Maybe<ReadonlyArray<ILoyaltyTransactionAdditionalReferenceId>>;
  readonly bonusPointsEarned: Scalars['Int'];
  readonly channel: Scalars['String'];
  readonly createdAt: Scalars['String'];
  readonly dateUpdated?: Maybe<Scalars['String']>;
  readonly hasRewards: Scalars['Boolean'];
  readonly id: Scalars['LoyaltyID'];
  readonly loyaltyId?: Maybe<Scalars['String']>;
  readonly maxTransactionLimitReached: Scalars['Boolean'];
  readonly pointsDeducted?: Maybe<Scalars['Int']>;
  readonly pointsEarned: Scalars['Int'];
  readonly pointsUsed: Scalars['Int'];
  readonly shortId: Scalars['String'];
  readonly status: LoyaltyTransactionStatus;
  readonly transactionDetails?: Maybe<ILoyaltyTransactionDetails>;
}

export interface ILoyaltyTransactionsInput {
  readonly excludedChannels?: InputMaybe<ReadonlyArray<LoyaltyRbiChannel>>;
  readonly ids?: InputMaybe<ReadonlyArray<Scalars['LoyaltyID']>>;
  readonly statuses?: InputMaybe<ReadonlyArray<LoyaltyTransactionStatus>>;
}

export interface ILoyaltyUser {
  readonly __typename?: 'LoyaltyUser';
  /**
   * DEPRECATED
   * This query is no longer available
   */
  readonly alohaActiveRewards: ReadonlyArray<ILoyaltyAlohaActiveReward>;
  readonly bestPromotion?: Maybe<ILoyaltySystemWidePromotion>;
  readonly createdAt: Scalars['String'];
  readonly dateOfBirth?: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  /**
   * DEPRECATED
   * Incentive evaluation errors are now provided as part of the incentive data.
   */
  readonly evaluatedIncentives: ILoyaltyEvaluatedIncentives;
  readonly expirationBuckets?: Maybe<ReadonlyArray<ILoyaltyExpirationBucket>>;
  readonly id: Scalars['LoyaltyID'];
  readonly idPay?: Maybe<ILoyaltyIdAndPay>;
  readonly metadata?: Maybe<ReadonlyArray<Maybe<ILoyaltyObjectType>>>;
  readonly name?: Maybe<Scalars['String']>;
  readonly offerRedemptionAvailability?: Maybe<ILoyaltyOfferRedemptionAvailability>;
  /**
   * DEPRECATED
   * This field is replaced by field offerRedemptionAvailability
   */
  readonly offerRedemptionAvailableAfter?: Maybe<Scalars['String']>;
  readonly offers?: Maybe<ReadonlyArray<ILoyaltyOffer>>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly points: Scalars['Int'];
  readonly pointsExpiryDateKey?: Maybe<Scalars['String']>;
  readonly promotions?: Maybe<ReadonlyArray<ILoyaltySystemWidePromotion>>;
  readonly quests?: Maybe<ReadonlyArray<ILoyaltyQuest>>;
  readonly rewards?: Maybe<ReadonlyArray<ILoyaltyReward>>;
  readonly secondaryIdentifiers?: Maybe<ReadonlyArray<Maybe<ILoyaltySecondaryIdentifier>>>;
  readonly transactions?: Maybe<ReadonlyArray<ILoyaltyTransactionV2>>;
}


export interface ILoyaltyUserBestPromotionArgs {
  where?: InputMaybe<ILoyaltyPromotionsInput>;
}


export interface ILoyaltyUserEvaluatedIncentivesArgs {
  where: ILoyaltyEvaluateIncentivesInput;
}


export interface ILoyaltyUserOffersArgs {
  where?: InputMaybe<ILoyaltyOffersInput>;
}


export interface ILoyaltyUserPromotionsArgs {
  where?: InputMaybe<ILoyaltyPromotionsInput>;
}


export interface ILoyaltyUserQuestsArgs {
  where?: InputMaybe<ILoyaltyQuestsInput>;
}


export interface ILoyaltyUserRewardsArgs {
  where?: InputMaybe<ILoyaltyRewardsInput>;
}


export interface ILoyaltyUserTransactionsArgs {
  where?: InputMaybe<ILoyaltyTransactionsInput>;
}

export interface ILoyaltyValidatePromoCodeInput {
  readonly code: Scalars['String'];
  readonly loyaltyId: Scalars['String'];
  readonly shouldRedeem?: InputMaybe<Scalars['Boolean']>;
}

export interface ILoyaltyVendorConfigInput {
  readonly constantPlu?: InputMaybe<Scalars['String']>;
  readonly discountPlu?: InputMaybe<Scalars['String']>;
  readonly multiConstantPlus?: InputMaybe<ReadonlyArray<InputMaybe<ILoyaltyQuantityPluInput>>>;
  readonly parentChildPlu?: InputMaybe<ILoyaltyParentChildPluInput>;
  readonly parentSanityId?: InputMaybe<Scalars['String']>;
  readonly pluType?: InputMaybe<Scalars['String']>;
  readonly pullUpLevels?: InputMaybe<Scalars['Int']>;
  readonly quantityBasedPlu?: InputMaybe<ReadonlyArray<InputMaybe<ILoyaltyQuantityPluInput>>>;
  readonly sizeBasedPlu?: InputMaybe<ILoyaltySizeBasedPluInput>;
}

export interface ILoyaltyVendorConfigsInput {
  readonly brink?: InputMaybe<ILoyaltyVendorConfigInput>;
  readonly carrols?: InputMaybe<ILoyaltyVendorConfigInput>;
  readonly ncr?: InputMaybe<ILoyaltyVendorConfigInput>;
  readonly partner?: InputMaybe<ILoyaltyVendorConfigInput>;
  readonly qdi?: InputMaybe<ILoyaltyVendorConfigInput>;
  readonly rpos?: InputMaybe<ILoyaltyVendorConfigInput>;
  readonly sicom?: InputMaybe<ILoyaltyVendorConfigInput>;
  readonly tablet?: InputMaybe<ILoyaltyVendorConfigInput>;
}

/**
 * MenuEntityWithHours represents the store menu items with availability hours from the Connector menu.
 * Availability is propagated from items to top level structures (pickers, sections, etc) algorithmically.
 */
export interface IMenuEntityWithHours {
  readonly __typename?: 'MenuEntityWithHours';
  readonly calories?: Maybe<ICalories>;
  readonly hours: ReadonlyArray<IMenuItemHours>;
  readonly id: Scalars['String'];
  readonly isAvailable?: Maybe<Scalars['Boolean']>;
  readonly options?: Maybe<ReadonlyArray<IOption>>;
  readonly price?: Maybe<IPrice>;
}

/** DEPRECATED */
export interface IMenuItem {
  readonly __typename?: 'MenuItem';
  readonly plu: Scalars['String'];
  readonly price: Scalars['String'];
}

/** MenuItemHours represents the consolidated times windows during which the item is available for orders, expressed in restaurant local time. */
export interface IMenuItemHours {
  readonly __typename?: 'MenuItemHours';
  /** End time of the available hours in ISO8601 time format - Thh:mm. */
  readonly end: Scalars['String'];
  /** Start time of the available hours in ISO8601 time format - Thh:mm. */
  readonly start: Scalars['String'];
}

/** A Prepaid Merge two gift cards response */
export interface IMerge {
  readonly __typename?: 'Merge';
  /** dollar amount destination gift card begins with */
  readonly beginBalance: Scalars['Int'];
  /** destination card currency code */
  readonly currencyCode: Scalars['String'];
  /** new balance of destination gift card after merge in dollars */
  readonly currentBalance: Scalars['Int'];
  /** card number of destination gift card */
  readonly destinationCardNumber?: Maybe<Scalars['String']>;
  readonly fdAccountId?: Maybe<Scalars['String']>;
  readonly fdCorrelationId?: Maybe<Scalars['String']>;
  /** card number of source gift card that was deleted */
  readonly sourceCardNumber?: Maybe<Scalars['String']>;
  readonly transactionId: Scalars['String'];
}

/** Merge two prepaid gift cards into one. Source gets deleted. */
export interface IMergePrepaidInput {
  /** Number of physical Gift Card which is the funding source (card being deactivated) */
  readonly sourceCardNumber: Scalars['String'];
  /** Pin number for physical gift card which is the funding source (card being deactivated) */
  readonly sourcePin?: InputMaybe<Scalars['String']>;
}

export interface IMergePrepaidPayload {
  readonly __typename?: 'MergePrepaidPayload';
  readonly prepaidDetails: IPrepaidDetails;
  readonly storedPaymentMethodId: Scalars['String'];
}

export interface IMissingItem {
  /** Line Id of item */
  readonly lineId: Scalars['String'];
  /** Quantity of items requested for refund */
  readonly refundQuantity: Scalars['Int'];
  /** Total quantity of items in a Combo or OfferCombo */
  readonly totalQuantity?: InputMaybe<Scalars['Int']>;
}

export interface IMissingOrderRefundDetails {
  readonly __typename?: 'MissingOrderRefundDetails';
  /** Amount refunded in cents */
  readonly approvedAmount: Scalars['Int'];
  /** Date time when refund was issued */
  readonly transactionDateTime: Scalars['String'];
}

export interface IMissingOrderResolution {
  readonly __typename?: 'MissingOrderResolution';
  /** Refund details */
  readonly refund?: Maybe<IMissingOrderRefundDetails>;
  /** Knowledge Force or Zendesk support ticket */
  readonly ticket?: Maybe<Scalars['String']>;
}

export interface IModifier {
  readonly __typename?: 'Modifier';
  readonly id: Scalars['String'];
  readonly isAvailable?: Maybe<Scalars['Boolean']>;
  readonly price?: Maybe<Scalars['Int']>;
}

export interface IMultipleOstCreationPayload {
  readonly __typename?: 'MultipleOstCreationPayload';
  readonly expirationTime: Scalars['String'];
  readonly key: Scalars['String'];
  readonly ostType: OstType;
}

/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutation {
  readonly __typename?: 'Mutation';
  readonly _empty?: Maybe<Scalars['String']>;
  readonly _loyaltyEmpty?: Maybe<Scalars['String']>;
  /** Deprecated: Activates a reward for an RBI loyalty user on Aloha loyalty. */
  readonly activateAlohaReward: IActivateAlohaRewardResponse;
  readonly activateQuest?: Maybe<IQuest>;
  /** Legacy Add Credit Account to user */
  readonly addCreditAccount: IAccount;
  /**
   * Add a gift account (gift card) for a customer using a vaulted fd account.
   * Can throw MaxGiftCardsExistError.
   */
  readonly addGiftAccount: IGiftAccount;
  /** Add payment method to user */
  readonly addPaymentMethod: IAddPaymentMethodPayload;
  /** Associate guestId with loyaltyId. */
  readonly associateGuestUser?: Maybe<IAssociateGuestUserResponse>;
  /** Associates a secondary id to a loyalty user without needing a guest user */
  readonly associateSecondaryId?: Maybe<ISecondaryIdentifier>;
  /**
   * Collect payments and commit the order to the PoS.
   *
   * If the service mode in the previously priced order was DRIVE_THRU or DELIVERY,
   * then the PoS will immediately start cooking the order. Else the PoS
   * will not cook the order until the customer arrives.
   *
   * (Please note that despite the name this is not a "transactional" flow)
   */
  readonly commitOrder: IOrder;
  /** Create a favorite */
  readonly createFavorite: IFavorite;
  /** Request a jwt to auth for a given vendor */
  readonly createLoginForVendor?: Maybe<Scalars['String']>;
  /** Request a one-time password for the given user */
  readonly createLoginOTP: ICreateOtp;
  /**
   * Create a user one time password
   * @deprecated Use createLoginOTP
   */
  readonly createOTP: ICreateOtp;
  /** Creates an order selection for this loyaltyId */
  readonly createOrderSelectionByMultipleType: ReadonlyArray<IMultipleOstCreationPayload>;
  /** Creates an order selection for this loyaltyId */
  readonly createOrderSelectionByType: IOstCreationPayload;
  /**
   * Allows the creation of a transaction not tied to an order, which is useful to redeem static code incentives while enforcing redemption rules.
   * Returns null if the transaction is successfully created.
   */
  readonly createOrderlessTransaction: ITransaction;
  /** Create a user sms one time password */
  readonly createSmsOtp: ICreateOtp;
  /** Create a support case */
  readonly createSupportCase?: Maybe<ISupportCase>;
  /** Delete user account payment method (Legacy) */
  readonly deleteAccount: Scalars['Boolean'];
  /** Delete a favorite */
  readonly deleteFavorite: IFavorite;
  /** Delete current user */
  readonly deleteMe?: Maybe<Scalars['Boolean']>;
  /**
   * Deletes the order selection linked to the OTP code
   * If it is an OTP code, attempts to make the code available again.
   * Doesn't return a payload.
   */
  readonly deleteOrderSelection?: Maybe<Scalars['Boolean']>;
  /**
   * Deletes the order selection linked to a key based on  the ostType
   * Doesn't return a payload.
   */
  readonly deleteOrderSelectionByType?: Maybe<Scalars['Boolean']>;
  /** Delete a customer's account */
  readonly deletePaymentMethod: IDeletePaymentMethodPayload;
  /** Fetch public key & access token for encrypting CC values. */
  readonly encryptionDetails: IEncryptionDetails;
  /**
   * Validates a previously-created OTP code and then exchanges the
   * valid code for Cognito credentials
   */
  readonly exchangeOTPCodeForCognitoCredentials: ICognitoCredentials;
  /** generates OTP code associated with incentive items for in-store redemption */
  readonly generateOtp: IOtp;
  /** Deprecated: Activates a reward for an RBI loyalty user on Aloha loyalty. */
  readonly loyaltyActivateAlohaReward: ILoyaltyActivateAlohaRewardResponse;
  readonly loyaltyActivateQuest?: Maybe<ILoyaltyQuest>;
  /** Associate guestId with loyaltyId. */
  readonly loyaltyAssociateGuestUser?: Maybe<ILoyaltyAssociateGuestUserResponse>;
  /** Associates a secondary id to a loyalty user without needing a guest user */
  readonly loyaltyAssociateSecondaryId?: Maybe<ILoyaltySecondaryIdentifier>;
  readonly loyaltyCreateOrderSelection: ILoyaltyCreateOrderSelectionResponse;
  /** Creates an order selection for this loyaltyId */
  readonly loyaltyCreateOrderSelectionByMultipleType: ReadonlyArray<ILoyaltyMultipleOstCreationPayload>;
  /** Creates an order selection for this loyaltyId */
  readonly loyaltyCreateOrderSelectionByType: ILoyaltyOstCreationPayload;
  /**
   * Allows the creation of a transaction not tied to an order, which is useful to redeem static code incentives while enforcing redemption rules.
   * Returns null if the transaction is successfully created.
   */
  readonly loyaltyCreateOrderlessTransaction: ILoyaltyTransactionV2;
  readonly loyaltyDeleteOrderSelection: Scalars['Boolean'];
  /**
   * Deletes the order selection linked to a key based on  the ostType
   * Doesn't return a payload.
   */
  readonly loyaltyDeleteOrderSelectionByType?: Maybe<Scalars['Boolean']>;
  /** generates OTP code associated with incentive items for in-store redemption */
  readonly loyaltyGenerateOtp: ILoyaltyOtp;
  /**
   * processes a transaction's smg code with the following possible outcomes
   *   - accept -> transaction is claimed and points are granted
   *   - reject -> error is thrown with rejection status
   *   - retry_request -> a request is added to the retry-table and points may/may not be granted depending on result of retry attempts
   *   - not_found -> temporary response while process-retry work is in progress
   */
  readonly loyaltyProcessSmgCode: ILoyaltyProcessSmgCodeResponse;
  /** Redeem promo code for Loyalty */
  readonly loyaltyRedeemPromoCode?: Maybe<ILoyaltyRedeemCouponResponse>;
  readonly loyaltyRemoveSecondaryIdAssociation?: Maybe<Scalars['Boolean']>;
  /** Updates Id and Pay data of given user */
  readonly loyaltyUpdateIdAndPay?: Maybe<ILoyaltyIdAndPayUpdateResponse>;
  /** Validate promo code for Loyalty */
  readonly loyaltyValidatePromoCode?: Maybe<ILoyaltyCouponResponse>;
  /** Merge customer's prepaid accounts */
  readonly mergePrepaid: IMergePrepaidPayload;
  /** Get balance for prepaid account */
  readonly prepaidsBalance: IBalance;
  /** Transfer balance of prepaid gift card into one and delete it  (legacy) */
  readonly prepaidsMerge: IMerge;
  /** Reload a prepaid gift card account */
  readonly prepaidsReload: IReload;
  /**
   * Price an order using the store's PoS.
   *
   * This endpoint _must_ be called previous to finalizing the order.
   */
  readonly priceOrder: IOrder;
  /**
   * processes a transaction's smg code with the following possible outcomes
   *   - accept -> transaction is claimed and points are granted
   *   - reject -> error is thrown with rejection status
   *   - retry_request -> a request is added to the retry-table and points may/may not be granted depending on result of retry attempts
   *   - not_found -> temporary response while process-retry work is in progress
   */
  readonly processSmgCode: IProcessSmgCodeResponse;
  /** Purchase a new prepaid card */
  readonly purchasePrepaid: IPurchasePrepaidPayload;
  /** Redeem one coupon for the authenticated user id. */
  readonly redeemCoupon: ICoupon;
  /** Redeem promo code for legacy CBA */
  readonly redeemPromoCode?: Maybe<ICbaRedeemCouponResponse>;
  /** Reload an existing prepaid card */
  readonly reloadPrepaid: IReloadPrepaidPayload;
  /** Remove a delivery address */
  readonly removeDeliveryAddress: IDeliveryAddressResponse;
  readonly removeSecondaryIdAssociation?: Maybe<Scalars['Boolean']>;
  /** Kicks off email with all data we have on the user */
  readonly requestMyInfo?: Maybe<Scalars['Boolean']>;
  /** Re-sends the current OTP code for the given user email/phone number */
  readonly resendCurrentLoginOTP: ICreateOtp;
  /** Re-sends the verification email to the current user */
  readonly resendVerificationEmail?: Maybe<Scalars['Boolean']>;
  /** Resume add payment method */
  readonly resumeAddPaymentMethod: IAddPaymentMethodPayload;
  /** Save a delivery address */
  readonly saveDeliveryAddress: IDeliveryAddressResponse;
  /** Re-sends the verification email to the current user */
  readonly sendPhoneVerification?: Maybe<Scalars['Boolean']>;
  /** Kicks off part one of Login Flow */
  readonly signInJWT?: Maybe<Scalars['Boolean']>;
  /** Sign up user with cognito returns a JWT */
  readonly signUp?: Maybe<Scalars['String']>;
  /** Validate & Sign up Sms Otp */
  readonly signUpSmsOtp: Scalars['String'];
  /** Performs social login */
  readonly socialLogin?: Maybe<ICognitoCredentials>;
  /** Sync and return the user's communication preferences settings between Braze and Dynamo */
  readonly syncUserCommunicationPreferences: ISyncUserCommunicationPreferencesResult;
  /** Update a user default payment method */
  readonly updateDefaultPaymentMethod: IUpdateDefaultPaymentMethodPayload;
  /** Update a favorite */
  readonly updateFavorite: IFavorite;
  /** Updates Id and Pay data of given user */
  readonly updateIdAndPay?: Maybe<IIdAndPayUpdateResponse>;
  /**
   * Update an order using the store's PoS.
   *
   * This endpoint _must_ be called after committing the order.
   */
  readonly updateOrder: IOrder;
  /** Updates the user's preference center settings */
  readonly updateUserCommunicationPreferences: ISyncUserCommunicationPreferencesResult;
  /** Validate the RBI generated JWT and exchange for cognito credentials */
  readonly validateAuthJwt: ICognitoCredentials;
  /** Validate promo code for legacy CBA */
  readonly validatePromoCode?: Maybe<ICbaCouponResponse>;
  /** Verifies the phone number for the given user */
  readonly verifyPhoneNumber?: Maybe<Scalars['Boolean']>;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationActivateAlohaRewardArgs {
  loyaltyId: Scalars['ID'];
  rewardSanityId: Scalars['String'];
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationActivateQuestArgs {
  loyaltyId: Scalars['ID'];
  questId: Scalars['ID'];
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationAddCreditAccountArgs {
  input: IAddCreditAccountInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationAddGiftAccountArgs {
  input: IAddGiftAccountInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationAddPaymentMethodArgs {
  input: IAddPaymentMethodInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationAssociateGuestUserArgs {
  identifier: Scalars['String'];
  loyaltyId: Scalars['ID'];
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationAssociateSecondaryIdArgs {
  identifier: Scalars['String'];
  loyaltyId: Scalars['ID'];
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationCommitOrderArgs {
  delivery?: InputMaybe<ICommitDeliveryInput>;
  input: ICommitOrderInput;
  skipCoolingPeriod?: InputMaybe<Scalars['Boolean']>;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationCreateFavoriteArgs {
  input: IFavoriteInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationCreateLoginForVendorArgs {
  vendor: Scalars['String'];
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationCreateLoginOtpArgs {
  input: ICreateOtpInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationCreateOtpArgs {
  input: ICreateOtpInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationCreateOrderSelectionByMultipleTypeArgs {
  inRestaurantOrder: ReadonlyArray<IInRestaurantOrderLineItem>;
  loyaltyId: Scalars['ID'];
  ostTypes: ReadonlyArray<OstType>;
  restaurantId?: InputMaybe<Scalars['ID']>;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationCreateOrderSelectionByTypeArgs {
  inRestaurantOrder: ReadonlyArray<IInRestaurantOrderLineItem>;
  loyaltyId: Scalars['ID'];
  ostType: OstType;
  restaurantId?: InputMaybe<Scalars['ID']>;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationCreateOrderlessTransactionArgs {
  input: IOrderlessTransactionInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationCreateSmsOtpArgs {
  input: ICreateSmsOtpInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationCreateSupportCaseArgs {
  caseInfo: ISupportCaseInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationDeleteAccountArgs {
  input: IDeleteAccountInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationDeleteFavoriteArgs {
  favoriteId: Scalars['String'];
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationDeleteOrderSelectionArgs {
  loyaltyId?: InputMaybe<Scalars['ID']>;
  otp: Scalars['String'];
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationDeleteOrderSelectionByTypeArgs {
  key: Scalars['String'];
  loyaltyId?: InputMaybe<Scalars['ID']>;
  ostType: OstType;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationDeletePaymentMethodArgs {
  input: IDeletePaymentMethodInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationExchangeOtpCodeForCognitoCredentialsArgs {
  input: IExchangeOtpCodeForCredentialsInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationGenerateOtpArgs {
  inRestaurantOrder: ReadonlyArray<IInRestaurantOrderLineItem>;
  loyaltyId: Scalars['ID'];
  restaurantId?: InputMaybe<Scalars['ID']>;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationLoyaltyActivateAlohaRewardArgs {
  loyaltyId: Scalars['LoyaltyID'];
  rewardSanityId: Scalars['String'];
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationLoyaltyActivateQuestArgs {
  loyaltyId: Scalars['LoyaltyID'];
  questId: Scalars['LoyaltyID'];
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationLoyaltyAssociateGuestUserArgs {
  identifier: Scalars['String'];
  loyaltyId: Scalars['LoyaltyID'];
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationLoyaltyAssociateSecondaryIdArgs {
  identifier: Scalars['String'];
  loyaltyId: Scalars['LoyaltyID'];
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationLoyaltyCreateOrderSelectionArgs {
  input: ILoyaltyCreateOrderSelectionInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationLoyaltyCreateOrderSelectionByMultipleTypeArgs {
  inRestaurantOrder: ReadonlyArray<ILoyaltyInRestaurantOrderLineItem>;
  loyaltyId: Scalars['LoyaltyID'];
  ostTypes: ReadonlyArray<LoyaltyOstType>;
  restaurantId?: InputMaybe<Scalars['LoyaltyID']>;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationLoyaltyCreateOrderSelectionByTypeArgs {
  inRestaurantOrder: ReadonlyArray<ILoyaltyInRestaurantOrderLineItem>;
  loyaltyId: Scalars['LoyaltyID'];
  ostType: LoyaltyOstType;
  restaurantId?: InputMaybe<Scalars['LoyaltyID']>;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationLoyaltyCreateOrderlessTransactionArgs {
  input: ILoyaltyOrderlessTransactionInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationLoyaltyDeleteOrderSelectionArgs {
  input: ILoyaltyDeleteOrderSelectionInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationLoyaltyDeleteOrderSelectionByTypeArgs {
  key: Scalars['String'];
  loyaltyId?: InputMaybe<Scalars['LoyaltyID']>;
  ostType: LoyaltyOstType;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationLoyaltyGenerateOtpArgs {
  inRestaurantOrder: ReadonlyArray<ILoyaltyInRestaurantOrderLineItem>;
  loyaltyId: Scalars['LoyaltyID'];
  restaurantId?: InputMaybe<Scalars['LoyaltyID']>;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationLoyaltyProcessSmgCodeArgs {
  loyaltyId: Scalars['LoyaltyID'];
  smgCode: Scalars['String'];
  transactionDate?: InputMaybe<Scalars['String']>;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationLoyaltyRedeemPromoCodeArgs {
  input?: InputMaybe<ILoyaltyRedeemPromoCodeInput>;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationLoyaltyRemoveSecondaryIdAssociationArgs {
  identifier: Scalars['String'];
  identifierType: LoyaltySecondaryIdentifierType;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationLoyaltyUpdateIdAndPayArgs {
  idAndPayInput: ILoyaltyIdAndPayInput;
  loyaltyId: Scalars['LoyaltyID'];
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationLoyaltyValidatePromoCodeArgs {
  input?: InputMaybe<ILoyaltyValidatePromoCodeInput>;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationMergePrepaidArgs {
  input: IMergePrepaidInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationPrepaidsBalanceArgs {
  cardNumber: Scalars['String'];
  feCountryCode?: InputMaybe<IsoCountryCode>;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationPrepaidsMergeArgs {
  input: IPrepaidsMergeInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationPrepaidsReloadArgs {
  input: IPrepaidsReloadInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationPriceOrderArgs {
  delivery?: InputMaybe<IPriceDeliveryInput>;
  input: IPriceOrderInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationProcessSmgCodeArgs {
  loyaltyId: Scalars['ID'];
  smgCode: Scalars['String'];
  transactionDate?: InputMaybe<Scalars['String']>;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationPurchasePrepaidArgs {
  input: IPurchasePrepaidInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationRedeemCouponArgs {
  couponId: Scalars['ID'];
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationRedeemPromoCodeArgs {
  code: Scalars['String'];
  cognitoId: Scalars['String'];
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationReloadPrepaidArgs {
  input: IReloadPrepaidInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationRemoveDeliveryAddressArgs {
  input: IRemoveDeliveryAddressInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationRemoveSecondaryIdAssociationArgs {
  identifier: Scalars['String'];
  identifierType: SecondaryIdentifierType;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationResendCurrentLoginOtpArgs {
  input: IResendOtpInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationResendVerificationEmailArgs {
  input: IResendVerificationEmailInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationResumeAddPaymentMethodArgs {
  input: IResumeAddPaymentMethodInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationSaveDeliveryAddressArgs {
  input: ISaveDeliveryAddressInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationSendPhoneVerificationArgs {
  input: IResendPhoneVerificationInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationSignInJwtArgs {
  userInfo: ISignInUserInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationSignUpArgs {
  userInfo: ISignUpUserInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationSignUpSmsOtpArgs {
  input: ISignUpSmsOtpInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationSocialLoginArgs {
  input: ISocialLoginInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationUpdateDefaultPaymentMethodArgs {
  input: IUpdateDefaultPaymentMethodInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationUpdateFavoriteArgs {
  favoriteId: Scalars['String'];
  input: IFavoriteInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationUpdateIdAndPayArgs {
  idAndPayInput: IIdAndPayInput;
  loyaltyId: Scalars['ID'];
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationUpdateOrderArgs {
  input: IUpdateOrderInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationUpdateUserCommunicationPreferencesArgs {
  input: IUpdateUserCommunicationPreferencesInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationValidateAuthJwtArgs {
  authInput: IValidateAuthJwtInput;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationValidatePromoCodeArgs {
  code: Scalars['String'];
  cognitoId: Scalars['String'];
  offers: ReadonlyArray<Scalars['String']>;
  shouldRedeem?: InputMaybe<Scalars['Boolean']>;
}


/**
 * TODO: make the legacy CBA mutations adhere to most up to date GQL standards defined here:
 * https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3790832340/GraphQL+Schema+Guidelines
 */
export interface IMutationVerifyPhoneNumberArgs {
  input: IVerifyPhoneNumberInput;
}

export interface INearbyRestaurantsInput {
  /** A coordinates object that sorts results based on location provided. */
  readonly coordinates: ICoordinates;
  /** Pagination input fields */
  readonly pagination?: InputMaybe<IPaginationInput>;
  /**
   * A flag to enable strict radius checking. When enabled, stores will be filtered
   * based on a circle radius. Any stores outside the radius are not included.
   */
  readonly radiusStrictMode?: InputMaybe<Scalars['Boolean']>;
  /**
   * A list of service modes to search for.
   * Filters list to subset of stores that have one of the service modes available.
   */
  readonly serviceModes?: InputMaybe<ReadonlyArray<ServiceMode>>;
  /**
   * Restaurant operational status.
   * Filters list to subset of stores that have the provided status.
   */
  readonly status?: InputMaybe<OperationalStatus>;
}

/**
 * https://relay.dev/graphql/connections.htm#sec-Node
 *
 * Interface that is implemented by an application data node.
 */
export interface INode {
  readonly id?: Maybe<Scalars['ID']>;
}

export interface IObjectType {
  readonly __typename?: 'ObjectType';
  readonly key?: Maybe<Scalars['String']>;
  readonly value?: Maybe<Scalars['JSON']>;
}

export interface IOffer extends IBaseIncentive {
  readonly __typename?: 'Offer';
  readonly benefits?: Maybe<ReadonlyArray<IBenefit>>;
  readonly cartRequirements?: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ICartRequirement>>>>>;
  readonly configId?: Maybe<Scalars['ID']>;
  readonly coolDown?: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['String'];
  readonly endDate: Scalars['String'];
  readonly endTime?: Maybe<Scalars['String']>;
  readonly errors?: Maybe<ReadonlyArray<IRuleConditionEvaluation>>;
  readonly externalIdentifiers?: Maybe<ReadonlyArray<Maybe<IExternalIdentifiers>>>;
  readonly firstOrder?: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  /** Deprecated - Please configure offer stackability by redemption type in the loyalty configuration. */
  readonly isStackable?: Maybe<Scalars['Boolean']>;
  readonly loyaltyId?: Maybe<Scalars['ID']>;
  readonly maxRedemptionsDuration?: Maybe<DurationPeriod>;
  readonly maxRedemptionsLimit?: Maybe<Scalars['Int']>;
  readonly metadata?: Maybe<ReadonlyArray<Maybe<IObjectType>>>;
  readonly minimumSpend?: Maybe<Scalars['Int']>;
  readonly name: Scalars['String'];
  readonly paymentMethod?: Maybe<PaymentMethod>;
  readonly questId?: Maybe<Scalars['String']>;
  readonly redemptionType?: Maybe<OfferRedemptionType>;
  readonly restaurantGroups?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly sanityId?: Maybe<Scalars['String']>;
  readonly serviceModes?: Maybe<ReadonlyArray<Maybe<ServiceMode>>>;
  readonly startDate: Scalars['String'];
  readonly startTime?: Maybe<Scalars['String']>;
  /** Deprecated - storeRestrictions will be omited because it is not used and the size of the response is too large. */
  readonly storeRestrictions?: Maybe<IStoreRestrictions>;
  readonly templateId?: Maybe<Scalars['ID']>;
  readonly type: OfferType;
  readonly updatedAt: Scalars['String'];
  readonly userBirthdayDuration?: Maybe<BirthdayDuration>;
  readonly userEnrollment?: Maybe<IDateSpan>;
  readonly validDaysOfTheWeek?: Maybe<ReadonlyArray<DayOfTheWeek>>;
}

export interface IOfferRedemptionAvailability {
  readonly __typename?: 'OfferRedemptionAvailability';
  readonly availableAfter?: Maybe<Scalars['String']>;
  readonly transactionId?: Maybe<Scalars['String']>;
}

export enum OfferRedemptionType {
  PROMO_CODE = 'PROMO_CODE',
  STANDARD = 'STANDARD',
  SURPRISE = 'SURPRISE',
  SWAP = 'SWAP'
}

export enum OfferType {
  GLOBAL = 'GLOBAL',
  PERSONALIZED = 'PERSONALIZED'
}

export interface IOfferVariable {
  readonly __typename?: 'OfferVariable';
  /** The key of OfferVariable. */
  readonly key: Scalars['String'];
  /**
   * The type of OfferVariable to be used by FE. Available types:
   * 'currency',
   * 'datetime',
   * 'int',
   * 'number',
   * 'string',
   */
  readonly type: Scalars['String'];
  /** The value of OfferVariable. */
  readonly value: Scalars['String'];
}

export interface IOffersInput {
  readonly appliedIncentives?: InputMaybe<ReadonlyArray<IPromotionInput>>;
  readonly appliedPromotions?: InputMaybe<ReadonlyArray<IPromotionInput>>;
  readonly cartEntries?: InputMaybe<ReadonlyArray<IRbiCartEntryInput>>;
  readonly configId?: InputMaybe<Scalars['ID']>;
  readonly global?: InputMaybe<Scalars['Boolean']>;
  readonly ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly ignoreRules?: InputMaybe<Scalars['Boolean']>;
  readonly isTransactionCreation?: InputMaybe<Scalars['Boolean']>;
  readonly limit?: InputMaybe<Scalars['Int']>;
  readonly omitInvalids?: InputMaybe<Scalars['Boolean']>;
  readonly paymentMethod?: InputMaybe<PaymentMethod>;
  readonly redemptionTypes?: InputMaybe<ReadonlyArray<OfferRedemptionType>>;
  readonly serviceMode?: InputMaybe<ServiceMode>;
  readonly storeId?: InputMaybe<Scalars['String']>;
  readonly subtotalAmount?: InputMaybe<Scalars['Int']>;
}

/**
 * Operating hours for a restaurant in local time formatted
 * as "YYYY-MM-DD hh:mm:ss" (the date component should be ignored)
 */
export interface IOperatingHours {
  readonly __typename?: 'OperatingHours';
  /** Friday operating hours close */
  readonly friClose?: Maybe<Scalars['String']>;
  /** Friday operating hours open */
  readonly friOpen?: Maybe<Scalars['String']>;
  /** Monday operating hours close */
  readonly monClose?: Maybe<Scalars['String']>;
  /** Monday operating hours open */
  readonly monOpen?: Maybe<Scalars['String']>;
  /** Saturday operating hours close */
  readonly satClose?: Maybe<Scalars['String']>;
  /** Saturday operating hours open */
  readonly satOpen?: Maybe<Scalars['String']>;
  /** Sunday operating hours close */
  readonly sunClose?: Maybe<Scalars['String']>;
  /** Sunday operating hours open */
  readonly sunOpen?: Maybe<Scalars['String']>;
  /** Thursday operating hours close */
  readonly thrClose?: Maybe<Scalars['String']>;
  /** Thursday operating hours open */
  readonly thrOpen?: Maybe<Scalars['String']>;
  /** Tuesday operating hours close */
  readonly tueClose?: Maybe<Scalars['String']>;
  /** Tuesday operating hours open */
  readonly tueOpen?: Maybe<Scalars['String']>;
  /** Wednesday operating hours close */
  readonly wedClose?: Maybe<Scalars['String']>;
  /** Wednesday operating hours open */
  readonly wedOpen?: Maybe<Scalars['String']>;
}

export enum OperationStatus {
  FAILED = 'FAILED',
  REQUESTED = 'REQUESTED',
  SUCCESSFUL = 'SUCCESSFUL'
}

export enum OperationalStatus {
  CLOSED = 'CLOSED',
  CLOSED_TEMPORARILY = 'CLOSED_TEMPORARILY',
  OPEN = 'OPEN',
  PROJECTED = 'PROJECTED'
}

export interface IOption {
  readonly __typename?: 'Option';
  readonly id: Scalars['String'];
  readonly options?: Maybe<ReadonlyArray<IModifier>>;
}

export interface IOrbitalPayment {
  /**
   * Represents a saved funding source. (i.e. orbitalIdentifier or recurringDetailReference)
   * If passed this will be used to process payment. Either accountIdentifier or
   * encrypted payload is required.
   */
  readonly accountIdentifier?: InputMaybe<Scalars['String']>;
  /** Encrypted Payment Payload. If accountIdentifier is not passed this will be used. */
  readonly encryptedPayload?: InputMaybe<IAddOrbitalAccountInput>;
  /** When true, payment details will be saved as a recurring payment method in Adyen */
  readonly savePaymentMethod?: InputMaybe<Scalars['Boolean']>;
}

export interface IOrder {
  readonly __typename?: 'Order';
  readonly cart: ICart;
  readonly catering?: Maybe<ICatering>;
  readonly createdAt: Scalars['String'];
  readonly delivery?: Maybe<IDelivery>;
  readonly earliestPickupTimeInSeconds?: Maybe<Scalars['Int']>;
  readonly fireOrderIn?: Maybe<Scalars['Int']>;
  readonly fulfillmentDetails?: Maybe<IFulfillmentDetails>;
  /** Same value as rbiOrderId, used for Apollo Cache */
  readonly id?: Maybe<Scalars['String']>;
  readonly loyaltyTransaction?: Maybe<ILoyaltyTransaction>;
  readonly order?: Maybe<IRbiOrder>;
  readonly orderNumberFormatted?: Maybe<Scalars['String']>;
  readonly pk: Scalars['String'];
  readonly posOrderId?: Maybe<Scalars['String']>;
  readonly posVendor: PosVendor;
  readonly rbiOrderId: Scalars['String'];
  readonly revision: Scalars['Int'];
  readonly sk: Scalars['String'];
  readonly status: RbiOrderStatus;
  readonly updatedAt: Scalars['String'];
  readonly userId?: Maybe<Scalars['String']>;
  readonly userSortKey: Scalars['String'];
}

export interface IOrderListResponse {
  readonly __typename?: 'OrderListResponse';
  readonly count: Scalars['Int'];
  readonly orders?: Maybe<ReadonlyArray<Maybe<IOrder>>>;
  readonly resumeAfter?: Maybe<Scalars['String']>;
}

export enum OrderSelectionStatus {
  CLAIMED = 'CLAIMED',
  PENDING = 'PENDING'
}

export interface IOrderSelectionTransfer {
  readonly __typename?: 'OrderSelectionTransfer';
  readonly createdAt: Scalars['String'];
  readonly expiry?: Maybe<Scalars['Int']>;
  readonly loyaltyId?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly order: ReadonlyArray<IInRestaurantOrderLineItemType>;
  readonly otp?: Maybe<Scalars['String']>;
  readonly restaurantId?: Maybe<Scalars['String']>;
  readonly status?: Maybe<OrderSelectionStatus>;
  readonly transactionId?: Maybe<Scalars['String']>;
  readonly updatedAt?: Maybe<Scalars['String']>;
}

export enum OrderingStatus {
  ALPHA = 'alpha',
  BETA = 'beta',
  DEV = 'dev',
  LIVE = 'live',
  PROD = 'prod',
  TEMPORARILY_UNAVAILABLE = 'temporarily_unavailable',
  TEMPORARY_UNAVAILABLE = 'temporary_unavailable'
}

export interface IOrderlessIncentiveInput {
  readonly id: Scalars['String'];
  readonly metadata?: InputMaybe<Scalars['JSON']>;
  readonly type: PromotionType;
}

export interface IOrderlessTransactionInput {
  /** Represents the source of the transaction i.e web | mobile | support | campaign | receipt etc. */
  readonly channel: Scalars['String'];
  readonly cognitoId?: InputMaybe<Scalars['String']>;
  readonly incentives: ReadonlyArray<IOrderlessIncentiveInput>;
  readonly loyaltyId?: InputMaybe<Scalars['String']>;
  readonly storeId?: InputMaybe<Scalars['String']>;
}

export interface IOstCreationPayload {
  readonly __typename?: 'OstCreationPayload';
  readonly expirationTime: Scalars['String'];
  readonly key: Scalars['String'];
}

export enum OstType {
  LOYALTY_ID = 'LOYALTY_ID',
  OTP = 'OTP'
}

export interface IOtp {
  readonly __typename?: 'Otp';
  readonly expirationTime: Scalars['String'];
  readonly password: Scalars['String'];
}

export interface IOverride {
  readonly __typename?: 'Override';
  readonly key?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly price?: Maybe<Scalars['Int']>;
}

/**
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 *
 * Page information to determine if there are more results, and what node,
 * determined by it's cursor, is at the start and end of the page returned.
 */
export interface IPageInfo {
  readonly __typename?: 'PageInfo';
  readonly endCursor?: Maybe<Scalars['String']>;
  readonly hasNextPage: Scalars['Boolean'];
  readonly hasPreviousPage: Scalars['Boolean'];
  readonly startCursor?: Maybe<Scalars['String']>;
}

export interface IPaginationInput {
  /**
   * An opaque cursor for pagination. Return results after provided cursor.
   * Used in combination with first field.
   */
  readonly after?: InputMaybe<Scalars['String']>;
  /**
   * An opaque cursor for pagination. Return results before provided cursor.
   * Used in combination with last field.
   */
  readonly before?: InputMaybe<Scalars['String']>;
  /**
   * Return first provided number of edges for pagination query.
   * Used in combination with after field.
   */
  readonly first?: InputMaybe<Scalars['Int']>;
  /**
   * Return last provided number of edges for pagination query.
   * Used in combination with before field.
   */
  readonly last?: InputMaybe<Scalars['Int']>;
}

export interface IParentChildPlu {
  readonly __typename?: 'ParentChildPlu';
  readonly childPlu?: Maybe<Scalars['String']>;
  readonly plu?: Maybe<Scalars['String']>;
}

export interface IParentChildPluInput {
  readonly childPlu?: InputMaybe<Scalars['String']>;
  readonly plu?: InputMaybe<Scalars['String']>;
}

export interface IPayment {
  readonly __typename?: 'Payment';
  readonly approvalNumber?: Maybe<Scalars['String']>;
  readonly cardType?: Maybe<Scalars['String']>;
  readonly ccLast4?: Maybe<Scalars['String']>;
  readonly fdCorrelationId?: Maybe<Scalars['String']>;
  readonly fdSaleId: Scalars['String'];
  readonly panToken?: Maybe<Scalars['String']>;
  readonly paymentType?: Maybe<CartPaymentType>;
}

export interface IPaymentBillingAddressInput {
  readonly administrativeArea?: InputMaybe<Scalars['String']>;
  readonly locality?: InputMaybe<Scalars['String']>;
  readonly postalCode?: InputMaybe<Scalars['String']>;
  readonly regionCode: Scalars['String'];
  readonly route?: InputMaybe<Scalars['String']>;
  readonly streetNumber?: InputMaybe<Scalars['String']>;
}

/** ***** End of Legacy Typings ***** */
export interface IPaymentConfig {
  readonly __typename?: 'PaymentConfig';
  readonly allowedPaymentMethods: ReadonlyArray<PaymentMethodType>;
  readonly applePay?: Maybe<IApplePayPaymentConfig>;
  readonly frontendIntegration: FrontendIntegration;
  readonly googlePay?: Maybe<IGooglePayPaymentConfig>;
}

export interface IPaymentExpiration {
  readonly __typename?: 'PaymentExpiration';
  readonly month?: Maybe<Scalars['Int']>;
  readonly year?: Maybe<Scalars['Int']>;
}

export interface IPaymentInput {
  /** Details from Apple Pay for payment. */
  readonly applePayDetails?: InputMaybe<IApplePay>;
  /** Billing address associated to card */
  readonly billingAddress?: InputMaybe<IBillingAddressInput>;
  /** Denotes a cash payment */
  readonly cashPayment?: InputMaybe<Scalars['Boolean']>;
  /** Contains supplemental data for CC transactions */
  readonly ccMetadata?: InputMaybe<ICreditCardMetadataInput>;
  /** First Data payment data */
  readonly firstDataInput?: InputMaybe<IFirstDataPayment>;
  /** Name on credit card */
  readonly fullName: Scalars['String'];
  /** Details from Google Pay for payment. */
  readonly googlePayDetails?: InputMaybe<IGooglePay>;
  /**
   * Unique Kount Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   */
  readonly kountSessionId?: InputMaybe<Scalars['String']>;
  /** Orbital Payment data */
  readonly orbitalInput?: InputMaybe<IOrbitalPayment>;
  /** Details from Paypal for payment. */
  readonly paypalDetails?: InputMaybe<IPaypal>;
  /** Details from Venmo for payment. */
  readonly venmoDetails?: InputMaybe<IVenmo>;
}

export enum PaymentMethod {
  AMEX = 'AMEX',
  APPLE_PAY = 'APPLE_PAY',
  CASH = 'CASH',
  CREDIT = 'CREDIT',
  DINERSCLUB = 'DINERSCLUB',
  DISCOVER = 'DISCOVER',
  GIFT_CARD = 'GIFT_CARD',
  GOOGLE_PAY = 'GOOGLE_PAY',
  JCB = 'JCB',
  MASTERCARD = 'MASTERCARD',
  PAYPAL = 'PAYPAL',
  VENMO = 'VENMO',
  VISA = 'VISA'
}

export interface IPaymentMethodData {
  /** Card display name with last 4 digits of the credit card */
  readonly displayName?: InputMaybe<Scalars['String']>;
  /** Card type used for digital pay */
  readonly paymentMethodType?: InputMaybe<Scalars['String']>;
  /** Payment type used for digital pay */
  readonly paymentType?: InputMaybe<Scalars['String']>;
}

export enum PaymentMethodType {
  APPLE_PAY = 'APPLE_PAY',
  GOOGLE_PAY = 'GOOGLE_PAY',
  PAYPAL_FAST = 'PAYPAL_FAST',
  PREPAID = 'PREPAID',
  SCHEME = 'SCHEME'
}

export interface IPaymentPreferences {
  readonly __typename?: 'PaymentPreferences';
  /** Is auto reload enabled */
  readonly autoReload: Scalars['Boolean'];
  /** Auto reload threshold */
  readonly autoReloadThreshold?: Maybe<Scalars['Int']>;
  /** Default prepaid reload amount */
  readonly reloadAmount?: Maybe<Scalars['Int']>;
  /** Default payment account id */
  readonly storedPaymentMethodId?: Maybe<Scalars['String']>;
}

export enum PaymentProcessor {
  ADYEN = 'ADYEN',
  FIRSTDATA = 'FIRSTDATA',
  ORBITAL = 'ORBITAL'
}

export interface IPaymentTransaction {
  readonly __typename?: 'PaymentTransaction';
  readonly amount: Scalars['Int'];
  readonly client?: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['String'];
  readonly currency: Scalars['String'];
  readonly orderId?: Maybe<Scalars['String']>;
  readonly paymentId: Scalars['String'];
  readonly paymentMethodType?: Maybe<PaymentMethodType>;
  readonly pspReference?: Maybe<Scalars['String']>;
  readonly reason?: Maybe<Scalars['String']>;
  readonly region: Scalars['String'];
  readonly schemeType?: Maybe<SchemePaymentMethodType>;
  readonly status: OperationStatus;
  readonly storeId?: Maybe<Scalars['String']>;
  readonly type: PaymentTransactionType;
}

export enum PaymentTransactionType {
  CANCEL = 'CANCEL',
  CAPTURE = 'CAPTURE',
  ORDER = 'ORDER',
  PAYMENT = 'PAYMENT',
  REFUND = 'REFUND',
  THREE_DS_PAYMENT = 'THREE_DS_PAYMENT',
  THREE_DS_PAYMENT_METHOD = 'THREE_DS_PAYMENT_METHOD',
  TRANSACTION = 'TRANSACTION'
}

export interface IPaypal {
  readonly details?: InputMaybe<Scalars['String']>;
  readonly deviceData?: InputMaybe<Scalars['String']>;
  readonly nonce: Scalars['String'];
}

export interface IPerson {
  readonly __typename?: 'Person';
  readonly email?: Maybe<Scalars['String']>;
  readonly externalIds?: Maybe<ReadonlyArray<Maybe<IExternalIdentifier>>>;
  readonly phone?: Maybe<Scalars['String']>;
}

export interface IPhysicalAddress {
  readonly __typename?: 'PhysicalAddress';
  readonly address1?: Maybe<Scalars['String']>;
  readonly address2?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Scalars['String']>;
  readonly postalCode?: Maybe<Scalars['String']>;
  readonly stateProvince?: Maybe<Scalars['String']>;
  readonly stateProvinceShort?: Maybe<Scalars['String']>;
}

export interface IPickupContact {
  readonly __typename?: 'PickupContact';
  readonly hasArrived: Scalars['Boolean'];
  readonly name?: Maybe<Scalars['String']>;
  readonly phone?: Maybe<Scalars['String']>;
  readonly vehicle?: Maybe<IPickupContactVehicle>;
}

export interface IPickupContactVehicle {
  readonly __typename?: 'PickupContactVehicle';
  readonly color?: Maybe<Scalars['String']>;
  readonly licensePlate?: Maybe<Scalars['String']>;
  readonly make?: Maybe<Scalars['String']>;
  readonly model?: Maybe<Scalars['String']>;
}

export interface IPlaceCateringOrderInput {
  /**
   * Billing address Comes in the following format
   * billingStreetAddress, billingApt, billingCity, billingState, billingZip
   */
  readonly billingAddress?: InputMaybe<IBillingAddressInput>;
  /**
   * Catering Information
   * contains Datetime for the catering
   */
  readonly cateringInfo: ICateringInfoInput;
  /**
   * First 6 digits of credit card.
   * Required for anonymous payment.
   * @constraint(pattern: "^[0-9]{6}$")
   */
  readonly ccBin?: InputMaybe<Scalars['String']>;
  /** Credit card 2 digit expiry month */
  readonly ccExpiryMonth?: InputMaybe<Scalars['String']>;
  /** Credit card 2 digit expiry year */
  readonly ccExpiryYear?: InputMaybe<Scalars['String']>;
  /**
   * Last 6 digits of credit card.
   * Required for anonymous payment.
   * @constraint(pattern: "^[0-9]{4}$")
   */
  readonly ccLast4?: InputMaybe<Scalars['String']>;
  /** The payment provider type eg. (VISA/MASTERCARD/DISCOVER/AMEX) */
  readonly creditType?: InputMaybe<CartPaymentCardType>;
  /** Valid access token for accessing First Data API */
  readonly fdAccessToken?: InputMaybe<Scalars['String']>;
  /**
   * The First Data payment method ID which must be associated to the user
   * making the request.
   */
  readonly fdAccountId?: InputMaybe<Scalars['String']>;
  /**
   * Nonce retrieved from First Data. Sale will be performed with the payment
   * method associated with the nonce.
   */
  readonly fdNonce?: InputMaybe<Scalars['String']>;
  /** Customer full name */
  readonly fullName?: InputMaybe<Scalars['String']>;
  /**
   * Unique Kount Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   */
  readonly kountSessionId?: InputMaybe<Scalars['String']>;
  /** ID for a previous order that has been priced */
  readonly rbiOrderId: Scalars['ID'];
  /**
   * The moment of redemption - the user's local date+time - in ISO format.
   * Only ISO-formatted timestamp values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
   */
  readonly redeemedOn?: InputMaybe<Scalars['String']>;
  /**
   * Unique Session ID
   * 32 characters long
   * Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces)
   *
   * Note that the "sessionId" field is deprecated and will be ignored.
   */
  readonly sessionId?: InputMaybe<Scalars['String']>;
  /** Store email address */
  readonly storeEmail?: InputMaybe<Scalars['String']>;
  /** Details from 3DS transactions, relates to properties needed to resume sale transactions. */
  readonly threeDSDetails?: InputMaybe<IResumeThreeDSaleTransaction>;
}

export enum Platform {
  APP = 'app',
  KIOSK = 'kiosk',
  WEB = 'web'
}

export interface IPlu {
  readonly __typename?: 'Plu';
  readonly brink?: Maybe<Scalars['String']>;
  readonly brinkDelivery?: Maybe<Scalars['String']>;
  /** @deprecated POS Vendor no longer in use */
  readonly connector?: Maybe<Scalars['String']>;
  readonly ncr?: Maybe<Scalars['String']>;
  readonly ncrDelivery?: Maybe<Scalars['String']>;
  /** @deprecated POS Vendor no longer in use */
  readonly oheics?: Maybe<Scalars['String']>;
  /** @deprecated POS Vendor no longer in use */
  readonly oheicsDelivery?: Maybe<Scalars['String']>;
  /** @deprecated POS Vendor no longer in use */
  readonly partner?: Maybe<Scalars['String']>;
  /** @deprecated POS Vendor no longer in use */
  readonly partnerDelivery?: Maybe<Scalars['String']>;
  /** @deprecated POS Vendor no longer in use */
  readonly productNumber?: Maybe<Scalars['String']>;
  /** @deprecated POS Vendor no longer in use */
  readonly productNumberDelivery?: Maybe<Scalars['String']>;
  /** @deprecated POS Vendor no longer in use */
  readonly qst?: Maybe<Scalars['String']>;
  /** @deprecated POS Vendor no longer in use */
  readonly qstDelivery?: Maybe<Scalars['String']>;
  readonly sicom?: Maybe<Scalars['String']>;
  readonly sicomDelivery?: Maybe<Scalars['String']>;
  /** @deprecated POS Vendor no longer in use */
  readonly simphony?: Maybe<Scalars['String']>;
  /** @deprecated POS Vendor no longer in use */
  readonly simphonyDelivery?: Maybe<Scalars['String']>;
  /** @deprecated POS Vendor no longer in use */
  readonly simplyDelivery?: Maybe<Scalars['String']>;
  /** @deprecated POS Vendor no longer in use */
  readonly simplyDeliveryDelivery?: Maybe<Scalars['String']>;
}

export interface IPluInput {
  readonly brink?: InputMaybe<Scalars['String']>;
  readonly brinkDelivery?: InputMaybe<Scalars['String']>;
  readonly ncr?: InputMaybe<Scalars['String']>;
  readonly ncrDelivery?: InputMaybe<Scalars['String']>;
  readonly sicom?: InputMaybe<Scalars['String']>;
  readonly sicomDelivery?: InputMaybe<Scalars['String']>;
}

/** PluPrice represents the price of a menu entity. */
export interface IPluPrice {
  readonly __typename?: 'PluPrice';
  /**
   * Price Lookup Unit (PLU) is a vendor-specific menu entry identifier.
   *
   * "Compound" PLUs are individual PLUs joined with the "-" character, and
   * represent the price of entity in the context of another parent entity. For
   * example the compound PLU "123-456" represents the price of menu item "456"
   * in the combo "123".
   */
  readonly plu: Scalars['String'];
  /** PLU price in cents. */
  readonly price: Scalars['Int'];
}

export enum PosDataServiceMode {
  DELIVERY = 'delivery',
  PICKUP = 'pickup'
}

export enum PosVendor {
  BRINK = 'BRINK',
  CARROLS = 'CARROLS',
  /** @deprecated POS no longer in use */
  CONNECTOR = 'CONNECTOR',
  NCR = 'NCR',
  /** @deprecated POS no longer in use */
  OHEICS = 'OHEICS',
  /** @deprecated POS no longer in use */
  PARTNER = 'PARTNER',
  /** @deprecated POS no longer in use */
  PRODUCT_NUMBER = 'PRODUCT_NUMBER',
  QDI = 'QDI',
  /** @deprecated POS no longer in use */
  QST = 'QST',
  /** @deprecated POS no longer in use */
  RPOS = 'RPOS',
  SICOM = 'SICOM',
  /** @deprecated POS no longer in use */
  SIMPHONY = 'SIMPHONY',
  /** @deprecated POS no longer in use */
  SIMPLY_DELIVERY = 'SIMPLY_DELIVERY',
  /** @deprecated POS no longer in use */
  TABLET = 'TABLET',
  /** @deprecated POS no longer in use */
  XENIAL = 'XENIAL'
}

export interface IPrepaidDetails {
  readonly __typename?: 'PrepaidDetails';
  readonly balance: Scalars['Int'];
  readonly cardNumber: Scalars['String'];
  readonly currency: Scalars['String'];
  readonly expiryMonth: Scalars['String'];
  readonly expiryYear: Scalars['String'];
  readonly last4: Scalars['String'];
}

export interface IPrepaidStoredPaymentMethod extends IStoredPaymentMethod {
  readonly __typename?: 'PrepaidStoredPaymentMethod';
  /** Balance in the smallest currency unit (e.g. USD Cent) */
  readonly balance: Scalars['Int'];
  /** Currency */
  readonly currency: Scalars['String'];
  /** Stored payment method id */
  readonly id: Scalars['ID'];
  /** Last 4 digits of card number */
  readonly last4: Scalars['String'];
  /** Shuffled card number */
  readonly shuffledCardNumber: Scalars['String'];
  /** Type of payment method */
  readonly type: PaymentMethodType;
}

/** A transaction for a prepaid gift card */
export interface IPrepaidTransaction {
  readonly __typename?: 'PrepaidTransaction';
  /** First Data account ID */
  readonly amount: Scalars['Int'];
  readonly currencyCode: ICurrencyCode;
  readonly info: Scalars['String'];
  readonly transactionTime: Scalars['String'];
}

export interface IPrepaidTransactions {
  readonly __typename?: 'PrepaidTransactions';
  readonly amount: Scalars['Int'];
  readonly currency: Scalars['String'];
  readonly info: Scalars['String'];
  readonly timestamp: Scalars['String'];
}

/** Merge two prepaid gift cards into one. Source gets deleted. */
export interface IPrepaidsMergeInput {
  /** Destination first data gift card Account ID gets balance from source */
  readonly destinationFdAccountId?: InputMaybe<Scalars['String']>;
  /** Number of physical Gift Card which is the funding source (card being deactivated) */
  readonly sourceCardNumber: Scalars['String'];
  /** Pin number for physical gift card which is the funding source (card being deactivated) */
  readonly sourcePin?: InputMaybe<Scalars['String']>;
}

/** Reload a prepaid gift card (payment method) */
export interface IPrepaidsReloadInput {
  /** Details from Apple Pay for funding. Only one of fdAccountId or applePayDetails or googlePayDetails should be provided. */
  readonly applePayDetails?: InputMaybe<IApplePay>;
  /** Country of currency to reload card */
  readonly countryCode?: InputMaybe<CountryCode>;
  /**
   * Vaulted first data Account ID (credit) used to fund gift card. Either this or applePayDetails is required.
   * Only one of fdAccountId or applePayDetails or googlePayDetails should be provided.
   */
  readonly fdAccountId?: InputMaybe<Scalars['String']>;
  /** Amount to fund to gift card account in cents */
  readonly fundValue: Scalars['Int'];
  /** Details from Goole Pay for funding. Only one of fdAccountId or applePayDetails or googlePayDetails should be provided. */
  readonly googlePayDetails?: InputMaybe<IGooglePay>;
  /** Unique Kount Session ID 32 characters long Example: faa6370074b53928bc51ef913441e0cd (one continuous string with no spaces) */
  readonly kountSessionId?: InputMaybe<Scalars['String']>;
  /** First Data Account ID of prepaid gift card to be reloaded */
  readonly prepaidFdAccountId: Scalars['String'];
  /** Session ID as set by the FE. Note that the "sessionId" field is deprecated and will be ignored. */
  readonly sessionId?: InputMaybe<Scalars['String']>;
}

export interface IPrice {
  readonly __typename?: 'Price';
  readonly default?: Maybe<Scalars['Int']>;
  readonly max?: Maybe<Scalars['Int']>;
  readonly min?: Maybe<Scalars['Int']>;
  readonly overrides?: Maybe<ReadonlyArray<IOverride>>;
}

export interface IPriceDeliveryInput {
  readonly dropoff: IDeliveryWaypointInput;
  readonly instructions?: InputMaybe<Scalars['String']>;
  readonly quoteId?: InputMaybe<Scalars['String']>;
  readonly tipCents?: InputMaybe<Scalars['Int']>;
}

export interface IPriceOrderInput {
  /** Offers applied to cart */
  readonly appliedOffers?: InputMaybe<ReadonlyArray<InputMaybe<IAppliedOffer>>>;
  /** The brand of the store. */
  readonly brand: Brand;
  /** The order cart entries to be injected into the POS. */
  readonly cartEntries?: InputMaybe<ReadonlyArray<ICartEntryInput>>;
  /** The cart shape version. */
  readonly cartVersion?: InputMaybe<Scalars['Int']>;
  /** The locale of the customer. */
  readonly customerLocale?: InputMaybe<Scalars['String']>;
  /**
   * The name of the customer. If provided, this will
   * supersede the user's name on this order.
   */
  readonly customerName?: InputMaybe<Scalars['String']>;
  /** barcode of user's loyalty card to apply reward/visit */
  readonly loyaltyBarcode?: InputMaybe<Scalars['String']>;
  /** payment method - for cash orders */
  readonly paymentMethod?: InputMaybe<CartPaymentCardType>;
  /** The Platform */
  readonly platform?: InputMaybe<Platform>;
  /** The POS Vendor */
  readonly posVendor: PosVendor;
  /** the quoteId related to the current delivery restaurant */
  readonly quotedId?: InputMaybe<Scalars['String']>;
  /** flag for reward redemption, if true must provide loyaltyBarcode */
  readonly redeemReward?: InputMaybe<Scalars['Boolean']>;
  /**
   * The moment of redemption - the user's local date+time - in ISO format.
   * Only ISO-formatted timestamp values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
   */
  readonly redeemedOn?: InputMaybe<Scalars['String']>;
  /** Requested sale amount in cents (USD) */
  readonly requestedAmountCents: Scalars['Int'];
  /** Reward ids being applied to cart */
  readonly rewardsApplied?: InputMaybe<ReadonlyArray<InputMaybe<IAppliedReward>>>;
  /** How the order will be executed. */
  readonly serviceMode: ServiceMode;
  /** Store Address, derived from MDM. */
  readonly storeAddress: IStoreAddressInput;
  /** Store ID, derived from MDM. This value will be validated within First Data. */
  readonly storeId: Scalars['String'];
  /** The internal Store ID. */
  readonly storePosId?: InputMaybe<Scalars['String']>;
  /**
   * Cart Item swaps being applied to cart
   * @deprecated(reason: "Not needed anymore since it is included in AppliedOffer")
   */
  readonly swaps?: InputMaybe<ReadonlyArray<InputMaybe<ISwapInput>>>;
  /** vat number on the restaurant document for BK UK */
  readonly vatNumber?: InputMaybe<Scalars['String']>;
}

export interface IProcessSmgCodeResponse {
  readonly __typename?: 'ProcessSmgCodeResponse';
  readonly pointsEarned: Scalars['Int'];
  readonly status: SmgCodeStatus;
}

export interface IProductHierarchyInput {
  readonly L1?: InputMaybe<Scalars['String']>;
  readonly L2?: InputMaybe<Scalars['String']>;
  readonly L3?: InputMaybe<Scalars['String']>;
  readonly L4?: InputMaybe<Scalars['String']>;
  readonly L5?: InputMaybe<Scalars['String']>;
}

export interface IPromotion {
  readonly __typename?: 'Promotion';
  readonly id: Scalars['String'];
  readonly lineId?: Maybe<Scalars['String']>;
  readonly type: PromotionType;
}

export interface IPromotionInput {
  readonly id: Scalars['String'];
  readonly lineId?: InputMaybe<Scalars['String']>;
  readonly swap?: InputMaybe<IPromotionSwapInput>;
  readonly type: PromotionType;
}

export interface IPromotionSwapInput {
  readonly from: Scalars['String'];
  readonly lineId: Scalars['String'];
  readonly to: Scalars['String'];
  readonly type: SwapType;
}

export enum PromotionType {
  OFFER = 'OFFER',
  REWARD = 'REWARD',
  SYSTEMWIDE_PROMOTION = 'SYSTEMWIDE_PROMOTION'
}

export interface IPromotionsInput {
  readonly omitInvalids?: InputMaybe<Scalars['Boolean']>;
  readonly serviceMode?: InputMaybe<ServiceMode>;
  readonly storeId?: InputMaybe<Scalars['String']>;
  readonly subtotalAmount?: InputMaybe<Scalars['Int']>;
}

export enum ProviderType {
  APPLE = 'APPLE',
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE'
}

export interface IPurchasePrepaidAuthorized {
  readonly __typename?: 'PurchasePrepaidAuthorized';
  readonly prepaidDetails: IPrepaidDetails;
}

export interface IPurchasePrepaidInput {
  /** Payment amount */
  readonly amount: Scalars['Int'];
  /** Billing address if applicable */
  readonly billingAddress?: InputMaybe<IPaymentBillingAddressInput>;
  /** Payment currency */
  readonly currency: Scalars['String'];
  /** PSP formatted payment details (stringified) */
  readonly paymentMethod: Scalars['String'];
  /** Platform used by user to purchase prepaid */
  readonly platform?: InputMaybe<Platform>;
  /** Fraud risk data (stringified) */
  readonly riskData: Scalars['String'];
}

export type IPurchasePrepaidPayload = IPurchasePrepaidAuthorized | IPurchasePrepaidRefused;

export enum PurchasePrepaidRefusalCode {
  BANK_DECLINED = 'BANK_DECLINED'
}

export interface IPurchasePrepaidRefused {
  readonly __typename?: 'PurchasePrepaidRefused';
  readonly code: PurchasePrepaidRefusalCode;
}

export interface IQuantityPlu {
  readonly __typename?: 'QuantityPlu';
  readonly plu?: Maybe<Scalars['String']>;
  readonly qualifier?: Maybe<Scalars['String']>;
  readonly quantity?: Maybe<Scalars['Int']>;
}

export interface IQuantityPluInput {
  readonly plu?: InputMaybe<Scalars['String']>;
  readonly qualifier?: InputMaybe<Scalars['String']>;
  readonly quantity?: InputMaybe<Scalars['Int']>;
}

export interface IQuery {
  readonly __typename?: 'Query';
  readonly _empty?: Maybe<Scalars['String']>;
  readonly _loyaltyEmpty?: Maybe<Scalars['String']>;
  /** Returns an available delivery restaurant based on vendor quote given provided address and search radius. */
  readonly deliveryRestaurant: IDeliveryRestaurant;
  /**
   * Evaluate all couponIds from sanity. All cart-dependent rules are bypassed.
   * If authenticated, offers will evaluated in the context of the authenticated user id.
   */
  readonly evaluateAllUserOffers: ICouponUserOffersFeedback;
  /**
   * Evaluate user offers: either those in the cart or a set to be evaluated against one.
   * If no cart and no RBI order are specified, then all cart-dependent rules are bypassed.
   * If authenticated, offers will evaluated in the context of the authenticated user id.
   * Setting the evaluateAllCouponIds flag will ignore couponIds and evaluate all couponIds from sanity.
   */
  readonly evaluateUserOffers: ICouponUserOffersFeedback;
  /** Get the latest Payment transaction */
  readonly latestPaymentTransaction: IPaymentTransaction;
  readonly listUserCouponTokens: ICouponTokenListResponse;
  readonly loyaltyGetOrderSelection?: Maybe<ILoyaltyOrderSelection>;
  /** Get offers for both authenticated and unauthenticated users */
  readonly loyaltyOffers?: Maybe<ReadonlyArray<IOffer>>;
  /** Get offers for both authenticated and unauthenticated users */
  readonly loyaltyOffersV2?: Maybe<ReadonlyArray<ILoyaltyOffer>>;
  /** gets Order Transfer Selection by associated OTP code */
  readonly loyaltyOrderSelection?: Maybe<ILoyaltyOrderSelectionTransfer>;
  /** gets Order Transfer Selection by key based on the ostType */
  readonly loyaltyOrderSelectionByMultipleType?: Maybe<ReadonlyArray<Maybe<ILoyaltyOrderSelectionTransfer>>>;
  /** gets Order Transfer Selection by key based on the ostType */
  readonly loyaltyOrderSelectionByType?: Maybe<ILoyaltyOrderSelectionTransfer>;
  /** Get quests by loyaltyId. */
  readonly loyaltyQuests?: Maybe<ReadonlyArray<IQuest>>;
  /** Get quests by loyaltyId. */
  readonly loyaltyQuestsV2?: Maybe<ReadonlyArray<ILoyaltyQuest>>;
  /**
   * Get rewards by loyaltyId and / or reward ids
   * optionally accepts service mode and store id for rule evaluation
   */
  readonly loyaltyRewards?: Maybe<ReadonlyArray<IReward>>;
  /**
   * Get rewards by loyaltyId and / or reward ids
   * optionally accepts service mode and store id for rule evaluation
   */
  readonly loyaltyRewardsV2?: Maybe<ReadonlyArray<ILoyaltyReward>>;
  /** Get loyalty user by loyalty id */
  readonly loyaltyUser?: Maybe<IUser>;
  /** Get loyalty user by loyalty id */
  readonly loyaltyUserV2?: Maybe<ILoyaltyUser>;
  /** Query an order by order id for the current user. */
  readonly order?: Maybe<IOrder>;
  /** gets Order Transfer Selection by associated OTP code */
  readonly orderSelection?: Maybe<IOrderSelectionTransfer>;
  /** gets Order Transfer Selection by key based on the ostType */
  readonly orderSelectionByMultipleType?: Maybe<ReadonlyArray<Maybe<IOrderSelectionTransfer>>>;
  /** gets Order Transfer Selection by key based on the ostType */
  readonly orderSelectionByType?: Maybe<IOrderSelectionTransfer>;
  readonly paymentConfig: IPaymentConfig;
  readonly paymentPreferences: IPaymentPreferences;
  /** DEPRECATED! Use plusV2 instead. */
  readonly plus?: Maybe<ReadonlyArray<IMenuItem>>;
  /** Returns the PLU-price map for a store. */
  readonly plusV2?: Maybe<ReadonlyArray<IPluPrice>>;
  readonly prepaidByNumber: IPrepaidDetails;
  readonly prepaidTransactionsById: ReadonlyArray<IPrepaidTransactions>;
  readonly prepaidTransactionsByNumber: ReadonlyArray<Maybe<IPrepaidTransactions>>;
  /** Return transaction history for prepaid gift card account from FD */
  readonly prepaidsTransactions?: Maybe<ITransactionListResponse>;
  /** Returns a restaurant entity given store id */
  readonly restaurant: IRestaurant;
  /**
   * Returns a list of restaurants based on provided filters.
   * private cache control because this provides legacy NEARBY (not technically public but lets keep it same as before)
   * and RECENT and FAVORITE should not be CDN cached because they are per user.
   * @todo: Return result with pagination metadata
   */
  readonly restaurants?: Maybe<IRestaurantsConnection>;
  /** Returns a list of restaurants based on provided filters. */
  readonly restaurantsV2?: Maybe<IRestaurantsFullSearchResult>;
  readonly signUpComplete?: Maybe<Scalars['Boolean']>;
  readonly storeMenu?: Maybe<ReadonlyArray<IEntity>>;
  readonly storeMenuWithConnectorHours?: Maybe<ReadonlyArray<IMenuEntityWithHours>>;
  /** Get stored payment methods */
  readonly storedPaymentMethods: ReadonlyArray<IStoredPaymentMethod>;
  readonly uniqueStores: IOrderListResponse;
  /** Fetch all accounts for current customer (limit 100) */
  readonly userAccounts?: Maybe<IAccountListResponse>;
  /** Get a user favorite */
  readonly userFavorite: IFavorite;
  /** List of user favorites */
  readonly userFavorites: IFavoriteList;
  readonly userGeo: IUserGeo;
  /**
   * Query all orders for current user.
   *
   * Note that the "userId" field is deprecated and will be ignored.
   */
  readonly userOrders: IOrderListResponse;
  /** Get user phone from braze */
  readonly userPhoneFromBraze?: Maybe<IBrazeUserPhone>;
}


export interface IQueryDeliveryRestaurantArgs {
  dropoff: IDeliveryWaypointInput;
  platform?: InputMaybe<Platform>;
  searchRadius: Scalars['Float'];
}


export interface IQueryEvaluateAllUserOffersArgs {
  locale?: InputMaybe<Locale>;
  platform?: InputMaybe<Platform>;
  redeemedOn: Scalars['String'];
  serviceMode?: InputMaybe<ServiceMode>;
  storeId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface IQueryEvaluateUserOffersArgs {
  cart?: InputMaybe<IPriceOrderInput>;
  couponIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  evaluateAllCouponIds?: InputMaybe<Scalars['Boolean']>;
  locale?: InputMaybe<Locale>;
  platform?: InputMaybe<Platform>;
  rbiOrderId?: InputMaybe<Scalars['ID']>;
  redeemedOn: Scalars['String'];
  serviceMode?: InputMaybe<ServiceMode>;
  storeId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface IQueryLatestPaymentTransactionArgs {
  feCountryCode?: InputMaybe<IsoCountryCode>;
}


export interface IQueryListUserCouponTokensArgs {
  couponId?: InputMaybe<Scalars['ID']>;
  expiresAfter?: InputMaybe<Scalars['String']>;
  expiresBefore?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  resumeAfter?: InputMaybe<Scalars['String']>;
  sortAscending?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface IQueryLoyaltyGetOrderSelectionArgs {
  key: Scalars['String'];
  type: LoyaltyOrderSelectionType;
}


export interface IQueryLoyaltyOffersArgs {
  configId?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  isTransactionCreation?: InputMaybe<Scalars['Boolean']>;
  loyaltyId?: InputMaybe<Scalars['ID']>;
  omitInvalids?: InputMaybe<Scalars['Boolean']>;
  redemptionTypes?: InputMaybe<ReadonlyArray<OfferRedemptionType>>;
  serviceMode?: InputMaybe<ServiceMode>;
  storeId?: InputMaybe<Scalars['String']>;
  subtotalAmount?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IOffersInput>;
}


export interface IQueryLoyaltyOffersV2Args {
  configId?: InputMaybe<Scalars['LoyaltyID']>;
  ids?: InputMaybe<ReadonlyArray<Scalars['LoyaltyID']>>;
  isTransactionCreation?: InputMaybe<Scalars['Boolean']>;
  loyaltyId?: InputMaybe<Scalars['LoyaltyID']>;
  omitInvalids?: InputMaybe<Scalars['Boolean']>;
  redemptionTypes?: InputMaybe<ReadonlyArray<LoyaltyOfferRedemptionType>>;
  serviceMode?: InputMaybe<LoyaltyServiceMode>;
  storeId?: InputMaybe<Scalars['String']>;
  subtotalAmount?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ILoyaltyOffersInput>;
}


export interface IQueryLoyaltyOrderSelectionArgs {
  otp: Scalars['String'];
}


export interface IQueryLoyaltyOrderSelectionByMultipleTypeArgs {
  Input: ReadonlyArray<ILoyaltyGetOrderSelectionByMultipleType>;
}


export interface IQueryLoyaltyOrderSelectionByTypeArgs {
  key: Scalars['String'];
  ostType: LoyaltyOstType;
}


export interface IQueryLoyaltyQuestsArgs {
  loyaltyId?: InputMaybe<Scalars['ID']>;
}


export interface IQueryLoyaltyQuestsV2Args {
  loyaltyId?: InputMaybe<Scalars['LoyaltyID']>;
}


export interface IQueryLoyaltyRewardsArgs {
  ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  isTransactionCreation?: InputMaybe<Scalars['Boolean']>;
  loyaltyId?: InputMaybe<Scalars['ID']>;
  omitInvalids?: InputMaybe<Scalars['Boolean']>;
  serviceMode?: InputMaybe<ServiceMode>;
  storeId?: InputMaybe<Scalars['String']>;
  subtotalAmount?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<IRewardsInput>;
}


export interface IQueryLoyaltyRewardsV2Args {
  ids?: InputMaybe<ReadonlyArray<Scalars['LoyaltyID']>>;
  isTransactionCreation?: InputMaybe<Scalars['Boolean']>;
  loyaltyId?: InputMaybe<Scalars['LoyaltyID']>;
  omitInvalids?: InputMaybe<Scalars['Boolean']>;
  serviceMode?: InputMaybe<LoyaltyServiceMode>;
  storeId?: InputMaybe<Scalars['String']>;
  subtotalAmount?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ILoyaltyRewardsInput>;
}


export interface IQueryLoyaltyUserArgs {
  loyaltyId: Scalars['ID'];
}


export interface IQueryLoyaltyUserV2Args {
  loyaltyId: Scalars['LoyaltyID'];
}


export interface IQueryOrderArgs {
  rbiOrderId: Scalars['ID'];
}


export interface IQueryOrderSelectionArgs {
  otp: Scalars['String'];
}


export interface IQueryOrderSelectionByMultipleTypeArgs {
  Input: ReadonlyArray<IGetOrderSelectionByMultipleType>;
}


export interface IQueryOrderSelectionByTypeArgs {
  key: Scalars['String'];
  ostType: OstType;
}


export interface IQueryPlusArgs {
  serviceMode?: InputMaybe<PosDataServiceMode>;
  storeId: Scalars['ID'];
}


export interface IQueryPlusV2Args {
  serviceMode?: InputMaybe<PosDataServiceMode>;
  storeId: Scalars['ID'];
}


export interface IQueryPrepaidByNumberArgs {
  cardNumber: Scalars['String'];
}


export interface IQueryPrepaidTransactionsByIdArgs {
  storedPaymentMethodId: Scalars['String'];
}


export interface IQueryPrepaidTransactionsByNumberArgs {
  cardNumber: Scalars['String'];
}


export interface IQueryPrepaidsTransactionsArgs {
  cardNumber?: InputMaybe<Scalars['String']>;
  fdAccountId?: InputMaybe<Scalars['String']>;
}


export interface IQueryRestaurantArgs {
  localDateTime?: InputMaybe<Scalars['String']>;
  storeId?: InputMaybe<Scalars['String']>;
  storeNumber?: InputMaybe<Scalars['String']>;
}


export interface IQueryRestaurantsArgs {
  input?: InputMaybe<IRestaurantsInput>;
}


export interface IQuerySignUpCompleteArgs {
  jwt: Scalars['String'];
}


export interface IQueryStoreMenuArgs {
  channel: Channel;
  region: Scalars['String'];
  serviceMode?: InputMaybe<PosDataServiceMode>;
  storeId: Scalars['ID'];
  variantName?: InputMaybe<Scalars['String']>;
}


export interface IQueryStoreMenuWithConnectorHoursArgs {
  channel: Channel;
  region: Scalars['String'];
  serviceMode?: InputMaybe<PosDataServiceMode>;
  storeId: Scalars['ID'];
}


export interface IQueryUniqueStoresArgs {
  createdAfter?: InputMaybe<Scalars['String']>;
  createdBefore?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderStatuses?: InputMaybe<ReadonlyArray<RbiOrderStatus>>;
  resumeAfter?: InputMaybe<Scalars['String']>;
  sortAscending?: InputMaybe<Scalars['Boolean']>;
}


export interface IQueryUserAccountsArgs {
  feCountryCode?: InputMaybe<IsoCountryCode>;
}


export interface IQueryUserFavoriteArgs {
  favoriteId: Scalars['String'];
}


export interface IQueryUserFavoritesArgs {
  limit?: InputMaybe<Scalars['Int']>;
  resumeAfter?: InputMaybe<Scalars['String']>;
  sortAscending?: InputMaybe<Scalars['Boolean']>;
}


export interface IQueryUserOrdersArgs {
  createdAfter?: InputMaybe<Scalars['String']>;
  createdBefore?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderStatuses?: InputMaybe<ReadonlyArray<RbiOrderStatus>>;
  resumeAfter?: InputMaybe<Scalars['String']>;
  shouldFilterByRegion?: InputMaybe<Scalars['Boolean']>;
  sortAscending?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['ID']>;
}


export interface IQueryUserPhoneFromBrazeArgs {
  brazeId?: InputMaybe<Scalars['String']>;
}

export interface IQuest {
  readonly __typename?: 'Quest';
  readonly bonusPoints?: Maybe<Scalars['Int']>;
  readonly completions?: Maybe<ReadonlyArray<Maybe<IQuestCompletion>>>;
  readonly configId?: Maybe<Scalars['ID']>;
  readonly createdAt: Scalars['String'];
  readonly endDate: Scalars['String'];
  readonly externalIdentifiers?: Maybe<ReadonlyArray<Maybe<IExternalIdentifiers>>>;
  readonly id: Scalars['ID'];
  readonly incentiveId?: Maybe<Scalars['ID']>;
  readonly incentiveRedeemed: Scalars['Boolean'];
  readonly incentiveType: QuestIncentiveType;
  readonly lastCompletion?: Maybe<IQuestCompletion>;
  readonly sanityId?: Maybe<Scalars['String']>;
  readonly startDate: Scalars['String'];
  readonly status: QuestStatus;
  readonly steps?: Maybe<ReadonlyArray<IQuestStep>>;
  readonly type: QuestType;
}

export interface IQuestCompletion {
  readonly __typename?: 'QuestCompletion';
  readonly benefitId: Scalars['String'];
  readonly completedAt: Scalars['String'];
  readonly redeemed: Scalars['Boolean'];
}

export enum QuestIncentiveType {
  BONUS_POINTS = 'BONUS_POINTS',
  OFFER = 'OFFER',
  REWARD = 'REWARD'
}

export enum QuestStatus {
  ACTIVATED = 'ACTIVATED',
  COMPLETED = 'COMPLETED',
  NOT_COMPLETED = 'NOT_COMPLETED',
  NOT_ENROLLED = 'NOT_ENROLLED'
}

export interface IQuestStep {
  readonly __typename?: 'QuestStep';
  readonly cartRequirements?: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ICartRequirement>>>>>;
  readonly completedAt?: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly status: QuestStepStatus;
}

export enum QuestStepStatus {
  COMPLETED = 'COMPLETED',
  NOT_COMPLETED = 'NOT_COMPLETED'
}

export enum QuestType {
  CONFIG = 'CONFIG',
  GLOBAL = 'GLOBAL',
  PERSONALIZED = 'PERSONALIZED'
}

export interface IQuestsInput {
  readonly activeOrEligible?: InputMaybe<Scalars['Boolean']>;
}

export interface IRbiCartEntryInput {
  readonly children?: InputMaybe<ReadonlyArray<IRbiCartEntryInput>>;
  readonly lineId?: InputMaybe<Scalars['String']>;
  readonly price?: InputMaybe<Scalars['Int']>;
  readonly quantity: Scalars['Int'];
  readonly sanityId: Scalars['String'];
}

export enum RbiChannel {
  APP = 'APP',
  ORDERLESS = 'ORDERLESS',
  RECEIPT = 'RECEIPT',
  REMEDIATION = 'REMEDIATION',
  RESTAURANT = 'RESTAURANT',
  WEB = 'WEB'
}

export interface IRbiOrder {
  readonly __typename?: 'RbiOrder';
  readonly refund?: Maybe<IRefund>;
}

export enum RbiOrderStatus {
  CATERING_DECLINED = 'CATERING_DECLINED',
  CATERING_ERROR = 'CATERING_ERROR',
  CATERING_PLACED = 'CATERING_PLACED',
  CATERING_SUCCESSFUL = 'CATERING_SUCCESSFUL',
  INSERT_ERROR = 'INSERT_ERROR',
  INSERT_REQUESTED = 'INSERT_REQUESTED',
  INSERT_SUCCESSFUL = 'INSERT_SUCCESSFUL',
  KOUNT_DENIAL = 'KOUNT_DENIAL',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  PAYMENT_REQUESTED = 'PAYMENT_REQUESTED',
  PAYMENT_REQUIRED = 'PAYMENT_REQUIRED',
  PAYMENT_SUCCESSFUL = 'PAYMENT_SUCCESSFUL',
  PRICE_ERROR = 'PRICE_ERROR',
  PRICE_REQUESTED = 'PRICE_REQUESTED',
  PRICE_SUCCESSFUL = 'PRICE_SUCCESSFUL',
  REFUND_ERROR = 'REFUND_ERROR',
  REFUND_REQUESTED = 'REFUND_REQUESTED',
  REFUND_SUCCESSFUL = 'REFUND_SUCCESSFUL',
  UPDATE_ERROR = 'UPDATE_ERROR',
  UPDATE_REQUESTED = 'UPDATE_REQUESTED',
  UPDATE_SUCCESSFUL = 'UPDATE_SUCCESSFUL',
  VALIDATION_ERROR = 'VALIDATION_ERROR'
}

export interface IRbiParentChildPlu {
  readonly __typename?: 'RbiParentChildPlu';
  readonly childPlu?: Maybe<Scalars['String']>;
  readonly plu?: Maybe<Scalars['String']>;
}

export interface IRbiParentChildPluInput {
  readonly childPlu?: InputMaybe<Scalars['String']>;
  readonly plu?: InputMaybe<Scalars['String']>;
}

export interface IRbiQuantityPlu {
  readonly __typename?: 'RbiQuantityPlu';
  readonly plu?: Maybe<Scalars['String']>;
  readonly qualifier?: Maybe<Scalars['String']>;
  readonly quantity?: Maybe<Scalars['Int']>;
}

export interface IRbiQuantityPluInput {
  readonly plu?: InputMaybe<Scalars['String']>;
  readonly qualifier?: InputMaybe<Scalars['String']>;
  readonly quantity?: InputMaybe<Scalars['Int']>;
}

export interface IRbiSizeBasedPlu {
  readonly __typename?: 'RbiSizeBasedPlu';
  readonly comboPlu?: Maybe<Scalars['String']>;
  readonly comboSize?: Maybe<Scalars['String']>;
}

export interface IRbiSizeBasedPluInput {
  readonly comboPlu?: InputMaybe<Scalars['String']>;
  readonly comboSize?: InputMaybe<Scalars['String']>;
}

export interface IRbiVendorConfig {
  readonly __typename?: 'RbiVendorConfig';
  readonly constantPlu?: Maybe<Scalars['String']>;
  readonly discountPlu?: Maybe<Scalars['String']>;
  readonly multiConstantPlus?: Maybe<ReadonlyArray<Maybe<IRbiQuantityPlu>>>;
  readonly parentChildPlu?: Maybe<IRbiParentChildPlu>;
  readonly parentSanityId?: Maybe<Scalars['String']>;
  readonly pluType?: Maybe<Scalars['String']>;
  readonly pullUpLevels?: Maybe<Scalars['Int']>;
  readonly quantityBasedPlu?: Maybe<ReadonlyArray<Maybe<IRbiQuantityPlu>>>;
  readonly sizeBasedPlu?: Maybe<IRbiSizeBasedPlu>;
}

export interface IRbiVendorConfigInput {
  readonly constantPlu?: InputMaybe<Scalars['String']>;
  readonly discountPlu?: InputMaybe<Scalars['String']>;
  readonly multiConstantPlus?: InputMaybe<ReadonlyArray<InputMaybe<IRbiQuantityPluInput>>>;
  readonly parentChildPlu?: InputMaybe<IRbiParentChildPluInput>;
  readonly parentSanityId?: InputMaybe<Scalars['String']>;
  readonly pluType?: InputMaybe<Scalars['String']>;
  readonly pullUpLevels?: InputMaybe<Scalars['Int']>;
  readonly quantityBasedPlu?: InputMaybe<ReadonlyArray<InputMaybe<IRbiQuantityPluInput>>>;
  readonly sizeBasedPlu?: InputMaybe<IRbiSizeBasedPluInput>;
}

export interface IRbiVendorConfigs {
  readonly __typename?: 'RbiVendorConfigs';
  readonly brink?: Maybe<IRbiVendorConfig>;
  readonly brinkDelivery?: Maybe<IRbiVendorConfig>;
  readonly carrols?: Maybe<IRbiVendorConfig>;
  readonly carrolsDelivery?: Maybe<IRbiVendorConfig>;
  /** HDX is not currently supported */
  readonly hdx?: Maybe<IRbiVendorConfig>;
  readonly ncr?: Maybe<IRbiVendorConfig>;
  readonly ncrDelivery?: Maybe<IRbiVendorConfig>;
  /** Deprecated */
  readonly oheics?: Maybe<IRbiVendorConfig>;
  /** Deprecated */
  readonly oheicsDelivery?: Maybe<IRbiVendorConfig>;
  readonly partner?: Maybe<IRbiVendorConfig>;
  readonly partnerDelivery?: Maybe<IRbiVendorConfig>;
  readonly productNumber?: Maybe<IRbiVendorConfig>;
  readonly productNumberDelivery?: Maybe<IRbiVendorConfig>;
  readonly qdi?: Maybe<IRbiVendorConfig>;
  readonly qdiDelivery?: Maybe<IRbiVendorConfig>;
  /** QST is not currently supported */
  readonly qst?: Maybe<IRbiVendorConfig>;
  readonly rpos?: Maybe<IRbiVendorConfig>;
  readonly rposDelivery?: Maybe<IRbiVendorConfig>;
  readonly sicom?: Maybe<IRbiVendorConfig>;
  readonly sicomDelivery?: Maybe<IRbiVendorConfig>;
  readonly simphony?: Maybe<IRbiVendorConfig>;
  readonly simphonyDelivery?: Maybe<IRbiVendorConfig>;
  readonly tablet?: Maybe<IRbiVendorConfig>;
  readonly tabletDelivery?: Maybe<IRbiVendorConfig>;
  readonly xenial?: Maybe<IRbiVendorConfig>;
  readonly xenialDelivery?: Maybe<IRbiVendorConfig>;
}

export interface IRbiVendorConfigsInput {
  readonly brink?: InputMaybe<IRbiVendorConfigInput>;
  readonly brinkDelivery?: InputMaybe<IRbiVendorConfigInput>;
  readonly carrols?: InputMaybe<IRbiVendorConfigInput>;
  readonly carrolsDelivery?: InputMaybe<IRbiVendorConfigInput>;
  /** HDX is not currently supported */
  readonly hdx?: InputMaybe<IRbiVendorConfigInput>;
  readonly ncr?: InputMaybe<IRbiVendorConfigInput>;
  readonly ncrDelivery?: InputMaybe<IRbiVendorConfigInput>;
  /** Deprecated */
  readonly oheics?: InputMaybe<IRbiVendorConfigInput>;
  /** Deprecated */
  readonly oheicsDelivery?: InputMaybe<IRbiVendorConfigInput>;
  readonly partner?: InputMaybe<IRbiVendorConfigInput>;
  readonly partnerDelivery?: InputMaybe<IRbiVendorConfigInput>;
  readonly productNumber?: InputMaybe<IRbiVendorConfigInput>;
  readonly productNumberDelivery?: InputMaybe<IRbiVendorConfigInput>;
  readonly qdi?: InputMaybe<IRbiVendorConfigInput>;
  readonly qdiDelivery?: InputMaybe<IRbiVendorConfigInput>;
  /** QST is not currently supported */
  readonly qst?: InputMaybe<IRbiVendorConfigInput>;
  readonly rpos?: InputMaybe<IRbiVendorConfigInput>;
  readonly rposDelivery?: InputMaybe<IRbiVendorConfigInput>;
  readonly sicom?: InputMaybe<IRbiVendorConfigInput>;
  readonly sicomDelivery?: InputMaybe<IRbiVendorConfigInput>;
  readonly simphony?: InputMaybe<IRbiVendorConfigInput>;
  readonly simphonyDelivery?: InputMaybe<IRbiVendorConfigInput>;
  readonly tablet?: InputMaybe<IRbiVendorConfigInput>;
  readonly tabletDelivery?: InputMaybe<IRbiVendorConfigInput>;
  readonly xenial?: InputMaybe<IRbiVendorConfigInput>;
  readonly xenialDelivery?: InputMaybe<IRbiVendorConfigInput>;
}

export interface IRedeemedCouponResponse {
  readonly code: Scalars['String'];
  readonly isRedeemed: Scalars['Boolean'];
  readonly message?: Maybe<Scalars['String']>;
  readonly reason?: Maybe<Scalars['String']>;
}

export interface IRefund {
  readonly __typename?: 'Refund';
  /** Reason picked from a predefined dropdown list */
  readonly primaryReason: RefundReason;
  /** Items that were refunded. Undefined if order was fully refunded. */
  readonly refundedItems?: Maybe<ReadonlyArray<Maybe<IRefundedItem>>>;
  /** Optional reason either added by a support agent or an user via the support form */
  readonly secondaryReason?: Maybe<Scalars['String']>;
  readonly subtotal: Scalars['String'];
  readonly tax: Scalars['String'];
  /** Date time when refund was issued */
  readonly transactionDateTime: Scalars['String'];
}

export interface IRefundEligibilityResponse {
  readonly __typename?: 'RefundEligibilityResponse';
  readonly eligible: Scalars['Boolean'];
  readonly ineligibilityReason?: Maybe<RefundIneligibilityReason>;
}

export enum RefundIneligibilityReason {
  ALREADY_REFUNDED = 'ALREADY_REFUNDED',
  DISABLED = 'DISABLED',
  INVALID_ORDER_STATUS = 'INVALID_ORDER_STATUS',
  INVALID_PAYMENT_TYPE = 'INVALID_PAYMENT_TYPE',
  INVALID_USER_ID = 'INVALID_USER_ID',
  ORDER_BEING_DELIVERED = 'ORDER_BEING_DELIVERED',
  ORDER_NOT_FOUND = 'ORDER_NOT_FOUND',
  OVER_ALLOWED_REFUND_AMOUNT = 'OVER_ALLOWED_REFUND_AMOUNT',
  REFUNDED_MAX_TIMES = 'REFUNDED_MAX_TIMES'
}

export enum RefundReason {
  CATERING_ORDER_DECLINED = 'CATERING_ORDER_DECLINED',
  CATERING_ORDER_ERROR = 'CATERING_ORDER_ERROR',
  CATERING_ORDER_TIME_OUT = 'CATERING_ORDER_TIME_OUT',
  CUSTOMER_OVERCHARGED = 'CUSTOMER_OVERCHARGED',
  CUSTOMER_REQUESTED_CANCEL_ORDER = 'CUSTOMER_REQUESTED_CANCEL_ORDER',
  FOOD_QUALITY_ISSUE = 'FOOD_QUALITY_ISSUE',
  INCORRECT_CUSTOMIZATION = 'INCORRECT_CUSTOMIZATION',
  ITEMS_OUT_OF_STOCK = 'ITEMS_OUT_OF_STOCK',
  MISSING_OR_INCORRECT_ITEM = 'MISSING_OR_INCORRECT_ITEM',
  MOBILE_ORDERING_TECHNICAL_ISSUE = 'MOBILE_ORDERING_TECHNICAL_ISSUE',
  ORDER_ARRIVED_LATE = 'ORDER_ARRIVED_LATE',
  ORDER_CANCELLED = 'ORDER_CANCELLED',
  ORDER_COMMIT_ERROR = 'ORDER_COMMIT_ERROR',
  ORDER_NEVER_ARRIVED = 'ORDER_NEVER_ARRIVED',
  ORDER_WAS_DAMAGED = 'ORDER_WAS_DAMAGED',
  OTHER_ADD_COMMENT = 'OTHER_ADD_COMMENT',
  RECEIVED_INCORRECT_ORDER = 'RECEIVED_INCORRECT_ORDER',
  RESTAURANT_CLOSED = 'RESTAURANT_CLOSED',
  RESTAURANT_COULDNT_FIND_ORDER = 'RESTAURANT_COULDNT_FIND_ORDER'
}

export interface IRefundRequestResponse {
  readonly __typename?: 'RefundRequestResponse';
  /** Requested refund amount in cents */
  readonly refundRequestAmountCents: Scalars['Int'];
  /** Date time when refund was requested */
  readonly requestDateTime?: Maybe<Scalars['String']>;
}

export interface IRefundedItem {
  readonly __typename?: 'RefundedItem';
  /** Name of item refunded */
  readonly name?: Maybe<Scalars['String']>;
  /** Plu of item refunded */
  readonly plu?: Maybe<Scalars['String']>;
  /** Amount refunded in dollars for item */
  readonly refundAmount?: Maybe<Scalars['String']>;
  /** Quantity of item refunded */
  readonly refundQuantity?: Maybe<Scalars['String']>;
  /** SanityId of item refunded */
  readonly sanityId?: Maybe<Scalars['String']>;
  /** Type of item refunded */
  readonly type?: Maybe<CartEntryType>;
}

/** A Prepaid Reload response (payment method) */
export interface IReload {
  readonly __typename?: 'Reload';
  /** dollar amount gift card begins with */
  readonly beginBalance: Scalars['Int'];
  readonly currencyCode: Scalars['String'];
  /** current gift card balance in dollars */
  readonly currentBalance: Scalars['Int'];
  /** First Data account id of gift card */
  readonly fdAccountId: Scalars['String'];
  readonly fdCorrelationId?: Maybe<Scalars['String']>;
  readonly transactionId: Scalars['String'];
}

export interface IReloadPrepaidAuthorized {
  readonly __typename?: 'ReloadPrepaidAuthorized';
  readonly prepaidDetails: IPrepaidDetails;
}

export interface IReloadPrepaidInput {
  /** Payment amount */
  readonly amount: Scalars['Int'];
  /** Billing address if applicable */
  readonly billingAddress?: InputMaybe<IPaymentBillingAddressInput>;
  /** Payment currency */
  readonly currency: Scalars['String'];
  /** Destination payment method ID of the prepaid card to reload */
  readonly destinationPaymentMethodId: Scalars['String'];
  /** PSP formatted payment details (stringified) */
  readonly paymentMethod: Scalars['String'];
  /** Platform used by user to purchase prepaid */
  readonly platform?: InputMaybe<Platform>;
  /** Fraud risk data (stringified) */
  readonly riskData: Scalars['String'];
}

export type IReloadPrepaidPayload = IReloadPrepaidAuthorized | IReloadPrepaidRefused;

export interface IReloadPrepaidRefused {
  readonly __typename?: 'ReloadPrepaidRefused';
  readonly code: PurchasePrepaidRefusalCode;
}

export interface IRemoveDeliveryAddressInput {
  readonly addressLine1?: InputMaybe<Scalars['String']>;
  readonly addressLine2?: InputMaybe<Scalars['String']>;
  readonly alias?: InputMaybe<Scalars['String']>;
  readonly city?: InputMaybe<Scalars['String']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
}

export interface IResendOtpInput {
  /**
   * User email. Only one of email or phone number should be provided
   * Example foobar@example.com
   */
  readonly email?: InputMaybe<Scalars['String']>;
  /**
   * User phone number. Only one of email or phone number should be provided
   * Example 4258675309
   */
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
  /** Requestor's platform */
  readonly platform: Platform;
}

export interface IRestaurant {
  readonly __typename?: 'Restaurant';
  /**
   * Boolean value for whether or not the restaurant is available
   * This is determined by the restaurant's heartbeat data stored in sanity
   */
  readonly available: Scalars['Boolean'];
  /** Catering operating hours */
  readonly cateringHours?: Maybe<IOperatingHours>;
  /** Curbside operating hours */
  readonly curbsideHours?: Maybe<IOperatingHours>;
  /** Day parts from sanity */
  readonly dayParts?: Maybe<ReadonlyArray<Maybe<IDayPart>>>;
  /** Delivery operating hours */
  readonly deliveryHours?: Maybe<IOperatingHours>;
  /** Dining room operating hours */
  readonly diningRoomHours?: Maybe<IOperatingHours>;
  /** Drive through operating hours */
  readonly driveThruHours?: Maybe<IOperatingHours>;
  /** Fastest Service Mode from Sanity */
  readonly fastestServiceMode?: Maybe<ServiceMode>;
  /**
   * Contains information about the store service hours for a range of X consecutive days,
   * where X is specified in the rolling window param
   * starting from the day before the request is made.
   */
  readonly futureServiceHours: ReadonlyArray<IFutureServiceHours>;
  /**
   * DEPRECATED
   * Last record heartbeat timestamp on this restaurant
   * @deprecated Only for internal use
   */
  readonly lastHeartbeatTimestamp?: Maybe<Scalars['String']>;
  /** Pos Vendor associated with restaurant */
  readonly posVendor?: Maybe<Scalars['String']>;
  /**
   * The MDM number identifier. This is the `number` property on the sanity store obj
   * this is NOT the `_id` property
   */
  readonly storeId?: Maybe<Scalars['String']>;
  /** The restaurant timezone */
  readonly timezone?: Maybe<Scalars['String']>;
  /** Restaurant Vat Number for BK UK */
  readonly vatNumber?: Maybe<Scalars['String']>;
}

export interface IRestaurantEdge extends IEdge {
  readonly __typename?: 'RestaurantEdge';
  readonly cursor: Scalars['String'];
  readonly node: IRestaurantNode;
}

/** Extended restaurant data containing all fields from Sanity + Dynamo */
export interface IRestaurantNode extends INode {
  readonly __typename?: 'RestaurantNode';
  /** While pagination spec requires an id, Sanity and Frontend use _id */
  readonly _id?: Maybe<Scalars['String']>;
  readonly cateringHours?: Maybe<IOperatingHours>;
  readonly chaseMerchantId?: Maybe<Scalars['String']>;
  readonly curbsideHours?: Maybe<IOperatingHours>;
  readonly deliveryHours?: Maybe<IOperatingHours>;
  readonly diningRoomHours?: Maybe<IOperatingHours>;
  readonly distanceInMiles?: Maybe<Scalars['Int']>;
  readonly drinkStationType?: Maybe<Scalars['String']>;
  readonly driveThruHours?: Maybe<IOperatingHours>;
  readonly driveThruLaneType?: Maybe<Scalars['String']>;
  readonly email?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly environment?: Maybe<RestaurantStatus>;
  readonly fastestServiceMode?: Maybe<ServiceMode>;
  readonly franchiseGroupId?: Maybe<Scalars['Int']>;
  readonly franchiseGroupName?: Maybe<Scalars['String']>;
  readonly frontCounterClosed?: Maybe<Scalars['Boolean']>;
  readonly hasBreakfast?: Maybe<Scalars['Boolean']>;
  readonly hasBurgersForBreakfast?: Maybe<Scalars['Boolean']>;
  readonly hasCatering?: Maybe<Scalars['Boolean']>;
  readonly hasCurbside?: Maybe<Scalars['Boolean']>;
  readonly hasDelivery?: Maybe<Scalars['Boolean']>;
  readonly hasDineIn?: Maybe<Scalars['Boolean']>;
  readonly hasDriveThru?: Maybe<Scalars['Boolean']>;
  readonly hasLateNightMenu?: Maybe<Scalars['Boolean']>;
  readonly hasLoyalty?: Maybe<Scalars['Boolean']>;
  readonly hasMobileOrdering?: Maybe<Scalars['Boolean']>;
  readonly hasParking?: Maybe<Scalars['Boolean']>;
  readonly hasPlayground?: Maybe<Scalars['Boolean']>;
  readonly hasTableService?: Maybe<Scalars['Boolean']>;
  readonly hasTakeOut?: Maybe<Scalars['Boolean']>;
  readonly hasWifi?: Maybe<Scalars['Boolean']>;
  /** Arbitrary unique identifier. */
  readonly id?: Maybe<Scalars['ID']>;
  /**
   * Boolean value for whether or not the restaurant is available
   * This is determined by the restaurant's heartbeat data stored in sanity
   */
  readonly isAvailable: Scalars['Boolean'];
  readonly isDarkKitchen?: Maybe<Scalars['Boolean']>;
  readonly isFavorite: Scalars['Boolean'];
  readonly isHalal?: Maybe<Scalars['Boolean']>;
  readonly isRecent: Scalars['Boolean'];
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  readonly mobileOrderingStatus?: Maybe<OrderingStatus>;
  readonly name?: Maybe<Scalars['String']>;
  readonly number?: Maybe<Scalars['String']>;
  readonly parkingType?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly physicalAddress?: Maybe<IPhysicalAddress>;
  readonly playgroundType?: Maybe<Scalars['String']>;
  readonly pos?: Maybe<IRestaurantPos>;
  readonly posRestaurantId?: Maybe<Scalars['String']>;
  /** Pos Vendor associated with restaurant */
  readonly posVendor?: Maybe<Scalars['String']>;
  readonly restaurantImage?: Maybe<ISanityImage>;
  readonly restaurantPosData?: Maybe<IRestaurantPosData>;
  readonly status?: Maybe<Scalars['String']>;
  /**
   * The MDM number identifier. This is the `number` property on the sanity store obj
   * this is NOT the `_id` property
   */
  readonly storeId?: Maybe<Scalars['String']>;
  /** The restaurant timezone */
  readonly timezone?: Maybe<Scalars['String']>;
  readonly vatNumber?: Maybe<Scalars['String']>;
}

export interface IRestaurantPos {
  readonly __typename?: 'RestaurantPos';
  readonly vendor?: Maybe<Scalars['String']>;
}

export interface IRestaurantPosData {
  readonly __typename?: 'RestaurantPosData';
  readonly _id?: Maybe<Scalars['String']>;
}

export enum RestaurantStatus {
  DEV = 'DEV',
  PROD = 'PROD'
}

export interface IRestaurantTimeSlot {
  readonly __typename?: 'RestaurantTimeSlot';
  /** Store close time. */
  readonly closes: Scalars['String'];
  /** Calendar day that this time slot reflects. */
  readonly date: Scalars['String'];
  /** Flag to determine if the store is closed. */
  readonly isClosed?: Maybe<Scalars['Boolean']>;
  /** Store open time. */
  readonly opens: Scalars['String'];
}

export interface IRestaurantsConnection extends IConnection {
  readonly __typename?: 'RestaurantsConnection';
  readonly edges: ReadonlyArray<IRestaurantEdge>;
  readonly nodes: ReadonlyArray<IRestaurantNode>;
  readonly pageInfo: IPageInfo;
  readonly totalCount?: Maybe<Scalars['Int']>;
}

export interface IRestaurantsFullSearchResult {
  readonly __typename?: 'RestaurantsFullSearchResult';
  readonly nearby?: Maybe<IRestaurantsConnection>;
}


export interface IRestaurantsFullSearchResultNearbyArgs {
  input: INearbyRestaurantsInput;
}

export interface IRestaurantsInput {
  /**
   * An opaque cursor for pagination. Return results after provided cursor.
   * Used in combination with first field.
   */
  readonly after?: InputMaybe<Scalars['String']>;
  /**
   * An opaque cursor for pagination. Return results before provided cursor.
   * Used in combination with last field.
   */
  readonly before?: InputMaybe<Scalars['String']>;
  /** A coordinates object that sorts results based on location provided. */
  readonly coordinates?: InputMaybe<ICoordinates>;
  /**
   * Filter to a subset of stores
   * Defaults to NEARBY
   */
  readonly filter?: InputMaybe<FilterRestaurantType>;
  /**
   * Return first provided number of edges for pagination query.
   * Used in combination with after field.
   */
  readonly first?: InputMaybe<Scalars['Int']>;
  /** A list of store IDs to filter to */
  readonly ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  /**
   * Return last provided number of edges for pagination query.
   * Used in combination with before field.
   */
  readonly last?: InputMaybe<Scalars['Int']>;
  /**
   * A flag to enable strict radius checking. When enabled, stores will be filtered
   * based on a circle radius. Any stores outside the radius are not included.
   */
  readonly radiusStrictMode?: InputMaybe<Scalars['Boolean']>;
  /**
   * A list of service modes to search for.
   * Filters list to subset of stores that have one of the service modes available.
   */
  readonly serviceModes?: InputMaybe<ReadonlyArray<ServiceMode>>;
  /**
   * Restaurant operational status.
   * Filters list to subset of stores that have the provided status.
   */
  readonly status?: InputMaybe<OperationalStatus>;
}

export interface IResumeAddPaymentMethodInput {
  readonly challengeResponse: Scalars['String'];
  readonly transactionId: Scalars['String'];
}

/** Resume 3DS sale transaction input */
export interface IResumeThreeDSaleTransaction {
  /** saleId of the transaction */
  readonly saleId: Scalars['String'];
  /** threeDSOptions to resume 3ds flow transaction */
  readonly threeDSOptions: IThreeDsOptions;
}

export interface IReward extends IBaseIncentive {
  readonly __typename?: 'Reward';
  readonly cartRequirements?: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ICartRequirement>>>>>;
  readonly coolDown?: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['String'];
  readonly endDate: Scalars['String'];
  readonly endTime?: Maybe<Scalars['String']>;
  readonly errors?: Maybe<ReadonlyArray<IRuleConditionEvaluation>>;
  readonly externalIdentifiers?: Maybe<ReadonlyArray<Maybe<IExternalIdentifiers>>>;
  readonly firstOrder?: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly limitPerOrder?: Maybe<Scalars['Int']>;
  readonly locked?: Maybe<Scalars['Boolean']>;
  readonly maxRedemptionsDuration?: Maybe<DurationPeriod>;
  readonly maxRedemptionsLimit?: Maybe<Scalars['Int']>;
  readonly metadata?: Maybe<ReadonlyArray<Maybe<IObjectType>>>;
  readonly minimumSpend?: Maybe<Scalars['Int']>;
  readonly name: Scalars['String'];
  readonly paymentMethod?: Maybe<PaymentMethod>;
  readonly pointCost: Scalars['Int'];
  readonly redemptionPercentage?: Maybe<Scalars['Int']>;
  readonly remainingPointsNeededForRedemption?: Maybe<Scalars['Int']>;
  readonly restaurantGroups?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly rewardBenefitId: Scalars['String'];
  readonly sanityId?: Maybe<Scalars['String']>;
  readonly serviceModes?: Maybe<ReadonlyArray<Maybe<ServiceMode>>>;
  readonly startDate: Scalars['String'];
  readonly startTime?: Maybe<Scalars['String']>;
  readonly storeRestrictions?: Maybe<IStoreRestrictions>;
  readonly type: RewardType;
  readonly updatedAt: Scalars['String'];
  readonly userBirthdayDuration?: Maybe<BirthdayDuration>;
  readonly userEnrollment?: Maybe<IDateSpan>;
  readonly validDaysOfTheWeek?: Maybe<ReadonlyArray<DayOfTheWeek>>;
}

export enum RewardType {
  GLOBAL = 'GLOBAL',
  PERSONALIZED = 'PERSONALIZED'
}

export interface IRewardsInput {
  readonly appliedIncentives?: InputMaybe<ReadonlyArray<IPromotionInput>>;
  readonly cartEntries?: InputMaybe<ReadonlyArray<IRbiCartEntryInput>>;
  readonly configId?: InputMaybe<Scalars['ID']>;
  readonly ignorePointBalance?: InputMaybe<Scalars['Boolean']>;
  readonly ignoreRules?: InputMaybe<Scalars['Boolean']>;
  readonly incentiveIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly isTransactionCreation?: InputMaybe<Scalars['Boolean']>;
  readonly omitInvalids?: InputMaybe<Scalars['Boolean']>;
  readonly paymentMethod?: InputMaybe<PaymentMethod>;
  readonly rewardIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly serviceMode?: InputMaybe<ServiceMode>;
  readonly storeId?: InputMaybe<Scalars['String']>;
  readonly subtotalAmount?: InputMaybe<Scalars['Int']>;
}

export interface IRuleConditionEvaluation {
  readonly __typename?: 'RuleConditionEvaluation';
  readonly code: Scalars['String'];
  readonly currentValue?: Maybe<Scalars['JSON']>;
  readonly message?: Maybe<Scalars['String']>;
  readonly ruleId: Scalars['String'];
  readonly targetValue?: Maybe<Scalars['JSON']>;
}

export interface ISanityImage {
  readonly __typename?: 'SanityImage';
  readonly asset?: Maybe<ISanityImageAsset>;
  readonly crop?: Maybe<ISanityImageCrop>;
  readonly hotspot?: Maybe<ISanityImageHotspot>;
}

export interface ISanityImageAsset {
  readonly __typename?: 'SanityImageAsset';
  readonly _id?: Maybe<Scalars['String']>;
  readonly metadata?: Maybe<ISanityImageMetaData>;
}

export interface ISanityImageCrop {
  readonly __typename?: 'SanityImageCrop';
  readonly bottom?: Maybe<Scalars['Float']>;
  readonly left?: Maybe<Scalars['Float']>;
  readonly right?: Maybe<Scalars['Float']>;
  readonly top?: Maybe<Scalars['Float']>;
}

export interface ISanityImageHotspot {
  readonly __typename?: 'SanityImageHotspot';
  readonly height?: Maybe<Scalars['Float']>;
  readonly width?: Maybe<Scalars['Float']>;
  readonly x?: Maybe<Scalars['Float']>;
  readonly y?: Maybe<Scalars['Float']>;
}

export interface ISanityImageMetaData {
  readonly __typename?: 'SanityImageMetaData';
  readonly lqip?: Maybe<Scalars['String']>;
  readonly palette?: Maybe<ISanityImagePalette>;
}

export interface ISanityImagePalette {
  readonly __typename?: 'SanityImagePalette';
  readonly dominant?: Maybe<ISanityImagePaletteSwatch>;
}

export interface ISanityImagePaletteSwatch {
  readonly __typename?: 'SanityImagePaletteSwatch';
  readonly background?: Maybe<Scalars['String']>;
  readonly foreground?: Maybe<Scalars['String']>;
}

export interface ISaveDeliveryAddressInput {
  readonly addressLine1: Scalars['String'];
  readonly addressLine2?: InputMaybe<Scalars['String']>;
  readonly alias?: InputMaybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly country?: InputMaybe<IsoCountryCode>;
  readonly latitude?: InputMaybe<Scalars['Float']>;
  readonly longitude?: InputMaybe<Scalars['Float']>;
  readonly phoneNumber: Scalars['String'];
  readonly route?: InputMaybe<Scalars['String']>;
  readonly state?: InputMaybe<Scalars['String']>;
  readonly streetNumber?: InputMaybe<Scalars['String']>;
  readonly zip?: InputMaybe<Scalars['String']>;
}

export enum SchemePaymentMethodType {
  ONE_TIME = 'ONE_TIME',
  VAULTED = 'VAULTED'
}

export interface ISchemeStoredPaymentMethod extends IStoredPaymentMethod {
  readonly __typename?: 'SchemeStoredPaymentMethod';
  /** Card Brand. Ex: Visa */
  readonly brand: CardBrand;
  /** Card expiration month. Ex: 04 */
  readonly expiryMonth: Scalars['String'];
  /** Card expiration year. Ex: 2030 */
  readonly expiryYear: Scalars['String'];
  /** Stored payment method id */
  readonly id: Scalars['ID'];
  /** Last 4 digits of card number */
  readonly last4: Scalars['String'];
  /** Card pan token */
  readonly panToken?: Maybe<Scalars['String']>;
  /** Type of payment method */
  readonly type: PaymentMethodType;
}

export interface ISecondaryIdentifier {
  readonly __typename?: 'SecondaryIdentifier';
  readonly createdAt?: Maybe<Scalars['String']>;
  readonly identifier: Scalars['String'];
  readonly identifierType: SecondaryIdentifierType;
  readonly loyaltyId?: Maybe<Scalars['ID']>;
  readonly verified?: Maybe<Scalars['Boolean']>;
}

export enum SecondaryIdentifierType {
  LOYALTY12DIGITSWIPECARD = 'LOYALTY12DIGITSWIPECARD',
  LOYALTYSWIPECARD = 'LOYALTYSWIPECARD',
  PANTOKEN = 'PANTOKEN',
  PHONENUMBER = 'PHONENUMBER'
}

export enum ServiceMode {
  CATERING_DELIVERY = 'CATERING_DELIVERY',
  CATERING_PICKUP = 'CATERING_PICKUP',
  CURBSIDE = 'CURBSIDE',
  DELIVERY = 'DELIVERY',
  DRIVE_THRU = 'DRIVE_THRU',
  EAT_IN = 'EAT_IN',
  TABLE_SERVICE = 'TABLE_SERVICE',
  TAKEOUT = 'TAKEOUT'
}

export interface ISignInUserInput {
  readonly email: Scalars['String'];
  readonly platform: Platform;
  readonly stage: Stage;
}

export interface ISignUpSmsOtpInput {
  /** The code associated with the user's current OTP, for validation */
  readonly code: Scalars['String'];
  readonly country: IsoCountryCode;
  readonly dob?: InputMaybe<Scalars['String']>;
  readonly favoriteStores?: InputMaybe<ReadonlyArray<IFavoriteStoreInput>>;
  readonly name: Scalars['String'];
  /** The phone number of the user logging in with a One-Time Password. */
  readonly phoneNumber: Scalars['String'];
  readonly platform: Platform;
  /** The unique identifier provided when the OTP was created */
  readonly sessionId: Scalars['ID'];
  readonly stage: Stage;
  readonly userName: Scalars['String'];
  readonly wantsPromotionalEmails: Scalars['Boolean'];
  readonly zipcode?: InputMaybe<Scalars['String']>;
}

export interface ISignUpUserInput {
  readonly country: IsoCountryCode;
  readonly crmAttributes?: InputMaybe<ICrmAttributes>;
  readonly dob?: InputMaybe<Scalars['String']>;
  readonly favoriteStores?: InputMaybe<ReadonlyArray<IFavoriteStoreInput>>;
  readonly name: Scalars['String'];
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
  readonly platform: Platform;
  readonly providerType?: InputMaybe<ProviderType>;
  readonly stage: Stage;
  readonly userName: Scalars['String'];
  readonly wantsPromotionalEmails: Scalars['Boolean'];
  readonly zipcode?: InputMaybe<Scalars['String']>;
}

export interface ISizeBasedPlu {
  readonly __typename?: 'SizeBasedPlu';
  readonly comboPlu?: Maybe<Scalars['String']>;
  readonly comboSize?: Maybe<Scalars['String']>;
}

export interface ISizeBasedPluInput {
  readonly comboPlu?: InputMaybe<Scalars['String']>;
  readonly comboSize?: InputMaybe<Scalars['String']>;
}

export enum SmgCodeStatus {
  ACCEPTED = 'ACCEPTED',
  CODE_EXISTS = 'CODE_EXISTS',
  EXPIRED = 'EXPIRED',
  INVALID_FORMAT = 'INVALID_FORMAT',
  INVALID_RESTAURANT = 'INVALID_RESTAURANT',
  LIMIT_EXCEEDED = 'LIMIT_EXCEEDED',
  NOT_FOUND = 'NOT_FOUND',
  RETRY_REQUESTED = 'RETRY_REQUESTED',
  THROTTLING_ERROR = 'THROTTLING_ERROR',
  TRANSACTION_CLAIMED = 'TRANSACTION_CLAIMED'
}

export interface ISocialLoginInput {
  readonly providerToken: Scalars['String'];
  readonly providerType: ProviderType;
}

export enum Stage {
  ALPHA = 'alpha',
  BETA = 'beta',
  DEV = 'dev',
  LOCALDEV = 'localdev',
  PROD = 'prod',
  QA = 'qa',
  SANDBOX = 'sandbox',
  STAGING = 'staging',
  TEST = 'test'
}

export interface IStoreAddress {
  readonly __typename?: 'StoreAddress';
  readonly addressLine1: Scalars['String'];
  readonly addressLine2?: Maybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly country: Scalars['String'];
  readonly phoneNumber: Scalars['String'];
  readonly state: Scalars['String'];
  readonly zip: Scalars['String'];
}

export interface IStoreAddressInput {
  readonly addressLine1: Scalars['String'];
  readonly addressLine2?: InputMaybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly country: Scalars['String'];
  readonly phoneNumber: Scalars['String'];
  readonly state: Scalars['String'];
  readonly zip: Scalars['String'];
}

export interface IStoreDetails {
  readonly __typename?: 'StoreDetails';
  readonly deliveryHours?: Maybe<IStoreHours>;
  readonly diningRoomHours?: Maybe<IStoreHours>;
  readonly driveThruHours?: Maybe<IStoreHours>;
  readonly franchiseGroupId?: Maybe<Scalars['Int']>;
  readonly franchiseGroupName?: Maybe<Scalars['String']>;
  readonly hasCatering?: Maybe<Scalars['Boolean']>;
  readonly hasDelivery?: Maybe<Scalars['Boolean']>;
  readonly hasDriveThru?: Maybe<Scalars['Boolean']>;
  readonly hasMobileOrdering?: Maybe<Scalars['Boolean']>;
  /** Last date time when the store made an order */
  readonly lastActiveDateTime?: Maybe<Scalars['String']>;
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  readonly mobileOrderingStatus?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly posVendor?: Maybe<Scalars['String']>;
  readonly status?: Maybe<Scalars['String']>;
  readonly storeNumber?: Maybe<Scalars['String']>;
}

export interface IStoreHours {
  readonly __typename?: 'StoreHours';
  readonly friday?: Maybe<IDay>;
  readonly monday?: Maybe<IDay>;
  readonly saturday?: Maybe<IDay>;
  readonly sunday?: Maybe<IDay>;
  readonly thursday?: Maybe<IDay>;
  readonly tuesday?: Maybe<IDay>;
  readonly wednesday?: Maybe<IDay>;
}

export interface IStoreRestrictions {
  readonly __typename?: 'StoreRestrictions';
  readonly ids: ReadonlyArray<Maybe<Scalars['String']>>;
  readonly inclusive: Scalars['Boolean'];
}

export interface IStoredPaymentMethod {
  /** Stored payment method id */
  readonly id: Scalars['ID'];
  /** Type of payment method */
  readonly type: PaymentMethodType;
}

export interface ISupportCase {
  readonly __typename?: 'SupportCase';
  /** Identifier for the case. Useful for the user to have */
  readonly caseId?: Maybe<Scalars['String']>;
}

export interface ISupportCaseInput {
  /** Description of the issue the user is having */
  readonly comments: Scalars['String'];
  /** User's email */
  readonly email: Scalars['String'];
  /** Id corresponding to the category of the issue. These are set in Sanity */
  readonly issueId: Scalars['String'];
  /** Name of subcategory of the issue.  These are set in Sanity */
  readonly issueSubCategory?: InputMaybe<Scalars['String']>;
  /** The local time the order associated with the issue was placed */
  readonly localStoreOrderTime?: InputMaybe<Scalars['String']>;
  /** User's name */
  readonly name: Scalars['String'];
  /** The time and date the order associated with the issue was placed */
  readonly orderDateTime?: InputMaybe<Scalars['String']>;
  /** Unique order identifier in RBI */
  readonly rbiOrderId?: InputMaybe<Scalars['String']>;
  /** Service mode of the order associated with the issue */
  readonly serviceMode?: InputMaybe<Scalars['String']>;
  /** Address of the store associated with the issue */
  readonly storeAddress?: InputMaybe<Scalars['String']>;
  /** Store number from MDS */
  readonly storeId?: InputMaybe<Scalars['String']>;
  /** Region user signed up in (account region) */
  readonly userAccountRegion?: InputMaybe<Scalars['String']>;
  /** User's region */
  readonly userRegion?: InputMaybe<Scalars['String']>;
}

export interface ISwap {
  readonly __typename?: 'Swap';
  readonly from: Scalars['String'];
  readonly to: Scalars['String'];
  readonly type: SwapType;
}

export interface ISwapInput {
  readonly cartId: Scalars['String'];
  readonly from: Scalars['String'];
  readonly swapType: Scalars['String'];
  readonly to: Scalars['String'];
}

export enum SwapType {
  UPSIZE = 'UPSIZE'
}

export interface ISyncUserCommunicationPreferencesResult {
  readonly __typename?: 'SyncUserCommunicationPreferencesResult';
  readonly marketingEmail: Scalars['Boolean'];
  readonly marketingPush: Scalars['Boolean'];
  readonly marketingSms: Scalars['Boolean'];
}

export interface ISystemWidePromotion extends IBaseIncentive {
  readonly __typename?: 'SystemWidePromotion';
  readonly bonusPoints?: Maybe<Scalars['Int']>;
  readonly cartRequirements?: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<ICartRequirement>>>>>;
  readonly coolDown?: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['String'];
  readonly endDate: Scalars['String'];
  readonly endTime?: Maybe<Scalars['String']>;
  readonly errors?: Maybe<ReadonlyArray<IRuleConditionEvaluation>>;
  readonly externalIdentifiers?: Maybe<ReadonlyArray<Maybe<IExternalIdentifiers>>>;
  readonly firstOrder?: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['ID'];
  readonly maxRedemptionsDuration?: Maybe<DurationPeriod>;
  readonly maxRedemptionsLimit?: Maybe<Scalars['Int']>;
  readonly metadata?: Maybe<Scalars['JSON']>;
  readonly minimumSpend?: Maybe<Scalars['Int']>;
  readonly name: Scalars['String'];
  readonly paymentMethod?: Maybe<PaymentMethod>;
  readonly pointMultiplier?: Maybe<Scalars['Int']>;
  readonly restaurantGroups?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly sanityId?: Maybe<Scalars['String']>;
  readonly serviceModes?: Maybe<ReadonlyArray<Maybe<ServiceMode>>>;
  readonly startDate: Scalars['String'];
  readonly startTime?: Maybe<Scalars['String']>;
  readonly storeRestrictions?: Maybe<IStoreRestrictions>;
  readonly updatedAt: Scalars['String'];
  readonly userBirthdayDuration?: Maybe<BirthdayDuration>;
  readonly userEnrollment?: Maybe<IDateSpan>;
  readonly validDaysOfTheWeek?: Maybe<ReadonlyArray<DayOfTheWeek>>;
}

export interface IThreeDsOptions {
  /** challenge response obtained in challengeCallbackUrl to resume challenge flow */
  readonly challengeResponse?: InputMaybe<Scalars['String']>;
  /** transactionId to resume method or challenge flow */
  readonly transactionId: Scalars['String'];
}

export interface IThreeDsChallenge {
  readonly __typename?: 'ThreeDsChallenge';
  readonly acsUrl: Scalars['String'];
  readonly challengeRequestToken: Scalars['String'];
  readonly transactionId: Scalars['String'];
}

export interface IThreeDsFrictionless {
  readonly __typename?: 'ThreeDsFrictionless';
  readonly iFrameContent: Scalars['String'];
  readonly transactionId: Scalars['String'];
}

export interface ITransaction {
  readonly __typename?: 'Transaction';
  readonly additionalReferenceIds?: Maybe<ReadonlyArray<ITransactionAdditionalReferenceId>>;
  readonly bonusPointsEarned: Scalars['Int'];
  readonly channel: Scalars['String'];
  readonly createdAt: Scalars['String'];
  readonly dateUpdated?: Maybe<Scalars['String']>;
  readonly hasRewards: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly loyaltyId?: Maybe<Scalars['String']>;
  readonly maxTransactionLimitReached: Scalars['Boolean'];
  readonly pointsDeducted?: Maybe<Scalars['Int']>;
  readonly pointsEarned: Scalars['Int'];
  readonly pointsUsed: Scalars['Int'];
  readonly shortId: Scalars['String'];
  readonly status: TransactionStatus;
  readonly transactionDetails?: Maybe<ITransactionDetails>;
}

export interface ITransactionAdditionalReferenceId {
  readonly __typename?: 'TransactionAdditionalReferenceId';
  readonly description?: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly type: Scalars['String'];
}

export interface ITransactionDetails {
  readonly __typename?: 'TransactionDetails';
  readonly currency: Scalars['String'];
  readonly fulfillment: ITransactionFulfillment;
  readonly language?: Maybe<Language>;
  readonly orders: ReadonlyArray<ITransactionOrder>;
  readonly payments: ReadonlyArray<ITransactionPayment>;
  readonly person?: Maybe<IPerson>;
  readonly pickupContact?: Maybe<IPickupContact>;
  readonly posVendor?: Maybe<ITransactionPosVendor>;
  readonly promotions?: Maybe<ReadonlyArray<IPromotion>>;
}

export interface ITransactionFulfillment {
  readonly __typename?: 'TransactionFulfillment';
  readonly autoRelease?: Maybe<Scalars['Boolean']>;
  readonly type: Scalars['String'];
}

export interface ITransactionListResponse {
  readonly __typename?: 'TransactionListResponse';
  readonly fdCorrelationId?: Maybe<Scalars['String']>;
  readonly transactions?: Maybe<ReadonlyArray<Maybe<IPrepaidTransaction>>>;
}

export interface ITransactionOrder {
  readonly __typename?: 'TransactionOrder';
  readonly parentReferenceId?: Maybe<Scalars['String']>;
  readonly price: Scalars['Int'];
  readonly productId?: Maybe<Scalars['String']>;
  readonly quantity: Scalars['Int'];
}

export interface ITransactionPayment {
  readonly __typename?: 'TransactionPayment';
  readonly amount: Scalars['Int'];
  readonly description?: Maybe<Scalars['String']>;
  readonly expiration?: Maybe<IPaymentExpiration>;
  readonly token?: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
}

export interface ITransactionPosVendor {
  readonly __typename?: 'TransactionPosVendor';
  readonly id?: Maybe<Scalars['String']>;
  readonly transactionId: Scalars['String'];
  readonly type: Scalars['String'];
}

export enum TransactionStatus {
  CLAIMED = 'CLAIMED',
  PENDING = 'PENDING',
  UNCLAIMED = 'UNCLAIMED',
  VOID = 'VOID'
}

export interface ITransactionsInput {
  readonly excludedChannels?: InputMaybe<ReadonlyArray<RbiChannel>>;
  readonly ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly statuses?: InputMaybe<ReadonlyArray<TransactionStatus>>;
}

export interface IUnavailableCartEntry {
  readonly __typename?: 'UnavailableCartEntry';
  readonly lineId?: Maybe<Scalars['String']>;
  readonly sanityId: Scalars['String'];
}

export interface IUpdateDefaultPaymentMethodInput {
  readonly storedPaymentMethodId: Scalars['String'];
}

export interface IUpdateDefaultPaymentMethodPayload {
  readonly __typename?: 'UpdateDefaultPaymentMethodPayload';
  readonly defaultPaymentMethodId: Scalars['String'];
}

export interface IUpdateOrderInput {
  /** number of seconds from now to inject order */
  readonly fireOrderIn: Scalars['Int'];
  readonly rbiOrderId: Scalars['ID'];
}

export interface IUpdateUserCommunicationPreferencesInput {
  readonly communicationPreferenceType: CommunicationPreferenceType;
  readonly newStatus: Scalars['Boolean'];
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
}

export interface IUser {
  readonly __typename?: 'User';
  /**
   * DEPRECATED
   * This query is no longer available
   */
  readonly alohaActiveRewards: ReadonlyArray<IAlohaActiveReward>;
  readonly bestPromotion?: Maybe<ISystemWidePromotion>;
  readonly createdAt: Scalars['String'];
  readonly dateOfBirth?: Maybe<Scalars['String']>;
  readonly email: Scalars['String'];
  /**
   * DEPRECATED
   * Incentive evaluation errors are now provided as part of the incentive data.
   */
  readonly evaluatedIncentives: IEvaluatedIncentives;
  readonly expirationBuckets?: Maybe<ReadonlyArray<IExpirationBucket>>;
  readonly id: Scalars['ID'];
  readonly idPay?: Maybe<IIdAndPay>;
  readonly metadata?: Maybe<ReadonlyArray<Maybe<IObjectType>>>;
  readonly name?: Maybe<Scalars['String']>;
  readonly offerRedemptionAvailability?: Maybe<IOfferRedemptionAvailability>;
  /**
   * DEPRECATED
   * This field is replaced by field offerRedemptionAvailability
   */
  readonly offerRedemptionAvailableAfter?: Maybe<Scalars['String']>;
  readonly offers?: Maybe<ReadonlyArray<IOffer>>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly points: Scalars['Int'];
  readonly pointsExpiryDateKey?: Maybe<Scalars['String']>;
  readonly promotions?: Maybe<ReadonlyArray<ISystemWidePromotion>>;
  readonly quests?: Maybe<ReadonlyArray<IQuest>>;
  readonly rewards?: Maybe<ReadonlyArray<IReward>>;
  readonly secondaryIdentifiers?: Maybe<ReadonlyArray<Maybe<ISecondaryIdentifier>>>;
  readonly transactions?: Maybe<ReadonlyArray<ITransaction>>;
}


export interface IUserBestPromotionArgs {
  where?: InputMaybe<IPromotionsInput>;
}


export interface IUserEvaluatedIncentivesArgs {
  where: IEvaluateIncentivesInput;
}


export interface IUserOffersArgs {
  where?: InputMaybe<IOffersInput>;
}


export interface IUserPromotionsArgs {
  where?: InputMaybe<IPromotionsInput>;
}


export interface IUserQuestsArgs {
  where?: InputMaybe<IQuestsInput>;
}


export interface IUserRewardsArgs {
  where?: InputMaybe<IRewardsInput>;
}


export interface IUserTransactionsArgs {
  where?: InputMaybe<ITransactionsInput>;
}

export interface IUserDetails {
  readonly __typename?: 'UserDetails';
  /** Giftcard can be auto reloaded */
  readonly autoReloadEnabled?: Maybe<Scalars['Boolean']>;
  /** Amount in cents that balance must reach for auto reload */
  readonly autoReloadThreshold?: Maybe<Scalars['Int']>;
  /** Array of Communication Preferences */
  readonly communicationPreferences?: Maybe<ReadonlyArray<Maybe<ICommunicationPreference>>>;
  /** Account (Adyen or First-Data) ID of auto reload default payment method */
  readonly defaultAccountIdentifier?: Maybe<Scalars['String']>;
  /**
   * First Data ID of auto reload default payment method
   * @deprecated Use `defaultAccountIdentifier`.
   */
  readonly defaultFdAccountId?: Maybe<Scalars['String']>;
  /** Adyen or First Data ID of default payment method */
  readonly defaultPaymentAccountId?: Maybe<Scalars['String']>;
  /** Reload amount to default to for user's gift cards */
  readonly defaultReloadAmt?: Maybe<Scalars['Int']>;
  /** Default Account Id for Scan & Pay */
  readonly defaultScanAndPayAccountIdentifier?: Maybe<Scalars['String']>;
  /**
   * User Adresses and phone number combinations to be used to alllow users
   * to select from multiple saced addresses
   */
  readonly deliveryAddresses?: Maybe<ReadonlyArray<Maybe<IDeliveryAddress>>>;
  /** Date of birth (format TBD) */
  readonly dob?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  /** Whether the user has verified the email */
  readonly emailVerified?: Maybe<Scalars['Boolean']>;
  /** User's saved list of favorite stores */
  readonly favoriteStores?: Maybe<ReadonlyArray<Maybe<IFavoriteStore>>>;
  /** User's ISO Country Code (e.g. USA, CAN) */
  readonly isoCountryCode?: Maybe<IsoCountryCode>;
  /** User's selected loyalty tier */
  readonly loyaltyTier?: Maybe<Scalars['String']>;
  /** User's name */
  readonly name?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  /** Whether the user has opted in to promotional emails */
  readonly promotionalEmails?: Maybe<Scalars['Boolean']>;
  /** Last time the user failed the skills tests of RUTR */
  readonly rutrFailedSkillsTestTimestamp?: Maybe<Scalars['String']>;
  /** Last time the user passed the skills tests of RUTR */
  readonly rutrPassedSkillsTestTimestamp?: Maybe<Scalars['String']>;
  readonly zipcode?: Maybe<Scalars['String']>;
}

export interface IUserGeo {
  readonly __typename?: 'UserGeo';
  readonly city?: Maybe<Scalars['String']>;
  readonly country?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
}

export interface IUserOrdersInput {
  readonly createdAfter?: InputMaybe<Scalars['String']>;
  readonly createdBefore?: InputMaybe<Scalars['String']>;
  readonly limit?: InputMaybe<Scalars['Int']>;
  readonly orderStatuses?: InputMaybe<ReadonlyArray<RbiOrderStatus>>;
  readonly resumeAfter?: InputMaybe<Scalars['String']>;
  readonly shouldFilterByRegion?: InputMaybe<Scalars['Boolean']>;
  readonly sortAscending?: InputMaybe<Scalars['Boolean']>;
  /** Deprecated. This field will be ignored. */
  readonly userId?: InputMaybe<Scalars['ID']>;
}

export interface IUserReportsMissingOrderInput {
  /** Id corresponding to the category of the issue. These are set in Sanity */
  readonly issueId?: InputMaybe<Scalars['String']>;
  /** Name of subcategory of the issue.  These are set in Sanity */
  readonly issueSubCategory?: InputMaybe<Scalars['String']>;
  /** List of reported missing items. Undefined if entire order is missing */
  readonly missingItems?: InputMaybe<ReadonlyArray<InputMaybe<IMissingItem>>>;
  /** Order ID that the user is reporting */
  readonly rbiOrderId: Scalars['String'];
  /** Optional user comment as part of the report */
  readonly userComment?: InputMaybe<Scalars['String']>;
}

export interface IUserRequestsRefundInput {
  /** Id corresponding to the category of the issue. These are set in Sanity */
  readonly issueId?: InputMaybe<Scalars['String']>;
  /** Name of subcategory of the issue.  These are set in Sanity */
  readonly issueSubCategory?: InputMaybe<Scalars['String']>;
  /** List of reported missing items. Undefined if entire order is missing */
  readonly missingItems?: InputMaybe<ReadonlyArray<InputMaybe<IMissingItem>>>;
  /** Order ID that the user is reporting */
  readonly rbiOrderId: Scalars['String'];
  /** Optional user comment as part of the report */
  readonly userComment?: InputMaybe<Scalars['String']>;
}

export interface IValidateCommitOrderInput {
  /** Delivery information */
  readonly delivery?: InputMaybe<ICommitDeliveryInput>;
  /** Takes in a time in seconds to delay the order commit */
  readonly fireOrderIn?: InputMaybe<Scalars['Int']>;
  /** ID for a previous order that has been priced */
  readonly rbiOrderId: Scalars['String'];
  /**
   * The moment of redemption - the user's local date+time - in ISO format.
   * Only ISO-formatted timestamp values of the format "YYYY-MM-DDTHH:mm:ss.SSSZ" are accepted.
   */
  readonly redeemedOn?: InputMaybe<Scalars['String']>;
  /** Whether to skip cooling period or not */
  readonly skipCoolingPeriod?: InputMaybe<Scalars['Boolean']>;
}

export interface IValidateSmsOtpCognitoCredentials {
  readonly __typename?: 'ValidateSmsOtpCognitoCredentials';
  readonly challengeCode: Scalars['String'];
  readonly sessionId: Scalars['String'];
}

export interface IVendorConfig {
  readonly __typename?: 'VendorConfig';
  readonly constantPlu?: Maybe<Scalars['String']>;
  readonly discountPlu?: Maybe<Scalars['String']>;
  readonly multiConstantPlus?: Maybe<ReadonlyArray<Maybe<IQuantityPlu>>>;
  readonly parentChildPlu?: Maybe<IParentChildPlu>;
  readonly parentSanityId?: Maybe<Scalars['String']>;
  readonly pluType: Scalars['String'];
  readonly pullUpLevels?: Maybe<Scalars['Int']>;
  readonly quantityBasedPlu?: Maybe<ReadonlyArray<Maybe<IQuantityPlu>>>;
  readonly sizeBasedPlu?: Maybe<ISizeBasedPlu>;
}

export interface IVendorConfigInput {
  readonly constantPlu?: InputMaybe<Scalars['String']>;
  readonly discountPlu?: InputMaybe<Scalars['String']>;
  readonly multiConstantPlus?: InputMaybe<ReadonlyArray<InputMaybe<IQuantityPluInput>>>;
  readonly parentChildPlu?: InputMaybe<IParentChildPluInput>;
  readonly parentSanityId?: InputMaybe<Scalars['String']>;
  readonly pluType: Scalars['String'];
  readonly pullUpLevels?: InputMaybe<Scalars['Int']>;
  readonly quantityBasedPlu?: InputMaybe<ReadonlyArray<InputMaybe<IQuantityPluInput>>>;
  readonly sizeBasedPlu?: InputMaybe<ISizeBasedPluInput>;
}

export interface IVendorConfigs {
  readonly __typename?: 'VendorConfigs';
  readonly brink?: Maybe<IVendorConfig>;
  readonly brinkDelivery?: Maybe<IVendorConfig>;
  readonly carrols?: Maybe<IVendorConfig>;
  readonly carrolsDelivery?: Maybe<IVendorConfig>;
  readonly ncr?: Maybe<IVendorConfig>;
  readonly ncrDelivery?: Maybe<IVendorConfig>;
  /** @deprecated POS Vendor no longer in use */
  readonly oheics?: Maybe<IVendorConfig>;
  /** @deprecated POS Vendor no longer in use */
  readonly oheicsDelivery?: Maybe<IVendorConfig>;
  /** @deprecated POS Vendor no longer in use */
  readonly partner?: Maybe<IVendorConfig>;
  /** @deprecated POS Vendor no longer in use */
  readonly partnerDelivery?: Maybe<IVendorConfig>;
  /** @deprecated POS Vendor no longer in use */
  readonly productNumber?: Maybe<IVendorConfig>;
  /** @deprecated POS Vendor no longer in use */
  readonly productNumberDelivery?: Maybe<IVendorConfig>;
  readonly qdi?: Maybe<IVendorConfig>;
  readonly qdiDelivery?: Maybe<IVendorConfig>;
  /** @deprecated POS Vendor no longer in use */
  readonly qst?: Maybe<IVendorConfig>;
  /** @deprecated POS Vendor no longer in use */
  readonly qstDelivery?: Maybe<IVendorConfig>;
  /** @deprecated POS Vendor no longer in use */
  readonly rpos?: Maybe<IVendorConfig>;
  /** @deprecated POS Vendor no longer in use */
  readonly rposDelivery?: Maybe<IVendorConfig>;
  readonly sicom?: Maybe<IVendorConfig>;
  readonly sicomDelivery?: Maybe<IVendorConfig>;
  /** @deprecated POS Vendor no longer in use */
  readonly simphony?: Maybe<IVendorConfig>;
  /** @deprecated POS Vendor no longer in use */
  readonly simphonyDelivery?: Maybe<IVendorConfig>;
  /** @deprecated POS Vendor no longer in use */
  readonly simplyDelivery?: Maybe<IVendorConfig>;
  /** @deprecated POS Vendor no longer in use */
  readonly simplyDeliveryDelivery?: Maybe<IVendorConfig>;
  /** @deprecated POS Vendor no longer in use */
  readonly tablet?: Maybe<IVendorConfig>;
  /** @deprecated POS Vendor no longer in use */
  readonly tabletDelivery?: Maybe<IVendorConfig>;
}

/** Vendor configs */
export interface IVendorConfigsInput {
  readonly brink?: InputMaybe<IVendorConfigInput>;
  readonly brinkDelivery?: InputMaybe<IVendorConfigInput>;
  readonly carrols?: InputMaybe<IVendorConfigInput>;
  readonly carrolsDelivery?: InputMaybe<IVendorConfigInput>;
  readonly ncr?: InputMaybe<IVendorConfigInput>;
  readonly ncrDelivery?: InputMaybe<IVendorConfigInput>;
  readonly qdi?: InputMaybe<IVendorConfigInput>;
  readonly qdiDelivery?: InputMaybe<IVendorConfigInput>;
  readonly sicom?: InputMaybe<IVendorConfigInput>;
  readonly sicomDelivery?: InputMaybe<IVendorConfigInput>;
}

export interface IVenmo {
  readonly details?: InputMaybe<Scalars['String']>;
  readonly deviceData?: InputMaybe<Scalars['String']>;
  readonly nonce: Scalars['String'];
}

export interface IResendPhoneVerificationInput {
  /** user's current platform */
  readonly platform: Platform;
  /** The unique identifier provided when the OTP was created */
  readonly sessionId?: InputMaybe<Scalars['ID']>;
  /** user's current stage */
  readonly stage: Stage;
}

export interface IResendVerificationEmailInput {
  /** user's current platform */
  readonly platform: Platform;
  /** user's current stage */
  readonly stage: Stage;
}

export interface IValidateAuthJwtInput {
  readonly jwt: Scalars['String'];
}

export interface IVerifyPhoneNumberInput {
  /** The code associated with the user's current OTP, for validation */
  readonly code: Scalars['String'];
  /** user's current platform */
  readonly platform: Platform;
  /** The unique identifier provided when the OTP was created */
  readonly sessionId: Scalars['ID'];
  /** user's current stage */
  readonly stage: Stage;
}

export type ISchemeStoredPaymentMethodResponseFragment = { readonly __typename?: 'SchemeStoredPaymentMethod', readonly id: string, readonly type: PaymentMethodType, readonly brand: CardBrand, readonly expiryYear: string, readonly expiryMonth: string, readonly last4: string, readonly panToken?: string | null };

export type IAddPaymentMethodSuccessFragment = { readonly __typename?: 'AddPaymentMethodSuccess', readonly storedPaymentMethod: { readonly __typename?: 'PrepaidStoredPaymentMethod' } | (
    { readonly __typename?: 'SchemeStoredPaymentMethod' }
    & ISchemeStoredPaymentMethodResponseFragment
  ) };

export type ICartEntryFragment = { readonly __typename?: 'CartEntries', readonly lineId: string, readonly image?: string | null, readonly isDonation?: boolean | null, readonly isExtra?: boolean | null, readonly name?: string | null, readonly pickerSelections?: string | null, readonly price?: number | null, readonly quantity: number, readonly sanityId: string, readonly type: CartEntryType, readonly url?: string | null, readonly redeemable?: boolean | null, readonly _id: string, readonly vendorConfigs?: (
    { readonly __typename?: 'VendorConfigs' }
    & IPlusFragment
  ) | null };

export type ICartEntryWithChildrenFragment = (
  { readonly __typename?: 'CartEntries', readonly children?: ReadonlyArray<(
    { readonly __typename?: 'CartEntries', readonly children?: ReadonlyArray<(
      { readonly __typename?: 'CartEntries', readonly children?: ReadonlyArray<(
        { readonly __typename?: 'CartEntries', readonly children?: ReadonlyArray<(
          { readonly __typename?: 'CartEntries', readonly children?: ReadonlyArray<(
            { readonly __typename?: 'CartEntries' }
            & ICartEntryFragment
          ) | null> | null }
          & ICartEntryFragment
        ) | null> | null }
        & ICartEntryFragment
      ) | null> | null }
      & ICartEntryFragment
    ) | null> | null }
    & ICartEntryFragment
  ) | null> | null }
  & ICartEntryFragment
);

export type IFavoriteFragment = { readonly __typename?: 'Favorite', readonly favoriteId?: string | null, readonly name?: string | null, readonly ref?: string | null, readonly createdAt?: string | null, readonly updatedAt?: string | null, readonly _id?: string | null, readonly entries?: ReadonlyArray<(
    { readonly __typename?: 'CartEntries' }
    & ICartEntryWithChildrenFragment
  ) | null> | null };

export type IReorderFavoriteFragment = (
  { readonly __typename?: 'Favorite', readonly entries?: ReadonlyArray<(
    { readonly __typename?: 'CartEntries', readonly isInMenu?: boolean | null, readonly children?: ReadonlyArray<(
      { readonly __typename?: 'CartEntries', readonly isInMenu?: boolean | null, readonly children?: ReadonlyArray<(
        { readonly __typename?: 'CartEntries', readonly isInMenu?: boolean | null, readonly children?: ReadonlyArray<(
          { readonly __typename?: 'CartEntries', readonly isInMenu?: boolean | null, readonly children?: ReadonlyArray<(
            { readonly __typename?: 'CartEntries', readonly isInMenu?: boolean | null, readonly children?: ReadonlyArray<(
              { readonly __typename?: 'CartEntries', readonly isInMenu?: boolean | null }
              & ICartEntryFragment
            ) | null> | null }
            & ICartEntryFragment
          ) | null> | null }
          & ICartEntryFragment
        ) | null> | null }
        & ICartEntryFragment
      ) | null> | null }
      & ICartEntryFragment
    ) | null> | null }
    & ICartEntryFragment
  ) | null> | null }
  & IFavoriteFragment
);

export type ITransactionFragment = { readonly __typename?: 'LoyaltyTransactionV2', readonly channel: string, readonly pointsEarned: number, readonly bonusPointsEarned: number, readonly pointsUsed: number, readonly pointsDeducted?: number | null, readonly hasRewards: boolean, readonly createdAt: string, readonly transactionDetails?: { readonly __typename?: 'LoyaltyTransactionDetails', readonly payments: ReadonlyArray<{ readonly __typename?: 'LoyaltyTransactionPayment', readonly amount: number }> } | null, readonly additionalReferenceIds?: ReadonlyArray<{ readonly __typename?: 'LoyaltyTransactionAdditionalReferenceId', readonly id: string, readonly type: string }> | null };

export type IRewardFragment = { readonly __typename?: 'LoyaltyReward', readonly id: any, readonly rewardBenefitId: string, readonly name: string, readonly pointCost: number, readonly sanityId?: string | null, readonly locked?: boolean | null, readonly redemptionPercentage?: number | null, readonly limitPerOrder?: number | null, readonly remainingPointsNeededForRedemption?: number | null, readonly type: LoyaltyRewardType };

export type ILoyaltyUserFragment = { readonly __typename?: 'LoyaltyUser', readonly id: any, readonly name?: string | null, readonly points: number, readonly pointsExpiryDateKey?: string | null, readonly metadata?: ReadonlyArray<{ readonly __typename?: 'LoyaltyObjectType', readonly key?: string | null, readonly value?: any | null } | null> | null, readonly bestPromotion?: { readonly __typename?: 'LoyaltySystemWidePromotion', readonly sanityId?: string | null } | null, readonly offerRedemptionAvailability?: { readonly __typename?: 'LoyaltyOfferRedemptionAvailability', readonly availableAfter?: string | null } | null, readonly secondaryIdentifiers?: ReadonlyArray<{ readonly __typename?: 'LoyaltySecondaryIdentifier', readonly identifier: string, readonly identifierType: LoyaltySecondaryIdentifierType } | null> | null, readonly expirationBuckets?: ReadonlyArray<{ readonly __typename?: 'LoyaltyExpirationBucket', readonly expirationDate: string, readonly pointsToExpire: number }> | null, readonly idPay?: { readonly __typename?: 'LoyaltyIdAndPay', readonly enabled?: boolean | null, readonly storedPaymentMethodId?: string | null } | null };

export type IOffersFragment = { readonly __typename?: 'LoyaltyOffer', readonly configId?: any | null, readonly id: any, readonly isStackable?: boolean | null, readonly loyaltyId?: any | null, readonly redemptionType?: LoyaltyOfferRedemptionType | null, readonly sanityId?: string | null, readonly serviceModes?: ReadonlyArray<LoyaltyServiceMode | null> | null, readonly templateId?: any | null, readonly type: LoyaltyOfferType, readonly benefits?: ReadonlyArray<{ readonly __typename?: 'LoyaltyBenefitReference', readonly type: LoyaltyBenefitType, readonly reference: string } | { readonly __typename?: 'LoyaltyBenefitSwap', readonly type: LoyaltyBenefitType, readonly value: { readonly __typename?: 'LoyaltySwap', readonly type: LoyaltySwapType, readonly from: string, readonly to: string } }> | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'LoyaltyRuleConditionEvaluation', readonly code: string, readonly currentValue?: any | null, readonly message?: string | null, readonly ruleId: string, readonly targetValue?: any | null }> | null, readonly metadata?: ReadonlyArray<{ readonly __typename?: 'LoyaltyObjectType', readonly key?: string | null, readonly value?: any | null } | null> | null };

export type IInvalidIncentiveFragment = { readonly __typename?: 'LoyaltyInvalidIncentives', readonly id: any, readonly errors: ReadonlyArray<{ readonly __typename?: 'LoyaltyRuleConditionEvaluation', readonly code: string, readonly currentValue?: any | null, readonly message?: string | null, readonly ruleId: string, readonly targetValue?: any | null }> };

export type IPromotionFragment = { readonly __typename?: 'LoyaltySystemWidePromotion', readonly id: any };

export type ILoyaltyCouponFragment = { readonly __typename?: 'LoyaltyCouponResponse', readonly code: string, readonly isValid: boolean, readonly message: string, readonly reason?: string | null, readonly isRedeemed?: boolean | null, readonly shouldRedeem?: boolean | null, readonly personalizedOfferId?: string | null, readonly configId?: string | null };

export type IOperatingHoursFragment = { readonly __typename?: 'OperatingHours', readonly friClose?: string | null, readonly friOpen?: string | null, readonly monClose?: string | null, readonly monOpen?: string | null, readonly satClose?: string | null, readonly satOpen?: string | null, readonly sunClose?: string | null, readonly sunOpen?: string | null, readonly thrClose?: string | null, readonly thrOpen?: string | null, readonly tueClose?: string | null, readonly tueOpen?: string | null, readonly wedClose?: string | null, readonly wedOpen?: string | null };

export type ISchemeStoredPaymentMethodsFragment = { readonly __typename?: 'SchemeStoredPaymentMethod', readonly id: string, readonly brand: CardBrand, readonly expiryYear: string, readonly expiryMonth: string, readonly last4: string, readonly panToken?: string | null, readonly type: PaymentMethodType };

export type IPrepaidStoredPaymentMethodsFragment = { readonly __typename?: 'PrepaidStoredPaymentMethod', readonly id: string, readonly balance: number, readonly currency: string, readonly last4: string, readonly shuffledCardNumber: string, readonly type: PaymentMethodType };

export type IPaymentPreferencesFragment = { readonly __typename?: 'PaymentPreferences', readonly storedPaymentMethodId?: string | null, readonly reloadAmount?: number | null, readonly autoReload: boolean, readonly autoReloadThreshold?: number | null };

export type IPaymentConfigFragment = { readonly __typename?: 'PaymentConfig', readonly allowedPaymentMethods: ReadonlyArray<PaymentMethodType>, readonly frontendIntegration: FrontendIntegration, readonly applePay?: { readonly __typename?: 'ApplePayPaymentConfig', readonly schemeMerchantId?: string | null, readonly prepaidMerchantId?: string | null } | null, readonly googlePay?: { readonly __typename?: 'GooglePayPaymentConfig', readonly schemeMerchantId?: string | null, readonly prepaidMerchantId?: string | null } | null };

export type IQuestFragment = { readonly __typename?: 'LoyaltyQuest', readonly id: any, readonly type: LoyaltyQuestType, readonly bonusPoints?: number | null, readonly startDate: string, readonly endDate: string, readonly sanityId?: string | null, readonly incentiveType: LoyaltyQuestIncentiveType, readonly status: LoyaltyQuestStatus, readonly externalIdentifiers?: ReadonlyArray<{ readonly __typename?: 'LoyaltyExternalIdentifiers', readonly type: string, readonly value: string } | null> | null, readonly lastCompletion?: { readonly __typename?: 'LoyaltyQuestCompletion', readonly benefitId: string, readonly completedAt: string, readonly redeemed: boolean } | null, readonly steps?: ReadonlyArray<{ readonly __typename?: 'LoyaltyQuestStep', readonly id: string, readonly status: LoyaltyQuestStepStatus, readonly cartRequirements?: ReadonlyArray<ReadonlyArray<{ readonly __typename?: 'LoyaltyCartRequirement', readonly id: string, readonly quantity: number } | null> | null> | null }> | null };

export type IRestaurantNodeFragment = { readonly __typename?: 'RestaurantNode', readonly _id?: string | null, readonly storeId?: string | null, readonly isAvailable: boolean, readonly posVendor?: string | null, readonly chaseMerchantId?: string | null, readonly distanceInMiles?: number | null, readonly drinkStationType?: string | null, readonly driveThruLaneType?: string | null, readonly email?: ReadonlyArray<string> | null, readonly environment?: RestaurantStatus | null, readonly fastestServiceMode?: ServiceMode | null, readonly franchiseGroupId?: number | null, readonly franchiseGroupName?: string | null, readonly frontCounterClosed?: boolean | null, readonly hasBreakfast?: boolean | null, readonly hasBurgersForBreakfast?: boolean | null, readonly hasCatering?: boolean | null, readonly hasCurbside?: boolean | null, readonly hasDelivery?: boolean | null, readonly hasDineIn?: boolean | null, readonly hasDriveThru?: boolean | null, readonly hasMobileOrdering?: boolean | null, readonly hasParking?: boolean | null, readonly hasPlayground?: boolean | null, readonly hasTakeOut?: boolean | null, readonly hasWifi?: boolean | null, readonly hasLoyalty?: boolean | null, readonly id?: string | null, readonly isDarkKitchen?: boolean | null, readonly isFavorite: boolean, readonly isHalal?: boolean | null, readonly isRecent: boolean, readonly latitude?: number | null, readonly longitude?: number | null, readonly mobileOrderingStatus?: OrderingStatus | null, readonly name?: string | null, readonly number?: string | null, readonly parkingType?: string | null, readonly phoneNumber?: string | null, readonly playgroundType?: string | null, readonly posRestaurantId?: string | null, readonly status?: string | null, readonly vatNumber?: string | null, readonly curbsideHours?: (
    { readonly __typename?: 'OperatingHours' }
    & IOperatingHoursFragment
  ) | null, readonly deliveryHours?: (
    { readonly __typename?: 'OperatingHours' }
    & IOperatingHoursFragment
  ) | null, readonly diningRoomHours?: (
    { readonly __typename?: 'OperatingHours' }
    & IOperatingHoursFragment
  ) | null, readonly driveThruHours?: (
    { readonly __typename?: 'OperatingHours' }
    & IOperatingHoursFragment
  ) | null, readonly physicalAddress?: { readonly __typename?: 'PhysicalAddress', readonly address1?: string | null, readonly address2?: string | null, readonly city?: string | null, readonly country?: string | null, readonly postalCode?: string | null, readonly stateProvince?: string | null, readonly stateProvinceShort?: string | null } | null, readonly pos?: { readonly __typename?: 'RestaurantPos', readonly vendor?: string | null } | null, readonly restaurantImage?: { readonly __typename?: 'SanityImage', readonly asset?: { readonly __typename?: 'SanityImageAsset', readonly _id?: string | null, readonly metadata?: { readonly __typename?: 'SanityImageMetaData', readonly lqip?: string | null } | null } | null } | null, readonly restaurantPosData?: { readonly __typename?: 'RestaurantPosData', readonly _id?: string | null } | null };

export type IPricingAndAvailabilityFragment = { readonly __typename?: 'Entity', readonly id: string, readonly isAvailable?: boolean | null, readonly price?: { readonly __typename?: 'Price', readonly default?: number | null, readonly max?: number | null, readonly min?: number | null, readonly overrides?: ReadonlyArray<{ readonly __typename?: 'Override', readonly key?: ReadonlyArray<string> | null, readonly price?: number | null }> | null } | null };

export type ICaloriesFragment = { readonly __typename?: 'Entity', readonly calories?: { readonly __typename?: 'Calories', readonly default?: number | null, readonly min?: number | null, readonly max?: number | null } | null };

export type IOptionsFragment = { readonly __typename?: 'Entity', readonly options?: ReadonlyArray<{ readonly __typename?: 'Option', readonly id: string, readonly options?: ReadonlyArray<{ readonly __typename?: 'Modifier', readonly id: string, readonly isAvailable?: boolean | null, readonly price?: number | null }> | null }> | null };

export type IUserGeoFragment = { readonly __typename?: 'UserGeo', readonly city?: string | null, readonly state?: string | null, readonly country?: string | null };

export type IVcFragment = { readonly __typename?: 'VendorConfig', readonly pluType: string, readonly parentSanityId?: string | null, readonly constantPlu?: string | null, readonly quantityBasedPlu?: ReadonlyArray<{ readonly __typename?: 'QuantityPlu', readonly quantity?: number | null, readonly plu?: string | null, readonly qualifier?: string | null } | null> | null, readonly multiConstantPlus?: ReadonlyArray<{ readonly __typename?: 'QuantityPlu', readonly quantity?: number | null, readonly plu?: string | null, readonly qualifier?: string | null } | null> | null, readonly parentChildPlu?: { readonly __typename?: 'ParentChildPlu', readonly plu?: string | null, readonly childPlu?: string | null } | null, readonly sizeBasedPlu?: { readonly __typename?: 'SizeBasedPlu', readonly comboPlu?: string | null, readonly comboSize?: string | null } | null };

export type IPlusFragment = { readonly __typename?: 'VendorConfigs', readonly brink?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null, readonly brinkDelivery?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null, readonly carrols?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null, readonly carrolsDelivery?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null, readonly ncr?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null, readonly ncrDelivery?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null, readonly qdi?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null, readonly qdiDelivery?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null, readonly sicom?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null, readonly sicomDelivery?: (
    { readonly __typename?: 'VendorConfig' }
    & IVcFragment
  ) | null };

export type ILoyaltyUserQueryVariables = Exact<{
  loyaltyId: Scalars['LoyaltyID'];
}>;


export type ILoyaltyUserQuery = { readonly __typename?: 'Query', readonly loyaltyUserV2?: (
    { readonly __typename?: 'LoyaltyUser' }
    & ILoyaltyUserFragment
  ) | null };

export type ILoyaltyUserTransactionsQueryVariables = Exact<{
  loyaltyId: Scalars['LoyaltyID'];
}>;


export type ILoyaltyUserTransactionsQuery = { readonly __typename?: 'Query', readonly loyaltyUserV2?: { readonly __typename?: 'LoyaltyUser', readonly id: any, readonly transactions?: ReadonlyArray<(
      { readonly __typename?: 'LoyaltyTransactionV2' }
      & ITransactionFragment
    )> | null } | null };

export type ILoyaltyUserRewardsQueryVariables = Exact<{
  loyaltyId: Scalars['LoyaltyID'];
  where?: InputMaybe<ILoyaltyRewardsInput>;
}>;


export type ILoyaltyUserRewardsQuery = { readonly __typename?: 'Query', readonly loyaltyUserV2?: { readonly __typename?: 'LoyaltyUser', readonly id: any, readonly rewards?: ReadonlyArray<(
      { readonly __typename?: 'LoyaltyReward' }
      & IRewardFragment
    )> | null } | null };

export type IGetLoyaltyOffersQueryVariables = Exact<{
  loyaltyId?: InputMaybe<Scalars['LoyaltyID']>;
  where?: InputMaybe<ILoyaltyOffersInput>;
}>;


export type IGetLoyaltyOffersQuery = { readonly __typename?: 'Query', readonly loyaltyOffersV2?: ReadonlyArray<(
    { readonly __typename?: 'LoyaltyOffer' }
    & IOffersFragment
  )> | null };

export type ILoyaltyUserOffersQueryVariables = Exact<{
  loyaltyId: Scalars['LoyaltyID'];
  where?: InputMaybe<ILoyaltyOffersInput>;
}>;


export type ILoyaltyUserOffersQuery = { readonly __typename?: 'Query', readonly loyaltyUserV2?: { readonly __typename?: 'LoyaltyUser', readonly id: any, readonly offerRedemptionAvailability?: { readonly __typename?: 'LoyaltyOfferRedemptionAvailability', readonly availableAfter?: string | null } | null, readonly offers?: ReadonlyArray<(
      { readonly __typename?: 'LoyaltyOffer' }
      & IOffersFragment
    )> | null } | null };

export type ILoyaltyOffersQueryVariables = Exact<{
  ids?: InputMaybe<ReadonlyArray<Scalars['LoyaltyID']> | Scalars['LoyaltyID']>;
  loyaltyId?: InputMaybe<Scalars['LoyaltyID']>;
  omitInvalids?: InputMaybe<Scalars['Boolean']>;
  redemptionTypes?: InputMaybe<ReadonlyArray<LoyaltyOfferRedemptionType> | LoyaltyOfferRedemptionType>;
  serviceMode?: InputMaybe<LoyaltyServiceMode>;
  storeId?: InputMaybe<Scalars['String']>;
  subtotalAmount?: InputMaybe<Scalars['Int']>;
}>;


export type ILoyaltyOffersQuery = { readonly __typename?: 'Query', readonly loyaltyOffersV2?: ReadonlyArray<(
    { readonly __typename?: 'LoyaltyOffer' }
    & IOffersFragment
  )> | null };

export type ILoyaltyEngineRewardsQueryVariables = Exact<{
  loyaltyId: Scalars['LoyaltyID'];
}>;


export type ILoyaltyEngineRewardsQuery = { readonly __typename?: 'Query', readonly loyaltyRewardsV2?: ReadonlyArray<(
    { readonly __typename?: 'LoyaltyReward' }
    & IRewardFragment
  )> | null };

export type ILoyaltyNotificationsRedeemableQueryVariables = Exact<{
  loyaltyId: Scalars['LoyaltyID'];
  rewardsInput?: InputMaybe<ILoyaltyRewardsInput>;
  offersInput?: InputMaybe<ILoyaltyOffersInput>;
}>;


export type ILoyaltyNotificationsRedeemableQuery = { readonly __typename?: 'Query', readonly loyaltyUserV2?: { readonly __typename?: 'LoyaltyUser', readonly id: any, readonly rewards?: ReadonlyArray<{ readonly __typename?: 'LoyaltyReward', readonly id: any }> | null, readonly promotions?: ReadonlyArray<{ readonly __typename?: 'LoyaltySystemWidePromotion', readonly id: any }> | null, readonly offers?: ReadonlyArray<{ readonly __typename?: 'LoyaltyOffer', readonly id: any }> | null } | null };

export type ILoyaltyGenerateOtpMutationVariables = Exact<{
  inRestaurantOrder: ReadonlyArray<ILoyaltyInRestaurantOrderLineItem> | ILoyaltyInRestaurantOrderLineItem;
  loyaltyId: Scalars['LoyaltyID'];
  restaurantId?: InputMaybe<Scalars['LoyaltyID']>;
}>;


export type ILoyaltyGenerateOtpMutation = { readonly __typename?: 'Mutation', readonly loyaltyGenerateOtp: { readonly __typename?: 'LoyaltyOtp', readonly password: string, readonly expirationTime: string } };

export type IProcessSmgCodeMutationVariables = Exact<{
  loyaltyId: Scalars['LoyaltyID'];
  smgCode: Scalars['String'];
  transactionDate?: InputMaybe<Scalars['String']>;
}>;


export type IProcessSmgCodeMutation = { readonly __typename?: 'Mutation', readonly loyaltyProcessSmgCode: { readonly __typename?: 'LoyaltyProcessSmgCodeResponse', readonly pointsEarned: number, readonly status: LoyaltySmgCodeStatus } };

export type IOrderSelectionQueryVariables = Exact<{
  otp: Scalars['String'];
}>;


export type IOrderSelectionQuery = { readonly __typename?: 'Query', readonly loyaltyOrderSelection?: { readonly __typename?: 'LoyaltyOrderSelectionTransfer', readonly status?: OrderSelectionStatus | null, readonly expiry?: number | null, readonly _id?: string | null } | null };

export type ICreateOrderlessTransactionMutationVariables = Exact<{
  input: ILoyaltyOrderlessTransactionInput;
}>;


export type ICreateOrderlessTransactionMutation = { readonly __typename?: 'Mutation', readonly loyaltyCreateOrderlessTransaction: { readonly __typename?: 'LoyaltyTransactionV2', readonly id: any } };

export type IGetLoyaltyQuestsQueryVariables = Exact<{
  loyaltyId: Scalars['LoyaltyID'];
  where?: InputMaybe<ILoyaltyQuestsInput>;
}>;


export type IGetLoyaltyQuestsQuery = { readonly __typename?: 'Query', readonly loyaltyUserV2?: { readonly __typename?: 'LoyaltyUser', readonly id: any, readonly quests?: ReadonlyArray<(
      { readonly __typename?: 'LoyaltyQuest' }
      & IQuestFragment
    )> | null } | null };

export type IActivateQuestMutationVariables = Exact<{
  questId: Scalars['LoyaltyID'];
  loyaltyId: Scalars['LoyaltyID'];
}>;


export type IActivateQuestMutation = { readonly __typename?: 'Mutation', readonly loyaltyActivateQuest?: (
    { readonly __typename?: 'LoyaltyQuest' }
    & IQuestFragment
  ) | null };

export type IOrderSelectionByTypeQueryVariables = Exact<{
  key: Scalars['String'];
  ostType: LoyaltyOstType;
}>;


export type IOrderSelectionByTypeQuery = { readonly __typename?: 'Query', readonly loyaltyOrderSelectionByType?: { readonly __typename?: 'LoyaltyOrderSelectionTransfer', readonly status?: OrderSelectionStatus | null, readonly expiry?: number | null, readonly _id?: string | null } | null };

export type IOrderSelectionByMultipleTypeQueryVariables = Exact<{
  input: ReadonlyArray<ILoyaltyGetOrderSelectionByMultipleType> | ILoyaltyGetOrderSelectionByMultipleType;
}>;


export type IOrderSelectionByMultipleTypeQuery = { readonly __typename?: 'Query', readonly loyaltyOrderSelectionByMultipleType?: ReadonlyArray<{ readonly __typename?: 'LoyaltyOrderSelectionTransfer', readonly status?: OrderSelectionStatus | null, readonly expiry?: number | null, readonly _id?: string | null } | null> | null };

export type ICreateOrderSelectionByMultipleTypeMutationVariables = Exact<{
  ostTypes: ReadonlyArray<LoyaltyOstType> | LoyaltyOstType;
  inRestaurantOrder: ReadonlyArray<ILoyaltyInRestaurantOrderLineItem> | ILoyaltyInRestaurantOrderLineItem;
  loyaltyId: Scalars['LoyaltyID'];
  restaurantId?: InputMaybe<Scalars['LoyaltyID']>;
}>;


export type ICreateOrderSelectionByMultipleTypeMutation = { readonly __typename?: 'Mutation', readonly loyaltyCreateOrderSelectionByMultipleType: ReadonlyArray<{ readonly __typename?: 'LoyaltyMultipleOstCreationPayload', readonly ostType: LoyaltyOstType, readonly expirationTime: string, readonly key: string }> };

export type ICreateOrderSelectionByTypeMutationVariables = Exact<{
  ostType: LoyaltyOstType;
  inRestaurantOrder: ReadonlyArray<ILoyaltyInRestaurantOrderLineItem> | ILoyaltyInRestaurantOrderLineItem;
  loyaltyId: Scalars['LoyaltyID'];
  restaurantId?: InputMaybe<Scalars['LoyaltyID']>;
}>;


export type ICreateOrderSelectionByTypeMutation = { readonly __typename?: 'Mutation', readonly loyaltyCreateOrderSelectionByType: { readonly __typename?: 'LoyaltyOstCreationPayload', readonly expirationTime: string, readonly key: string } };

export type ILoyaltyUserPromotionsQueryVariables = Exact<{
  loyaltyId: Scalars['LoyaltyID'];
  where?: InputMaybe<ILoyaltyPromotionsInput>;
}>;


export type ILoyaltyUserPromotionsQuery = { readonly __typename?: 'Query', readonly loyaltyUserV2?: { readonly __typename?: 'LoyaltyUser', readonly promotions?: ReadonlyArray<(
      { readonly __typename?: 'LoyaltySystemWidePromotion' }
      & IPromotionFragment
    )> | null } | null };

export type ILoyaltyRedeemPromoCodeMutationVariables = Exact<{
  input?: InputMaybe<ILoyaltyValidatePromoCodeInput>;
}>;


export type ILoyaltyRedeemPromoCodeMutation = { readonly __typename?: 'Mutation', readonly loyaltyValidatePromoCode?: (
    { readonly __typename?: 'LoyaltyCouponResponse' }
    & ILoyaltyCouponFragment
  ) | null };

export type ILoyaltyUpdateIdAndPayMutationVariables = Exact<{
  idAndPayInput: ILoyaltyIdAndPayInput;
  loyaltyId: Scalars['LoyaltyID'];
}>;


export type ILoyaltyUpdateIdAndPayMutation = { readonly __typename?: 'Mutation', readonly loyaltyUpdateIdAndPay?: { readonly __typename?: 'LoyaltyIdAndPayUpdateResponse', readonly enabled?: boolean | null } | null };

export type IPlusDataQueryVariables = Exact<{
  storeId: Scalars['ID'];
  serviceMode?: InputMaybe<PosDataServiceMode>;
}>;


export type IPlusDataQuery = { readonly __typename?: 'Query', readonly plus?: ReadonlyArray<{ readonly __typename?: 'MenuItem', readonly t: 'MenuItem', readonly k: string, readonly v: string }> | null };

export type IStoreMenuQueryVariables = Exact<{
  region: Scalars['String'];
  channel: Channel;
  storeId: Scalars['ID'];
  serviceMode?: InputMaybe<PosDataServiceMode>;
  variantName?: InputMaybe<Scalars['String']>;
}>;


export type IStoreMenuQuery = { readonly __typename?: 'Query', readonly storeMenu?: ReadonlyArray<(
    { readonly __typename?: 'Entity' }
    & IPricingAndAvailabilityFragment
    & ICaloriesFragment
    & IOptionsFragment
  )> | null };

export type IPaymentConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type IPaymentConfigQuery = { readonly __typename?: 'Query', readonly paymentConfig: (
    { readonly __typename?: 'PaymentConfig' }
    & IPaymentConfigFragment
  ) };

export type IStoredPaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type IStoredPaymentMethodsQuery = { readonly __typename?: 'Query', readonly storedPaymentMethods: ReadonlyArray<(
    { readonly __typename?: 'PrepaidStoredPaymentMethod' }
    & IPrepaidStoredPaymentMethodsFragment
  ) | (
    { readonly __typename?: 'SchemeStoredPaymentMethod' }
    & ISchemeStoredPaymentMethodsFragment
  )> };

export type IPaymentPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type IPaymentPreferencesQuery = { readonly __typename?: 'Query', readonly paymentPreferences: (
    { readonly __typename?: 'PaymentPreferences' }
    & IPaymentPreferencesFragment
  ) };

export type IUserPaymentInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type IUserPaymentInformationQuery = { readonly __typename?: 'Query', readonly paymentConfig: (
    { readonly __typename?: 'PaymentConfig' }
    & IPaymentConfigFragment
  ), readonly paymentPreferences: (
    { readonly __typename?: 'PaymentPreferences' }
    & IPaymentPreferencesFragment
  ), readonly storedPaymentMethods: ReadonlyArray<(
    { readonly __typename?: 'PrepaidStoredPaymentMethod' }
    & IPrepaidStoredPaymentMethodsFragment
  ) | (
    { readonly __typename?: 'SchemeStoredPaymentMethod' }
    & ISchemeStoredPaymentMethodsFragment
  )> };

export type IAddPaymentMethodMutationVariables = Exact<{
  input: IAddPaymentMethodInput;
}>;


export type IAddPaymentMethodMutation = { readonly __typename?: 'Mutation', readonly addPaymentMethod: (
    { readonly __typename?: 'AddPaymentMethodSuccess' }
    & IAddPaymentMethodSuccessFragment
  ) | { readonly __typename?: 'ThreeDsChallenge' } | { readonly __typename?: 'ThreeDsFrictionless' } };

export type IResumeAddPaymentMethodMutationVariables = Exact<{
  input: IResumeAddPaymentMethodInput;
}>;


export type IResumeAddPaymentMethodMutation = { readonly __typename?: 'Mutation', readonly resumeAddPaymentMethod: (
    { readonly __typename?: 'AddPaymentMethodSuccess' }
    & IAddPaymentMethodSuccessFragment
  ) | { readonly __typename?: 'ThreeDsChallenge' } | { readonly __typename?: 'ThreeDsFrictionless' } };

export type IMergePrepaidMutationVariables = Exact<{
  input: IMergePrepaidInput;
}>;


export type IMergePrepaidMutation = { readonly __typename?: 'Mutation', readonly mergePrepaid: { readonly __typename?: 'MergePrepaidPayload', readonly storedPaymentMethodId: string, readonly prepaidDetails: { readonly __typename?: 'PrepaidDetails', readonly last4: string, readonly cardNumber: string, readonly expiryMonth: string, readonly expiryYear: string, readonly balance: number, readonly currency: string } } };

export type IDeletePaymentMethodMutationVariables = Exact<{
  input: IDeletePaymentMethodInput;
}>;


export type IDeletePaymentMethodMutation = { readonly __typename?: 'Mutation', readonly deletePaymentMethod: { readonly __typename?: 'DeletePaymentMethodPayload', readonly success: boolean } };

export type IReloadPrepaidMutationVariables = Exact<{
  input: IReloadPrepaidInput;
}>;


export type IReloadPrepaidMutation = { readonly __typename?: 'Mutation', readonly reloadPrepaid: { readonly __typename?: 'ReloadPrepaidAuthorized', readonly prepaidDetails: { readonly __typename?: 'PrepaidDetails', readonly last4: string, readonly cardNumber: string, readonly expiryMonth: string, readonly expiryYear: string, readonly balance: number, readonly currency: string } } | { readonly __typename?: 'ReloadPrepaidRefused', readonly code: PurchasePrepaidRefusalCode } };

export type IUpdateDefaultPaymentMethodMutationVariables = Exact<{
  input: IUpdateDefaultPaymentMethodInput;
}>;


export type IUpdateDefaultPaymentMethodMutation = { readonly __typename?: 'Mutation', readonly updateDefaultPaymentMethod: { readonly __typename?: 'UpdateDefaultPaymentMethodPayload', readonly defaultPaymentMethodId: string } };

export type ILatestPaymentTransactionQueryVariables = Exact<{
  feCountryCode?: InputMaybe<IsoCountryCode>;
}>;


export type ILatestPaymentTransactionQuery = { readonly __typename?: 'Query', readonly latestPaymentTransaction: { readonly __typename?: 'PaymentTransaction', readonly amount: number, readonly client?: string | null, readonly createdAt: string, readonly currency: string, readonly orderId?: string | null, readonly paymentId: string, readonly paymentMethodType?: PaymentMethodType | null, readonly schemeType?: SchemePaymentMethodType | null, readonly pspReference?: string | null, readonly reason?: string | null, readonly region: string, readonly status: OperationStatus, readonly storeId?: string | null, readonly type: PaymentTransactionType } };

export type IUserAccountsQueryVariables = Exact<{
  feCountryCode: IsoCountryCode;
}>;


export type IUserAccountsQuery = { readonly __typename?: 'Query', readonly userAccounts?: { readonly __typename?: 'AccountListResponse', readonly count: number, readonly paymentProcessor?: PaymentProcessor | null, readonly accounts?: ReadonlyArray<{ readonly __typename?: 'Account', readonly accountIdentifier?: string | null, readonly fdAccountId?: string | null, readonly orbitalIdentifier?: string | null, readonly paypal?: boolean | null, readonly credit?: { readonly __typename?: 'CreditCard', readonly alias: string, readonly cardType: string, readonly expiryYear: string, readonly expiryMonth: string, readonly panToken?: string | null } | null, readonly prepaid?: { readonly __typename?: 'GiftCard', readonly alias: string, readonly currentBalance?: number | null, readonly cardNumber: string, readonly expiryMonth: string, readonly expiryYear: string, readonly feFormattedCurrentBalance?: number | null, readonly shuffledCardNumber: string } | null } | null> | null } | null };

export type IGetEncryptionDetailsMutationVariables = Exact<{ [key: string]: never; }>;


export type IGetEncryptionDetailsMutation = { readonly __typename?: 'Mutation', readonly encryptionDetails: { readonly __typename?: 'EncryptionDetails', readonly fdPublicKey: string, readonly fdAccessToken: string, readonly fdPublicKeyExpiresInSeconds: number, readonly fdApiKey: string, readonly algorithm?: string | null, readonly fdCustomerId?: string | null } };

export type IAddCreditAccountMutationVariables = Exact<{
  input: IAddCreditAccountInput;
}>;


export type IAddCreditAccountMutation = { readonly __typename?: 'Mutation', readonly addCreditAccount: { readonly __typename?: 'Account', readonly accountIdentifier?: string | null, readonly fdAccountId?: string | null, readonly orbitalIdentifier?: string | null, readonly credit?: { readonly __typename?: 'CreditCard', readonly alias: string, readonly cardType: string, readonly expiryMonth: string, readonly expiryYear: string, readonly panToken?: string | null, readonly billingAddress?: { readonly __typename?: 'BillingAddress', readonly locality: string, readonly postalCode: string, readonly region: string, readonly streetAddress: string, readonly unitNumber?: string | null } | null } | null } };

export type IPrepaidsReloadMutationVariables = Exact<{
  input: IPrepaidsReloadInput;
}>;


export type IPrepaidsReloadMutation = { readonly __typename?: 'Mutation', readonly prepaidsReload: { readonly __typename?: 'Reload', readonly currentBalance: number, readonly fdAccountId: string, readonly fdCorrelationId?: string | null, readonly transactionId: string } };

export type IPrepaidByNumberQueryVariables = Exact<{
  cardNumber: Scalars['String'];
}>;


export type IPrepaidByNumberQuery = { readonly __typename?: 'Query', readonly prepaidByNumber: { readonly __typename?: 'PrepaidDetails', readonly last4: string, readonly cardNumber: string, readonly expiryMonth: string, readonly expiryYear: string, readonly balance: number, readonly currency: string } };

export type IPromotionValidatePromoCodeMutationVariables = Exact<{
  code: Scalars['String'];
  cognitoId: Scalars['String'];
  shouldRedeem?: InputMaybe<Scalars['Boolean']>;
  offers: ReadonlyArray<Scalars['String']> | Scalars['String'];
}>;


export type IPromotionValidatePromoCodeMutation = { readonly __typename?: 'Mutation', readonly validatePromoCode?: { readonly __typename?: 'CBACouponResponse', readonly code: string, readonly reason?: string | null, readonly message: string, readonly isValid: boolean, readonly isRedeemed?: boolean | null, readonly offerId?: string | null } | null };

export type IPromotionRedeemPromoCodeMutationVariables = Exact<{
  code: Scalars['String'];
  cognitoId: Scalars['String'];
}>;


export type IPromotionRedeemPromoCodeMutation = { readonly __typename?: 'Mutation', readonly redeemPromoCode?: { readonly __typename?: 'CBARedeemCouponResponse', readonly code: string, readonly reason?: string | null, readonly message?: string | null, readonly isRedeemed: boolean, readonly offerId?: string | null } | null };

export type IGetRestaurantQueryVariables = Exact<{
  storeId?: InputMaybe<Scalars['String']>;
  storeNumber?: InputMaybe<Scalars['String']>;
}>;


export type IGetRestaurantQuery = { readonly __typename?: 'Query', readonly restaurant: { readonly __typename?: 'Restaurant', readonly available: boolean, readonly fastestServiceMode?: ServiceMode | null, readonly curbsideHours?: (
      { readonly __typename?: 'OperatingHours' }
      & IOperatingHoursFragment
    ) | null, readonly deliveryHours?: (
      { readonly __typename?: 'OperatingHours' }
      & IOperatingHoursFragment
    ) | null, readonly diningRoomHours?: (
      { readonly __typename?: 'OperatingHours' }
      & IOperatingHoursFragment
    ) | null, readonly driveThruHours?: (
      { readonly __typename?: 'OperatingHours' }
      & IOperatingHoursFragment
    ) | null, readonly futureServiceHours: ReadonlyArray<{ readonly __typename?: 'FutureServiceHours', readonly serviceMode?: ServiceMode | null, readonly timeSlots?: ReadonlyArray<{ readonly __typename?: 'RestaurantTimeSlot', readonly closes: string, readonly date: string, readonly isClosed?: boolean | null, readonly opens: string } | null> | null }> } };

export type IGetRestaurantsQueryVariables = Exact<{
  input?: InputMaybe<IRestaurantsInput>;
}>;


export type IGetRestaurantsQuery = { readonly __typename?: 'Query', readonly restaurants?: { readonly __typename?: 'RestaurantsConnection', readonly totalCount?: number | null, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly nodes: ReadonlyArray<(
      { readonly __typename?: 'RestaurantNode' }
      & IRestaurantNodeFragment
    )> } | null };

export type IDeliveryRestaurantQueryVariables = Exact<{
  dropoff: IDeliveryWaypointInput;
  searchRadius: Scalars['Float'];
  platform: Platform;
}>;


export type IDeliveryRestaurantQuery = { readonly __typename?: 'Query', readonly deliveryRestaurant: { readonly __typename?: 'DeliveryRestaurant', readonly storeStatus: DeliveryStoreStatus, readonly quote?: DeliveryStatus | null, readonly nextEarliestOpen?: string | null, readonly deliverySurchargeFeeCents?: number | null, readonly quoteId?: string | null, readonly restaurant?: (
      { readonly __typename?: 'RestaurantNode' }
      & IRestaurantNodeFragment
    ) | null } };

export type IGetNearbyRestaurantsQueryVariables = Exact<{
  input: INearbyRestaurantsInput;
}>;


export type IGetNearbyRestaurantsQuery = { readonly __typename?: 'Query', readonly restaurantsV2?: { readonly __typename?: 'RestaurantsFullSearchResult', readonly nearby?: { readonly __typename?: 'RestaurantsConnection', readonly nodes: ReadonlyArray<(
        { readonly __typename?: 'RestaurantNode' }
        & IRestaurantNodeFragment
      )> } | null } | null };

export type IGetUserFavoritesRefsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  resumeAfter?: InputMaybe<Scalars['String']>;
}>;


export type IGetUserFavoritesRefsQuery = { readonly __typename?: 'Query', readonly userFavorites: { readonly __typename?: 'FavoriteList', readonly count?: number | null, readonly resumeAfter?: string | null, readonly favorites?: ReadonlyArray<{ readonly __typename?: 'Favorite', readonly ref?: string | null, readonly _id?: string | null } | null> | null } };

export type IGetUserFavoriteQueryVariables = Exact<{
  favoriteId: Scalars['String'];
}>;


export type IGetUserFavoriteQuery = { readonly __typename?: 'Query', readonly userFavorite: (
    { readonly __typename?: 'Favorite' }
    & IFavoriteFragment
  ) };

export type IGetUserFavoritesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  resumeAfter?: InputMaybe<Scalars['String']>;
}>;


export type IGetUserFavoritesQuery = { readonly __typename?: 'Query', readonly userFavorites: { readonly __typename?: 'FavoriteList', readonly count?: number | null, readonly resumeAfter?: string | null, readonly favorites?: ReadonlyArray<(
      { readonly __typename?: 'Favorite' }
      & IFavoriteFragment
    ) | null> | null } };

export type IGetUserReorderFavoritesQueryVariables = Exact<{ [key: string]: never; }>;


export type IGetUserReorderFavoritesQuery = { readonly __typename?: 'Query', readonly userFavorites: { readonly __typename?: 'FavoriteList', readonly count?: number | null, readonly favorites?: ReadonlyArray<(
      { readonly __typename?: 'Favorite' }
      & IReorderFavoriteFragment
    ) | null> | null } };

export type ICreateFavoriteMutationVariables = Exact<{
  input: IFavoriteInput;
}>;


export type ICreateFavoriteMutation = { readonly __typename?: 'Mutation', readonly createFavorite: (
    { readonly __typename?: 'Favorite' }
    & IFavoriteFragment
  ) };

export type IUpdateFavoriteMutationVariables = Exact<{
  favoriteId: Scalars['String'];
  input: IFavoriteInput;
}>;


export type IUpdateFavoriteMutation = { readonly __typename?: 'Mutation', readonly updateFavorite: (
    { readonly __typename?: 'Favorite' }
    & IFavoriteFragment
  ) };

export type IDeleteFavoriteMutationVariables = Exact<{
  favoriteId: Scalars['String'];
}>;


export type IDeleteFavoriteMutation = { readonly __typename?: 'Mutation', readonly deleteFavorite: (
    { readonly __typename?: 'Favorite' }
    & IFavoriteFragment
  ) };

export type ISignUpMutationVariables = Exact<{
  input: ISignUpUserInput;
}>;


export type ISignUpMutation = { readonly __typename?: 'Mutation', readonly signUp?: string | null };

export type ISignUpCompleteQueryVariables = Exact<{
  jwt: Scalars['String'];
}>;


export type ISignUpCompleteQuery = { readonly __typename?: 'Query', readonly signUpComplete?: boolean | null };

export type IUserGeoQueryVariables = Exact<{ [key: string]: never; }>;


export type IUserGeoQuery = { readonly __typename?: 'Query', readonly userGeo: (
    { readonly __typename?: 'UserGeo' }
    & IUserGeoFragment
  ) };

export type IResendVerificationEmailMutationVariables = Exact<{
  input: IResendVerificationEmailInput;
}>;


export type IResendVerificationEmailMutation = { readonly __typename?: 'Mutation', readonly resendVerificationEmail?: boolean | null };

export type IResendCurrentLoginOtpMutationVariables = Exact<{
  input: IResendOtpInput;
}>;


export type IResendCurrentLoginOtpMutation = { readonly __typename?: 'Mutation', readonly resendCurrentLoginOTP: { readonly __typename?: 'CreateOTP', readonly maxValidateAttempts: number, readonly ttl: number } };

export type ISignInJwtMutationVariables = Exact<{
  input: ISignInUserInput;
}>;


export type ISignInJwtMutation = { readonly __typename?: 'Mutation', readonly signInJWT?: boolean | null };

export type IValidateAuthJwtMutationVariables = Exact<{
  input: IValidateAuthJwtInput;
}>;


export type IValidateAuthJwtMutation = { readonly __typename?: 'Mutation', readonly validateAuthJwt: { readonly __typename?: 'CognitoCredentials', readonly challengeCode: string, readonly sessionId: string } };

export type IValidateOtpMutationVariables = Exact<{
  input: IExchangeOtpCodeForCredentialsInput;
}>;


export type IValidateOtpMutation = { readonly __typename?: 'Mutation', readonly exchangeOTPCodeForCognitoCredentials: { readonly __typename?: 'CognitoCredentials', readonly challengeCode: string, readonly sessionId: string, readonly email?: string | null } };

export type ICreateOtpMutationVariables = Exact<{
  input: ICreateOtpInput;
}>;


export type ICreateOtpMutation = { readonly __typename?: 'Mutation', readonly createOTP: { readonly __typename?: 'CreateOTP', readonly maxValidateAttempts: number, readonly ttl: number } };

export type ICreateLoginForVendorMutationVariables = Exact<{
  vendor: Scalars['String'];
}>;


export type ICreateLoginForVendorMutation = { readonly __typename?: 'Mutation', readonly createLoginForVendor?: string | null };

export type ISocialLoginMutationVariables = Exact<{
  input: ISocialLoginInput;
}>;


export type ISocialLoginMutation = { readonly __typename?: 'Mutation', readonly socialLogin?: { readonly __typename?: 'CognitoCredentials', readonly sessionId: string, readonly challengeCode: string, readonly email?: string | null } | null };

export type IDeleteMeMutationVariables = Exact<{ [key: string]: never; }>;


export type IDeleteMeMutation = { readonly __typename?: 'Mutation', readonly deleteMe?: boolean | null };

export type ISyncUserCommunicationPreferencesMutationVariables = Exact<{ [key: string]: never; }>;


export type ISyncUserCommunicationPreferencesMutation = { readonly __typename?: 'Mutation', readonly syncUserCommunicationPreferences: { readonly __typename?: 'SyncUserCommunicationPreferencesResult', readonly marketingEmail: boolean, readonly marketingPush: boolean, readonly marketingSms: boolean } };

export type IUpdateUserCommunicationPreferencesMutationVariables = Exact<{
  input: IUpdateUserCommunicationPreferencesInput;
}>;


export type IUpdateUserCommunicationPreferencesMutation = { readonly __typename?: 'Mutation', readonly updateUserCommunicationPreferences: { readonly __typename?: 'SyncUserCommunicationPreferencesResult', readonly marketingEmail: boolean, readonly marketingPush: boolean, readonly marketingSms: boolean } };

export type IVerifyPhoneNumberMutationVariables = Exact<{
  input: IVerifyPhoneNumberInput;
}>;


export type IVerifyPhoneNumberMutation = { readonly __typename?: 'Mutation', readonly verifyPhoneNumber?: boolean | null };

export type ISendPhoneVerificationMutationVariables = Exact<{
  input: IResendPhoneVerificationInput;
}>;


export type ISendPhoneVerificationMutation = { readonly __typename?: 'Mutation', readonly sendPhoneVerification?: boolean | null };

export type IUserPhoneFromBrazeQueryVariables = Exact<{
  brazeId: Scalars['String'];
}>;


export type IUserPhoneFromBrazeQuery = { readonly __typename?: 'Query', readonly userPhoneFromBraze?: { readonly __typename?: 'BrazeUserPhone', readonly phone?: string | null } | null };

export const SchemeStoredPaymentMethodResponseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchemeStoredPaymentMethodResponse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SchemeStoredPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"panToken"}}]}}]} as unknown as DocumentNode;
export const AddPaymentMethodSuccessFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddPaymentMethodSuccess"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddPaymentMethodSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storedPaymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchemeStoredPaymentMethodResponse"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchemeStoredPaymentMethodResponse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SchemeStoredPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"panToken"}}]}}]} as unknown as DocumentNode;
export const VcFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VC"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluType"}},{"kind":"Field","name":{"kind":"Name","value":"parentSanityId"}},{"kind":"Field","name":{"kind":"Name","value":"constantPlu"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiConstantPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentChildPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"childPlu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comboPlu"}},{"kind":"Field","name":{"kind":"Name","value":"comboSize"}}]}}]}}]} as unknown as DocumentNode;
export const PlusFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Plus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfigs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brinkDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrols"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrolsDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncrDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdiDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicomDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VC"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluType"}},{"kind":"Field","name":{"kind":"Name","value":"parentSanityId"}},{"kind":"Field","name":{"kind":"Name","value":"constantPlu"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiConstantPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentChildPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"childPlu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comboPlu"}},{"kind":"Field","name":{"kind":"Name","value":"comboSize"}}]}}]}}]} as unknown as DocumentNode;
export const CartEntryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isDonation"}},{"kind":"Field","name":{"kind":"Name","value":"isExtra"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pickerSelections"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"redeemable"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Plus"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VC"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluType"}},{"kind":"Field","name":{"kind":"Name","value":"parentSanityId"}},{"kind":"Field","name":{"kind":"Name","value":"constantPlu"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiConstantPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentChildPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"childPlu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comboPlu"}},{"kind":"Field","name":{"kind":"Name","value":"comboSize"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Plus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfigs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brinkDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrols"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrolsDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncrDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdiDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicomDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}}]}}]} as unknown as DocumentNode;
export const CartEntryWithChildrenFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isDonation"}},{"kind":"Field","name":{"kind":"Name","value":"isExtra"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pickerSelections"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"redeemable"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Plus"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VC"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluType"}},{"kind":"Field","name":{"kind":"Name","value":"parentSanityId"}},{"kind":"Field","name":{"kind":"Name","value":"constantPlu"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiConstantPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentChildPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"childPlu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comboPlu"}},{"kind":"Field","name":{"kind":"Name","value":"comboSize"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Plus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfigs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brinkDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrols"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrolsDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncrDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdiDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicomDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}}]}}]} as unknown as DocumentNode;
export const FavoriteFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FavoriteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Favorite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"favoriteId"}},{"kind":"Field","name":{"kind":"Name","value":"favoriteId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ref"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isDonation"}},{"kind":"Field","name":{"kind":"Name","value":"isExtra"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pickerSelections"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"redeemable"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Plus"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VC"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluType"}},{"kind":"Field","name":{"kind":"Name","value":"parentSanityId"}},{"kind":"Field","name":{"kind":"Name","value":"constantPlu"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiConstantPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentChildPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"childPlu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comboPlu"}},{"kind":"Field","name":{"kind":"Name","value":"comboSize"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Plus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfigs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brinkDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrols"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrolsDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncrDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdiDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicomDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}}]}}]} as unknown as DocumentNode;
export const ReorderFavoriteFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReorderFavoriteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Favorite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FavoriteFragment"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"isInMenu"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"isInMenu"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"isInMenu"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"isInMenu"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"isInMenu"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"isInMenu"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isDonation"}},{"kind":"Field","name":{"kind":"Name","value":"isExtra"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pickerSelections"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"redeemable"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Plus"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FavoriteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Favorite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"favoriteId"}},{"kind":"Field","name":{"kind":"Name","value":"favoriteId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ref"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VC"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluType"}},{"kind":"Field","name":{"kind":"Name","value":"parentSanityId"}},{"kind":"Field","name":{"kind":"Name","value":"constantPlu"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiConstantPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentChildPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"childPlu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comboPlu"}},{"kind":"Field","name":{"kind":"Name","value":"comboSize"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Plus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfigs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brinkDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrols"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrolsDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncrDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdiDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicomDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}}]}}]} as unknown as DocumentNode;
export const TransactionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyTransactionV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"pointsEarned"}},{"kind":"Field","name":{"kind":"Name","value":"bonusPointsEarned"}},{"kind":"Field","name":{"kind":"Name","value":"pointsUsed"}},{"kind":"Field","name":{"kind":"Name","value":"pointsDeducted"}},{"kind":"Field","name":{"kind":"Name","value":"hasRewards"}},{"kind":"Field","name":{"kind":"Name","value":"transactionDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"additionalReferenceIds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode;
export const RewardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyReward"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rewardBenefitId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pointCost"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"locked"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"limitPerOrder"}},{"kind":"Field","name":{"kind":"Name","value":"remainingPointsNeededForRedemption"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode;
export const LoyaltyUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoyaltyUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bestPromotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sanityId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointsExpiryDateKey"}},{"kind":"Field","name":{"kind":"Name","value":"offerRedemptionAvailability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableAfter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"identifierType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationBuckets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"pointsToExpire"}}]}},{"kind":"Field","name":{"kind":"Name","value":"idPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"storedPaymentMethodId"}}]}}]}}]} as unknown as DocumentNode;
export const OffersFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OffersFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyOffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyBenefitReference"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"reference"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyBenefitSwap"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltySwap"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"configId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"currentValue"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"ruleId"}},{"kind":"Field","name":{"kind":"Name","value":"targetValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isStackable"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyId"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionType"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"serviceModes"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode;
export const InvalidIncentiveFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvalidIncentiveFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyInvalidIncentives"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"currentValue"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"ruleId"}},{"kind":"Field","name":{"kind":"Name","value":"targetValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode;
export const PromotionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltySystemWidePromotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode;
export const LoyaltyCouponFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoyaltyCouponFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyCouponResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"isRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"shouldRedeem"}},{"kind":"Field","name":{"kind":"Name","value":"personalizedOfferId"}},{"kind":"Field","name":{"kind":"Name","value":"configId"}}]}}]} as unknown as DocumentNode;
export const SchemeStoredPaymentMethodsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchemeStoredPaymentMethods"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SchemeStoredPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"panToken"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode;
export const PrepaidStoredPaymentMethodsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PrepaidStoredPaymentMethods"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepaidStoredPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"shuffledCardNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode;
export const PaymentPreferencesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentPreferences"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentPreferences"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storedPaymentMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"reloadAmount"}},{"kind":"Field","name":{"kind":"Name","value":"autoReload"}},{"kind":"Field","name":{"kind":"Name","value":"autoReloadThreshold"}}]}}]} as unknown as DocumentNode;
export const PaymentConfigFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentConfig"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowedPaymentMethods"}},{"kind":"Field","name":{"kind":"Name","value":"frontendIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"applePay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schemeMerchantId"}},{"kind":"Field","name":{"kind":"Name","value":"prepaidMerchantId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"googlePay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schemeMerchantId"}},{"kind":"Field","name":{"kind":"Name","value":"prepaidMerchantId"}}]}}]}}]} as unknown as DocumentNode;
export const QuestFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuestFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyQuest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"bonusPoints"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastCompletion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"benefitId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"redeemed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incentiveType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"cartRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]}}]} as unknown as DocumentNode;
export const OperatingHoursFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OperatingHoursFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OperatingHours"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"friClose"}},{"kind":"Field","name":{"kind":"Name","value":"friOpen"}},{"kind":"Field","name":{"kind":"Name","value":"monClose"}},{"kind":"Field","name":{"kind":"Name","value":"monOpen"}},{"kind":"Field","name":{"kind":"Name","value":"satClose"}},{"kind":"Field","name":{"kind":"Name","value":"satOpen"}},{"kind":"Field","name":{"kind":"Name","value":"sunClose"}},{"kind":"Field","name":{"kind":"Name","value":"sunOpen"}},{"kind":"Field","name":{"kind":"Name","value":"thrClose"}},{"kind":"Field","name":{"kind":"Name","value":"thrOpen"}},{"kind":"Field","name":{"kind":"Name","value":"tueClose"}},{"kind":"Field","name":{"kind":"Name","value":"tueOpen"}},{"kind":"Field","name":{"kind":"Name","value":"wedClose"}},{"kind":"Field","name":{"kind":"Name","value":"wedOpen"}}]}}]} as unknown as DocumentNode;
export const RestaurantNodeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RestaurantNodeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RestaurantNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"posVendor"}},{"kind":"Field","name":{"kind":"Name","value":"chaseMerchantId"}},{"kind":"Field","name":{"kind":"Name","value":"curbsideHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diningRoomHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"distanceInMiles"}},{"kind":"Field","name":{"kind":"Name","value":"drinkStationType"}},{"kind":"Field","name":{"kind":"Name","value":"driveThruHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"driveThruLaneType"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"environment"}},{"kind":"Field","name":{"kind":"Name","value":"fastestServiceMode"}},{"kind":"Field","name":{"kind":"Name","value":"franchiseGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"franchiseGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"frontCounterClosed"}},{"kind":"Field","name":{"kind":"Name","value":"hasBreakfast"}},{"kind":"Field","name":{"kind":"Name","value":"hasBurgersForBreakfast"}},{"kind":"Field","name":{"kind":"Name","value":"hasCatering"}},{"kind":"Field","name":{"kind":"Name","value":"hasCurbside"}},{"kind":"Field","name":{"kind":"Name","value":"hasDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"hasDineIn"}},{"kind":"Field","name":{"kind":"Name","value":"hasDriveThru"}},{"kind":"Field","name":{"kind":"Name","value":"hasMobileOrdering"}},{"kind":"Field","name":{"kind":"Name","value":"hasParking"}},{"kind":"Field","name":{"kind":"Name","value":"hasPlayground"}},{"kind":"Field","name":{"kind":"Name","value":"hasTakeOut"}},{"kind":"Field","name":{"kind":"Name","value":"hasWifi"}},{"kind":"Field","name":{"kind":"Name","value":"hasLoyalty"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDarkKitchen"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}},{"kind":"Field","name":{"kind":"Name","value":"isHalal"}},{"kind":"Field","name":{"kind":"Name","value":"isRecent"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"mobileOrderingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"parkingType"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","name":{"kind":"Name","value":"stateProvinceShort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"playgroundType"}},{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"posRestaurantId"}},{"kind":"Field","name":{"kind":"Name","value":"restaurantImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lqip"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"restaurantPosData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"vatNumber"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OperatingHoursFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OperatingHours"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"friClose"}},{"kind":"Field","name":{"kind":"Name","value":"friOpen"}},{"kind":"Field","name":{"kind":"Name","value":"monClose"}},{"kind":"Field","name":{"kind":"Name","value":"monOpen"}},{"kind":"Field","name":{"kind":"Name","value":"satClose"}},{"kind":"Field","name":{"kind":"Name","value":"satOpen"}},{"kind":"Field","name":{"kind":"Name","value":"sunClose"}},{"kind":"Field","name":{"kind":"Name","value":"sunOpen"}},{"kind":"Field","name":{"kind":"Name","value":"thrClose"}},{"kind":"Field","name":{"kind":"Name","value":"thrOpen"}},{"kind":"Field","name":{"kind":"Name","value":"tueClose"}},{"kind":"Field","name":{"kind":"Name","value":"tueOpen"}},{"kind":"Field","name":{"kind":"Name","value":"wedClose"}},{"kind":"Field","name":{"kind":"Name","value":"wedOpen"}}]}}]} as unknown as DocumentNode;
export const PricingAndAvailabilityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PricingAndAvailability"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"overrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]}}]} as unknown as DocumentNode;
export const CaloriesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Calories"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]} as unknown as DocumentNode;
export const OptionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Options"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]}}]} as unknown as DocumentNode;
export const UserGeoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserGeoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserGeo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]} as unknown as DocumentNode;
export const LoyaltyUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoyaltyUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyUserV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loyaltyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyUserFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoyaltyUserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bestPromotion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sanityId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pointsExpiryDateKey"}},{"kind":"Field","name":{"kind":"Name","value":"offerRedemptionAvailability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableAfter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"identifierType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"expirationBuckets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"pointsToExpire"}}]}},{"kind":"Field","name":{"kind":"Name","value":"idPay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"storedPaymentMethodId"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLoyaltyUserQuery__
 *
 * To run a query within a React component, call `useLoyaltyUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyUserQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *   },
 * });
 */
export function useLoyaltyUserQuery(baseOptions: Apollo.QueryHookOptions<ILoyaltyUserQuery, ILoyaltyUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ILoyaltyUserQuery, ILoyaltyUserQueryVariables>(LoyaltyUserDocument, options);
      }
export function useLoyaltyUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ILoyaltyUserQuery, ILoyaltyUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ILoyaltyUserQuery, ILoyaltyUserQueryVariables>(LoyaltyUserDocument, options);
        }
export type LoyaltyUserQueryHookResult = ReturnType<typeof useLoyaltyUserQuery>;
export type LoyaltyUserLazyQueryHookResult = ReturnType<typeof useLoyaltyUserLazyQuery>;
export type LoyaltyUserQueryResult = Apollo.QueryResult<ILoyaltyUserQuery, ILoyaltyUserQueryVariables>;
export const LoyaltyUserTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoyaltyUserTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyUserV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loyaltyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"statuses"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CLAIMED"}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"excludedChannels"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ORDERLESS"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TransactionFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TransactionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyTransactionV2"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"pointsEarned"}},{"kind":"Field","name":{"kind":"Name","value":"bonusPointsEarned"}},{"kind":"Field","name":{"kind":"Name","value":"pointsUsed"}},{"kind":"Field","name":{"kind":"Name","value":"pointsDeducted"}},{"kind":"Field","name":{"kind":"Name","value":"hasRewards"}},{"kind":"Field","name":{"kind":"Name","value":"transactionDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"additionalReferenceIds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLoyaltyUserTransactionsQuery__
 *
 * To run a query within a React component, call `useLoyaltyUserTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyUserTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyUserTransactionsQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *   },
 * });
 */
export function useLoyaltyUserTransactionsQuery(baseOptions: Apollo.QueryHookOptions<ILoyaltyUserTransactionsQuery, ILoyaltyUserTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ILoyaltyUserTransactionsQuery, ILoyaltyUserTransactionsQueryVariables>(LoyaltyUserTransactionsDocument, options);
      }
export function useLoyaltyUserTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ILoyaltyUserTransactionsQuery, ILoyaltyUserTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ILoyaltyUserTransactionsQuery, ILoyaltyUserTransactionsQueryVariables>(LoyaltyUserTransactionsDocument, options);
        }
export type LoyaltyUserTransactionsQueryHookResult = ReturnType<typeof useLoyaltyUserTransactionsQuery>;
export type LoyaltyUserTransactionsLazyQueryHookResult = ReturnType<typeof useLoyaltyUserTransactionsLazyQuery>;
export type LoyaltyUserTransactionsQueryResult = Apollo.QueryResult<ILoyaltyUserTransactionsQuery, ILoyaltyUserTransactionsQueryVariables>;
export const LoyaltyUserRewardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoyaltyUserRewards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyRewardsInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyUserV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loyaltyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rewards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RewardFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyReward"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rewardBenefitId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pointCost"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"locked"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"limitPerOrder"}},{"kind":"Field","name":{"kind":"Name","value":"remainingPointsNeededForRedemption"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode;

/**
 * __useLoyaltyUserRewardsQuery__
 *
 * To run a query within a React component, call `useLoyaltyUserRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyUserRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyUserRewardsQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLoyaltyUserRewardsQuery(baseOptions: Apollo.QueryHookOptions<ILoyaltyUserRewardsQuery, ILoyaltyUserRewardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ILoyaltyUserRewardsQuery, ILoyaltyUserRewardsQueryVariables>(LoyaltyUserRewardsDocument, options);
      }
export function useLoyaltyUserRewardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ILoyaltyUserRewardsQuery, ILoyaltyUserRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ILoyaltyUserRewardsQuery, ILoyaltyUserRewardsQueryVariables>(LoyaltyUserRewardsDocument, options);
        }
export type LoyaltyUserRewardsQueryHookResult = ReturnType<typeof useLoyaltyUserRewardsQuery>;
export type LoyaltyUserRewardsLazyQueryHookResult = ReturnType<typeof useLoyaltyUserRewardsLazyQuery>;
export type LoyaltyUserRewardsQueryResult = Apollo.QueryResult<ILoyaltyUserRewardsQuery, ILoyaltyUserRewardsQueryVariables>;
export const GetLoyaltyOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLoyaltyOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyOffersInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyOffersV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loyaltyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OffersFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OffersFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyOffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyBenefitReference"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"reference"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyBenefitSwap"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltySwap"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"configId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"currentValue"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"ruleId"}},{"kind":"Field","name":{"kind":"Name","value":"targetValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isStackable"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyId"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionType"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"serviceModes"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetLoyaltyOffersQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyOffersQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetLoyaltyOffersQuery(baseOptions?: Apollo.QueryHookOptions<IGetLoyaltyOffersQuery, IGetLoyaltyOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetLoyaltyOffersQuery, IGetLoyaltyOffersQueryVariables>(GetLoyaltyOffersDocument, options);
      }
export function useGetLoyaltyOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetLoyaltyOffersQuery, IGetLoyaltyOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetLoyaltyOffersQuery, IGetLoyaltyOffersQueryVariables>(GetLoyaltyOffersDocument, options);
        }
export type GetLoyaltyOffersQueryHookResult = ReturnType<typeof useGetLoyaltyOffersQuery>;
export type GetLoyaltyOffersLazyQueryHookResult = ReturnType<typeof useGetLoyaltyOffersLazyQuery>;
export type GetLoyaltyOffersQueryResult = Apollo.QueryResult<IGetLoyaltyOffersQuery, IGetLoyaltyOffersQueryVariables>;
export const LoyaltyUserOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoyaltyUserOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyOffersInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyUserV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loyaltyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"offerRedemptionAvailability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableAfter"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OffersFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OffersFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyOffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyBenefitReference"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"reference"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyBenefitSwap"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltySwap"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"configId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"currentValue"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"ruleId"}},{"kind":"Field","name":{"kind":"Name","value":"targetValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isStackable"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyId"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionType"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"serviceModes"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode;

/**
 * __useLoyaltyUserOffersQuery__
 *
 * To run a query within a React component, call `useLoyaltyUserOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyUserOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyUserOffersQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLoyaltyUserOffersQuery(baseOptions: Apollo.QueryHookOptions<ILoyaltyUserOffersQuery, ILoyaltyUserOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ILoyaltyUserOffersQuery, ILoyaltyUserOffersQueryVariables>(LoyaltyUserOffersDocument, options);
      }
export function useLoyaltyUserOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ILoyaltyUserOffersQuery, ILoyaltyUserOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ILoyaltyUserOffersQuery, ILoyaltyUserOffersQueryVariables>(LoyaltyUserOffersDocument, options);
        }
export type LoyaltyUserOffersQueryHookResult = ReturnType<typeof useLoyaltyUserOffersQuery>;
export type LoyaltyUserOffersLazyQueryHookResult = ReturnType<typeof useLoyaltyUserOffersLazyQuery>;
export type LoyaltyUserOffersQueryResult = Apollo.QueryResult<ILoyaltyUserOffersQuery, ILoyaltyUserOffersQueryVariables>;
export const LoyaltyOffersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoyaltyOffers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"omitInvalids"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redemptionTypes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyOfferRedemptionType"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceMode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyServiceMode"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subtotalAmount"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyOffersV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}},{"kind":"Argument","name":{"kind":"Name","value":"loyaltyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"omitInvalids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"omitInvalids"}}},{"kind":"Argument","name":{"kind":"Name","value":"redemptionTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redemptionTypes"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceMode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceMode"}}},{"kind":"Argument","name":{"kind":"Name","value":"storeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"subtotalAmount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subtotalAmount"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OffersFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OffersFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyOffer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"benefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyBenefitReference"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"reference"},"name":{"kind":"Name","value":"value"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyBenefitSwap"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltySwap"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"configId"}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"currentValue"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"ruleId"}},{"kind":"Field","name":{"kind":"Name","value":"targetValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isStackable"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyId"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionType"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"serviceModes"}},{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode;

/**
 * __useLoyaltyOffersQuery__
 *
 * To run a query within a React component, call `useLoyaltyOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyOffersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      loyaltyId: // value for 'loyaltyId'
 *      omitInvalids: // value for 'omitInvalids'
 *      redemptionTypes: // value for 'redemptionTypes'
 *      serviceMode: // value for 'serviceMode'
 *      storeId: // value for 'storeId'
 *      subtotalAmount: // value for 'subtotalAmount'
 *   },
 * });
 */
export function useLoyaltyOffersQuery(baseOptions?: Apollo.QueryHookOptions<ILoyaltyOffersQuery, ILoyaltyOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ILoyaltyOffersQuery, ILoyaltyOffersQueryVariables>(LoyaltyOffersDocument, options);
      }
export function useLoyaltyOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ILoyaltyOffersQuery, ILoyaltyOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ILoyaltyOffersQuery, ILoyaltyOffersQueryVariables>(LoyaltyOffersDocument, options);
        }
export type LoyaltyOffersQueryHookResult = ReturnType<typeof useLoyaltyOffersQuery>;
export type LoyaltyOffersLazyQueryHookResult = ReturnType<typeof useLoyaltyOffersLazyQuery>;
export type LoyaltyOffersQueryResult = Apollo.QueryResult<ILoyaltyOffersQuery, ILoyaltyOffersQueryVariables>;
export const LoyaltyEngineRewardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoyaltyEngineRewards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyRewardsV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loyaltyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RewardFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RewardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyReward"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rewardBenefitId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pointCost"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"locked"}},{"kind":"Field","name":{"kind":"Name","value":"redemptionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"limitPerOrder"}},{"kind":"Field","name":{"kind":"Name","value":"remainingPointsNeededForRedemption"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode;

/**
 * __useLoyaltyEngineRewardsQuery__
 *
 * To run a query within a React component, call `useLoyaltyEngineRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyEngineRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyEngineRewardsQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *   },
 * });
 */
export function useLoyaltyEngineRewardsQuery(baseOptions: Apollo.QueryHookOptions<ILoyaltyEngineRewardsQuery, ILoyaltyEngineRewardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ILoyaltyEngineRewardsQuery, ILoyaltyEngineRewardsQueryVariables>(LoyaltyEngineRewardsDocument, options);
      }
export function useLoyaltyEngineRewardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ILoyaltyEngineRewardsQuery, ILoyaltyEngineRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ILoyaltyEngineRewardsQuery, ILoyaltyEngineRewardsQueryVariables>(LoyaltyEngineRewardsDocument, options);
        }
export type LoyaltyEngineRewardsQueryHookResult = ReturnType<typeof useLoyaltyEngineRewardsQuery>;
export type LoyaltyEngineRewardsLazyQueryHookResult = ReturnType<typeof useLoyaltyEngineRewardsLazyQuery>;
export type LoyaltyEngineRewardsQueryResult = Apollo.QueryResult<ILoyaltyEngineRewardsQuery, ILoyaltyEngineRewardsQueryVariables>;
export const LoyaltyNotificationsRedeemableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoyaltyNotificationsRedeemable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"rewardsInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyRewardsInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offersInput"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyOffersInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyUserV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loyaltyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rewards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"rewardsInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"promotions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"offers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offersInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLoyaltyNotificationsRedeemableQuery__
 *
 * To run a query within a React component, call `useLoyaltyNotificationsRedeemableQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyNotificationsRedeemableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyNotificationsRedeemableQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *      rewardsInput: // value for 'rewardsInput'
 *      offersInput: // value for 'offersInput'
 *   },
 * });
 */
export function useLoyaltyNotificationsRedeemableQuery(baseOptions: Apollo.QueryHookOptions<ILoyaltyNotificationsRedeemableQuery, ILoyaltyNotificationsRedeemableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ILoyaltyNotificationsRedeemableQuery, ILoyaltyNotificationsRedeemableQueryVariables>(LoyaltyNotificationsRedeemableDocument, options);
      }
export function useLoyaltyNotificationsRedeemableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ILoyaltyNotificationsRedeemableQuery, ILoyaltyNotificationsRedeemableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ILoyaltyNotificationsRedeemableQuery, ILoyaltyNotificationsRedeemableQueryVariables>(LoyaltyNotificationsRedeemableDocument, options);
        }
export type LoyaltyNotificationsRedeemableQueryHookResult = ReturnType<typeof useLoyaltyNotificationsRedeemableQuery>;
export type LoyaltyNotificationsRedeemableLazyQueryHookResult = ReturnType<typeof useLoyaltyNotificationsRedeemableLazyQuery>;
export type LoyaltyNotificationsRedeemableQueryResult = Apollo.QueryResult<ILoyaltyNotificationsRedeemableQuery, ILoyaltyNotificationsRedeemableQueryVariables>;
export const LoyaltyGenerateOtpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoyaltyGenerateOtp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inRestaurantOrder"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyInRestaurantOrderLineItem"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"restaurantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyGenerateOtp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inRestaurantOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inRestaurantOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"loyaltyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"restaurantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"restaurantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"expirationTime"}}]}}]}}]} as unknown as DocumentNode;
export type ILoyaltyGenerateOtpMutationFn = Apollo.MutationFunction<ILoyaltyGenerateOtpMutation, ILoyaltyGenerateOtpMutationVariables>;

/**
 * __useLoyaltyGenerateOtpMutation__
 *
 * To run a mutation, you first call `useLoyaltyGenerateOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyGenerateOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loyaltyGenerateOtpMutation, { data, loading, error }] = useLoyaltyGenerateOtpMutation({
 *   variables: {
 *      inRestaurantOrder: // value for 'inRestaurantOrder'
 *      loyaltyId: // value for 'loyaltyId'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useLoyaltyGenerateOtpMutation(baseOptions?: Apollo.MutationHookOptions<ILoyaltyGenerateOtpMutation, ILoyaltyGenerateOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ILoyaltyGenerateOtpMutation, ILoyaltyGenerateOtpMutationVariables>(LoyaltyGenerateOtpDocument, options);
      }
export type LoyaltyGenerateOtpMutationHookResult = ReturnType<typeof useLoyaltyGenerateOtpMutation>;
export type LoyaltyGenerateOtpMutationResult = Apollo.MutationResult<ILoyaltyGenerateOtpMutation>;
export type LoyaltyGenerateOtpMutationOptions = Apollo.BaseMutationOptions<ILoyaltyGenerateOtpMutation, ILoyaltyGenerateOtpMutationVariables>;
export const ProcessSmgCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProcessSmgCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"smgCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transactionDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyProcessSmgCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loyaltyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"smgCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"smgCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"transactionDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transactionDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pointsEarned"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode;
export type IProcessSmgCodeMutationFn = Apollo.MutationFunction<IProcessSmgCodeMutation, IProcessSmgCodeMutationVariables>;

/**
 * __useProcessSmgCodeMutation__
 *
 * To run a mutation, you first call `useProcessSmgCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessSmgCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processSmgCodeMutation, { data, loading, error }] = useProcessSmgCodeMutation({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *      smgCode: // value for 'smgCode'
 *      transactionDate: // value for 'transactionDate'
 *   },
 * });
 */
export function useProcessSmgCodeMutation(baseOptions?: Apollo.MutationHookOptions<IProcessSmgCodeMutation, IProcessSmgCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IProcessSmgCodeMutation, IProcessSmgCodeMutationVariables>(ProcessSmgCodeDocument, options);
      }
export type ProcessSmgCodeMutationHookResult = ReturnType<typeof useProcessSmgCodeMutation>;
export type ProcessSmgCodeMutationResult = Apollo.MutationResult<IProcessSmgCodeMutation>;
export type ProcessSmgCodeMutationOptions = Apollo.BaseMutationOptions<IProcessSmgCodeMutation, IProcessSmgCodeMutationVariables>;
export const OrderSelectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"orderSelection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyOrderSelection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"otp"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otp"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"loyaltyId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"expiry"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useOrderSelectionQuery__
 *
 * To run a query within a React component, call `useOrderSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSelectionQuery({
 *   variables: {
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useOrderSelectionQuery(baseOptions: Apollo.QueryHookOptions<IOrderSelectionQuery, IOrderSelectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IOrderSelectionQuery, IOrderSelectionQueryVariables>(OrderSelectionDocument, options);
      }
export function useOrderSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IOrderSelectionQuery, IOrderSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IOrderSelectionQuery, IOrderSelectionQueryVariables>(OrderSelectionDocument, options);
        }
export type OrderSelectionQueryHookResult = ReturnType<typeof useOrderSelectionQuery>;
export type OrderSelectionLazyQueryHookResult = ReturnType<typeof useOrderSelectionLazyQuery>;
export type OrderSelectionQueryResult = Apollo.QueryResult<IOrderSelectionQuery, IOrderSelectionQueryVariables>;
export const CreateOrderlessTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrderlessTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyOrderlessTransactionInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyCreateOrderlessTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode;
export type ICreateOrderlessTransactionMutationFn = Apollo.MutationFunction<ICreateOrderlessTransactionMutation, ICreateOrderlessTransactionMutationVariables>;

/**
 * __useCreateOrderlessTransactionMutation__
 *
 * To run a mutation, you first call `useCreateOrderlessTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderlessTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderlessTransactionMutation, { data, loading, error }] = useCreateOrderlessTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderlessTransactionMutation(baseOptions?: Apollo.MutationHookOptions<ICreateOrderlessTransactionMutation, ICreateOrderlessTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateOrderlessTransactionMutation, ICreateOrderlessTransactionMutationVariables>(CreateOrderlessTransactionDocument, options);
      }
export type CreateOrderlessTransactionMutationHookResult = ReturnType<typeof useCreateOrderlessTransactionMutation>;
export type CreateOrderlessTransactionMutationResult = Apollo.MutationResult<ICreateOrderlessTransactionMutation>;
export type CreateOrderlessTransactionMutationOptions = Apollo.BaseMutationOptions<ICreateOrderlessTransactionMutation, ICreateOrderlessTransactionMutationVariables>;
export const GetLoyaltyQuestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLoyaltyQuests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyQuestsInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyUserV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loyaltyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuestFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuestFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyQuest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"bonusPoints"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastCompletion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"benefitId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"redeemed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incentiveType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"cartRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetLoyaltyQuestsQuery__
 *
 * To run a query within a React component, call `useGetLoyaltyQuestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoyaltyQuestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoyaltyQuestsQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetLoyaltyQuestsQuery(baseOptions: Apollo.QueryHookOptions<IGetLoyaltyQuestsQuery, IGetLoyaltyQuestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetLoyaltyQuestsQuery, IGetLoyaltyQuestsQueryVariables>(GetLoyaltyQuestsDocument, options);
      }
export function useGetLoyaltyQuestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetLoyaltyQuestsQuery, IGetLoyaltyQuestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetLoyaltyQuestsQuery, IGetLoyaltyQuestsQueryVariables>(GetLoyaltyQuestsDocument, options);
        }
export type GetLoyaltyQuestsQueryHookResult = ReturnType<typeof useGetLoyaltyQuestsQuery>;
export type GetLoyaltyQuestsLazyQueryHookResult = ReturnType<typeof useGetLoyaltyQuestsLazyQuery>;
export type GetLoyaltyQuestsQueryResult = Apollo.QueryResult<IGetLoyaltyQuestsQuery, IGetLoyaltyQuestsQueryVariables>;
export const ActivateQuestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ActivateQuest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"questId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyActivateQuest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"questId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"questId"}}},{"kind":"Argument","name":{"kind":"Name","value":"loyaltyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"QuestFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"QuestFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyQuest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"bonusPoints"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"externalIdentifiers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastCompletion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"benefitId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"redeemed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"incentiveType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"cartRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}}]}}]}}]} as unknown as DocumentNode;
export type IActivateQuestMutationFn = Apollo.MutationFunction<IActivateQuestMutation, IActivateQuestMutationVariables>;

/**
 * __useActivateQuestMutation__
 *
 * To run a mutation, you first call `useActivateQuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateQuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateQuestMutation, { data, loading, error }] = useActivateQuestMutation({
 *   variables: {
 *      questId: // value for 'questId'
 *      loyaltyId: // value for 'loyaltyId'
 *   },
 * });
 */
export function useActivateQuestMutation(baseOptions?: Apollo.MutationHookOptions<IActivateQuestMutation, IActivateQuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IActivateQuestMutation, IActivateQuestMutationVariables>(ActivateQuestDocument, options);
      }
export type ActivateQuestMutationHookResult = ReturnType<typeof useActivateQuestMutation>;
export type ActivateQuestMutationResult = Apollo.MutationResult<IActivateQuestMutation>;
export type ActivateQuestMutationOptions = Apollo.BaseMutationOptions<IActivateQuestMutation, IActivateQuestMutationVariables>;
export const OrderSelectionByTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"orderSelectionByType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ostType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyOstType"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyOrderSelectionByType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}},{"kind":"Argument","name":{"kind":"Name","value":"ostType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ostType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"loyaltyId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"expiry"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useOrderSelectionByTypeQuery__
 *
 * To run a query within a React component, call `useOrderSelectionByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSelectionByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSelectionByTypeQuery({
 *   variables: {
 *      key: // value for 'key'
 *      ostType: // value for 'ostType'
 *   },
 * });
 */
export function useOrderSelectionByTypeQuery(baseOptions: Apollo.QueryHookOptions<IOrderSelectionByTypeQuery, IOrderSelectionByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IOrderSelectionByTypeQuery, IOrderSelectionByTypeQueryVariables>(OrderSelectionByTypeDocument, options);
      }
export function useOrderSelectionByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IOrderSelectionByTypeQuery, IOrderSelectionByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IOrderSelectionByTypeQuery, IOrderSelectionByTypeQueryVariables>(OrderSelectionByTypeDocument, options);
        }
export type OrderSelectionByTypeQueryHookResult = ReturnType<typeof useOrderSelectionByTypeQuery>;
export type OrderSelectionByTypeLazyQueryHookResult = ReturnType<typeof useOrderSelectionByTypeLazyQuery>;
export type OrderSelectionByTypeQueryResult = Apollo.QueryResult<IOrderSelectionByTypeQuery, IOrderSelectionByTypeQueryVariables>;
export const OrderSelectionByMultipleTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"orderSelectionByMultipleType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyGetOrderSelectionByMultipleType"}}}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyOrderSelectionByMultipleType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"loyaltyId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"expiry"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useOrderSelectionByMultipleTypeQuery__
 *
 * To run a query within a React component, call `useOrderSelectionByMultipleTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderSelectionByMultipleTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderSelectionByMultipleTypeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrderSelectionByMultipleTypeQuery(baseOptions: Apollo.QueryHookOptions<IOrderSelectionByMultipleTypeQuery, IOrderSelectionByMultipleTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IOrderSelectionByMultipleTypeQuery, IOrderSelectionByMultipleTypeQueryVariables>(OrderSelectionByMultipleTypeDocument, options);
      }
export function useOrderSelectionByMultipleTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IOrderSelectionByMultipleTypeQuery, IOrderSelectionByMultipleTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IOrderSelectionByMultipleTypeQuery, IOrderSelectionByMultipleTypeQueryVariables>(OrderSelectionByMultipleTypeDocument, options);
        }
export type OrderSelectionByMultipleTypeQueryHookResult = ReturnType<typeof useOrderSelectionByMultipleTypeQuery>;
export type OrderSelectionByMultipleTypeLazyQueryHookResult = ReturnType<typeof useOrderSelectionByMultipleTypeLazyQuery>;
export type OrderSelectionByMultipleTypeQueryResult = Apollo.QueryResult<IOrderSelectionByMultipleTypeQuery, IOrderSelectionByMultipleTypeQueryVariables>;
export const CreateOrderSelectionByMultipleTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrderSelectionByMultipleType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ostTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyOstType"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inRestaurantOrder"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyInRestaurantOrderLineItem"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"restaurantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyCreateOrderSelectionByMultipleType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ostTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ostTypes"}}},{"kind":"Argument","name":{"kind":"Name","value":"inRestaurantOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inRestaurantOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"loyaltyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"restaurantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"restaurantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ostType"}},{"kind":"Field","name":{"kind":"Name","value":"expirationTime"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]} as unknown as DocumentNode;
export type ICreateOrderSelectionByMultipleTypeMutationFn = Apollo.MutationFunction<ICreateOrderSelectionByMultipleTypeMutation, ICreateOrderSelectionByMultipleTypeMutationVariables>;

/**
 * __useCreateOrderSelectionByMultipleTypeMutation__
 *
 * To run a mutation, you first call `useCreateOrderSelectionByMultipleTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderSelectionByMultipleTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderSelectionByMultipleTypeMutation, { data, loading, error }] = useCreateOrderSelectionByMultipleTypeMutation({
 *   variables: {
 *      ostTypes: // value for 'ostTypes'
 *      inRestaurantOrder: // value for 'inRestaurantOrder'
 *      loyaltyId: // value for 'loyaltyId'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useCreateOrderSelectionByMultipleTypeMutation(baseOptions?: Apollo.MutationHookOptions<ICreateOrderSelectionByMultipleTypeMutation, ICreateOrderSelectionByMultipleTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateOrderSelectionByMultipleTypeMutation, ICreateOrderSelectionByMultipleTypeMutationVariables>(CreateOrderSelectionByMultipleTypeDocument, options);
      }
export type CreateOrderSelectionByMultipleTypeMutationHookResult = ReturnType<typeof useCreateOrderSelectionByMultipleTypeMutation>;
export type CreateOrderSelectionByMultipleTypeMutationResult = Apollo.MutationResult<ICreateOrderSelectionByMultipleTypeMutation>;
export type CreateOrderSelectionByMultipleTypeMutationOptions = Apollo.BaseMutationOptions<ICreateOrderSelectionByMultipleTypeMutation, ICreateOrderSelectionByMultipleTypeMutationVariables>;
export const CreateOrderSelectionByTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrderSelectionByType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ostType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyOstType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inRestaurantOrder"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyInRestaurantOrderLineItem"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"restaurantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyCreateOrderSelectionByType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ostType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ostType"}}},{"kind":"Argument","name":{"kind":"Name","value":"inRestaurantOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inRestaurantOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"loyaltyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"restaurantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"restaurantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expirationTime"}},{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]} as unknown as DocumentNode;
export type ICreateOrderSelectionByTypeMutationFn = Apollo.MutationFunction<ICreateOrderSelectionByTypeMutation, ICreateOrderSelectionByTypeMutationVariables>;

/**
 * __useCreateOrderSelectionByTypeMutation__
 *
 * To run a mutation, you first call `useCreateOrderSelectionByTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderSelectionByTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderSelectionByTypeMutation, { data, loading, error }] = useCreateOrderSelectionByTypeMutation({
 *   variables: {
 *      ostType: // value for 'ostType'
 *      inRestaurantOrder: // value for 'inRestaurantOrder'
 *      loyaltyId: // value for 'loyaltyId'
 *      restaurantId: // value for 'restaurantId'
 *   },
 * });
 */
export function useCreateOrderSelectionByTypeMutation(baseOptions?: Apollo.MutationHookOptions<ICreateOrderSelectionByTypeMutation, ICreateOrderSelectionByTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateOrderSelectionByTypeMutation, ICreateOrderSelectionByTypeMutationVariables>(CreateOrderSelectionByTypeDocument, options);
      }
export type CreateOrderSelectionByTypeMutationHookResult = ReturnType<typeof useCreateOrderSelectionByTypeMutation>;
export type CreateOrderSelectionByTypeMutationResult = Apollo.MutationResult<ICreateOrderSelectionByTypeMutation>;
export type CreateOrderSelectionByTypeMutationOptions = Apollo.BaseMutationOptions<ICreateOrderSelectionByTypeMutation, ICreateOrderSelectionByTypeMutationVariables>;
export const LoyaltyUserPromotionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoyaltyUserPromotions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyPromotionsInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyUserV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"loyaltyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promotions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PromotionFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PromotionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltySystemWidePromotion"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode;

/**
 * __useLoyaltyUserPromotionsQuery__
 *
 * To run a query within a React component, call `useLoyaltyUserPromotionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyUserPromotionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoyaltyUserPromotionsQuery({
 *   variables: {
 *      loyaltyId: // value for 'loyaltyId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useLoyaltyUserPromotionsQuery(baseOptions: Apollo.QueryHookOptions<ILoyaltyUserPromotionsQuery, ILoyaltyUserPromotionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ILoyaltyUserPromotionsQuery, ILoyaltyUserPromotionsQueryVariables>(LoyaltyUserPromotionsDocument, options);
      }
export function useLoyaltyUserPromotionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ILoyaltyUserPromotionsQuery, ILoyaltyUserPromotionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ILoyaltyUserPromotionsQuery, ILoyaltyUserPromotionsQueryVariables>(LoyaltyUserPromotionsDocument, options);
        }
export type LoyaltyUserPromotionsQueryHookResult = ReturnType<typeof useLoyaltyUserPromotionsQuery>;
export type LoyaltyUserPromotionsLazyQueryHookResult = ReturnType<typeof useLoyaltyUserPromotionsLazyQuery>;
export type LoyaltyUserPromotionsQueryResult = Apollo.QueryResult<ILoyaltyUserPromotionsQuery, ILoyaltyUserPromotionsQueryVariables>;
export const LoyaltyRedeemPromoCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoyaltyRedeemPromoCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyValidatePromoCodeInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyValidatePromoCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LoyaltyCouponFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LoyaltyCouponFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyCouponResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"isRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"shouldRedeem"}},{"kind":"Field","name":{"kind":"Name","value":"personalizedOfferId"}},{"kind":"Field","name":{"kind":"Name","value":"configId"}}]}}]} as unknown as DocumentNode;
export type ILoyaltyRedeemPromoCodeMutationFn = Apollo.MutationFunction<ILoyaltyRedeemPromoCodeMutation, ILoyaltyRedeemPromoCodeMutationVariables>;

/**
 * __useLoyaltyRedeemPromoCodeMutation__
 *
 * To run a mutation, you first call `useLoyaltyRedeemPromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyRedeemPromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loyaltyRedeemPromoCodeMutation, { data, loading, error }] = useLoyaltyRedeemPromoCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoyaltyRedeemPromoCodeMutation(baseOptions?: Apollo.MutationHookOptions<ILoyaltyRedeemPromoCodeMutation, ILoyaltyRedeemPromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ILoyaltyRedeemPromoCodeMutation, ILoyaltyRedeemPromoCodeMutationVariables>(LoyaltyRedeemPromoCodeDocument, options);
      }
export type LoyaltyRedeemPromoCodeMutationHookResult = ReturnType<typeof useLoyaltyRedeemPromoCodeMutation>;
export type LoyaltyRedeemPromoCodeMutationResult = Apollo.MutationResult<ILoyaltyRedeemPromoCodeMutation>;
export type LoyaltyRedeemPromoCodeMutationOptions = Apollo.BaseMutationOptions<ILoyaltyRedeemPromoCodeMutation, ILoyaltyRedeemPromoCodeMutationVariables>;
export const LoyaltyUpdateIdAndPayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoyaltyUpdateIdAndPay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idAndPayInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyIdAndPayInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoyaltyID"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loyaltyUpdateIdAndPay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idAndPayInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idAndPayInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"loyaltyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loyaltyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode;
export type ILoyaltyUpdateIdAndPayMutationFn = Apollo.MutationFunction<ILoyaltyUpdateIdAndPayMutation, ILoyaltyUpdateIdAndPayMutationVariables>;

/**
 * __useLoyaltyUpdateIdAndPayMutation__
 *
 * To run a mutation, you first call `useLoyaltyUpdateIdAndPayMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoyaltyUpdateIdAndPayMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loyaltyUpdateIdAndPayMutation, { data, loading, error }] = useLoyaltyUpdateIdAndPayMutation({
 *   variables: {
 *      idAndPayInput: // value for 'idAndPayInput'
 *      loyaltyId: // value for 'loyaltyId'
 *   },
 * });
 */
export function useLoyaltyUpdateIdAndPayMutation(baseOptions?: Apollo.MutationHookOptions<ILoyaltyUpdateIdAndPayMutation, ILoyaltyUpdateIdAndPayMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ILoyaltyUpdateIdAndPayMutation, ILoyaltyUpdateIdAndPayMutationVariables>(LoyaltyUpdateIdAndPayDocument, options);
      }
export type LoyaltyUpdateIdAndPayMutationHookResult = ReturnType<typeof useLoyaltyUpdateIdAndPayMutation>;
export type LoyaltyUpdateIdAndPayMutationResult = Apollo.MutationResult<ILoyaltyUpdateIdAndPayMutation>;
export type LoyaltyUpdateIdAndPayMutationOptions = Apollo.BaseMutationOptions<ILoyaltyUpdateIdAndPayMutation, ILoyaltyUpdateIdAndPayMutationVariables>;
export const PlusDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"plusData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceMode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PosDataServiceMode"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}},{"kind":"Directive","name":{"kind":"Name","value":"useCache"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"storeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceMode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceMode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"t"},"name":{"kind":"Name","value":"__typename"}},{"kind":"Field","alias":{"kind":"Name","value":"k"},"name":{"kind":"Name","value":"plu"}},{"kind":"Field","alias":{"kind":"Name","value":"v"},"name":{"kind":"Name","value":"price"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __usePlusDataQuery__
 *
 * To run a query within a React component, call `usePlusDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlusDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlusDataQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      serviceMode: // value for 'serviceMode'
 *   },
 * });
 */
export function usePlusDataQuery(baseOptions: Apollo.QueryHookOptions<IPlusDataQuery, IPlusDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPlusDataQuery, IPlusDataQueryVariables>(PlusDataDocument, options);
      }
export function usePlusDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPlusDataQuery, IPlusDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPlusDataQuery, IPlusDataQueryVariables>(PlusDataDocument, options);
        }
export type PlusDataQueryHookResult = ReturnType<typeof usePlusDataQuery>;
export type PlusDataLazyQueryHookResult = ReturnType<typeof usePlusDataLazyQuery>;
export type PlusDataQueryResult = Apollo.QueryResult<IPlusDataQuery, IPlusDataQueryVariables>;
export const StoreMenuDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"storeMenu"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"region"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Channel"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceMode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PosDataServiceMode"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"variantName"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}},{"kind":"Directive","name":{"kind":"Name","value":"useCache"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storeMenu"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"region"},"value":{"kind":"Variable","name":{"kind":"Name","value":"region"}}},{"kind":"Argument","name":{"kind":"Name","value":"channel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channel"}}},{"kind":"Argument","name":{"kind":"Name","value":"storeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceMode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceMode"}}},{"kind":"Argument","name":{"kind":"Name","value":"variantName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"variantName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PricingAndAvailability"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Calories"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Options"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PricingAndAvailability"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"max"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"overrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Calories"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Options"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useStoreMenuQuery__
 *
 * To run a query within a React component, call `useStoreMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreMenuQuery({
 *   variables: {
 *      region: // value for 'region'
 *      channel: // value for 'channel'
 *      storeId: // value for 'storeId'
 *      serviceMode: // value for 'serviceMode'
 *      variantName: // value for 'variantName'
 *   },
 * });
 */
export function useStoreMenuQuery(baseOptions: Apollo.QueryHookOptions<IStoreMenuQuery, IStoreMenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IStoreMenuQuery, IStoreMenuQueryVariables>(StoreMenuDocument, options);
      }
export function useStoreMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IStoreMenuQuery, IStoreMenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IStoreMenuQuery, IStoreMenuQueryVariables>(StoreMenuDocument, options);
        }
export type StoreMenuQueryHookResult = ReturnType<typeof useStoreMenuQuery>;
export type StoreMenuLazyQueryHookResult = ReturnType<typeof useStoreMenuLazyQuery>;
export type StoreMenuQueryResult = Apollo.QueryResult<IStoreMenuQuery, IStoreMenuQueryVariables>;
export const PaymentConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"paymentConfig"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentConfig"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentConfig"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowedPaymentMethods"}},{"kind":"Field","name":{"kind":"Name","value":"frontendIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"applePay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schemeMerchantId"}},{"kind":"Field","name":{"kind":"Name","value":"prepaidMerchantId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"googlePay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schemeMerchantId"}},{"kind":"Field","name":{"kind":"Name","value":"prepaidMerchantId"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __usePaymentConfigQuery__
 *
 * To run a query within a React component, call `usePaymentConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentConfigQuery(baseOptions?: Apollo.QueryHookOptions<IPaymentConfigQuery, IPaymentConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPaymentConfigQuery, IPaymentConfigQueryVariables>(PaymentConfigDocument, options);
      }
export function usePaymentConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPaymentConfigQuery, IPaymentConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPaymentConfigQuery, IPaymentConfigQueryVariables>(PaymentConfigDocument, options);
        }
export type PaymentConfigQueryHookResult = ReturnType<typeof usePaymentConfigQuery>;
export type PaymentConfigLazyQueryHookResult = ReturnType<typeof usePaymentConfigLazyQuery>;
export type PaymentConfigQueryResult = Apollo.QueryResult<IPaymentConfigQuery, IPaymentConfigQueryVariables>;
export const StoredPaymentMethodsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"storedPaymentMethods"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}},{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storedPaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchemeStoredPaymentMethods"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PrepaidStoredPaymentMethods"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchemeStoredPaymentMethods"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SchemeStoredPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"panToken"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PrepaidStoredPaymentMethods"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepaidStoredPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"shuffledCardNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode;

/**
 * __useStoredPaymentMethodsQuery__
 *
 * To run a query within a React component, call `useStoredPaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoredPaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoredPaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStoredPaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<IStoredPaymentMethodsQuery, IStoredPaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IStoredPaymentMethodsQuery, IStoredPaymentMethodsQueryVariables>(StoredPaymentMethodsDocument, options);
      }
export function useStoredPaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IStoredPaymentMethodsQuery, IStoredPaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IStoredPaymentMethodsQuery, IStoredPaymentMethodsQueryVariables>(StoredPaymentMethodsDocument, options);
        }
export type StoredPaymentMethodsQueryHookResult = ReturnType<typeof useStoredPaymentMethodsQuery>;
export type StoredPaymentMethodsLazyQueryHookResult = ReturnType<typeof useStoredPaymentMethodsLazyQuery>;
export type StoredPaymentMethodsQueryResult = Apollo.QueryResult<IStoredPaymentMethodsQuery, IStoredPaymentMethodsQueryVariables>;
export const PaymentPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"paymentPreferences"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}},{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentPreferences"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentPreferences"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentPreferences"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storedPaymentMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"reloadAmount"}},{"kind":"Field","name":{"kind":"Name","value":"autoReload"}},{"kind":"Field","name":{"kind":"Name","value":"autoReloadThreshold"}}]}}]} as unknown as DocumentNode;

/**
 * __usePaymentPreferencesQuery__
 *
 * To run a query within a React component, call `usePaymentPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<IPaymentPreferencesQuery, IPaymentPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPaymentPreferencesQuery, IPaymentPreferencesQueryVariables>(PaymentPreferencesDocument, options);
      }
export function usePaymentPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPaymentPreferencesQuery, IPaymentPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPaymentPreferencesQuery, IPaymentPreferencesQueryVariables>(PaymentPreferencesDocument, options);
        }
export type PaymentPreferencesQueryHookResult = ReturnType<typeof usePaymentPreferencesQuery>;
export type PaymentPreferencesLazyQueryHookResult = ReturnType<typeof usePaymentPreferencesLazyQuery>;
export type PaymentPreferencesQueryResult = Apollo.QueryResult<IPaymentPreferencesQuery, IPaymentPreferencesQueryVariables>;
export const UserPaymentInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userPaymentInformation"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}},{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentConfig"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentPreferences"}}]}},{"kind":"Field","name":{"kind":"Name","value":"storedPaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchemeStoredPaymentMethods"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PrepaidStoredPaymentMethods"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchemeStoredPaymentMethods"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SchemeStoredPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"panToken"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PrepaidStoredPaymentMethods"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PrepaidStoredPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"shuffledCardNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentPreferences"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentPreferences"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storedPaymentMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"reloadAmount"}},{"kind":"Field","name":{"kind":"Name","value":"autoReload"}},{"kind":"Field","name":{"kind":"Name","value":"autoReloadThreshold"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentConfig"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowedPaymentMethods"}},{"kind":"Field","name":{"kind":"Name","value":"frontendIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"applePay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schemeMerchantId"}},{"kind":"Field","name":{"kind":"Name","value":"prepaidMerchantId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"googlePay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schemeMerchantId"}},{"kind":"Field","name":{"kind":"Name","value":"prepaidMerchantId"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useUserPaymentInformationQuery__
 *
 * To run a query within a React component, call `useUserPaymentInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPaymentInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPaymentInformationQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPaymentInformationQuery(baseOptions?: Apollo.QueryHookOptions<IUserPaymentInformationQuery, IUserPaymentInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IUserPaymentInformationQuery, IUserPaymentInformationQueryVariables>(UserPaymentInformationDocument, options);
      }
export function useUserPaymentInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IUserPaymentInformationQuery, IUserPaymentInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IUserPaymentInformationQuery, IUserPaymentInformationQueryVariables>(UserPaymentInformationDocument, options);
        }
export type UserPaymentInformationQueryHookResult = ReturnType<typeof useUserPaymentInformationQuery>;
export type UserPaymentInformationLazyQueryHookResult = ReturnType<typeof useUserPaymentInformationLazyQuery>;
export type UserPaymentInformationQueryResult = Apollo.QueryResult<IUserPaymentInformationQuery, IUserPaymentInformationQueryVariables>;
export const AddPaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addPaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddPaymentMethodInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}},{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddPaymentMethodSuccess"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchemeStoredPaymentMethodResponse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SchemeStoredPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"panToken"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddPaymentMethodSuccess"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddPaymentMethodSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storedPaymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchemeStoredPaymentMethodResponse"}}]}}]}}]} as unknown as DocumentNode;
export type IAddPaymentMethodMutationFn = Apollo.MutationFunction<IAddPaymentMethodMutation, IAddPaymentMethodMutationVariables>;

/**
 * __useAddPaymentMethodMutation__
 *
 * To run a mutation, you first call `useAddPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaymentMethodMutation, { data, loading, error }] = useAddPaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<IAddPaymentMethodMutation, IAddPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddPaymentMethodMutation, IAddPaymentMethodMutationVariables>(AddPaymentMethodDocument, options);
      }
export type AddPaymentMethodMutationHookResult = ReturnType<typeof useAddPaymentMethodMutation>;
export type AddPaymentMethodMutationResult = Apollo.MutationResult<IAddPaymentMethodMutation>;
export type AddPaymentMethodMutationOptions = Apollo.BaseMutationOptions<IAddPaymentMethodMutation, IAddPaymentMethodMutationVariables>;
export const ResumeAddPaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resumeAddPaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResumeAddPaymentMethodInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}},{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resumeAddPaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AddPaymentMethodSuccess"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SchemeStoredPaymentMethodResponse"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SchemeStoredPaymentMethod"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"panToken"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AddPaymentMethodSuccess"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AddPaymentMethodSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storedPaymentMethod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SchemeStoredPaymentMethodResponse"}}]}}]}}]} as unknown as DocumentNode;
export type IResumeAddPaymentMethodMutationFn = Apollo.MutationFunction<IResumeAddPaymentMethodMutation, IResumeAddPaymentMethodMutationVariables>;

/**
 * __useResumeAddPaymentMethodMutation__
 *
 * To run a mutation, you first call `useResumeAddPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeAddPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeAddPaymentMethodMutation, { data, loading, error }] = useResumeAddPaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResumeAddPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<IResumeAddPaymentMethodMutation, IResumeAddPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IResumeAddPaymentMethodMutation, IResumeAddPaymentMethodMutationVariables>(ResumeAddPaymentMethodDocument, options);
      }
export type ResumeAddPaymentMethodMutationHookResult = ReturnType<typeof useResumeAddPaymentMethodMutation>;
export type ResumeAddPaymentMethodMutationResult = Apollo.MutationResult<IResumeAddPaymentMethodMutation>;
export type ResumeAddPaymentMethodMutationOptions = Apollo.BaseMutationOptions<IResumeAddPaymentMethodMutation, IResumeAddPaymentMethodMutationVariables>;
export const MergePrepaidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"mergePrepaid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MergePrepaidInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}},{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mergePrepaid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storedPaymentMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"prepaidDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"cardNumber"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]} as unknown as DocumentNode;
export type IMergePrepaidMutationFn = Apollo.MutationFunction<IMergePrepaidMutation, IMergePrepaidMutationVariables>;

/**
 * __useMergePrepaidMutation__
 *
 * To run a mutation, you first call `useMergePrepaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergePrepaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergePrepaidMutation, { data, loading, error }] = useMergePrepaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergePrepaidMutation(baseOptions?: Apollo.MutationHookOptions<IMergePrepaidMutation, IMergePrepaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IMergePrepaidMutation, IMergePrepaidMutationVariables>(MergePrepaidDocument, options);
      }
export type MergePrepaidMutationHookResult = ReturnType<typeof useMergePrepaidMutation>;
export type MergePrepaidMutationResult = Apollo.MutationResult<IMergePrepaidMutation>;
export type MergePrepaidMutationOptions = Apollo.BaseMutationOptions<IMergePrepaidMutation, IMergePrepaidMutationVariables>;
export const DeletePaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeletePaymentMethodInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}},{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;
export type IDeletePaymentMethodMutationFn = Apollo.MutationFunction<IDeletePaymentMethodMutation, IDeletePaymentMethodMutationVariables>;

/**
 * __useDeletePaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeletePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentMethodMutation, { data, loading, error }] = useDeletePaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<IDeletePaymentMethodMutation, IDeletePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeletePaymentMethodMutation, IDeletePaymentMethodMutationVariables>(DeletePaymentMethodDocument, options);
      }
export type DeletePaymentMethodMutationHookResult = ReturnType<typeof useDeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationResult = Apollo.MutationResult<IDeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationOptions = Apollo.BaseMutationOptions<IDeletePaymentMethodMutation, IDeletePaymentMethodMutationVariables>;
export const ReloadPrepaidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"reloadPrepaid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReloadPrepaidInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}},{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reloadPrepaid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReloadPrepaidAuthorized"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepaidDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"cardNumber"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReloadPrepaidRefused"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode;
export type IReloadPrepaidMutationFn = Apollo.MutationFunction<IReloadPrepaidMutation, IReloadPrepaidMutationVariables>;

/**
 * __useReloadPrepaidMutation__
 *
 * To run a mutation, you first call `useReloadPrepaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReloadPrepaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reloadPrepaidMutation, { data, loading, error }] = useReloadPrepaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReloadPrepaidMutation(baseOptions?: Apollo.MutationHookOptions<IReloadPrepaidMutation, IReloadPrepaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IReloadPrepaidMutation, IReloadPrepaidMutationVariables>(ReloadPrepaidDocument, options);
      }
export type ReloadPrepaidMutationHookResult = ReturnType<typeof useReloadPrepaidMutation>;
export type ReloadPrepaidMutationResult = Apollo.MutationResult<IReloadPrepaidMutation>;
export type ReloadPrepaidMutationOptions = Apollo.BaseMutationOptions<IReloadPrepaidMutation, IReloadPrepaidMutationVariables>;
export const UpdateDefaultPaymentMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateDefaultPaymentMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDefaultPaymentMethodInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}},{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDefaultPaymentMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultPaymentMethodId"}}]}}]}}]} as unknown as DocumentNode;
export type IUpdateDefaultPaymentMethodMutationFn = Apollo.MutationFunction<IUpdateDefaultPaymentMethodMutation, IUpdateDefaultPaymentMethodMutationVariables>;

/**
 * __useUpdateDefaultPaymentMethodMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultPaymentMethodMutation, { data, loading, error }] = useUpdateDefaultPaymentMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDefaultPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateDefaultPaymentMethodMutation, IUpdateDefaultPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateDefaultPaymentMethodMutation, IUpdateDefaultPaymentMethodMutationVariables>(UpdateDefaultPaymentMethodDocument, options);
      }
export type UpdateDefaultPaymentMethodMutationHookResult = ReturnType<typeof useUpdateDefaultPaymentMethodMutation>;
export type UpdateDefaultPaymentMethodMutationResult = Apollo.MutationResult<IUpdateDefaultPaymentMethodMutation>;
export type UpdateDefaultPaymentMethodMutationOptions = Apollo.BaseMutationOptions<IUpdateDefaultPaymentMethodMutation, IUpdateDefaultPaymentMethodMutationVariables>;
export const LatestPaymentTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LatestPaymentTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feCountryCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"IsoCountryCode"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"latestPaymentTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"feCountryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feCountryCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"client"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodType"}},{"kind":"Field","name":{"kind":"Name","value":"schemeType"}},{"kind":"Field","name":{"kind":"Name","value":"pspReference"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useLatestPaymentTransactionQuery__
 *
 * To run a query within a React component, call `useLatestPaymentTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestPaymentTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestPaymentTransactionQuery({
 *   variables: {
 *      feCountryCode: // value for 'feCountryCode'
 *   },
 * });
 */
export function useLatestPaymentTransactionQuery(baseOptions?: Apollo.QueryHookOptions<ILatestPaymentTransactionQuery, ILatestPaymentTransactionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ILatestPaymentTransactionQuery, ILatestPaymentTransactionQueryVariables>(LatestPaymentTransactionDocument, options);
      }
export function useLatestPaymentTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ILatestPaymentTransactionQuery, ILatestPaymentTransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ILatestPaymentTransactionQuery, ILatestPaymentTransactionQueryVariables>(LatestPaymentTransactionDocument, options);
        }
export type LatestPaymentTransactionQueryHookResult = ReturnType<typeof useLatestPaymentTransactionQuery>;
export type LatestPaymentTransactionLazyQueryHookResult = ReturnType<typeof useLatestPaymentTransactionLazyQuery>;
export type LatestPaymentTransactionQueryResult = Apollo.QueryResult<ILatestPaymentTransactionQuery, ILatestPaymentTransactionQueryVariables>;
export const UserAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"feCountryCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IsoCountryCode"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"feCountryCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"feCountryCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"accounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"fdAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"orbitalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"credit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"cardType"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"panToken"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prepaid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"currentBalance"}},{"kind":"Field","name":{"kind":"Name","value":"cardNumber"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}},{"kind":"Field","name":{"kind":"Name","value":"feFormattedCurrentBalance"}},{"kind":"Field","name":{"kind":"Name","value":"shuffledCardNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paypal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentProcessor"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useUserAccountsQuery__
 *
 * To run a query within a React component, call `useUserAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAccountsQuery({
 *   variables: {
 *      feCountryCode: // value for 'feCountryCode'
 *   },
 * });
 */
export function useUserAccountsQuery(baseOptions: Apollo.QueryHookOptions<IUserAccountsQuery, IUserAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IUserAccountsQuery, IUserAccountsQueryVariables>(UserAccountsDocument, options);
      }
export function useUserAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IUserAccountsQuery, IUserAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IUserAccountsQuery, IUserAccountsQueryVariables>(UserAccountsDocument, options);
        }
export type UserAccountsQueryHookResult = ReturnType<typeof useUserAccountsQuery>;
export type UserAccountsLazyQueryHookResult = ReturnType<typeof useUserAccountsLazyQuery>;
export type UserAccountsQueryResult = Apollo.QueryResult<IUserAccountsQuery, IUserAccountsQueryVariables>;
export const GetEncryptionDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetEncryptionDetails"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"encryptionDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fdPublicKey"}},{"kind":"Field","name":{"kind":"Name","value":"fdAccessToken"}},{"kind":"Field","name":{"kind":"Name","value":"fdPublicKeyExpiresInSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"fdApiKey"}},{"kind":"Field","name":{"kind":"Name","value":"algorithm"}},{"kind":"Field","name":{"kind":"Name","value":"fdCustomerId"}}]}}]}}]} as unknown as DocumentNode;
export type IGetEncryptionDetailsMutationFn = Apollo.MutationFunction<IGetEncryptionDetailsMutation, IGetEncryptionDetailsMutationVariables>;

/**
 * __useGetEncryptionDetailsMutation__
 *
 * To run a mutation, you first call `useGetEncryptionDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetEncryptionDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getEncryptionDetailsMutation, { data, loading, error }] = useGetEncryptionDetailsMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetEncryptionDetailsMutation(baseOptions?: Apollo.MutationHookOptions<IGetEncryptionDetailsMutation, IGetEncryptionDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IGetEncryptionDetailsMutation, IGetEncryptionDetailsMutationVariables>(GetEncryptionDetailsDocument, options);
      }
export type GetEncryptionDetailsMutationHookResult = ReturnType<typeof useGetEncryptionDetailsMutation>;
export type GetEncryptionDetailsMutationResult = Apollo.MutationResult<IGetEncryptionDetailsMutation>;
export type GetEncryptionDetailsMutationOptions = Apollo.BaseMutationOptions<IGetEncryptionDetailsMutation, IGetEncryptionDetailsMutationVariables>;
export const AddCreditAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddCreditAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddCreditAccountInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addCreditAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"fdAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"orbitalIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"credit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locality"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"unitNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cardType"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}},{"kind":"Field","name":{"kind":"Name","value":"panToken"}}]}}]}}]}}]} as unknown as DocumentNode;
export type IAddCreditAccountMutationFn = Apollo.MutationFunction<IAddCreditAccountMutation, IAddCreditAccountMutationVariables>;

/**
 * __useAddCreditAccountMutation__
 *
 * To run a mutation, you first call `useAddCreditAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCreditAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCreditAccountMutation, { data, loading, error }] = useAddCreditAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCreditAccountMutation(baseOptions?: Apollo.MutationHookOptions<IAddCreditAccountMutation, IAddCreditAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddCreditAccountMutation, IAddCreditAccountMutationVariables>(AddCreditAccountDocument, options);
      }
export type AddCreditAccountMutationHookResult = ReturnType<typeof useAddCreditAccountMutation>;
export type AddCreditAccountMutationResult = Apollo.MutationResult<IAddCreditAccountMutation>;
export type AddCreditAccountMutationOptions = Apollo.BaseMutationOptions<IAddCreditAccountMutation, IAddCreditAccountMutationVariables>;
export const PrepaidsReloadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PrepaidsReload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepaidsReloadInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}},{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepaidsReload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentBalance"}},{"kind":"Field","name":{"kind":"Name","value":"fdAccountId"}},{"kind":"Field","name":{"kind":"Name","value":"fdCorrelationId"}},{"kind":"Field","name":{"kind":"Name","value":"transactionId"}}]}}]}}]} as unknown as DocumentNode;
export type IPrepaidsReloadMutationFn = Apollo.MutationFunction<IPrepaidsReloadMutation, IPrepaidsReloadMutationVariables>;

/**
 * __usePrepaidsReloadMutation__
 *
 * To run a mutation, you first call `usePrepaidsReloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepaidsReloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepaidsReloadMutation, { data, loading, error }] = usePrepaidsReloadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrepaidsReloadMutation(baseOptions?: Apollo.MutationHookOptions<IPrepaidsReloadMutation, IPrepaidsReloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IPrepaidsReloadMutation, IPrepaidsReloadMutationVariables>(PrepaidsReloadDocument, options);
      }
export type PrepaidsReloadMutationHookResult = ReturnType<typeof usePrepaidsReloadMutation>;
export type PrepaidsReloadMutationResult = Apollo.MutationResult<IPrepaidsReloadMutation>;
export type PrepaidsReloadMutationOptions = Apollo.BaseMutationOptions<IPrepaidsReloadMutation, IPrepaidsReloadMutationVariables>;
export const PrepaidByNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PrepaidByNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardNumber"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}},{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepaidByNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"cardNumber"}},{"kind":"Field","name":{"kind":"Name","value":"expiryMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expiryYear"}},{"kind":"Field","name":{"kind":"Name","value":"balance"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __usePrepaidByNumberQuery__
 *
 * To run a query within a React component, call `usePrepaidByNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrepaidByNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrepaidByNumberQuery({
 *   variables: {
 *      cardNumber: // value for 'cardNumber'
 *   },
 * });
 */
export function usePrepaidByNumberQuery(baseOptions: Apollo.QueryHookOptions<IPrepaidByNumberQuery, IPrepaidByNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IPrepaidByNumberQuery, IPrepaidByNumberQueryVariables>(PrepaidByNumberDocument, options);
      }
export function usePrepaidByNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IPrepaidByNumberQuery, IPrepaidByNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IPrepaidByNumberQuery, IPrepaidByNumberQueryVariables>(PrepaidByNumberDocument, options);
        }
export type PrepaidByNumberQueryHookResult = ReturnType<typeof usePrepaidByNumberQuery>;
export type PrepaidByNumberLazyQueryHookResult = ReturnType<typeof usePrepaidByNumberLazyQuery>;
export type PrepaidByNumberQueryResult = Apollo.QueryResult<IPrepaidByNumberQuery, IPrepaidByNumberQueryVariables>;
export const PromotionValidatePromoCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PromotionValidatePromoCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cognitoId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shouldRedeem"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offers"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validatePromoCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"Argument","name":{"kind":"Name","value":"cognitoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cognitoId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shouldRedeem"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shouldRedeem"}}},{"kind":"Argument","name":{"kind":"Name","value":"offers"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offers"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"isRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"offerId"}}]}}]}}]} as unknown as DocumentNode;
export type IPromotionValidatePromoCodeMutationFn = Apollo.MutationFunction<IPromotionValidatePromoCodeMutation, IPromotionValidatePromoCodeMutationVariables>;

/**
 * __usePromotionValidatePromoCodeMutation__
 *
 * To run a mutation, you first call `usePromotionValidatePromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromotionValidatePromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promotionValidatePromoCodeMutation, { data, loading, error }] = usePromotionValidatePromoCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      cognitoId: // value for 'cognitoId'
 *      shouldRedeem: // value for 'shouldRedeem'
 *      offers: // value for 'offers'
 *   },
 * });
 */
export function usePromotionValidatePromoCodeMutation(baseOptions?: Apollo.MutationHookOptions<IPromotionValidatePromoCodeMutation, IPromotionValidatePromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IPromotionValidatePromoCodeMutation, IPromotionValidatePromoCodeMutationVariables>(PromotionValidatePromoCodeDocument, options);
      }
export type PromotionValidatePromoCodeMutationHookResult = ReturnType<typeof usePromotionValidatePromoCodeMutation>;
export type PromotionValidatePromoCodeMutationResult = Apollo.MutationResult<IPromotionValidatePromoCodeMutation>;
export type PromotionValidatePromoCodeMutationOptions = Apollo.BaseMutationOptions<IPromotionValidatePromoCodeMutation, IPromotionValidatePromoCodeMutationVariables>;
export const PromotionRedeemPromoCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PromotionRedeemPromoCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cognitoId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redeemPromoCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"Argument","name":{"kind":"Name","value":"cognitoId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cognitoId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"isRedeemed"}},{"kind":"Field","name":{"kind":"Name","value":"offerId"}}]}}]}}]} as unknown as DocumentNode;
export type IPromotionRedeemPromoCodeMutationFn = Apollo.MutationFunction<IPromotionRedeemPromoCodeMutation, IPromotionRedeemPromoCodeMutationVariables>;

/**
 * __usePromotionRedeemPromoCodeMutation__
 *
 * To run a mutation, you first call `usePromotionRedeemPromoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromotionRedeemPromoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promotionRedeemPromoCodeMutation, { data, loading, error }] = usePromotionRedeemPromoCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      cognitoId: // value for 'cognitoId'
 *   },
 * });
 */
export function usePromotionRedeemPromoCodeMutation(baseOptions?: Apollo.MutationHookOptions<IPromotionRedeemPromoCodeMutation, IPromotionRedeemPromoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IPromotionRedeemPromoCodeMutation, IPromotionRedeemPromoCodeMutationVariables>(PromotionRedeemPromoCodeDocument, options);
      }
export type PromotionRedeemPromoCodeMutationHookResult = ReturnType<typeof usePromotionRedeemPromoCodeMutation>;
export type PromotionRedeemPromoCodeMutationResult = Apollo.MutationResult<IPromotionRedeemPromoCodeMutation>;
export type PromotionRedeemPromoCodeMutationOptions = Apollo.BaseMutationOptions<IPromotionRedeemPromoCodeMutation, IPromotionRedeemPromoCodeMutationVariables>;
export const GetRestaurantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRestaurant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"storeNumber"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"storeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"storeNumber"},"value":{"kind":"Variable","name":{"kind":"Name","value":"storeNumber"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"available"}},{"kind":"Field","name":{"kind":"Name","value":"curbsideHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diningRoomHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"driveThruHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fastestServiceMode"}},{"kind":"Field","name":{"kind":"Name","value":"futureServiceHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serviceMode"}},{"kind":"Field","name":{"kind":"Name","value":"timeSlots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closes"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"isClosed"}},{"kind":"Field","name":{"kind":"Name","value":"opens"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OperatingHoursFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OperatingHours"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"friClose"}},{"kind":"Field","name":{"kind":"Name","value":"friOpen"}},{"kind":"Field","name":{"kind":"Name","value":"monClose"}},{"kind":"Field","name":{"kind":"Name","value":"monOpen"}},{"kind":"Field","name":{"kind":"Name","value":"satClose"}},{"kind":"Field","name":{"kind":"Name","value":"satOpen"}},{"kind":"Field","name":{"kind":"Name","value":"sunClose"}},{"kind":"Field","name":{"kind":"Name","value":"sunOpen"}},{"kind":"Field","name":{"kind":"Name","value":"thrClose"}},{"kind":"Field","name":{"kind":"Name","value":"thrOpen"}},{"kind":"Field","name":{"kind":"Name","value":"tueClose"}},{"kind":"Field","name":{"kind":"Name","value":"tueOpen"}},{"kind":"Field","name":{"kind":"Name","value":"wedClose"}},{"kind":"Field","name":{"kind":"Name","value":"wedOpen"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetRestaurantQuery__
 *
 * To run a query within a React component, call `useGetRestaurantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantQuery({
 *   variables: {
 *      storeId: // value for 'storeId'
 *      storeNumber: // value for 'storeNumber'
 *   },
 * });
 */
export function useGetRestaurantQuery(baseOptions?: Apollo.QueryHookOptions<IGetRestaurantQuery, IGetRestaurantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRestaurantQuery, IGetRestaurantQueryVariables>(GetRestaurantDocument, options);
      }
export function useGetRestaurantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRestaurantQuery, IGetRestaurantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRestaurantQuery, IGetRestaurantQueryVariables>(GetRestaurantDocument, options);
        }
export type GetRestaurantQueryHookResult = ReturnType<typeof useGetRestaurantQuery>;
export type GetRestaurantLazyQueryHookResult = ReturnType<typeof useGetRestaurantLazyQuery>;
export type GetRestaurantQueryResult = Apollo.QueryResult<IGetRestaurantQuery, IGetRestaurantQueryVariables>;
export const GetRestaurantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRestaurants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RestaurantsInput"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restaurants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RestaurantNodeFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OperatingHoursFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OperatingHours"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"friClose"}},{"kind":"Field","name":{"kind":"Name","value":"friOpen"}},{"kind":"Field","name":{"kind":"Name","value":"monClose"}},{"kind":"Field","name":{"kind":"Name","value":"monOpen"}},{"kind":"Field","name":{"kind":"Name","value":"satClose"}},{"kind":"Field","name":{"kind":"Name","value":"satOpen"}},{"kind":"Field","name":{"kind":"Name","value":"sunClose"}},{"kind":"Field","name":{"kind":"Name","value":"sunOpen"}},{"kind":"Field","name":{"kind":"Name","value":"thrClose"}},{"kind":"Field","name":{"kind":"Name","value":"thrOpen"}},{"kind":"Field","name":{"kind":"Name","value":"tueClose"}},{"kind":"Field","name":{"kind":"Name","value":"tueOpen"}},{"kind":"Field","name":{"kind":"Name","value":"wedClose"}},{"kind":"Field","name":{"kind":"Name","value":"wedOpen"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RestaurantNodeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RestaurantNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"posVendor"}},{"kind":"Field","name":{"kind":"Name","value":"chaseMerchantId"}},{"kind":"Field","name":{"kind":"Name","value":"curbsideHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diningRoomHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"distanceInMiles"}},{"kind":"Field","name":{"kind":"Name","value":"drinkStationType"}},{"kind":"Field","name":{"kind":"Name","value":"driveThruHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"driveThruLaneType"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"environment"}},{"kind":"Field","name":{"kind":"Name","value":"fastestServiceMode"}},{"kind":"Field","name":{"kind":"Name","value":"franchiseGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"franchiseGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"frontCounterClosed"}},{"kind":"Field","name":{"kind":"Name","value":"hasBreakfast"}},{"kind":"Field","name":{"kind":"Name","value":"hasBurgersForBreakfast"}},{"kind":"Field","name":{"kind":"Name","value":"hasCatering"}},{"kind":"Field","name":{"kind":"Name","value":"hasCurbside"}},{"kind":"Field","name":{"kind":"Name","value":"hasDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"hasDineIn"}},{"kind":"Field","name":{"kind":"Name","value":"hasDriveThru"}},{"kind":"Field","name":{"kind":"Name","value":"hasMobileOrdering"}},{"kind":"Field","name":{"kind":"Name","value":"hasParking"}},{"kind":"Field","name":{"kind":"Name","value":"hasPlayground"}},{"kind":"Field","name":{"kind":"Name","value":"hasTakeOut"}},{"kind":"Field","name":{"kind":"Name","value":"hasWifi"}},{"kind":"Field","name":{"kind":"Name","value":"hasLoyalty"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDarkKitchen"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}},{"kind":"Field","name":{"kind":"Name","value":"isHalal"}},{"kind":"Field","name":{"kind":"Name","value":"isRecent"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"mobileOrderingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"parkingType"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","name":{"kind":"Name","value":"stateProvinceShort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"playgroundType"}},{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"posRestaurantId"}},{"kind":"Field","name":{"kind":"Name","value":"restaurantImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lqip"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"restaurantPosData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"vatNumber"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetRestaurantsQuery__
 *
 * To run a query within a React component, call `useGetRestaurantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRestaurantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRestaurantsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRestaurantsQuery(baseOptions?: Apollo.QueryHookOptions<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>(GetRestaurantsDocument, options);
      }
export function useGetRestaurantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>(GetRestaurantsDocument, options);
        }
export type GetRestaurantsQueryHookResult = ReturnType<typeof useGetRestaurantsQuery>;
export type GetRestaurantsLazyQueryHookResult = ReturnType<typeof useGetRestaurantsLazyQuery>;
export type GetRestaurantsQueryResult = Apollo.QueryResult<IGetRestaurantsQuery, IGetRestaurantsQueryVariables>;
export const DeliveryRestaurantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeliveryRestaurant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dropoff"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeliveryWaypointInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchRadius"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"platform"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Platform"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliveryRestaurant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"dropoff"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dropoff"}}},{"kind":"Argument","name":{"kind":"Name","value":"searchRadius"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchRadius"}}},{"kind":"Argument","name":{"kind":"Name","value":"platform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"platform"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storeStatus"}},{"kind":"Field","name":{"kind":"Name","value":"quote"}},{"kind":"Field","name":{"kind":"Name","value":"nextEarliestOpen"}},{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RestaurantNodeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliverySurchargeFeeCents"}},{"kind":"Field","name":{"kind":"Name","value":"quoteId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OperatingHoursFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OperatingHours"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"friClose"}},{"kind":"Field","name":{"kind":"Name","value":"friOpen"}},{"kind":"Field","name":{"kind":"Name","value":"monClose"}},{"kind":"Field","name":{"kind":"Name","value":"monOpen"}},{"kind":"Field","name":{"kind":"Name","value":"satClose"}},{"kind":"Field","name":{"kind":"Name","value":"satOpen"}},{"kind":"Field","name":{"kind":"Name","value":"sunClose"}},{"kind":"Field","name":{"kind":"Name","value":"sunOpen"}},{"kind":"Field","name":{"kind":"Name","value":"thrClose"}},{"kind":"Field","name":{"kind":"Name","value":"thrOpen"}},{"kind":"Field","name":{"kind":"Name","value":"tueClose"}},{"kind":"Field","name":{"kind":"Name","value":"tueOpen"}},{"kind":"Field","name":{"kind":"Name","value":"wedClose"}},{"kind":"Field","name":{"kind":"Name","value":"wedOpen"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RestaurantNodeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RestaurantNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"posVendor"}},{"kind":"Field","name":{"kind":"Name","value":"chaseMerchantId"}},{"kind":"Field","name":{"kind":"Name","value":"curbsideHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diningRoomHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"distanceInMiles"}},{"kind":"Field","name":{"kind":"Name","value":"drinkStationType"}},{"kind":"Field","name":{"kind":"Name","value":"driveThruHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"driveThruLaneType"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"environment"}},{"kind":"Field","name":{"kind":"Name","value":"fastestServiceMode"}},{"kind":"Field","name":{"kind":"Name","value":"franchiseGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"franchiseGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"frontCounterClosed"}},{"kind":"Field","name":{"kind":"Name","value":"hasBreakfast"}},{"kind":"Field","name":{"kind":"Name","value":"hasBurgersForBreakfast"}},{"kind":"Field","name":{"kind":"Name","value":"hasCatering"}},{"kind":"Field","name":{"kind":"Name","value":"hasCurbside"}},{"kind":"Field","name":{"kind":"Name","value":"hasDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"hasDineIn"}},{"kind":"Field","name":{"kind":"Name","value":"hasDriveThru"}},{"kind":"Field","name":{"kind":"Name","value":"hasMobileOrdering"}},{"kind":"Field","name":{"kind":"Name","value":"hasParking"}},{"kind":"Field","name":{"kind":"Name","value":"hasPlayground"}},{"kind":"Field","name":{"kind":"Name","value":"hasTakeOut"}},{"kind":"Field","name":{"kind":"Name","value":"hasWifi"}},{"kind":"Field","name":{"kind":"Name","value":"hasLoyalty"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDarkKitchen"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}},{"kind":"Field","name":{"kind":"Name","value":"isHalal"}},{"kind":"Field","name":{"kind":"Name","value":"isRecent"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"mobileOrderingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"parkingType"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","name":{"kind":"Name","value":"stateProvinceShort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"playgroundType"}},{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"posRestaurantId"}},{"kind":"Field","name":{"kind":"Name","value":"restaurantImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lqip"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"restaurantPosData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"vatNumber"}}]}}]} as unknown as DocumentNode;

/**
 * __useDeliveryRestaurantQuery__
 *
 * To run a query within a React component, call `useDeliveryRestaurantQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryRestaurantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryRestaurantQuery({
 *   variables: {
 *      dropoff: // value for 'dropoff'
 *      searchRadius: // value for 'searchRadius'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useDeliveryRestaurantQuery(baseOptions: Apollo.QueryHookOptions<IDeliveryRestaurantQuery, IDeliveryRestaurantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IDeliveryRestaurantQuery, IDeliveryRestaurantQueryVariables>(DeliveryRestaurantDocument, options);
      }
export function useDeliveryRestaurantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IDeliveryRestaurantQuery, IDeliveryRestaurantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IDeliveryRestaurantQuery, IDeliveryRestaurantQueryVariables>(DeliveryRestaurantDocument, options);
        }
export type DeliveryRestaurantQueryHookResult = ReturnType<typeof useDeliveryRestaurantQuery>;
export type DeliveryRestaurantLazyQueryHookResult = ReturnType<typeof useDeliveryRestaurantLazyQuery>;
export type DeliveryRestaurantQueryResult = Apollo.QueryResult<IDeliveryRestaurantQuery, IDeliveryRestaurantQueryVariables>;
export const GetNearbyRestaurantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNearbyRestaurants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NearbyRestaurantsInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}},{"kind":"Directive","name":{"kind":"Name","value":"useCache"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restaurantsV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nearby"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RestaurantNodeFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OperatingHoursFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OperatingHours"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"friClose"}},{"kind":"Field","name":{"kind":"Name","value":"friOpen"}},{"kind":"Field","name":{"kind":"Name","value":"monClose"}},{"kind":"Field","name":{"kind":"Name","value":"monOpen"}},{"kind":"Field","name":{"kind":"Name","value":"satClose"}},{"kind":"Field","name":{"kind":"Name","value":"satOpen"}},{"kind":"Field","name":{"kind":"Name","value":"sunClose"}},{"kind":"Field","name":{"kind":"Name","value":"sunOpen"}},{"kind":"Field","name":{"kind":"Name","value":"thrClose"}},{"kind":"Field","name":{"kind":"Name","value":"thrOpen"}},{"kind":"Field","name":{"kind":"Name","value":"tueClose"}},{"kind":"Field","name":{"kind":"Name","value":"tueOpen"}},{"kind":"Field","name":{"kind":"Name","value":"wedClose"}},{"kind":"Field","name":{"kind":"Name","value":"wedOpen"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RestaurantNodeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RestaurantNode"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"storeId"}},{"kind":"Field","name":{"kind":"Name","value":"isAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"posVendor"}},{"kind":"Field","name":{"kind":"Name","value":"chaseMerchantId"}},{"kind":"Field","name":{"kind":"Name","value":"curbsideHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diningRoomHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"distanceInMiles"}},{"kind":"Field","name":{"kind":"Name","value":"drinkStationType"}},{"kind":"Field","name":{"kind":"Name","value":"driveThruHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OperatingHoursFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"driveThruLaneType"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"environment"}},{"kind":"Field","name":{"kind":"Name","value":"fastestServiceMode"}},{"kind":"Field","name":{"kind":"Name","value":"franchiseGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"franchiseGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"frontCounterClosed"}},{"kind":"Field","name":{"kind":"Name","value":"hasBreakfast"}},{"kind":"Field","name":{"kind":"Name","value":"hasBurgersForBreakfast"}},{"kind":"Field","name":{"kind":"Name","value":"hasCatering"}},{"kind":"Field","name":{"kind":"Name","value":"hasCurbside"}},{"kind":"Field","name":{"kind":"Name","value":"hasDelivery"}},{"kind":"Field","name":{"kind":"Name","value":"hasDineIn"}},{"kind":"Field","name":{"kind":"Name","value":"hasDriveThru"}},{"kind":"Field","name":{"kind":"Name","value":"hasMobileOrdering"}},{"kind":"Field","name":{"kind":"Name","value":"hasParking"}},{"kind":"Field","name":{"kind":"Name","value":"hasPlayground"}},{"kind":"Field","name":{"kind":"Name","value":"hasTakeOut"}},{"kind":"Field","name":{"kind":"Name","value":"hasWifi"}},{"kind":"Field","name":{"kind":"Name","value":"hasLoyalty"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDarkKitchen"}},{"kind":"Field","name":{"kind":"Name","value":"isFavorite"}},{"kind":"Field","name":{"kind":"Name","value":"isHalal"}},{"kind":"Field","name":{"kind":"Name","value":"isRecent"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"mobileOrderingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"parkingType"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"physicalAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","name":{"kind":"Name","value":"stateProvinceShort"}}]}},{"kind":"Field","name":{"kind":"Name","value":"playgroundType"}},{"kind":"Field","name":{"kind":"Name","value":"pos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"posRestaurantId"}},{"kind":"Field","name":{"kind":"Name","value":"restaurantImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lqip"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"restaurantPosData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"vatNumber"}}]}}]} as unknown as DocumentNode;

/**
 * __useGetNearbyRestaurantsQuery__
 *
 * To run a query within a React component, call `useGetNearbyRestaurantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNearbyRestaurantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNearbyRestaurantsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetNearbyRestaurantsQuery(baseOptions: Apollo.QueryHookOptions<IGetNearbyRestaurantsQuery, IGetNearbyRestaurantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetNearbyRestaurantsQuery, IGetNearbyRestaurantsQueryVariables>(GetNearbyRestaurantsDocument, options);
      }
export function useGetNearbyRestaurantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetNearbyRestaurantsQuery, IGetNearbyRestaurantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetNearbyRestaurantsQuery, IGetNearbyRestaurantsQueryVariables>(GetNearbyRestaurantsDocument, options);
        }
export type GetNearbyRestaurantsQueryHookResult = ReturnType<typeof useGetNearbyRestaurantsQuery>;
export type GetNearbyRestaurantsLazyQueryHookResult = ReturnType<typeof useGetNearbyRestaurantsLazyQuery>;
export type GetNearbyRestaurantsQueryResult = Apollo.QueryResult<IGetNearbyRestaurantsQuery, IGetNearbyRestaurantsQueryVariables>;
export const GetUserFavoritesRefsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserFavoritesRefs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resumeAfter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFavorites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"resumeAfter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resumeAfter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"resumeAfter"}},{"kind":"Field","name":{"kind":"Name","value":"favorites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"favoriteId"}},{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetUserFavoritesRefsQuery__
 *
 * To run a query within a React component, call `useGetUserFavoritesRefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFavoritesRefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFavoritesRefsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      resumeAfter: // value for 'resumeAfter'
 *   },
 * });
 */
export function useGetUserFavoritesRefsQuery(baseOptions?: Apollo.QueryHookOptions<IGetUserFavoritesRefsQuery, IGetUserFavoritesRefsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetUserFavoritesRefsQuery, IGetUserFavoritesRefsQueryVariables>(GetUserFavoritesRefsDocument, options);
      }
export function useGetUserFavoritesRefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetUserFavoritesRefsQuery, IGetUserFavoritesRefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetUserFavoritesRefsQuery, IGetUserFavoritesRefsQueryVariables>(GetUserFavoritesRefsDocument, options);
        }
export type GetUserFavoritesRefsQueryHookResult = ReturnType<typeof useGetUserFavoritesRefsQuery>;
export type GetUserFavoritesRefsLazyQueryHookResult = ReturnType<typeof useGetUserFavoritesRefsLazyQuery>;
export type GetUserFavoritesRefsQueryResult = Apollo.QueryResult<IGetUserFavoritesRefsQuery, IGetUserFavoritesRefsQueryVariables>;
export const GetUserFavoriteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserFavorite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"favoriteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFavorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"favoriteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"favoriteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FavoriteFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isDonation"}},{"kind":"Field","name":{"kind":"Name","value":"isExtra"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pickerSelections"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"redeemable"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Plus"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FavoriteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Favorite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"favoriteId"}},{"kind":"Field","name":{"kind":"Name","value":"favoriteId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ref"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VC"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluType"}},{"kind":"Field","name":{"kind":"Name","value":"parentSanityId"}},{"kind":"Field","name":{"kind":"Name","value":"constantPlu"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiConstantPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentChildPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"childPlu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comboPlu"}},{"kind":"Field","name":{"kind":"Name","value":"comboSize"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Plus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfigs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brinkDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrols"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrolsDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncrDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdiDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicomDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetUserFavoriteQuery__
 *
 * To run a query within a React component, call `useGetUserFavoriteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFavoriteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFavoriteQuery({
 *   variables: {
 *      favoriteId: // value for 'favoriteId'
 *   },
 * });
 */
export function useGetUserFavoriteQuery(baseOptions: Apollo.QueryHookOptions<IGetUserFavoriteQuery, IGetUserFavoriteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetUserFavoriteQuery, IGetUserFavoriteQueryVariables>(GetUserFavoriteDocument, options);
      }
export function useGetUserFavoriteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetUserFavoriteQuery, IGetUserFavoriteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetUserFavoriteQuery, IGetUserFavoriteQueryVariables>(GetUserFavoriteDocument, options);
        }
export type GetUserFavoriteQueryHookResult = ReturnType<typeof useGetUserFavoriteQuery>;
export type GetUserFavoriteLazyQueryHookResult = ReturnType<typeof useGetUserFavoriteLazyQuery>;
export type GetUserFavoriteQueryResult = Apollo.QueryResult<IGetUserFavoriteQuery, IGetUserFavoriteQueryVariables>;
export const GetUserFavoritesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserFavorites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resumeAfter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFavorites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"resumeAfter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resumeAfter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"resumeAfter"}},{"kind":"Field","name":{"kind":"Name","value":"favorites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FavoriteFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isDonation"}},{"kind":"Field","name":{"kind":"Name","value":"isExtra"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pickerSelections"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"redeemable"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Plus"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FavoriteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Favorite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"favoriteId"}},{"kind":"Field","name":{"kind":"Name","value":"favoriteId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ref"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VC"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluType"}},{"kind":"Field","name":{"kind":"Name","value":"parentSanityId"}},{"kind":"Field","name":{"kind":"Name","value":"constantPlu"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiConstantPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentChildPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"childPlu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comboPlu"}},{"kind":"Field","name":{"kind":"Name","value":"comboSize"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Plus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfigs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brinkDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrols"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrolsDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncrDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdiDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicomDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetUserFavoritesQuery__
 *
 * To run a query within a React component, call `useGetUserFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFavoritesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      resumeAfter: // value for 'resumeAfter'
 *   },
 * });
 */
export function useGetUserFavoritesQuery(baseOptions?: Apollo.QueryHookOptions<IGetUserFavoritesQuery, IGetUserFavoritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetUserFavoritesQuery, IGetUserFavoritesQueryVariables>(GetUserFavoritesDocument, options);
      }
export function useGetUserFavoritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetUserFavoritesQuery, IGetUserFavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetUserFavoritesQuery, IGetUserFavoritesQueryVariables>(GetUserFavoritesDocument, options);
        }
export type GetUserFavoritesQueryHookResult = ReturnType<typeof useGetUserFavoritesQuery>;
export type GetUserFavoritesLazyQueryHookResult = ReturnType<typeof useGetUserFavoritesLazyQuery>;
export type GetUserFavoritesQueryResult = Apollo.QueryResult<IGetUserFavoritesQuery, IGetUserFavoritesQueryVariables>;
export const GetUserReorderFavoritesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserReorderFavorites"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userFavorites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"favorites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReorderFavoriteFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isDonation"}},{"kind":"Field","name":{"kind":"Name","value":"isExtra"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pickerSelections"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"redeemable"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Plus"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FavoriteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Favorite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"favoriteId"}},{"kind":"Field","name":{"kind":"Name","value":"favoriteId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ref"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReorderFavoriteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Favorite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FavoriteFragment"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"isInMenu"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"isInMenu"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"isInMenu"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"isInMenu"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"isInMenu"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"isInMenu"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VC"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluType"}},{"kind":"Field","name":{"kind":"Name","value":"parentSanityId"}},{"kind":"Field","name":{"kind":"Name","value":"constantPlu"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiConstantPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentChildPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"childPlu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comboPlu"}},{"kind":"Field","name":{"kind":"Name","value":"comboSize"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Plus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfigs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brinkDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrols"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrolsDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncrDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdiDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicomDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useGetUserReorderFavoritesQuery__
 *
 * To run a query within a React component, call `useGetUserReorderFavoritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserReorderFavoritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserReorderFavoritesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserReorderFavoritesQuery(baseOptions?: Apollo.QueryHookOptions<IGetUserReorderFavoritesQuery, IGetUserReorderFavoritesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetUserReorderFavoritesQuery, IGetUserReorderFavoritesQueryVariables>(GetUserReorderFavoritesDocument, options);
      }
export function useGetUserReorderFavoritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetUserReorderFavoritesQuery, IGetUserReorderFavoritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetUserReorderFavoritesQuery, IGetUserReorderFavoritesQueryVariables>(GetUserReorderFavoritesDocument, options);
        }
export type GetUserReorderFavoritesQueryHookResult = ReturnType<typeof useGetUserReorderFavoritesQuery>;
export type GetUserReorderFavoritesLazyQueryHookResult = ReturnType<typeof useGetUserReorderFavoritesLazyQuery>;
export type GetUserReorderFavoritesQueryResult = Apollo.QueryResult<IGetUserReorderFavoritesQuery, IGetUserReorderFavoritesQueryVariables>;
export const CreateFavoriteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFavorite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FavoriteInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFavorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FavoriteFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isDonation"}},{"kind":"Field","name":{"kind":"Name","value":"isExtra"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pickerSelections"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"redeemable"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Plus"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FavoriteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Favorite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"favoriteId"}},{"kind":"Field","name":{"kind":"Name","value":"favoriteId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ref"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VC"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluType"}},{"kind":"Field","name":{"kind":"Name","value":"parentSanityId"}},{"kind":"Field","name":{"kind":"Name","value":"constantPlu"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiConstantPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentChildPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"childPlu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comboPlu"}},{"kind":"Field","name":{"kind":"Name","value":"comboSize"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Plus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfigs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brinkDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrols"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrolsDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncrDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdiDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicomDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}}]}}]} as unknown as DocumentNode;
export type ICreateFavoriteMutationFn = Apollo.MutationFunction<ICreateFavoriteMutation, ICreateFavoriteMutationVariables>;

/**
 * __useCreateFavoriteMutation__
 *
 * To run a mutation, you first call `useCreateFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFavoriteMutation, { data, loading, error }] = useCreateFavoriteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<ICreateFavoriteMutation, ICreateFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateFavoriteMutation, ICreateFavoriteMutationVariables>(CreateFavoriteDocument, options);
      }
export type CreateFavoriteMutationHookResult = ReturnType<typeof useCreateFavoriteMutation>;
export type CreateFavoriteMutationResult = Apollo.MutationResult<ICreateFavoriteMutation>;
export type CreateFavoriteMutationOptions = Apollo.BaseMutationOptions<ICreateFavoriteMutation, ICreateFavoriteMutationVariables>;
export const UpdateFavoriteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFavorite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"favoriteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FavoriteInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFavorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"favoriteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"favoriteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FavoriteFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isDonation"}},{"kind":"Field","name":{"kind":"Name","value":"isExtra"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pickerSelections"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"redeemable"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Plus"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FavoriteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Favorite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"favoriteId"}},{"kind":"Field","name":{"kind":"Name","value":"favoriteId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ref"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VC"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluType"}},{"kind":"Field","name":{"kind":"Name","value":"parentSanityId"}},{"kind":"Field","name":{"kind":"Name","value":"constantPlu"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiConstantPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentChildPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"childPlu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comboPlu"}},{"kind":"Field","name":{"kind":"Name","value":"comboSize"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Plus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfigs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brinkDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrols"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrolsDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncrDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdiDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicomDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}}]}}]} as unknown as DocumentNode;
export type IUpdateFavoriteMutationFn = Apollo.MutationFunction<IUpdateFavoriteMutation, IUpdateFavoriteMutationVariables>;

/**
 * __useUpdateFavoriteMutation__
 *
 * To run a mutation, you first call `useUpdateFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFavoriteMutation, { data, loading, error }] = useUpdateFavoriteMutation({
 *   variables: {
 *      favoriteId: // value for 'favoriteId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateFavoriteMutation, IUpdateFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateFavoriteMutation, IUpdateFavoriteMutationVariables>(UpdateFavoriteDocument, options);
      }
export type UpdateFavoriteMutationHookResult = ReturnType<typeof useUpdateFavoriteMutation>;
export type UpdateFavoriteMutationResult = Apollo.MutationResult<IUpdateFavoriteMutation>;
export type UpdateFavoriteMutationOptions = Apollo.BaseMutationOptions<IUpdateFavoriteMutation, IUpdateFavoriteMutationVariables>;
export const DeleteFavoriteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteFavorite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"favoriteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteFavorite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"favoriteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"favoriteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FavoriteFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"lineId"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"isDonation"}},{"kind":"Field","name":{"kind":"Name","value":"isExtra"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pickerSelections"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"sanityId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"redeemable"}},{"kind":"Field","name":{"kind":"Name","value":"vendorConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Plus"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CartEntries"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryFragment"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FavoriteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Favorite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"_id"},"name":{"kind":"Name","value":"favoriteId"}},{"kind":"Field","name":{"kind":"Name","value":"favoriteId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"ref"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CartEntryWithChildrenFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VC"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfig"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluType"}},{"kind":"Field","name":{"kind":"Name","value":"parentSanityId"}},{"kind":"Field","name":{"kind":"Name","value":"constantPlu"}},{"kind":"Field","name":{"kind":"Name","value":"quantityBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"multiConstantPlus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"qualifier"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parentChildPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plu"}},{"kind":"Field","name":{"kind":"Name","value":"childPlu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sizeBasedPlu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comboPlu"}},{"kind":"Field","name":{"kind":"Name","value":"comboSize"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Plus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorConfigs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"brinkDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrols"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"carrolsDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncr"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ncrDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdi"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qdiDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicom"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sicomDelivery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VC"}}]}}]}}]} as unknown as DocumentNode;
export type IDeleteFavoriteMutationFn = Apollo.MutationFunction<IDeleteFavoriteMutation, IDeleteFavoriteMutationVariables>;

/**
 * __useDeleteFavoriteMutation__
 *
 * To run a mutation, you first call `useDeleteFavoriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFavoriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFavoriteMutation, { data, loading, error }] = useDeleteFavoriteMutation({
 *   variables: {
 *      favoriteId: // value for 'favoriteId'
 *   },
 * });
 */
export function useDeleteFavoriteMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteFavoriteMutation, IDeleteFavoriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteFavoriteMutation, IDeleteFavoriteMutationVariables>(DeleteFavoriteDocument, options);
      }
export type DeleteFavoriteMutationHookResult = ReturnType<typeof useDeleteFavoriteMutation>;
export type DeleteFavoriteMutationResult = Apollo.MutationResult<IDeleteFavoriteMutation>;
export type DeleteFavoriteMutationOptions = Apollo.BaseMutationOptions<IDeleteFavoriteMutation, IDeleteFavoriteMutationVariables>;
export const SignUpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignUp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignUpUserInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signUp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode;
export type ISignUpMutationFn = Apollo.MutationFunction<ISignUpMutation, ISignUpMutationVariables>;

/**
 * __useSignUpMutation__
 *
 * To run a mutation, you first call `useSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpMutation, { data, loading, error }] = useSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpMutation(baseOptions?: Apollo.MutationHookOptions<ISignUpMutation, ISignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ISignUpMutation, ISignUpMutationVariables>(SignUpDocument, options);
      }
export type SignUpMutationHookResult = ReturnType<typeof useSignUpMutation>;
export type SignUpMutationResult = Apollo.MutationResult<ISignUpMutation>;
export type SignUpMutationOptions = Apollo.BaseMutationOptions<ISignUpMutation, ISignUpMutationVariables>;
export const SignUpCompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SignUpComplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jwt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signUpComplete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"jwt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jwt"}}}]}]}}]} as unknown as DocumentNode;

/**
 * __useSignUpCompleteQuery__
 *
 * To run a query within a React component, call `useSignUpCompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignUpCompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignUpCompleteQuery({
 *   variables: {
 *      jwt: // value for 'jwt'
 *   },
 * });
 */
export function useSignUpCompleteQuery(baseOptions: Apollo.QueryHookOptions<ISignUpCompleteQuery, ISignUpCompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISignUpCompleteQuery, ISignUpCompleteQueryVariables>(SignUpCompleteDocument, options);
      }
export function useSignUpCompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISignUpCompleteQuery, ISignUpCompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISignUpCompleteQuery, ISignUpCompleteQueryVariables>(SignUpCompleteDocument, options);
        }
export type SignUpCompleteQueryHookResult = ReturnType<typeof useSignUpCompleteQuery>;
export type SignUpCompleteLazyQueryHookResult = ReturnType<typeof useSignUpCompleteLazyQuery>;
export type SignUpCompleteQueryResult = Apollo.QueryResult<ISignUpCompleteQuery, ISignUpCompleteQueryVariables>;
export const UserGeoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserGeo"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGeo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserGeoFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserGeoFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserGeo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]} as unknown as DocumentNode;

/**
 * __useUserGeoQuery__
 *
 * To run a query within a React component, call `useUserGeoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGeoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGeoQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserGeoQuery(baseOptions?: Apollo.QueryHookOptions<IUserGeoQuery, IUserGeoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IUserGeoQuery, IUserGeoQueryVariables>(UserGeoDocument, options);
      }
export function useUserGeoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IUserGeoQuery, IUserGeoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IUserGeoQuery, IUserGeoQueryVariables>(UserGeoDocument, options);
        }
export type UserGeoQueryHookResult = ReturnType<typeof useUserGeoQuery>;
export type UserGeoLazyQueryHookResult = ReturnType<typeof useUserGeoLazyQuery>;
export type UserGeoQueryResult = Apollo.QueryResult<IUserGeoQuery, IUserGeoQueryVariables>;
export const ResendVerificationEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendVerificationEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"resendVerificationEmailInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendVerificationEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode;
export type IResendVerificationEmailMutationFn = Apollo.MutationFunction<IResendVerificationEmailMutation, IResendVerificationEmailMutationVariables>;

/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailMutation, { data, loading, error }] = useResendVerificationEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<IResendVerificationEmailMutation, IResendVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IResendVerificationEmailMutation, IResendVerificationEmailMutationVariables>(ResendVerificationEmailDocument, options);
      }
export type ResendVerificationEmailMutationHookResult = ReturnType<typeof useResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationResult = Apollo.MutationResult<IResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<IResendVerificationEmailMutation, IResendVerificationEmailMutationVariables>;
export const ResendCurrentLoginOtpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendCurrentLoginOTP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResendOTPInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendCurrentLoginOTP"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxValidateAttempts"}},{"kind":"Field","name":{"kind":"Name","value":"ttl"}}]}}]}}]} as unknown as DocumentNode;
export type IResendCurrentLoginOtpMutationFn = Apollo.MutationFunction<IResendCurrentLoginOtpMutation, IResendCurrentLoginOtpMutationVariables>;

/**
 * __useResendCurrentLoginOtpMutation__
 *
 * To run a mutation, you first call `useResendCurrentLoginOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendCurrentLoginOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendCurrentLoginOtpMutation, { data, loading, error }] = useResendCurrentLoginOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendCurrentLoginOtpMutation(baseOptions?: Apollo.MutationHookOptions<IResendCurrentLoginOtpMutation, IResendCurrentLoginOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IResendCurrentLoginOtpMutation, IResendCurrentLoginOtpMutationVariables>(ResendCurrentLoginOtpDocument, options);
      }
export type ResendCurrentLoginOtpMutationHookResult = ReturnType<typeof useResendCurrentLoginOtpMutation>;
export type ResendCurrentLoginOtpMutationResult = Apollo.MutationResult<IResendCurrentLoginOtpMutation>;
export type ResendCurrentLoginOtpMutationOptions = Apollo.BaseMutationOptions<IResendCurrentLoginOtpMutation, IResendCurrentLoginOtpMutationVariables>;
export const SignInJwtDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignInJWT"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignInUserInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signInJWT"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userInfo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode;
export type ISignInJwtMutationFn = Apollo.MutationFunction<ISignInJwtMutation, ISignInJwtMutationVariables>;

/**
 * __useSignInJwtMutation__
 *
 * To run a mutation, you first call `useSignInJwtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInJwtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInJwtMutation, { data, loading, error }] = useSignInJwtMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignInJwtMutation(baseOptions?: Apollo.MutationHookOptions<ISignInJwtMutation, ISignInJwtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ISignInJwtMutation, ISignInJwtMutationVariables>(SignInJwtDocument, options);
      }
export type SignInJwtMutationHookResult = ReturnType<typeof useSignInJwtMutation>;
export type SignInJwtMutationResult = Apollo.MutationResult<ISignInJwtMutation>;
export type SignInJwtMutationOptions = Apollo.BaseMutationOptions<ISignInJwtMutation, ISignInJwtMutationVariables>;
export const ValidateAuthJwtDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ValidateAuthJwt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"validateAuthJwtInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateAuthJwt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"authInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"challengeCode"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}}]}}]}}]} as unknown as DocumentNode;
export type IValidateAuthJwtMutationFn = Apollo.MutationFunction<IValidateAuthJwtMutation, IValidateAuthJwtMutationVariables>;

/**
 * __useValidateAuthJwtMutation__
 *
 * To run a mutation, you first call `useValidateAuthJwtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateAuthJwtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateAuthJwtMutation, { data, loading, error }] = useValidateAuthJwtMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateAuthJwtMutation(baseOptions?: Apollo.MutationHookOptions<IValidateAuthJwtMutation, IValidateAuthJwtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IValidateAuthJwtMutation, IValidateAuthJwtMutationVariables>(ValidateAuthJwtDocument, options);
      }
export type ValidateAuthJwtMutationHookResult = ReturnType<typeof useValidateAuthJwtMutation>;
export type ValidateAuthJwtMutationResult = Apollo.MutationResult<IValidateAuthJwtMutation>;
export type ValidateAuthJwtMutationOptions = Apollo.BaseMutationOptions<IValidateAuthJwtMutation, IValidateAuthJwtMutationVariables>;
export const ValidateOtpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ValidateOTP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExchangeOTPCodeForCredentialsInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exchangeOTPCodeForCognitoCredentials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"challengeCode"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode;
export type IValidateOtpMutationFn = Apollo.MutationFunction<IValidateOtpMutation, IValidateOtpMutationVariables>;

/**
 * __useValidateOtpMutation__
 *
 * To run a mutation, you first call `useValidateOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateOtpMutation, { data, loading, error }] = useValidateOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateOtpMutation(baseOptions?: Apollo.MutationHookOptions<IValidateOtpMutation, IValidateOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IValidateOtpMutation, IValidateOtpMutationVariables>(ValidateOtpDocument, options);
      }
export type ValidateOtpMutationHookResult = ReturnType<typeof useValidateOtpMutation>;
export type ValidateOtpMutationResult = Apollo.MutationResult<IValidateOtpMutation>;
export type ValidateOtpMutationOptions = Apollo.BaseMutationOptions<IValidateOtpMutation, IValidateOtpMutationVariables>;
export const CreateOtpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOTP"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOTPInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOTP"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxValidateAttempts"}},{"kind":"Field","name":{"kind":"Name","value":"ttl"}}]}}]}}]} as unknown as DocumentNode;
export type ICreateOtpMutationFn = Apollo.MutationFunction<ICreateOtpMutation, ICreateOtpMutationVariables>;

/**
 * __useCreateOtpMutation__
 *
 * To run a mutation, you first call `useCreateOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOtpMutation, { data, loading, error }] = useCreateOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOtpMutation(baseOptions?: Apollo.MutationHookOptions<ICreateOtpMutation, ICreateOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateOtpMutation, ICreateOtpMutationVariables>(CreateOtpDocument, options);
      }
export type CreateOtpMutationHookResult = ReturnType<typeof useCreateOtpMutation>;
export type CreateOtpMutationResult = Apollo.MutationResult<ICreateOtpMutation>;
export type CreateOtpMutationOptions = Apollo.BaseMutationOptions<ICreateOtpMutation, ICreateOtpMutationVariables>;
export const CreateLoginForVendorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLoginForVendor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"vendor"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLoginForVendor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"vendor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"vendor"}}}]}]}}]} as unknown as DocumentNode;
export type ICreateLoginForVendorMutationFn = Apollo.MutationFunction<ICreateLoginForVendorMutation, ICreateLoginForVendorMutationVariables>;

/**
 * __useCreateLoginForVendorMutation__
 *
 * To run a mutation, you first call `useCreateLoginForVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLoginForVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLoginForVendorMutation, { data, loading, error }] = useCreateLoginForVendorMutation({
 *   variables: {
 *      vendor: // value for 'vendor'
 *   },
 * });
 */
export function useCreateLoginForVendorMutation(baseOptions?: Apollo.MutationHookOptions<ICreateLoginForVendorMutation, ICreateLoginForVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateLoginForVendorMutation, ICreateLoginForVendorMutationVariables>(CreateLoginForVendorDocument, options);
      }
export type CreateLoginForVendorMutationHookResult = ReturnType<typeof useCreateLoginForVendorMutation>;
export type CreateLoginForVendorMutationResult = Apollo.MutationResult<ICreateLoginForVendorMutation>;
export type CreateLoginForVendorMutationOptions = Apollo.BaseMutationOptions<ICreateLoginForVendorMutation, ICreateLoginForVendorMutationVariables>;
export const SocialLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SocialLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SocialLoginInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"socialLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"challengeCode"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode;
export type ISocialLoginMutationFn = Apollo.MutationFunction<ISocialLoginMutation, ISocialLoginMutationVariables>;

/**
 * __useSocialLoginMutation__
 *
 * To run a mutation, you first call `useSocialLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialLoginMutation, { data, loading, error }] = useSocialLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSocialLoginMutation(baseOptions?: Apollo.MutationHookOptions<ISocialLoginMutation, ISocialLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ISocialLoginMutation, ISocialLoginMutationVariables>(SocialLoginDocument, options);
      }
export type SocialLoginMutationHookResult = ReturnType<typeof useSocialLoginMutation>;
export type SocialLoginMutationResult = Apollo.MutationResult<ISocialLoginMutation>;
export type SocialLoginMutationOptions = Apollo.BaseMutationOptions<ISocialLoginMutation, ISocialLoginMutationVariables>;
export const DeleteMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMe"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"flag"},"value":{"kind":"StringValue","value":"enable-gateway-deleteMe","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMe"}}]}}]} as unknown as DocumentNode;
export type IDeleteMeMutationFn = Apollo.MutationFunction<IDeleteMeMutation, IDeleteMeMutationVariables>;

/**
 * __useDeleteMeMutation__
 *
 * To run a mutation, you first call `useDeleteMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMeMutation, { data, loading, error }] = useDeleteMeMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteMeMutation(baseOptions?: Apollo.MutationHookOptions<IDeleteMeMutation, IDeleteMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteMeMutation, IDeleteMeMutationVariables>(DeleteMeDocument, options);
      }
export type DeleteMeMutationHookResult = ReturnType<typeof useDeleteMeMutation>;
export type DeleteMeMutationResult = Apollo.MutationResult<IDeleteMeMutation>;
export type DeleteMeMutationOptions = Apollo.BaseMutationOptions<IDeleteMeMutation, IDeleteMeMutationVariables>;
export const SyncUserCommunicationPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncUserCommunicationPreferences"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncUserCommunicationPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingEmail"}},{"kind":"Field","name":{"kind":"Name","value":"marketingPush"}},{"kind":"Field","name":{"kind":"Name","value":"marketingSms"}}]}}]}}]} as unknown as DocumentNode;
export type ISyncUserCommunicationPreferencesMutationFn = Apollo.MutationFunction<ISyncUserCommunicationPreferencesMutation, ISyncUserCommunicationPreferencesMutationVariables>;

/**
 * __useSyncUserCommunicationPreferencesMutation__
 *
 * To run a mutation, you first call `useSyncUserCommunicationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncUserCommunicationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncUserCommunicationPreferencesMutation, { data, loading, error }] = useSyncUserCommunicationPreferencesMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncUserCommunicationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<ISyncUserCommunicationPreferencesMutation, ISyncUserCommunicationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ISyncUserCommunicationPreferencesMutation, ISyncUserCommunicationPreferencesMutationVariables>(SyncUserCommunicationPreferencesDocument, options);
      }
export type SyncUserCommunicationPreferencesMutationHookResult = ReturnType<typeof useSyncUserCommunicationPreferencesMutation>;
export type SyncUserCommunicationPreferencesMutationResult = Apollo.MutationResult<ISyncUserCommunicationPreferencesMutation>;
export type SyncUserCommunicationPreferencesMutationOptions = Apollo.BaseMutationOptions<ISyncUserCommunicationPreferencesMutation, ISyncUserCommunicationPreferencesMutationVariables>;
export const UpdateUserCommunicationPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserCommunicationPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserCommunicationPreferencesInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserCommunicationPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketingEmail"}},{"kind":"Field","name":{"kind":"Name","value":"marketingPush"}},{"kind":"Field","name":{"kind":"Name","value":"marketingSms"}}]}}]}}]} as unknown as DocumentNode;
export type IUpdateUserCommunicationPreferencesMutationFn = Apollo.MutationFunction<IUpdateUserCommunicationPreferencesMutation, IUpdateUserCommunicationPreferencesMutationVariables>;

/**
 * __useUpdateUserCommunicationPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateUserCommunicationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserCommunicationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserCommunicationPreferencesMutation, { data, loading, error }] = useUpdateUserCommunicationPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserCommunicationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<IUpdateUserCommunicationPreferencesMutation, IUpdateUserCommunicationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateUserCommunicationPreferencesMutation, IUpdateUserCommunicationPreferencesMutationVariables>(UpdateUserCommunicationPreferencesDocument, options);
      }
export type UpdateUserCommunicationPreferencesMutationHookResult = ReturnType<typeof useUpdateUserCommunicationPreferencesMutation>;
export type UpdateUserCommunicationPreferencesMutationResult = Apollo.MutationResult<IUpdateUserCommunicationPreferencesMutation>;
export type UpdateUserCommunicationPreferencesMutationOptions = Apollo.BaseMutationOptions<IUpdateUserCommunicationPreferencesMutation, IUpdateUserCommunicationPreferencesMutationVariables>;
export const VerifyPhoneNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyPhoneNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"verifyPhoneNumberInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyPhoneNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode;
export type IVerifyPhoneNumberMutationFn = Apollo.MutationFunction<IVerifyPhoneNumberMutation, IVerifyPhoneNumberMutationVariables>;

/**
 * __useVerifyPhoneNumberMutation__
 *
 * To run a mutation, you first call `useVerifyPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPhoneNumberMutation, { data, loading, error }] = useVerifyPhoneNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<IVerifyPhoneNumberMutation, IVerifyPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IVerifyPhoneNumberMutation, IVerifyPhoneNumberMutationVariables>(VerifyPhoneNumberDocument, options);
      }
export type VerifyPhoneNumberMutationHookResult = ReturnType<typeof useVerifyPhoneNumberMutation>;
export type VerifyPhoneNumberMutationResult = Apollo.MutationResult<IVerifyPhoneNumberMutation>;
export type VerifyPhoneNumberMutationOptions = Apollo.BaseMutationOptions<IVerifyPhoneNumberMutation, IVerifyPhoneNumberMutationVariables>;
export const SendPhoneVerificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendPhoneVerification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"resendPhoneVerificationInput"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"authRequired"}},{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendPhoneVerification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode;
export type ISendPhoneVerificationMutationFn = Apollo.MutationFunction<ISendPhoneVerificationMutation, ISendPhoneVerificationMutationVariables>;

/**
 * __useSendPhoneVerificationMutation__
 *
 * To run a mutation, you first call `useSendPhoneVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPhoneVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPhoneVerificationMutation, { data, loading, error }] = useSendPhoneVerificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPhoneVerificationMutation(baseOptions?: Apollo.MutationHookOptions<ISendPhoneVerificationMutation, ISendPhoneVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ISendPhoneVerificationMutation, ISendPhoneVerificationMutationVariables>(SendPhoneVerificationDocument, options);
      }
export type SendPhoneVerificationMutationHookResult = ReturnType<typeof useSendPhoneVerificationMutation>;
export type SendPhoneVerificationMutationResult = Apollo.MutationResult<ISendPhoneVerificationMutation>;
export type SendPhoneVerificationMutationOptions = Apollo.BaseMutationOptions<ISendPhoneVerificationMutation, ISendPhoneVerificationMutationVariables>;
export const UserPhoneFromBrazeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserPhoneFromBraze"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brazeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"gateway"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userPhoneFromBraze"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"brazeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brazeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}}]}}]} as unknown as DocumentNode;

/**
 * __useUserPhoneFromBrazeQuery__
 *
 * To run a query within a React component, call `useUserPhoneFromBrazeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPhoneFromBrazeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPhoneFromBrazeQuery({
 *   variables: {
 *      brazeId: // value for 'brazeId'
 *   },
 * });
 */
export function useUserPhoneFromBrazeQuery(baseOptions: Apollo.QueryHookOptions<IUserPhoneFromBrazeQuery, IUserPhoneFromBrazeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IUserPhoneFromBrazeQuery, IUserPhoneFromBrazeQueryVariables>(UserPhoneFromBrazeDocument, options);
      }
export function useUserPhoneFromBrazeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IUserPhoneFromBrazeQuery, IUserPhoneFromBrazeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IUserPhoneFromBrazeQuery, IUserPhoneFromBrazeQueryVariables>(UserPhoneFromBrazeDocument, options);
        }
export type UserPhoneFromBrazeQueryHookResult = ReturnType<typeof useUserPhoneFromBrazeQuery>;
export type UserPhoneFromBrazeLazyQueryHookResult = ReturnType<typeof useUserPhoneFromBrazeLazyQuery>;
export type UserPhoneFromBrazeQueryResult = Apollo.QueryResult<IUserPhoneFromBrazeQuery, IUserPhoneFromBrazeQueryVariables>;